
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire28f6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire28f6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("joTVV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e1fba56a8c9482eb$export$ffb0004e005737fa; }, function (v) { return $e1fba56a8c9482eb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e1fba56a8c9482eb$export$34b9dba7ce09269b; }, function (v) { return $e1fba56a8c9482eb$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e1fba56a8c9482eb$export$25062201e9e25d76; }, function (v) { return $e1fba56a8c9482eb$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e1fba56a8c9482eb$export$ffb0004e005737fa;
var $e1fba56a8c9482eb$export$34b9dba7ce09269b;
var $e1fba56a8c9482eb$export$25062201e9e25d76;
'use strict';

var $6kl77 = parcelRequire("6kl77");
var $e1fba56a8c9482eb$var$k = Symbol.for("react.element"), $e1fba56a8c9482eb$var$l = Symbol.for("react.fragment"), $e1fba56a8c9482eb$var$m = Object.prototype.hasOwnProperty, $e1fba56a8c9482eb$var$n = $6kl77.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e1fba56a8c9482eb$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e1fba56a8c9482eb$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e1fba56a8c9482eb$var$m.call(a, b) && !$e1fba56a8c9482eb$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e1fba56a8c9482eb$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e1fba56a8c9482eb$var$n.current
    };
}
$e1fba56a8c9482eb$export$ffb0004e005737fa = $e1fba56a8c9482eb$var$l;
$e1fba56a8c9482eb$export$34b9dba7ce09269b = $e1fba56a8c9482eb$var$q;
$e1fba56a8c9482eb$export$25062201e9e25d76 = $e1fba56a8c9482eb$var$q;

});
parcelRegister("6kl77", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jT3Q4"));

});
parcelRegister("jT3Q4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e7a621b674aa2bc1$export$dca3b0875bd9a954; }, function (v) { return $e7a621b674aa2bc1$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e7a621b674aa2bc1$export$16fa2f45be04daa8; }, function (v) { return $e7a621b674aa2bc1$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e7a621b674aa2bc1$export$ffb0004e005737fa; }, function (v) { return $e7a621b674aa2bc1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e7a621b674aa2bc1$export$e2c29f18771995cb; }, function (v) { return $e7a621b674aa2bc1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e7a621b674aa2bc1$export$221d75b3f55bb0bd; }, function (v) { return $e7a621b674aa2bc1$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e7a621b674aa2bc1$export$5f8d39834fd61797; }, function (v) { return $e7a621b674aa2bc1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e7a621b674aa2bc1$export$74bf444e3cd11ea5; }, function (v) { return $e7a621b674aa2bc1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e7a621b674aa2bc1$export$ae55be85d98224ed; }, function (v) { return $e7a621b674aa2bc1$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e7a621b674aa2bc1$export$3ba232387fd5d6dd; }, function (v) { return $e7a621b674aa2bc1$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e7a621b674aa2bc1$export$e530037191fcd5d7; }, function (v) { return $e7a621b674aa2bc1$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e7a621b674aa2bc1$export$fd42f52fd3ae1109; }, function (v) { return $e7a621b674aa2bc1$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e7a621b674aa2bc1$export$c8a8987d4410bf2d; }, function (v) { return $e7a621b674aa2bc1$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e7a621b674aa2bc1$export$d38cd72104c1f0e9; }, function (v) { return $e7a621b674aa2bc1$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e7a621b674aa2bc1$export$7d1e3a5e95ceca43; }, function (v) { return $e7a621b674aa2bc1$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e7a621b674aa2bc1$export$257a8862b851cb5b; }, function (v) { return $e7a621b674aa2bc1$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e7a621b674aa2bc1$export$a8257692ac88316c; }, function (v) { return $e7a621b674aa2bc1$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e7a621b674aa2bc1$export$488013bae63b21da; }, function (v) { return $e7a621b674aa2bc1$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e7a621b674aa2bc1$export$7c73462e0d25e514; }, function (v) { return $e7a621b674aa2bc1$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e7a621b674aa2bc1$export$7568632d0d33d16d; }, function (v) { return $e7a621b674aa2bc1$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e7a621b674aa2bc1$export$88948ce120ea2619; }, function (v) { return $e7a621b674aa2bc1$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e7a621b674aa2bc1$export$35808ee640e87ca7; }, function (v) { return $e7a621b674aa2bc1$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e7a621b674aa2bc1$export$fae74005e78b1a27; }, function (v) { return $e7a621b674aa2bc1$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e7a621b674aa2bc1$export$dc8fbce3eb94dc1e; }, function (v) { return $e7a621b674aa2bc1$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e7a621b674aa2bc1$export$6a7bc4e911dc01cf; }, function (v) { return $e7a621b674aa2bc1$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e7a621b674aa2bc1$export$6d9c69b0de29b591; }, function (v) { return $e7a621b674aa2bc1$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e7a621b674aa2bc1$export$f680877a34711e37; }, function (v) { return $e7a621b674aa2bc1$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e7a621b674aa2bc1$export$d5a552a76deda3c2; }, function (v) { return $e7a621b674aa2bc1$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e7a621b674aa2bc1$export$aaabe4eda9ed9969; }, function (v) { return $e7a621b674aa2bc1$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e7a621b674aa2bc1$export$e5c5a5f917a5871c; }, function (v) { return $e7a621b674aa2bc1$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e7a621b674aa2bc1$export$1538c33de8887b59; }, function (v) { return $e7a621b674aa2bc1$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e7a621b674aa2bc1$export$13e3392192263954; }, function (v) { return $e7a621b674aa2bc1$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e7a621b674aa2bc1$export$b8f5890fc79d6aca; }, function (v) { return $e7a621b674aa2bc1$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e7a621b674aa2bc1$export$60241385465d0a34; }, function (v) { return $e7a621b674aa2bc1$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e7a621b674aa2bc1$export$306c0aa65ff9ec16; }, function (v) { return $e7a621b674aa2bc1$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e7a621b674aa2bc1$export$7b286972b8d8ccbf; }, function (v) { return $e7a621b674aa2bc1$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e7a621b674aa2bc1$export$83d89fbfd8236492; }, function (v) { return $e7a621b674aa2bc1$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e7a621b674aa2bc1$export$dca3b0875bd9a954;
var $e7a621b674aa2bc1$export$16fa2f45be04daa8;
var $e7a621b674aa2bc1$export$ffb0004e005737fa;
var $e7a621b674aa2bc1$export$e2c29f18771995cb;
var $e7a621b674aa2bc1$export$221d75b3f55bb0bd;
var $e7a621b674aa2bc1$export$5f8d39834fd61797;
var $e7a621b674aa2bc1$export$74bf444e3cd11ea5;
var $e7a621b674aa2bc1$export$ae55be85d98224ed;
var $e7a621b674aa2bc1$export$3ba232387fd5d6dd;
var $e7a621b674aa2bc1$export$e530037191fcd5d7;
var $e7a621b674aa2bc1$export$fd42f52fd3ae1109;
var $e7a621b674aa2bc1$export$c8a8987d4410bf2d;
var $e7a621b674aa2bc1$export$d38cd72104c1f0e9;
var $e7a621b674aa2bc1$export$7d1e3a5e95ceca43;
var $e7a621b674aa2bc1$export$257a8862b851cb5b;
var $e7a621b674aa2bc1$export$a8257692ac88316c;
var $e7a621b674aa2bc1$export$488013bae63b21da;
var $e7a621b674aa2bc1$export$7c73462e0d25e514;
var $e7a621b674aa2bc1$export$7568632d0d33d16d;
var $e7a621b674aa2bc1$export$88948ce120ea2619;
var $e7a621b674aa2bc1$export$35808ee640e87ca7;
var $e7a621b674aa2bc1$export$fae74005e78b1a27;
var $e7a621b674aa2bc1$export$dc8fbce3eb94dc1e;
var $e7a621b674aa2bc1$export$6a7bc4e911dc01cf;
var $e7a621b674aa2bc1$export$6d9c69b0de29b591;
var $e7a621b674aa2bc1$export$f680877a34711e37;
var $e7a621b674aa2bc1$export$d5a552a76deda3c2;
var $e7a621b674aa2bc1$export$aaabe4eda9ed9969;
var $e7a621b674aa2bc1$export$e5c5a5f917a5871c;
var $e7a621b674aa2bc1$export$1538c33de8887b59;
var $e7a621b674aa2bc1$export$13e3392192263954;
var $e7a621b674aa2bc1$export$b8f5890fc79d6aca;
var $e7a621b674aa2bc1$export$60241385465d0a34;
var $e7a621b674aa2bc1$export$306c0aa65ff9ec16;
var $e7a621b674aa2bc1$export$7b286972b8d8ccbf;
var $e7a621b674aa2bc1$export$83d89fbfd8236492;
'use strict';
var $e7a621b674aa2bc1$var$l = Symbol.for("react.element"), $e7a621b674aa2bc1$var$n = Symbol.for("react.portal"), $e7a621b674aa2bc1$var$p = Symbol.for("react.fragment"), $e7a621b674aa2bc1$var$q = Symbol.for("react.strict_mode"), $e7a621b674aa2bc1$var$r = Symbol.for("react.profiler"), $e7a621b674aa2bc1$var$t = Symbol.for("react.provider"), $e7a621b674aa2bc1$var$u = Symbol.for("react.context"), $e7a621b674aa2bc1$var$v = Symbol.for("react.forward_ref"), $e7a621b674aa2bc1$var$w = Symbol.for("react.suspense"), $e7a621b674aa2bc1$var$x = Symbol.for("react.memo"), $e7a621b674aa2bc1$var$y = Symbol.for("react.lazy"), $e7a621b674aa2bc1$var$z = Symbol.iterator;
function $e7a621b674aa2bc1$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e7a621b674aa2bc1$var$z && a[$e7a621b674aa2bc1$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e7a621b674aa2bc1$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e7a621b674aa2bc1$var$C = Object.assign, $e7a621b674aa2bc1$var$D = {};
function $e7a621b674aa2bc1$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e7a621b674aa2bc1$var$D;
    this.updater = e || $e7a621b674aa2bc1$var$B;
}
$e7a621b674aa2bc1$var$E.prototype.isReactComponent = {};
$e7a621b674aa2bc1$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e7a621b674aa2bc1$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e7a621b674aa2bc1$var$F() {}
$e7a621b674aa2bc1$var$F.prototype = $e7a621b674aa2bc1$var$E.prototype;
function $e7a621b674aa2bc1$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e7a621b674aa2bc1$var$D;
    this.updater = e || $e7a621b674aa2bc1$var$B;
}
var $e7a621b674aa2bc1$var$H = $e7a621b674aa2bc1$var$G.prototype = new $e7a621b674aa2bc1$var$F;
$e7a621b674aa2bc1$var$H.constructor = $e7a621b674aa2bc1$var$G;
$e7a621b674aa2bc1$var$C($e7a621b674aa2bc1$var$H, $e7a621b674aa2bc1$var$E.prototype);
$e7a621b674aa2bc1$var$H.isPureReactComponent = !0;
var $e7a621b674aa2bc1$var$I = Array.isArray, $e7a621b674aa2bc1$var$J = Object.prototype.hasOwnProperty, $e7a621b674aa2bc1$var$K = {
    current: null
}, $e7a621b674aa2bc1$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e7a621b674aa2bc1$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e7a621b674aa2bc1$var$J.call(b, d) && !$e7a621b674aa2bc1$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e7a621b674aa2bc1$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e7a621b674aa2bc1$var$K.current
    };
}
function $e7a621b674aa2bc1$var$N(a, b) {
    return {
        $$typeof: $e7a621b674aa2bc1$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e7a621b674aa2bc1$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e7a621b674aa2bc1$var$l;
}
function $e7a621b674aa2bc1$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e7a621b674aa2bc1$var$P = /\/+/g;
function $e7a621b674aa2bc1$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e7a621b674aa2bc1$var$escape("" + a.key) : b.toString(36);
}
function $e7a621b674aa2bc1$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e7a621b674aa2bc1$var$l:
                case $e7a621b674aa2bc1$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e7a621b674aa2bc1$var$Q(h, 0) : d, $e7a621b674aa2bc1$var$I(c) ? (e = "", null != a && (e = a.replace($e7a621b674aa2bc1$var$P, "$&/") + "/"), $e7a621b674aa2bc1$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e7a621b674aa2bc1$var$O(c) && (c = $e7a621b674aa2bc1$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e7a621b674aa2bc1$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e7a621b674aa2bc1$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e7a621b674aa2bc1$var$Q(k, g);
        h += $e7a621b674aa2bc1$var$R(k, b, e, f, c);
    }
    else if (f = $e7a621b674aa2bc1$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e7a621b674aa2bc1$var$Q(k, g++), h += $e7a621b674aa2bc1$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e7a621b674aa2bc1$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e7a621b674aa2bc1$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e7a621b674aa2bc1$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e7a621b674aa2bc1$var$U = {
    current: null
}, $e7a621b674aa2bc1$var$V = {
    transition: null
}, $e7a621b674aa2bc1$var$W = {
    ReactCurrentDispatcher: $e7a621b674aa2bc1$var$U,
    ReactCurrentBatchConfig: $e7a621b674aa2bc1$var$V,
    ReactCurrentOwner: $e7a621b674aa2bc1$var$K
};
function $e7a621b674aa2bc1$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e7a621b674aa2bc1$export$dca3b0875bd9a954 = {
    map: $e7a621b674aa2bc1$var$S,
    forEach: function(a, b, e) {
        $e7a621b674aa2bc1$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e7a621b674aa2bc1$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e7a621b674aa2bc1$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e7a621b674aa2bc1$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e7a621b674aa2bc1$export$16fa2f45be04daa8 = $e7a621b674aa2bc1$var$E;
$e7a621b674aa2bc1$export$ffb0004e005737fa = $e7a621b674aa2bc1$var$p;
$e7a621b674aa2bc1$export$e2c29f18771995cb = $e7a621b674aa2bc1$var$r;
$e7a621b674aa2bc1$export$221d75b3f55bb0bd = $e7a621b674aa2bc1$var$G;
$e7a621b674aa2bc1$export$5f8d39834fd61797 = $e7a621b674aa2bc1$var$q;
$e7a621b674aa2bc1$export$74bf444e3cd11ea5 = $e7a621b674aa2bc1$var$w;
$e7a621b674aa2bc1$export$ae55be85d98224ed = $e7a621b674aa2bc1$var$W;
$e7a621b674aa2bc1$export$3ba232387fd5d6dd = $e7a621b674aa2bc1$var$X;
$e7a621b674aa2bc1$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e7a621b674aa2bc1$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e7a621b674aa2bc1$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e7a621b674aa2bc1$var$J.call(b, f) && !$e7a621b674aa2bc1$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e7a621b674aa2bc1$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e7a621b674aa2bc1$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e7a621b674aa2bc1$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e7a621b674aa2bc1$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e7a621b674aa2bc1$export$c8a8987d4410bf2d = $e7a621b674aa2bc1$var$M;
$e7a621b674aa2bc1$export$d38cd72104c1f0e9 = function(a) {
    var b = $e7a621b674aa2bc1$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e7a621b674aa2bc1$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e7a621b674aa2bc1$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e7a621b674aa2bc1$var$v,
        render: a
    };
};
$e7a621b674aa2bc1$export$a8257692ac88316c = $e7a621b674aa2bc1$var$O;
$e7a621b674aa2bc1$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e7a621b674aa2bc1$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e7a621b674aa2bc1$var$T
    };
};
$e7a621b674aa2bc1$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e7a621b674aa2bc1$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e7a621b674aa2bc1$export$7568632d0d33d16d = function(a) {
    var b = $e7a621b674aa2bc1$var$V.transition;
    $e7a621b674aa2bc1$var$V.transition = {};
    try {
        a();
    } finally{
        $e7a621b674aa2bc1$var$V.transition = b;
    }
};
$e7a621b674aa2bc1$export$88948ce120ea2619 = $e7a621b674aa2bc1$var$X;
$e7a621b674aa2bc1$export$35808ee640e87ca7 = function(a, b) {
    return $e7a621b674aa2bc1$var$U.current.useCallback(a, b);
};
$e7a621b674aa2bc1$export$fae74005e78b1a27 = function(a) {
    return $e7a621b674aa2bc1$var$U.current.useContext(a);
};
$e7a621b674aa2bc1$export$dc8fbce3eb94dc1e = function() {};
$e7a621b674aa2bc1$export$6a7bc4e911dc01cf = function(a) {
    return $e7a621b674aa2bc1$var$U.current.useDeferredValue(a);
};
$e7a621b674aa2bc1$export$6d9c69b0de29b591 = function(a, b) {
    return $e7a621b674aa2bc1$var$U.current.useEffect(a, b);
};
$e7a621b674aa2bc1$export$f680877a34711e37 = function() {
    return $e7a621b674aa2bc1$var$U.current.useId();
};
$e7a621b674aa2bc1$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e7a621b674aa2bc1$var$U.current.useImperativeHandle(a, b, e);
};
$e7a621b674aa2bc1$export$aaabe4eda9ed9969 = function(a, b) {
    return $e7a621b674aa2bc1$var$U.current.useInsertionEffect(a, b);
};
$e7a621b674aa2bc1$export$e5c5a5f917a5871c = function(a, b) {
    return $e7a621b674aa2bc1$var$U.current.useLayoutEffect(a, b);
};
$e7a621b674aa2bc1$export$1538c33de8887b59 = function(a, b) {
    return $e7a621b674aa2bc1$var$U.current.useMemo(a, b);
};
$e7a621b674aa2bc1$export$13e3392192263954 = function(a, b, e) {
    return $e7a621b674aa2bc1$var$U.current.useReducer(a, b, e);
};
$e7a621b674aa2bc1$export$b8f5890fc79d6aca = function(a) {
    return $e7a621b674aa2bc1$var$U.current.useRef(a);
};
$e7a621b674aa2bc1$export$60241385465d0a34 = function(a) {
    return $e7a621b674aa2bc1$var$U.current.useState(a);
};
$e7a621b674aa2bc1$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e7a621b674aa2bc1$var$U.current.useSyncExternalStore(a, b, e);
};
$e7a621b674aa2bc1$export$7b286972b8d8ccbf = function() {
    return $e7a621b674aa2bc1$var$U.current.useTransition();
};
$e7a621b674aa2bc1$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("71HD7", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $51da786a5efa83c1$export$ae55be85d98224ed; }, function (v) { return $51da786a5efa83c1$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $51da786a5efa83c1$export$d39a5bbd09211389; }, function (v) { return $51da786a5efa83c1$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $51da786a5efa83c1$export$882461b6382ed46c; }, function (v) { return $51da786a5efa83c1$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $51da786a5efa83c1$export$466bfc07425424d5; }, function (v) { return $51da786a5efa83c1$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $51da786a5efa83c1$export$cd75ccfd720a3cd4; }, function (v) { return $51da786a5efa83c1$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $51da786a5efa83c1$export$fa8d919ba61d84db; }, function (v) { return $51da786a5efa83c1$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $51da786a5efa83c1$export$757ceba2d55c277e; }, function (v) { return $51da786a5efa83c1$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $51da786a5efa83c1$export$b3890eb0ae9dca99; }, function (v) { return $51da786a5efa83c1$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $51da786a5efa83c1$export$502457920280e6be; }, function (v) { return $51da786a5efa83c1$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $51da786a5efa83c1$export$c78a37762a8d58e1; }, function (v) { return $51da786a5efa83c1$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $51da786a5efa83c1$export$dc54d992c10e8a18; }, function (v) { return $51da786a5efa83c1$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $51da786a5efa83c1$export$83d89fbfd8236492; }, function (v) { return $51da786a5efa83c1$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $51da786a5efa83c1$export$ae55be85d98224ed;
var $51da786a5efa83c1$export$d39a5bbd09211389;
var $51da786a5efa83c1$export$882461b6382ed46c;
var $51da786a5efa83c1$export$466bfc07425424d5;
var $51da786a5efa83c1$export$cd75ccfd720a3cd4;
var $51da786a5efa83c1$export$fa8d919ba61d84db;
var $51da786a5efa83c1$export$757ceba2d55c277e;
var $51da786a5efa83c1$export$b3890eb0ae9dca99;
var $51da786a5efa83c1$export$502457920280e6be;
var $51da786a5efa83c1$export$c78a37762a8d58e1;
var $51da786a5efa83c1$export$dc54d992c10e8a18;
var $51da786a5efa83c1$export$83d89fbfd8236492;
'use strict';

var $6kl77 = parcelRequire("6kl77");

var $dVdJZ = parcelRequire("dVdJZ");
function $51da786a5efa83c1$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $51da786a5efa83c1$var$da = new Set, $51da786a5efa83c1$var$ea = {};
function $51da786a5efa83c1$var$fa(a, b) {
    $51da786a5efa83c1$var$ha(a, b);
    $51da786a5efa83c1$var$ha(a + "Capture", b);
}
function $51da786a5efa83c1$var$ha(a, b) {
    $51da786a5efa83c1$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$51da786a5efa83c1$var$da.add(b[a]);
}
var $51da786a5efa83c1$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $51da786a5efa83c1$var$ja = Object.prototype.hasOwnProperty, $51da786a5efa83c1$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $51da786a5efa83c1$var$la = {}, $51da786a5efa83c1$var$ma = {};
function $51da786a5efa83c1$var$oa(a) {
    if ($51da786a5efa83c1$var$ja.call($51da786a5efa83c1$var$ma, a)) return !0;
    if ($51da786a5efa83c1$var$ja.call($51da786a5efa83c1$var$la, a)) return !1;
    if ($51da786a5efa83c1$var$ka.test(a)) return $51da786a5efa83c1$var$ma[a] = !0;
    $51da786a5efa83c1$var$la[a] = !0;
    return !1;
}
function $51da786a5efa83c1$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $51da786a5efa83c1$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $51da786a5efa83c1$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $51da786a5efa83c1$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $51da786a5efa83c1$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $51da786a5efa83c1$var$z[b] = new $51da786a5efa83c1$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $51da786a5efa83c1$var$ra = /[\-:]([a-z])/g;
function $51da786a5efa83c1$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($51da786a5efa83c1$var$ra, $51da786a5efa83c1$var$sa);
    $51da786a5efa83c1$var$z[b] = new $51da786a5efa83c1$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($51da786a5efa83c1$var$ra, $51da786a5efa83c1$var$sa);
    $51da786a5efa83c1$var$z[b] = new $51da786a5efa83c1$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($51da786a5efa83c1$var$ra, $51da786a5efa83c1$var$sa);
    $51da786a5efa83c1$var$z[b] = new $51da786a5efa83c1$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$51da786a5efa83c1$var$z.xlinkHref = new $51da786a5efa83c1$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $51da786a5efa83c1$var$z[a] = new $51da786a5efa83c1$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $51da786a5efa83c1$var$ta(a, b, c, d) {
    var e = $51da786a5efa83c1$var$z.hasOwnProperty(b) ? $51da786a5efa83c1$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $51da786a5efa83c1$var$qa(b, c, e, d) && (c = null), d || null === e ? $51da786a5efa83c1$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $51da786a5efa83c1$var$ua = $6kl77.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $51da786a5efa83c1$var$va = Symbol.for("react.element"), $51da786a5efa83c1$var$wa = Symbol.for("react.portal"), $51da786a5efa83c1$var$ya = Symbol.for("react.fragment"), $51da786a5efa83c1$var$za = Symbol.for("react.strict_mode"), $51da786a5efa83c1$var$Aa = Symbol.for("react.profiler"), $51da786a5efa83c1$var$Ba = Symbol.for("react.provider"), $51da786a5efa83c1$var$Ca = Symbol.for("react.context"), $51da786a5efa83c1$var$Da = Symbol.for("react.forward_ref"), $51da786a5efa83c1$var$Ea = Symbol.for("react.suspense"), $51da786a5efa83c1$var$Fa = Symbol.for("react.suspense_list"), $51da786a5efa83c1$var$Ga = Symbol.for("react.memo"), $51da786a5efa83c1$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $51da786a5efa83c1$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $51da786a5efa83c1$var$Ja = Symbol.iterator;
function $51da786a5efa83c1$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $51da786a5efa83c1$var$Ja && a[$51da786a5efa83c1$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $51da786a5efa83c1$var$A = Object.assign, $51da786a5efa83c1$var$La;
function $51da786a5efa83c1$var$Ma(a) {
    if (void 0 === $51da786a5efa83c1$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $51da786a5efa83c1$var$La = b && b[1] || "";
    }
    return "\n" + $51da786a5efa83c1$var$La + a;
}
var $51da786a5efa83c1$var$Na = !1;
function $51da786a5efa83c1$var$Oa(a, b) {
    if (!a || $51da786a5efa83c1$var$Na) return "";
    $51da786a5efa83c1$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $51da786a5efa83c1$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $51da786a5efa83c1$var$Ma(a) : "";
}
function $51da786a5efa83c1$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $51da786a5efa83c1$var$Ma(a.type);
        case 16:
            return $51da786a5efa83c1$var$Ma("Lazy");
        case 13:
            return $51da786a5efa83c1$var$Ma("Suspense");
        case 19:
            return $51da786a5efa83c1$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $51da786a5efa83c1$var$Oa(a.type, !1), a;
        case 11:
            return a = $51da786a5efa83c1$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $51da786a5efa83c1$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $51da786a5efa83c1$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $51da786a5efa83c1$var$ya:
            return "Fragment";
        case $51da786a5efa83c1$var$wa:
            return "Portal";
        case $51da786a5efa83c1$var$Aa:
            return "Profiler";
        case $51da786a5efa83c1$var$za:
            return "StrictMode";
        case $51da786a5efa83c1$var$Ea:
            return "Suspense";
        case $51da786a5efa83c1$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $51da786a5efa83c1$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $51da786a5efa83c1$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $51da786a5efa83c1$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $51da786a5efa83c1$var$Ga:
            return b = a.displayName || null, null !== b ? b : $51da786a5efa83c1$var$Qa(a.type) || "Memo";
        case $51da786a5efa83c1$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $51da786a5efa83c1$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $51da786a5efa83c1$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $51da786a5efa83c1$var$Qa(b);
        case 8:
            return b === $51da786a5efa83c1$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $51da786a5efa83c1$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $51da786a5efa83c1$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $51da786a5efa83c1$var$Ua(a) {
    var b = $51da786a5efa83c1$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $51da786a5efa83c1$var$Va(a) {
    a._valueTracker || (a._valueTracker = $51da786a5efa83c1$var$Ua(a));
}
function $51da786a5efa83c1$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $51da786a5efa83c1$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $51da786a5efa83c1$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $51da786a5efa83c1$var$Ya(a, b) {
    var c = b.checked;
    return $51da786a5efa83c1$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $51da786a5efa83c1$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $51da786a5efa83c1$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $51da786a5efa83c1$var$ab(a, b) {
    b = b.checked;
    null != b && $51da786a5efa83c1$var$ta(a, "checked", b, !1);
}
function $51da786a5efa83c1$var$bb(a, b) {
    $51da786a5efa83c1$var$ab(a, b);
    var c = $51da786a5efa83c1$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $51da786a5efa83c1$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $51da786a5efa83c1$var$cb(a, b.type, $51da786a5efa83c1$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $51da786a5efa83c1$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $51da786a5efa83c1$var$cb(a, b, c) {
    if ("number" !== b || $51da786a5efa83c1$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $51da786a5efa83c1$var$eb = Array.isArray;
function $51da786a5efa83c1$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $51da786a5efa83c1$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $51da786a5efa83c1$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($51da786a5efa83c1$var$p(91));
    return $51da786a5efa83c1$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $51da786a5efa83c1$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($51da786a5efa83c1$var$p(92));
            if ($51da786a5efa83c1$var$eb(c)) {
                if (1 < c.length) throw Error($51da786a5efa83c1$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $51da786a5efa83c1$var$Sa(c)
    };
}
function $51da786a5efa83c1$var$ib(a, b) {
    var c = $51da786a5efa83c1$var$Sa(b.value), d = $51da786a5efa83c1$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $51da786a5efa83c1$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $51da786a5efa83c1$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $51da786a5efa83c1$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $51da786a5efa83c1$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $51da786a5efa83c1$var$mb, $51da786a5efa83c1$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $51da786a5efa83c1$var$mb = $51da786a5efa83c1$var$mb || document.createElement("div");
        $51da786a5efa83c1$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $51da786a5efa83c1$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $51da786a5efa83c1$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $51da786a5efa83c1$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $51da786a5efa83c1$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($51da786a5efa83c1$var$pb).forEach(function(a) {
    $51da786a5efa83c1$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $51da786a5efa83c1$var$pb[b] = $51da786a5efa83c1$var$pb[a];
    });
});
function $51da786a5efa83c1$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $51da786a5efa83c1$var$pb.hasOwnProperty(a) && $51da786a5efa83c1$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $51da786a5efa83c1$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $51da786a5efa83c1$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $51da786a5efa83c1$var$tb = $51da786a5efa83c1$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $51da786a5efa83c1$var$ub(a, b) {
    if (b) {
        if ($51da786a5efa83c1$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($51da786a5efa83c1$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($51da786a5efa83c1$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($51da786a5efa83c1$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($51da786a5efa83c1$var$p(62));
    }
}
function $51da786a5efa83c1$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $51da786a5efa83c1$var$wb = null;
function $51da786a5efa83c1$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $51da786a5efa83c1$var$yb = null, $51da786a5efa83c1$var$zb = null, $51da786a5efa83c1$var$Ab = null;
function $51da786a5efa83c1$var$Bb(a) {
    if (a = $51da786a5efa83c1$var$Cb(a)) {
        if ("function" !== typeof $51da786a5efa83c1$var$yb) throw Error($51da786a5efa83c1$var$p(280));
        var b = a.stateNode;
        b && (b = $51da786a5efa83c1$var$Db(b), $51da786a5efa83c1$var$yb(a.stateNode, a.type, b));
    }
}
function $51da786a5efa83c1$var$Eb(a) {
    $51da786a5efa83c1$var$zb ? $51da786a5efa83c1$var$Ab ? $51da786a5efa83c1$var$Ab.push(a) : $51da786a5efa83c1$var$Ab = [
        a
    ] : $51da786a5efa83c1$var$zb = a;
}
function $51da786a5efa83c1$var$Fb() {
    if ($51da786a5efa83c1$var$zb) {
        var a = $51da786a5efa83c1$var$zb, b = $51da786a5efa83c1$var$Ab;
        $51da786a5efa83c1$var$Ab = $51da786a5efa83c1$var$zb = null;
        $51da786a5efa83c1$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$51da786a5efa83c1$var$Bb(b[a]);
    }
}
function $51da786a5efa83c1$var$Gb(a, b) {
    return a(b);
}
function $51da786a5efa83c1$var$Hb() {}
var $51da786a5efa83c1$var$Ib = !1;
function $51da786a5efa83c1$var$Jb(a, b, c) {
    if ($51da786a5efa83c1$var$Ib) return a(b, c);
    $51da786a5efa83c1$var$Ib = !0;
    try {
        return $51da786a5efa83c1$var$Gb(a, b, c);
    } finally{
        if ($51da786a5efa83c1$var$Ib = !1, null !== $51da786a5efa83c1$var$zb || null !== $51da786a5efa83c1$var$Ab) $51da786a5efa83c1$var$Hb(), $51da786a5efa83c1$var$Fb();
    }
}
function $51da786a5efa83c1$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $51da786a5efa83c1$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($51da786a5efa83c1$var$p(231, b, typeof c));
    return c;
}
var $51da786a5efa83c1$var$Lb = !1;
if ($51da786a5efa83c1$var$ia) try {
    var $51da786a5efa83c1$var$Mb = {};
    Object.defineProperty($51da786a5efa83c1$var$Mb, "passive", {
        get: function() {
            $51da786a5efa83c1$var$Lb = !0;
        }
    });
    window.addEventListener("test", $51da786a5efa83c1$var$Mb, $51da786a5efa83c1$var$Mb);
    window.removeEventListener("test", $51da786a5efa83c1$var$Mb, $51da786a5efa83c1$var$Mb);
} catch (a) {
    $51da786a5efa83c1$var$Lb = !1;
}
function $51da786a5efa83c1$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $51da786a5efa83c1$var$Ob = !1, $51da786a5efa83c1$var$Pb = null, $51da786a5efa83c1$var$Qb = !1, $51da786a5efa83c1$var$Rb = null, $51da786a5efa83c1$var$Sb = {
    onError: function(a) {
        $51da786a5efa83c1$var$Ob = !0;
        $51da786a5efa83c1$var$Pb = a;
    }
};
function $51da786a5efa83c1$var$Tb(a, b, c, d, e, f, g, h, k) {
    $51da786a5efa83c1$var$Ob = !1;
    $51da786a5efa83c1$var$Pb = null;
    $51da786a5efa83c1$var$Nb.apply($51da786a5efa83c1$var$Sb, arguments);
}
function $51da786a5efa83c1$var$Ub(a, b, c, d, e, f, g, h, k) {
    $51da786a5efa83c1$var$Tb.apply(this, arguments);
    if ($51da786a5efa83c1$var$Ob) {
        if ($51da786a5efa83c1$var$Ob) {
            var l = $51da786a5efa83c1$var$Pb;
            $51da786a5efa83c1$var$Ob = !1;
            $51da786a5efa83c1$var$Pb = null;
        } else throw Error($51da786a5efa83c1$var$p(198));
        $51da786a5efa83c1$var$Qb || ($51da786a5efa83c1$var$Qb = !0, $51da786a5efa83c1$var$Rb = l);
    }
}
function $51da786a5efa83c1$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $51da786a5efa83c1$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $51da786a5efa83c1$var$Xb(a) {
    if ($51da786a5efa83c1$var$Vb(a) !== a) throw Error($51da786a5efa83c1$var$p(188));
}
function $51da786a5efa83c1$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $51da786a5efa83c1$var$Vb(a);
        if (null === b) throw Error($51da786a5efa83c1$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $51da786a5efa83c1$var$Xb(e), a;
                if (f === d) return $51da786a5efa83c1$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($51da786a5efa83c1$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($51da786a5efa83c1$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($51da786a5efa83c1$var$p(190));
    }
    if (3 !== c.tag) throw Error($51da786a5efa83c1$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $51da786a5efa83c1$var$Zb(a) {
    a = $51da786a5efa83c1$var$Yb(a);
    return null !== a ? $51da786a5efa83c1$var$$b(a) : null;
}
function $51da786a5efa83c1$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $51da786a5efa83c1$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $51da786a5efa83c1$var$ac = $dVdJZ.unstable_scheduleCallback, $51da786a5efa83c1$var$bc = $dVdJZ.unstable_cancelCallback, $51da786a5efa83c1$var$cc = $dVdJZ.unstable_shouldYield, $51da786a5efa83c1$var$dc = $dVdJZ.unstable_requestPaint, $51da786a5efa83c1$var$B = $dVdJZ.unstable_now, $51da786a5efa83c1$var$ec = $dVdJZ.unstable_getCurrentPriorityLevel, $51da786a5efa83c1$var$fc = $dVdJZ.unstable_ImmediatePriority, $51da786a5efa83c1$var$gc = $dVdJZ.unstable_UserBlockingPriority, $51da786a5efa83c1$var$hc = $dVdJZ.unstable_NormalPriority, $51da786a5efa83c1$var$ic = $dVdJZ.unstable_LowPriority, $51da786a5efa83c1$var$jc = $dVdJZ.unstable_IdlePriority, $51da786a5efa83c1$var$kc = null, $51da786a5efa83c1$var$lc = null;
function $51da786a5efa83c1$var$mc(a) {
    if ($51da786a5efa83c1$var$lc && "function" === typeof $51da786a5efa83c1$var$lc.onCommitFiberRoot) try {
        $51da786a5efa83c1$var$lc.onCommitFiberRoot($51da786a5efa83c1$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $51da786a5efa83c1$var$oc = Math.clz32 ? Math.clz32 : $51da786a5efa83c1$var$nc, $51da786a5efa83c1$var$pc = Math.log, $51da786a5efa83c1$var$qc = Math.LN2;
function $51da786a5efa83c1$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($51da786a5efa83c1$var$pc(a) / $51da786a5efa83c1$var$qc | 0) | 0;
}
var $51da786a5efa83c1$var$rc = 64, $51da786a5efa83c1$var$sc = 4194304;
function $51da786a5efa83c1$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $51da786a5efa83c1$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $51da786a5efa83c1$var$tc(h) : (f &= g, 0 !== f && (d = $51da786a5efa83c1$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $51da786a5efa83c1$var$tc(g) : 0 !== f && (d = $51da786a5efa83c1$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $51da786a5efa83c1$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $51da786a5efa83c1$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $51da786a5efa83c1$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $51da786a5efa83c1$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $51da786a5efa83c1$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $51da786a5efa83c1$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $51da786a5efa83c1$var$yc() {
    var a = $51da786a5efa83c1$var$rc;
    $51da786a5efa83c1$var$rc <<= 1;
    0 === ($51da786a5efa83c1$var$rc & 4194240) && ($51da786a5efa83c1$var$rc = 64);
    return a;
}
function $51da786a5efa83c1$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $51da786a5efa83c1$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $51da786a5efa83c1$var$oc(b);
    a[b] = c;
}
function $51da786a5efa83c1$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $51da786a5efa83c1$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $51da786a5efa83c1$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $51da786a5efa83c1$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $51da786a5efa83c1$var$C = 0;
function $51da786a5efa83c1$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $51da786a5efa83c1$var$Ec, $51da786a5efa83c1$var$Fc, $51da786a5efa83c1$var$Gc, $51da786a5efa83c1$var$Hc, $51da786a5efa83c1$var$Ic, $51da786a5efa83c1$var$Jc = !1, $51da786a5efa83c1$var$Kc = [], $51da786a5efa83c1$var$Lc = null, $51da786a5efa83c1$var$Mc = null, $51da786a5efa83c1$var$Nc = null, $51da786a5efa83c1$var$Oc = new Map, $51da786a5efa83c1$var$Pc = new Map, $51da786a5efa83c1$var$Qc = [], $51da786a5efa83c1$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $51da786a5efa83c1$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $51da786a5efa83c1$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $51da786a5efa83c1$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $51da786a5efa83c1$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $51da786a5efa83c1$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $51da786a5efa83c1$var$Pc.delete(b.pointerId);
    }
}
function $51da786a5efa83c1$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $51da786a5efa83c1$var$Cb(b), null !== b && $51da786a5efa83c1$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $51da786a5efa83c1$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $51da786a5efa83c1$var$Lc = $51da786a5efa83c1$var$Tc($51da786a5efa83c1$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $51da786a5efa83c1$var$Mc = $51da786a5efa83c1$var$Tc($51da786a5efa83c1$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $51da786a5efa83c1$var$Nc = $51da786a5efa83c1$var$Tc($51da786a5efa83c1$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $51da786a5efa83c1$var$Oc.set(f, $51da786a5efa83c1$var$Tc($51da786a5efa83c1$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $51da786a5efa83c1$var$Pc.set(f, $51da786a5efa83c1$var$Tc($51da786a5efa83c1$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $51da786a5efa83c1$var$Vc(a) {
    var b = $51da786a5efa83c1$var$Wc(a.target);
    if (null !== b) {
        var c = $51da786a5efa83c1$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $51da786a5efa83c1$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $51da786a5efa83c1$var$Ic(a.priority, function() {
                        $51da786a5efa83c1$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $51da786a5efa83c1$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $51da786a5efa83c1$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $51da786a5efa83c1$var$wb = d;
            c.target.dispatchEvent(d);
            $51da786a5efa83c1$var$wb = null;
        } else return b = $51da786a5efa83c1$var$Cb(c), null !== b && $51da786a5efa83c1$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $51da786a5efa83c1$var$Zc(a, b, c) {
    $51da786a5efa83c1$var$Xc(a) && c.delete(b);
}
function $51da786a5efa83c1$var$$c() {
    $51da786a5efa83c1$var$Jc = !1;
    null !== $51da786a5efa83c1$var$Lc && $51da786a5efa83c1$var$Xc($51da786a5efa83c1$var$Lc) && ($51da786a5efa83c1$var$Lc = null);
    null !== $51da786a5efa83c1$var$Mc && $51da786a5efa83c1$var$Xc($51da786a5efa83c1$var$Mc) && ($51da786a5efa83c1$var$Mc = null);
    null !== $51da786a5efa83c1$var$Nc && $51da786a5efa83c1$var$Xc($51da786a5efa83c1$var$Nc) && ($51da786a5efa83c1$var$Nc = null);
    $51da786a5efa83c1$var$Oc.forEach($51da786a5efa83c1$var$Zc);
    $51da786a5efa83c1$var$Pc.forEach($51da786a5efa83c1$var$Zc);
}
function $51da786a5efa83c1$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $51da786a5efa83c1$var$Jc || ($51da786a5efa83c1$var$Jc = !0, $dVdJZ.unstable_scheduleCallback($dVdJZ.unstable_NormalPriority, $51da786a5efa83c1$var$$c)));
}
function $51da786a5efa83c1$var$bd(a) {
    function b(b) {
        return $51da786a5efa83c1$var$ad(b, a);
    }
    if (0 < $51da786a5efa83c1$var$Kc.length) {
        $51da786a5efa83c1$var$ad($51da786a5efa83c1$var$Kc[0], a);
        for(var c = 1; c < $51da786a5efa83c1$var$Kc.length; c++){
            var d = $51da786a5efa83c1$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $51da786a5efa83c1$var$Lc && $51da786a5efa83c1$var$ad($51da786a5efa83c1$var$Lc, a);
    null !== $51da786a5efa83c1$var$Mc && $51da786a5efa83c1$var$ad($51da786a5efa83c1$var$Mc, a);
    null !== $51da786a5efa83c1$var$Nc && $51da786a5efa83c1$var$ad($51da786a5efa83c1$var$Nc, a);
    $51da786a5efa83c1$var$Oc.forEach(b);
    $51da786a5efa83c1$var$Pc.forEach(b);
    for(c = 0; c < $51da786a5efa83c1$var$Qc.length; c++)d = $51da786a5efa83c1$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $51da786a5efa83c1$var$Qc.length && (c = $51da786a5efa83c1$var$Qc[0], null === c.blockedOn);)$51da786a5efa83c1$var$Vc(c), null === c.blockedOn && $51da786a5efa83c1$var$Qc.shift();
}
var $51da786a5efa83c1$var$cd = $51da786a5efa83c1$var$ua.ReactCurrentBatchConfig, $51da786a5efa83c1$var$dd = !0;
function $51da786a5efa83c1$var$ed(a, b, c, d) {
    var e = $51da786a5efa83c1$var$C, f = $51da786a5efa83c1$var$cd.transition;
    $51da786a5efa83c1$var$cd.transition = null;
    try {
        $51da786a5efa83c1$var$C = 1, $51da786a5efa83c1$var$fd(a, b, c, d);
    } finally{
        $51da786a5efa83c1$var$C = e, $51da786a5efa83c1$var$cd.transition = f;
    }
}
function $51da786a5efa83c1$var$gd(a, b, c, d) {
    var e = $51da786a5efa83c1$var$C, f = $51da786a5efa83c1$var$cd.transition;
    $51da786a5efa83c1$var$cd.transition = null;
    try {
        $51da786a5efa83c1$var$C = 4, $51da786a5efa83c1$var$fd(a, b, c, d);
    } finally{
        $51da786a5efa83c1$var$C = e, $51da786a5efa83c1$var$cd.transition = f;
    }
}
function $51da786a5efa83c1$var$fd(a, b, c, d) {
    if ($51da786a5efa83c1$var$dd) {
        var e = $51da786a5efa83c1$var$Yc(a, b, c, d);
        if (null === e) $51da786a5efa83c1$var$hd(a, b, d, $51da786a5efa83c1$var$id, c), $51da786a5efa83c1$var$Sc(a, d);
        else if ($51da786a5efa83c1$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($51da786a5efa83c1$var$Sc(a, d), b & 4 && -1 < $51da786a5efa83c1$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $51da786a5efa83c1$var$Cb(e);
                null !== f && $51da786a5efa83c1$var$Ec(f);
                f = $51da786a5efa83c1$var$Yc(a, b, c, d);
                null === f && $51da786a5efa83c1$var$hd(a, b, d, $51da786a5efa83c1$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $51da786a5efa83c1$var$hd(a, b, d, null, c);
    }
}
var $51da786a5efa83c1$var$id = null;
function $51da786a5efa83c1$var$Yc(a, b, c, d) {
    $51da786a5efa83c1$var$id = null;
    a = $51da786a5efa83c1$var$xb(d);
    a = $51da786a5efa83c1$var$Wc(a);
    if (null !== a) {
        if (b = $51da786a5efa83c1$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $51da786a5efa83c1$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $51da786a5efa83c1$var$id = a;
    return null;
}
function $51da786a5efa83c1$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($51da786a5efa83c1$var$ec()){
                case $51da786a5efa83c1$var$fc:
                    return 1;
                case $51da786a5efa83c1$var$gc:
                    return 4;
                case $51da786a5efa83c1$var$hc:
                case $51da786a5efa83c1$var$ic:
                    return 16;
                case $51da786a5efa83c1$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $51da786a5efa83c1$var$kd = null, $51da786a5efa83c1$var$ld = null, $51da786a5efa83c1$var$md = null;
function $51da786a5efa83c1$var$nd() {
    if ($51da786a5efa83c1$var$md) return $51da786a5efa83c1$var$md;
    var a, b = $51da786a5efa83c1$var$ld, c = b.length, d, e = "value" in $51da786a5efa83c1$var$kd ? $51da786a5efa83c1$var$kd.value : $51da786a5efa83c1$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $51da786a5efa83c1$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $51da786a5efa83c1$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $51da786a5efa83c1$var$pd() {
    return !0;
}
function $51da786a5efa83c1$var$qd() {
    return !1;
}
function $51da786a5efa83c1$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $51da786a5efa83c1$var$pd : $51da786a5efa83c1$var$qd;
        this.isPropagationStopped = $51da786a5efa83c1$var$qd;
        return this;
    }
    $51da786a5efa83c1$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $51da786a5efa83c1$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $51da786a5efa83c1$var$pd);
        },
        persist: function() {},
        isPersistent: $51da786a5efa83c1$var$pd
    });
    return b;
}
var $51da786a5efa83c1$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $51da786a5efa83c1$var$td = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$sd), $51da786a5efa83c1$var$ud = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$sd, {
    view: 0,
    detail: 0
}), $51da786a5efa83c1$var$vd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$ud), $51da786a5efa83c1$var$wd, $51da786a5efa83c1$var$xd, $51da786a5efa83c1$var$yd, $51da786a5efa83c1$var$Ad = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $51da786a5efa83c1$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $51da786a5efa83c1$var$yd && ($51da786a5efa83c1$var$yd && "mousemove" === a.type ? ($51da786a5efa83c1$var$wd = a.screenX - $51da786a5efa83c1$var$yd.screenX, $51da786a5efa83c1$var$xd = a.screenY - $51da786a5efa83c1$var$yd.screenY) : $51da786a5efa83c1$var$xd = $51da786a5efa83c1$var$wd = 0, $51da786a5efa83c1$var$yd = a);
        return $51da786a5efa83c1$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $51da786a5efa83c1$var$xd;
    }
}), $51da786a5efa83c1$var$Bd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Ad), $51da786a5efa83c1$var$Cd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$Ad, {
    dataTransfer: 0
}), $51da786a5efa83c1$var$Dd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Cd), $51da786a5efa83c1$var$Ed = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$ud, {
    relatedTarget: 0
}), $51da786a5efa83c1$var$Fd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Ed), $51da786a5efa83c1$var$Gd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $51da786a5efa83c1$var$Hd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Gd), $51da786a5efa83c1$var$Id = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $51da786a5efa83c1$var$Jd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Id), $51da786a5efa83c1$var$Kd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$sd, {
    data: 0
}), $51da786a5efa83c1$var$Ld = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Kd), $51da786a5efa83c1$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $51da786a5efa83c1$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $51da786a5efa83c1$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $51da786a5efa83c1$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $51da786a5efa83c1$var$Od[a]) ? !!b[a] : !1;
}
function $51da786a5efa83c1$var$zd() {
    return $51da786a5efa83c1$var$Pd;
}
var $51da786a5efa83c1$var$Qd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $51da786a5efa83c1$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $51da786a5efa83c1$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $51da786a5efa83c1$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $51da786a5efa83c1$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $51da786a5efa83c1$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $51da786a5efa83c1$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $51da786a5efa83c1$var$Rd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Qd), $51da786a5efa83c1$var$Sd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $51da786a5efa83c1$var$Td = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Sd), $51da786a5efa83c1$var$Ud = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $51da786a5efa83c1$var$zd
}), $51da786a5efa83c1$var$Vd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Ud), $51da786a5efa83c1$var$Wd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $51da786a5efa83c1$var$Xd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Wd), $51da786a5efa83c1$var$Yd = $51da786a5efa83c1$var$A({}, $51da786a5efa83c1$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $51da786a5efa83c1$var$Zd = $51da786a5efa83c1$var$rd($51da786a5efa83c1$var$Yd), $51da786a5efa83c1$var$$d = [
    9,
    13,
    27,
    32
], $51da786a5efa83c1$var$ae = $51da786a5efa83c1$var$ia && "CompositionEvent" in window, $51da786a5efa83c1$var$be = null;
$51da786a5efa83c1$var$ia && "documentMode" in document && ($51da786a5efa83c1$var$be = document.documentMode);
var $51da786a5efa83c1$var$ce = $51da786a5efa83c1$var$ia && "TextEvent" in window && !$51da786a5efa83c1$var$be, $51da786a5efa83c1$var$de = $51da786a5efa83c1$var$ia && (!$51da786a5efa83c1$var$ae || $51da786a5efa83c1$var$be && 8 < $51da786a5efa83c1$var$be && 11 >= $51da786a5efa83c1$var$be), $51da786a5efa83c1$var$ee = String.fromCharCode(32), $51da786a5efa83c1$var$fe = !1;
function $51da786a5efa83c1$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $51da786a5efa83c1$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $51da786a5efa83c1$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $51da786a5efa83c1$var$ie = !1;
function $51da786a5efa83c1$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $51da786a5efa83c1$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $51da786a5efa83c1$var$fe = !0;
            return $51da786a5efa83c1$var$ee;
        case "textInput":
            return a = b.data, a === $51da786a5efa83c1$var$ee && $51da786a5efa83c1$var$fe ? null : a;
        default:
            return null;
    }
}
function $51da786a5efa83c1$var$ke(a, b) {
    if ($51da786a5efa83c1$var$ie) return "compositionend" === a || !$51da786a5efa83c1$var$ae && $51da786a5efa83c1$var$ge(a, b) ? (a = $51da786a5efa83c1$var$nd(), $51da786a5efa83c1$var$md = $51da786a5efa83c1$var$ld = $51da786a5efa83c1$var$kd = null, $51da786a5efa83c1$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $51da786a5efa83c1$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $51da786a5efa83c1$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $51da786a5efa83c1$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$51da786a5efa83c1$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $51da786a5efa83c1$var$ne(a, b, c, d) {
    $51da786a5efa83c1$var$Eb(d);
    b = $51da786a5efa83c1$var$oe(b, "onChange");
    0 < b.length && (c = new $51da786a5efa83c1$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $51da786a5efa83c1$var$pe = null, $51da786a5efa83c1$var$qe = null;
function $51da786a5efa83c1$var$re(a) {
    $51da786a5efa83c1$var$se(a, 0);
}
function $51da786a5efa83c1$var$te(a) {
    var b = $51da786a5efa83c1$var$ue(a);
    if ($51da786a5efa83c1$var$Wa(b)) return a;
}
function $51da786a5efa83c1$var$ve(a, b) {
    if ("change" === a) return b;
}
var $51da786a5efa83c1$var$we = !1;
if ($51da786a5efa83c1$var$ia) {
    var $51da786a5efa83c1$var$xe;
    if ($51da786a5efa83c1$var$ia) {
        var $51da786a5efa83c1$var$ye = "oninput" in document;
        if (!$51da786a5efa83c1$var$ye) {
            var $51da786a5efa83c1$var$ze = document.createElement("div");
            $51da786a5efa83c1$var$ze.setAttribute("oninput", "return;");
            $51da786a5efa83c1$var$ye = "function" === typeof $51da786a5efa83c1$var$ze.oninput;
        }
        $51da786a5efa83c1$var$xe = $51da786a5efa83c1$var$ye;
    } else $51da786a5efa83c1$var$xe = !1;
    $51da786a5efa83c1$var$we = $51da786a5efa83c1$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $51da786a5efa83c1$var$Ae() {
    $51da786a5efa83c1$var$pe && ($51da786a5efa83c1$var$pe.detachEvent("onpropertychange", $51da786a5efa83c1$var$Be), $51da786a5efa83c1$var$qe = $51da786a5efa83c1$var$pe = null);
}
function $51da786a5efa83c1$var$Be(a) {
    if ("value" === a.propertyName && $51da786a5efa83c1$var$te($51da786a5efa83c1$var$qe)) {
        var b = [];
        $51da786a5efa83c1$var$ne(b, $51da786a5efa83c1$var$qe, a, $51da786a5efa83c1$var$xb(a));
        $51da786a5efa83c1$var$Jb($51da786a5efa83c1$var$re, b);
    }
}
function $51da786a5efa83c1$var$Ce(a, b, c) {
    "focusin" === a ? ($51da786a5efa83c1$var$Ae(), $51da786a5efa83c1$var$pe = b, $51da786a5efa83c1$var$qe = c, $51da786a5efa83c1$var$pe.attachEvent("onpropertychange", $51da786a5efa83c1$var$Be)) : "focusout" === a && $51da786a5efa83c1$var$Ae();
}
function $51da786a5efa83c1$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $51da786a5efa83c1$var$te($51da786a5efa83c1$var$qe);
}
function $51da786a5efa83c1$var$Ee(a, b) {
    if ("click" === a) return $51da786a5efa83c1$var$te(b);
}
function $51da786a5efa83c1$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $51da786a5efa83c1$var$te(b);
}
function $51da786a5efa83c1$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $51da786a5efa83c1$var$He = "function" === typeof Object.is ? Object.is : $51da786a5efa83c1$var$Ge;
function $51da786a5efa83c1$var$Ie(a, b) {
    if ($51da786a5efa83c1$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$51da786a5efa83c1$var$ja.call(b, e) || !$51da786a5efa83c1$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $51da786a5efa83c1$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $51da786a5efa83c1$var$Ke(a, b) {
    var c = $51da786a5efa83c1$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $51da786a5efa83c1$var$Je(c);
    }
}
function $51da786a5efa83c1$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $51da786a5efa83c1$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $51da786a5efa83c1$var$Me() {
    for(var a = window, b = $51da786a5efa83c1$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $51da786a5efa83c1$var$Xa(a.document);
    }
    return b;
}
function $51da786a5efa83c1$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $51da786a5efa83c1$var$Oe(a) {
    var b = $51da786a5efa83c1$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $51da786a5efa83c1$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $51da786a5efa83c1$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $51da786a5efa83c1$var$Ke(c, f);
                var g = $51da786a5efa83c1$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $51da786a5efa83c1$var$Pe = $51da786a5efa83c1$var$ia && "documentMode" in document && 11 >= document.documentMode, $51da786a5efa83c1$var$Qe = null, $51da786a5efa83c1$var$Re = null, $51da786a5efa83c1$var$Se = null, $51da786a5efa83c1$var$Te = !1;
function $51da786a5efa83c1$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $51da786a5efa83c1$var$Te || null == $51da786a5efa83c1$var$Qe || $51da786a5efa83c1$var$Qe !== $51da786a5efa83c1$var$Xa(d) || (d = $51da786a5efa83c1$var$Qe, "selectionStart" in d && $51da786a5efa83c1$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $51da786a5efa83c1$var$Se && $51da786a5efa83c1$var$Ie($51da786a5efa83c1$var$Se, d) || ($51da786a5efa83c1$var$Se = d, d = $51da786a5efa83c1$var$oe($51da786a5efa83c1$var$Re, "onSelect"), 0 < d.length && (b = new $51da786a5efa83c1$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $51da786a5efa83c1$var$Qe)));
}
function $51da786a5efa83c1$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $51da786a5efa83c1$var$We = {
    animationend: $51da786a5efa83c1$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $51da786a5efa83c1$var$Ve("Animation", "AnimationIteration"),
    animationstart: $51da786a5efa83c1$var$Ve("Animation", "AnimationStart"),
    transitionend: $51da786a5efa83c1$var$Ve("Transition", "TransitionEnd")
}, $51da786a5efa83c1$var$Xe = {}, $51da786a5efa83c1$var$Ye = {};
$51da786a5efa83c1$var$ia && ($51da786a5efa83c1$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $51da786a5efa83c1$var$We.animationend.animation, delete $51da786a5efa83c1$var$We.animationiteration.animation, delete $51da786a5efa83c1$var$We.animationstart.animation), "TransitionEvent" in window || delete $51da786a5efa83c1$var$We.transitionend.transition);
function $51da786a5efa83c1$var$Ze(a) {
    if ($51da786a5efa83c1$var$Xe[a]) return $51da786a5efa83c1$var$Xe[a];
    if (!$51da786a5efa83c1$var$We[a]) return a;
    var b = $51da786a5efa83c1$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $51da786a5efa83c1$var$Ye) return $51da786a5efa83c1$var$Xe[a] = b[c];
    return a;
}
var $51da786a5efa83c1$var$$e = $51da786a5efa83c1$var$Ze("animationend"), $51da786a5efa83c1$var$af = $51da786a5efa83c1$var$Ze("animationiteration"), $51da786a5efa83c1$var$bf = $51da786a5efa83c1$var$Ze("animationstart"), $51da786a5efa83c1$var$cf = $51da786a5efa83c1$var$Ze("transitionend"), $51da786a5efa83c1$var$df = new Map, $51da786a5efa83c1$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $51da786a5efa83c1$var$ff(a, b) {
    $51da786a5efa83c1$var$df.set(a, b);
    $51da786a5efa83c1$var$fa(b, [
        a
    ]);
}
for(var $51da786a5efa83c1$var$gf = 0; $51da786a5efa83c1$var$gf < $51da786a5efa83c1$var$ef.length; $51da786a5efa83c1$var$gf++){
    var $51da786a5efa83c1$var$hf = $51da786a5efa83c1$var$ef[$51da786a5efa83c1$var$gf], $51da786a5efa83c1$var$jf = $51da786a5efa83c1$var$hf.toLowerCase(), $51da786a5efa83c1$var$kf = $51da786a5efa83c1$var$hf[0].toUpperCase() + $51da786a5efa83c1$var$hf.slice(1);
    $51da786a5efa83c1$var$ff($51da786a5efa83c1$var$jf, "on" + $51da786a5efa83c1$var$kf);
}
$51da786a5efa83c1$var$ff($51da786a5efa83c1$var$$e, "onAnimationEnd");
$51da786a5efa83c1$var$ff($51da786a5efa83c1$var$af, "onAnimationIteration");
$51da786a5efa83c1$var$ff($51da786a5efa83c1$var$bf, "onAnimationStart");
$51da786a5efa83c1$var$ff("dblclick", "onDoubleClick");
$51da786a5efa83c1$var$ff("focusin", "onFocus");
$51da786a5efa83c1$var$ff("focusout", "onBlur");
$51da786a5efa83c1$var$ff($51da786a5efa83c1$var$cf, "onTransitionEnd");
$51da786a5efa83c1$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$51da786a5efa83c1$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$51da786a5efa83c1$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$51da786a5efa83c1$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$51da786a5efa83c1$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$51da786a5efa83c1$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$51da786a5efa83c1$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$51da786a5efa83c1$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$51da786a5efa83c1$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$51da786a5efa83c1$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $51da786a5efa83c1$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $51da786a5efa83c1$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($51da786a5efa83c1$var$lf));
function $51da786a5efa83c1$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $51da786a5efa83c1$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $51da786a5efa83c1$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $51da786a5efa83c1$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $51da786a5efa83c1$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($51da786a5efa83c1$var$Qb) throw a = $51da786a5efa83c1$var$Rb, $51da786a5efa83c1$var$Qb = !1, $51da786a5efa83c1$var$Rb = null, a;
}
function $51da786a5efa83c1$var$D(a, b) {
    var c = b[$51da786a5efa83c1$var$of];
    void 0 === c && (c = b[$51da786a5efa83c1$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($51da786a5efa83c1$var$pf(b, a, 2, !1), c.add(d));
}
function $51da786a5efa83c1$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $51da786a5efa83c1$var$pf(c, a, d, b);
}
var $51da786a5efa83c1$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $51da786a5efa83c1$var$sf(a) {
    if (!a[$51da786a5efa83c1$var$rf]) {
        a[$51da786a5efa83c1$var$rf] = !0;
        $51da786a5efa83c1$var$da.forEach(function(b) {
            "selectionchange" !== b && ($51da786a5efa83c1$var$mf.has(b) || $51da786a5efa83c1$var$qf(b, !1, a), $51da786a5efa83c1$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$51da786a5efa83c1$var$rf] || (b[$51da786a5efa83c1$var$rf] = !0, $51da786a5efa83c1$var$qf("selectionchange", !1, b));
    }
}
function $51da786a5efa83c1$var$pf(a, b, c, d) {
    switch($51da786a5efa83c1$var$jd(b)){
        case 1:
            var e = $51da786a5efa83c1$var$ed;
            break;
        case 4:
            e = $51da786a5efa83c1$var$gd;
            break;
        default:
            e = $51da786a5efa83c1$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$51da786a5efa83c1$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $51da786a5efa83c1$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $51da786a5efa83c1$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $51da786a5efa83c1$var$Jb(function() {
        var d = f, e = $51da786a5efa83c1$var$xb(c), g = [];
        a: {
            var h = $51da786a5efa83c1$var$df.get(a);
            if (void 0 !== h) {
                var k = $51da786a5efa83c1$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $51da786a5efa83c1$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $51da786a5efa83c1$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $51da786a5efa83c1$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $51da786a5efa83c1$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $51da786a5efa83c1$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $51da786a5efa83c1$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $51da786a5efa83c1$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $51da786a5efa83c1$var$Vd;
                        break;
                    case $51da786a5efa83c1$var$$e:
                    case $51da786a5efa83c1$var$af:
                    case $51da786a5efa83c1$var$bf:
                        k = $51da786a5efa83c1$var$Hd;
                        break;
                    case $51da786a5efa83c1$var$cf:
                        k = $51da786a5efa83c1$var$Xd;
                        break;
                    case "scroll":
                        k = $51da786a5efa83c1$var$vd;
                        break;
                    case "wheel":
                        k = $51da786a5efa83c1$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $51da786a5efa83c1$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $51da786a5efa83c1$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $51da786a5efa83c1$var$Kb(w, x), null != F && t.push($51da786a5efa83c1$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $51da786a5efa83c1$var$wb && (n = c.relatedTarget || c.fromElement) && ($51da786a5efa83c1$var$Wc(n) || n[$51da786a5efa83c1$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $51da786a5efa83c1$var$Wc(n) : null, null !== n && (J = $51da786a5efa83c1$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $51da786a5efa83c1$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $51da786a5efa83c1$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $51da786a5efa83c1$var$ue(k);
                        u = null == n ? h : $51da786a5efa83c1$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $51da786a5efa83c1$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $51da786a5efa83c1$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $51da786a5efa83c1$var$vf(F))u++;
                            for(; 0 < w - u;)t = $51da786a5efa83c1$var$vf(t), w--;
                            for(; 0 < u - w;)x = $51da786a5efa83c1$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $51da786a5efa83c1$var$vf(t);
                                x = $51da786a5efa83c1$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $51da786a5efa83c1$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $51da786a5efa83c1$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $51da786a5efa83c1$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $51da786a5efa83c1$var$ve;
                else if ($51da786a5efa83c1$var$me(h)) {
                    if ($51da786a5efa83c1$var$we) na = $51da786a5efa83c1$var$Fe;
                    else {
                        na = $51da786a5efa83c1$var$De;
                        var xa = $51da786a5efa83c1$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $51da786a5efa83c1$var$Ee);
                if (na && (na = na(a, d))) {
                    $51da786a5efa83c1$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $51da786a5efa83c1$var$cb(h, "number", h.value);
            }
            xa = d ? $51da786a5efa83c1$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($51da786a5efa83c1$var$me(xa) || "true" === xa.contentEditable) $51da786a5efa83c1$var$Qe = xa, $51da786a5efa83c1$var$Re = d, $51da786a5efa83c1$var$Se = null;
                    break;
                case "focusout":
                    $51da786a5efa83c1$var$Se = $51da786a5efa83c1$var$Re = $51da786a5efa83c1$var$Qe = null;
                    break;
                case "mousedown":
                    $51da786a5efa83c1$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $51da786a5efa83c1$var$Te = !1;
                    $51da786a5efa83c1$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($51da786a5efa83c1$var$Pe) break;
                case "keydown":
                case "keyup":
                    $51da786a5efa83c1$var$Ue(g, c, e);
            }
            var $a;
            if ($51da786a5efa83c1$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $51da786a5efa83c1$var$ie ? $51da786a5efa83c1$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($51da786a5efa83c1$var$de && "ko" !== c.locale && ($51da786a5efa83c1$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $51da786a5efa83c1$var$ie && ($a = $51da786a5efa83c1$var$nd()) : ($51da786a5efa83c1$var$kd = e, $51da786a5efa83c1$var$ld = "value" in $51da786a5efa83c1$var$kd ? $51da786a5efa83c1$var$kd.value : $51da786a5efa83c1$var$kd.textContent, $51da786a5efa83c1$var$ie = !0)), xa = $51da786a5efa83c1$var$oe(d, ba), 0 < xa.length && (ba = new $51da786a5efa83c1$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $51da786a5efa83c1$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $51da786a5efa83c1$var$ce ? $51da786a5efa83c1$var$je(a, c) : $51da786a5efa83c1$var$ke(a, c)) d = $51da786a5efa83c1$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $51da786a5efa83c1$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $51da786a5efa83c1$var$se(g, b);
    });
}
function $51da786a5efa83c1$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $51da786a5efa83c1$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $51da786a5efa83c1$var$Kb(a, c), null != f && d.unshift($51da786a5efa83c1$var$tf(a, f, e)), f = $51da786a5efa83c1$var$Kb(a, b), null != f && d.push($51da786a5efa83c1$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $51da786a5efa83c1$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $51da786a5efa83c1$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $51da786a5efa83c1$var$Kb(c, f), null != k && g.unshift($51da786a5efa83c1$var$tf(c, k, h))) : e || (k = $51da786a5efa83c1$var$Kb(c, f), null != k && g.push($51da786a5efa83c1$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $51da786a5efa83c1$var$xf = /\r\n?/g, $51da786a5efa83c1$var$yf = /\u0000|\uFFFD/g;
function $51da786a5efa83c1$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($51da786a5efa83c1$var$xf, "\n").replace($51da786a5efa83c1$var$yf, "");
}
function $51da786a5efa83c1$var$Af(a, b, c) {
    b = $51da786a5efa83c1$var$zf(b);
    if ($51da786a5efa83c1$var$zf(a) !== b && c) throw Error($51da786a5efa83c1$var$p(425));
}
function $51da786a5efa83c1$var$Bf() {}
var $51da786a5efa83c1$var$Cf = null, $51da786a5efa83c1$var$Df = null;
function $51da786a5efa83c1$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $51da786a5efa83c1$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $51da786a5efa83c1$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $51da786a5efa83c1$var$Hf = "function" === typeof Promise ? Promise : void 0, $51da786a5efa83c1$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $51da786a5efa83c1$var$Hf ? function(a) {
    return $51da786a5efa83c1$var$Hf.resolve(null).then(a).catch($51da786a5efa83c1$var$If);
} : $51da786a5efa83c1$var$Ff;
function $51da786a5efa83c1$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $51da786a5efa83c1$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $51da786a5efa83c1$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $51da786a5efa83c1$var$bd(b);
}
function $51da786a5efa83c1$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $51da786a5efa83c1$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $51da786a5efa83c1$var$Nf = Math.random().toString(36).slice(2), $51da786a5efa83c1$var$Of = "__reactFiber$" + $51da786a5efa83c1$var$Nf, $51da786a5efa83c1$var$Pf = "__reactProps$" + $51da786a5efa83c1$var$Nf, $51da786a5efa83c1$var$uf = "__reactContainer$" + $51da786a5efa83c1$var$Nf, $51da786a5efa83c1$var$of = "__reactEvents$" + $51da786a5efa83c1$var$Nf, $51da786a5efa83c1$var$Qf = "__reactListeners$" + $51da786a5efa83c1$var$Nf, $51da786a5efa83c1$var$Rf = "__reactHandles$" + $51da786a5efa83c1$var$Nf;
function $51da786a5efa83c1$var$Wc(a) {
    var b = a[$51da786a5efa83c1$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$51da786a5efa83c1$var$uf] || c[$51da786a5efa83c1$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $51da786a5efa83c1$var$Mf(a); null !== a;){
                if (c = a[$51da786a5efa83c1$var$Of]) return c;
                a = $51da786a5efa83c1$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $51da786a5efa83c1$var$Cb(a) {
    a = a[$51da786a5efa83c1$var$Of] || a[$51da786a5efa83c1$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $51da786a5efa83c1$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($51da786a5efa83c1$var$p(33));
}
function $51da786a5efa83c1$var$Db(a) {
    return a[$51da786a5efa83c1$var$Pf] || null;
}
var $51da786a5efa83c1$var$Sf = [], $51da786a5efa83c1$var$Tf = -1;
function $51da786a5efa83c1$var$Uf(a) {
    return {
        current: a
    };
}
function $51da786a5efa83c1$var$E(a) {
    0 > $51da786a5efa83c1$var$Tf || (a.current = $51da786a5efa83c1$var$Sf[$51da786a5efa83c1$var$Tf], $51da786a5efa83c1$var$Sf[$51da786a5efa83c1$var$Tf] = null, $51da786a5efa83c1$var$Tf--);
}
function $51da786a5efa83c1$var$G(a, b) {
    $51da786a5efa83c1$var$Tf++;
    $51da786a5efa83c1$var$Sf[$51da786a5efa83c1$var$Tf] = a.current;
    a.current = b;
}
var $51da786a5efa83c1$var$Vf = {}, $51da786a5efa83c1$var$H = $51da786a5efa83c1$var$Uf($51da786a5efa83c1$var$Vf), $51da786a5efa83c1$var$Wf = $51da786a5efa83c1$var$Uf(!1), $51da786a5efa83c1$var$Xf = $51da786a5efa83c1$var$Vf;
function $51da786a5efa83c1$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $51da786a5efa83c1$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $51da786a5efa83c1$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $51da786a5efa83c1$var$$f() {
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wf);
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$H);
}
function $51da786a5efa83c1$var$ag(a, b, c) {
    if ($51da786a5efa83c1$var$H.current !== $51da786a5efa83c1$var$Vf) throw Error($51da786a5efa83c1$var$p(168));
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$H, b);
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$Wf, c);
}
function $51da786a5efa83c1$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($51da786a5efa83c1$var$p(108, $51da786a5efa83c1$var$Ra(a) || "Unknown", e));
    return $51da786a5efa83c1$var$A({}, c, d);
}
function $51da786a5efa83c1$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $51da786a5efa83c1$var$Vf;
    $51da786a5efa83c1$var$Xf = $51da786a5efa83c1$var$H.current;
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$H, a);
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$Wf, $51da786a5efa83c1$var$Wf.current);
    return !0;
}
function $51da786a5efa83c1$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($51da786a5efa83c1$var$p(169));
    c ? (a = $51da786a5efa83c1$var$bg(a, b, $51da786a5efa83c1$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wf), $51da786a5efa83c1$var$E($51da786a5efa83c1$var$H), $51da786a5efa83c1$var$G($51da786a5efa83c1$var$H, a)) : $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wf);
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$Wf, c);
}
var $51da786a5efa83c1$var$eg = null, $51da786a5efa83c1$var$fg = !1, $51da786a5efa83c1$var$gg = !1;
function $51da786a5efa83c1$var$hg(a) {
    null === $51da786a5efa83c1$var$eg ? $51da786a5efa83c1$var$eg = [
        a
    ] : $51da786a5efa83c1$var$eg.push(a);
}
function $51da786a5efa83c1$var$ig(a) {
    $51da786a5efa83c1$var$fg = !0;
    $51da786a5efa83c1$var$hg(a);
}
function $51da786a5efa83c1$var$jg() {
    if (!$51da786a5efa83c1$var$gg && null !== $51da786a5efa83c1$var$eg) {
        $51da786a5efa83c1$var$gg = !0;
        var a = 0, b = $51da786a5efa83c1$var$C;
        try {
            var c = $51da786a5efa83c1$var$eg;
            for($51da786a5efa83c1$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $51da786a5efa83c1$var$eg = null;
            $51da786a5efa83c1$var$fg = !1;
        } catch (e) {
            throw null !== $51da786a5efa83c1$var$eg && ($51da786a5efa83c1$var$eg = $51da786a5efa83c1$var$eg.slice(a + 1)), $51da786a5efa83c1$var$ac($51da786a5efa83c1$var$fc, $51da786a5efa83c1$var$jg), e;
        } finally{
            $51da786a5efa83c1$var$C = b, $51da786a5efa83c1$var$gg = !1;
        }
    }
    return null;
}
var $51da786a5efa83c1$var$kg = [], $51da786a5efa83c1$var$lg = 0, $51da786a5efa83c1$var$mg = null, $51da786a5efa83c1$var$ng = 0, $51da786a5efa83c1$var$og = [], $51da786a5efa83c1$var$pg = 0, $51da786a5efa83c1$var$qg = null, $51da786a5efa83c1$var$rg = 1, $51da786a5efa83c1$var$sg = "";
function $51da786a5efa83c1$var$tg(a, b) {
    $51da786a5efa83c1$var$kg[$51da786a5efa83c1$var$lg++] = $51da786a5efa83c1$var$ng;
    $51da786a5efa83c1$var$kg[$51da786a5efa83c1$var$lg++] = $51da786a5efa83c1$var$mg;
    $51da786a5efa83c1$var$mg = a;
    $51da786a5efa83c1$var$ng = b;
}
function $51da786a5efa83c1$var$ug(a, b, c) {
    $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg++] = $51da786a5efa83c1$var$rg;
    $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg++] = $51da786a5efa83c1$var$sg;
    $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg++] = $51da786a5efa83c1$var$qg;
    $51da786a5efa83c1$var$qg = a;
    var d = $51da786a5efa83c1$var$rg;
    a = $51da786a5efa83c1$var$sg;
    var e = 32 - $51da786a5efa83c1$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $51da786a5efa83c1$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $51da786a5efa83c1$var$rg = 1 << 32 - $51da786a5efa83c1$var$oc(b) + e | c << e | d;
        $51da786a5efa83c1$var$sg = f + a;
    } else $51da786a5efa83c1$var$rg = 1 << f | c << e | d, $51da786a5efa83c1$var$sg = a;
}
function $51da786a5efa83c1$var$vg(a) {
    null !== a.return && ($51da786a5efa83c1$var$tg(a, 1), $51da786a5efa83c1$var$ug(a, 1, 0));
}
function $51da786a5efa83c1$var$wg(a) {
    for(; a === $51da786a5efa83c1$var$mg;)$51da786a5efa83c1$var$mg = $51da786a5efa83c1$var$kg[--$51da786a5efa83c1$var$lg], $51da786a5efa83c1$var$kg[$51da786a5efa83c1$var$lg] = null, $51da786a5efa83c1$var$ng = $51da786a5efa83c1$var$kg[--$51da786a5efa83c1$var$lg], $51da786a5efa83c1$var$kg[$51da786a5efa83c1$var$lg] = null;
    for(; a === $51da786a5efa83c1$var$qg;)$51da786a5efa83c1$var$qg = $51da786a5efa83c1$var$og[--$51da786a5efa83c1$var$pg], $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg] = null, $51da786a5efa83c1$var$sg = $51da786a5efa83c1$var$og[--$51da786a5efa83c1$var$pg], $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg] = null, $51da786a5efa83c1$var$rg = $51da786a5efa83c1$var$og[--$51da786a5efa83c1$var$pg], $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg] = null;
}
var $51da786a5efa83c1$var$xg = null, $51da786a5efa83c1$var$yg = null, $51da786a5efa83c1$var$I = !1, $51da786a5efa83c1$var$zg = null;
function $51da786a5efa83c1$var$Ag(a, b) {
    var c = $51da786a5efa83c1$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $51da786a5efa83c1$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $51da786a5efa83c1$var$xg = a, $51da786a5efa83c1$var$yg = $51da786a5efa83c1$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $51da786a5efa83c1$var$xg = a, $51da786a5efa83c1$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $51da786a5efa83c1$var$qg ? {
                id: $51da786a5efa83c1$var$rg,
                overflow: $51da786a5efa83c1$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $51da786a5efa83c1$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $51da786a5efa83c1$var$xg = a, $51da786a5efa83c1$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $51da786a5efa83c1$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $51da786a5efa83c1$var$Eg(a) {
    if ($51da786a5efa83c1$var$I) {
        var b = $51da786a5efa83c1$var$yg;
        if (b) {
            var c = b;
            if (!$51da786a5efa83c1$var$Cg(a, b)) {
                if ($51da786a5efa83c1$var$Dg(a)) throw Error($51da786a5efa83c1$var$p(418));
                b = $51da786a5efa83c1$var$Lf(c.nextSibling);
                var d = $51da786a5efa83c1$var$xg;
                b && $51da786a5efa83c1$var$Cg(a, b) ? $51da786a5efa83c1$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $51da786a5efa83c1$var$I = !1, $51da786a5efa83c1$var$xg = a);
            }
        } else {
            if ($51da786a5efa83c1$var$Dg(a)) throw Error($51da786a5efa83c1$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $51da786a5efa83c1$var$I = !1;
            $51da786a5efa83c1$var$xg = a;
        }
    }
}
function $51da786a5efa83c1$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $51da786a5efa83c1$var$xg = a;
}
function $51da786a5efa83c1$var$Gg(a) {
    if (a !== $51da786a5efa83c1$var$xg) return !1;
    if (!$51da786a5efa83c1$var$I) return $51da786a5efa83c1$var$Fg(a), $51da786a5efa83c1$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$51da786a5efa83c1$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $51da786a5efa83c1$var$yg)) {
        if ($51da786a5efa83c1$var$Dg(a)) throw $51da786a5efa83c1$var$Hg(), Error($51da786a5efa83c1$var$p(418));
        for(; b;)$51da786a5efa83c1$var$Ag(a, b), b = $51da786a5efa83c1$var$Lf(b.nextSibling);
    }
    $51da786a5efa83c1$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($51da786a5efa83c1$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $51da786a5efa83c1$var$yg = $51da786a5efa83c1$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $51da786a5efa83c1$var$yg = null;
        }
    } else $51da786a5efa83c1$var$yg = $51da786a5efa83c1$var$xg ? $51da786a5efa83c1$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $51da786a5efa83c1$var$Hg() {
    for(var a = $51da786a5efa83c1$var$yg; a;)a = $51da786a5efa83c1$var$Lf(a.nextSibling);
}
function $51da786a5efa83c1$var$Ig() {
    $51da786a5efa83c1$var$yg = $51da786a5efa83c1$var$xg = null;
    $51da786a5efa83c1$var$I = !1;
}
function $51da786a5efa83c1$var$Jg(a) {
    null === $51da786a5efa83c1$var$zg ? $51da786a5efa83c1$var$zg = [
        a
    ] : $51da786a5efa83c1$var$zg.push(a);
}
var $51da786a5efa83c1$var$Kg = $51da786a5efa83c1$var$ua.ReactCurrentBatchConfig;
function $51da786a5efa83c1$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($51da786a5efa83c1$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($51da786a5efa83c1$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($51da786a5efa83c1$var$p(284));
        if (!c._owner) throw Error($51da786a5efa83c1$var$p(290, a));
    }
    return a;
}
function $51da786a5efa83c1$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($51da786a5efa83c1$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $51da786a5efa83c1$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $51da786a5efa83c1$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $51da786a5efa83c1$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $51da786a5efa83c1$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $51da786a5efa83c1$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $51da786a5efa83c1$var$Ha && $51da786a5efa83c1$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $51da786a5efa83c1$var$Lg(a, b, c), d.return = a, d;
        d = $51da786a5efa83c1$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $51da786a5efa83c1$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $51da786a5efa83c1$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $51da786a5efa83c1$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $51da786a5efa83c1$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $51da786a5efa83c1$var$va:
                    return c = $51da786a5efa83c1$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $51da786a5efa83c1$var$Lg(a, null, b), c.return = a, c;
                case $51da786a5efa83c1$var$wa:
                    return b = $51da786a5efa83c1$var$Sg(b, a.mode, c), b.return = a, b;
                case $51da786a5efa83c1$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($51da786a5efa83c1$var$eb(b) || $51da786a5efa83c1$var$Ka(b)) return b = $51da786a5efa83c1$var$Tg(b, a.mode, c, null), b.return = a, b;
            $51da786a5efa83c1$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $51da786a5efa83c1$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $51da786a5efa83c1$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $51da786a5efa83c1$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($51da786a5efa83c1$var$eb(c) || $51da786a5efa83c1$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $51da786a5efa83c1$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $51da786a5efa83c1$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $51da786a5efa83c1$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $51da786a5efa83c1$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($51da786a5efa83c1$var$eb(d) || $51da786a5efa83c1$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $51da786a5efa83c1$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $51da786a5efa83c1$var$I && $51da786a5efa83c1$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $51da786a5efa83c1$var$I && $51da786a5efa83c1$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $51da786a5efa83c1$var$I && $51da786a5efa83c1$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $51da786a5efa83c1$var$Ka(h);
        if ("function" !== typeof l) throw Error($51da786a5efa83c1$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($51da786a5efa83c1$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $51da786a5efa83c1$var$I && $51da786a5efa83c1$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $51da786a5efa83c1$var$I && $51da786a5efa83c1$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $51da786a5efa83c1$var$I && $51da786a5efa83c1$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $51da786a5efa83c1$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $51da786a5efa83c1$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $51da786a5efa83c1$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $51da786a5efa83c1$var$Ha && $51da786a5efa83c1$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $51da786a5efa83c1$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $51da786a5efa83c1$var$ya ? (d = $51da786a5efa83c1$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $51da786a5efa83c1$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $51da786a5efa83c1$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $51da786a5efa83c1$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $51da786a5efa83c1$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $51da786a5efa83c1$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($51da786a5efa83c1$var$eb(f)) return n(a, d, f, h);
            if ($51da786a5efa83c1$var$Ka(f)) return t(a, d, f, h);
            $51da786a5efa83c1$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $51da786a5efa83c1$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $51da786a5efa83c1$var$Ug = $51da786a5efa83c1$var$Og(!0), $51da786a5efa83c1$var$Vg = $51da786a5efa83c1$var$Og(!1), $51da786a5efa83c1$var$Wg = $51da786a5efa83c1$var$Uf(null), $51da786a5efa83c1$var$Xg = null, $51da786a5efa83c1$var$Yg = null, $51da786a5efa83c1$var$Zg = null;
function $51da786a5efa83c1$var$$g() {
    $51da786a5efa83c1$var$Zg = $51da786a5efa83c1$var$Yg = $51da786a5efa83c1$var$Xg = null;
}
function $51da786a5efa83c1$var$ah(a) {
    var b = $51da786a5efa83c1$var$Wg.current;
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wg);
    a._currentValue = b;
}
function $51da786a5efa83c1$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $51da786a5efa83c1$var$ch(a, b) {
    $51da786a5efa83c1$var$Xg = a;
    $51da786a5efa83c1$var$Zg = $51da786a5efa83c1$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($51da786a5efa83c1$var$dh = !0), a.firstContext = null);
}
function $51da786a5efa83c1$var$eh(a) {
    var b = a._currentValue;
    if ($51da786a5efa83c1$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $51da786a5efa83c1$var$Yg) {
            if (null === $51da786a5efa83c1$var$Xg) throw Error($51da786a5efa83c1$var$p(308));
            $51da786a5efa83c1$var$Yg = a;
            $51da786a5efa83c1$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $51da786a5efa83c1$var$Yg = $51da786a5efa83c1$var$Yg.next = a;
    }
    return b;
}
var $51da786a5efa83c1$var$fh = null;
function $51da786a5efa83c1$var$gh(a) {
    null === $51da786a5efa83c1$var$fh ? $51da786a5efa83c1$var$fh = [
        a
    ] : $51da786a5efa83c1$var$fh.push(a);
}
function $51da786a5efa83c1$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $51da786a5efa83c1$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $51da786a5efa83c1$var$ih(a, d);
}
function $51da786a5efa83c1$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $51da786a5efa83c1$var$jh = !1;
function $51da786a5efa83c1$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $51da786a5efa83c1$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $51da786a5efa83c1$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $51da786a5efa83c1$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($51da786a5efa83c1$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $51da786a5efa83c1$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $51da786a5efa83c1$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $51da786a5efa83c1$var$ih(a, c);
}
function $51da786a5efa83c1$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $51da786a5efa83c1$var$Cc(a, c);
    }
}
function $51da786a5efa83c1$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $51da786a5efa83c1$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $51da786a5efa83c1$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $51da786a5efa83c1$var$A({}, q, r);
                            break a;
                        case 2:
                            $51da786a5efa83c1$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $51da786a5efa83c1$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $51da786a5efa83c1$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($51da786a5efa83c1$var$p(191, e));
            e.call(d);
        }
    }
}
var $51da786a5efa83c1$var$th = {}, $51da786a5efa83c1$var$uh = $51da786a5efa83c1$var$Uf($51da786a5efa83c1$var$th), $51da786a5efa83c1$var$vh = $51da786a5efa83c1$var$Uf($51da786a5efa83c1$var$th), $51da786a5efa83c1$var$wh = $51da786a5efa83c1$var$Uf($51da786a5efa83c1$var$th);
function $51da786a5efa83c1$var$xh(a) {
    if (a === $51da786a5efa83c1$var$th) throw Error($51da786a5efa83c1$var$p(174));
    return a;
}
function $51da786a5efa83c1$var$yh(a, b) {
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$wh, b);
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$vh, a);
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$uh, $51da786a5efa83c1$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $51da786a5efa83c1$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $51da786a5efa83c1$var$lb(b, a);
    }
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$uh);
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$uh, b);
}
function $51da786a5efa83c1$var$zh() {
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$uh);
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$vh);
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$wh);
}
function $51da786a5efa83c1$var$Ah(a) {
    $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$wh.current);
    var b = $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$uh.current);
    var c = $51da786a5efa83c1$var$lb(b, a.type);
    b !== c && ($51da786a5efa83c1$var$G($51da786a5efa83c1$var$vh, a), $51da786a5efa83c1$var$G($51da786a5efa83c1$var$uh, c));
}
function $51da786a5efa83c1$var$Bh(a) {
    $51da786a5efa83c1$var$vh.current === a && ($51da786a5efa83c1$var$E($51da786a5efa83c1$var$uh), $51da786a5efa83c1$var$E($51da786a5efa83c1$var$vh));
}
var $51da786a5efa83c1$var$L = $51da786a5efa83c1$var$Uf(0);
function $51da786a5efa83c1$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $51da786a5efa83c1$var$Dh = [];
function $51da786a5efa83c1$var$Eh() {
    for(var a = 0; a < $51da786a5efa83c1$var$Dh.length; a++)$51da786a5efa83c1$var$Dh[a]._workInProgressVersionPrimary = null;
    $51da786a5efa83c1$var$Dh.length = 0;
}
var $51da786a5efa83c1$var$Fh = $51da786a5efa83c1$var$ua.ReactCurrentDispatcher, $51da786a5efa83c1$var$Gh = $51da786a5efa83c1$var$ua.ReactCurrentBatchConfig, $51da786a5efa83c1$var$Hh = 0, $51da786a5efa83c1$var$M = null, $51da786a5efa83c1$var$N = null, $51da786a5efa83c1$var$O = null, $51da786a5efa83c1$var$Ih = !1, $51da786a5efa83c1$var$Jh = !1, $51da786a5efa83c1$var$Kh = 0, $51da786a5efa83c1$var$Lh = 0;
function $51da786a5efa83c1$var$P() {
    throw Error($51da786a5efa83c1$var$p(321));
}
function $51da786a5efa83c1$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$51da786a5efa83c1$var$He(a[c], b[c])) return !1;
    return !0;
}
function $51da786a5efa83c1$var$Nh(a, b, c, d, e, f) {
    $51da786a5efa83c1$var$Hh = f;
    $51da786a5efa83c1$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $51da786a5efa83c1$var$Fh.current = null === a || null === a.memoizedState ? $51da786a5efa83c1$var$Oh : $51da786a5efa83c1$var$Ph;
    a = c(d, e);
    if ($51da786a5efa83c1$var$Jh) {
        f = 0;
        do {
            $51da786a5efa83c1$var$Jh = !1;
            $51da786a5efa83c1$var$Kh = 0;
            if (25 <= f) throw Error($51da786a5efa83c1$var$p(301));
            f += 1;
            $51da786a5efa83c1$var$O = $51da786a5efa83c1$var$N = null;
            b.updateQueue = null;
            $51da786a5efa83c1$var$Fh.current = $51da786a5efa83c1$var$Qh;
            a = c(d, e);
        }while ($51da786a5efa83c1$var$Jh);
    }
    $51da786a5efa83c1$var$Fh.current = $51da786a5efa83c1$var$Rh;
    b = null !== $51da786a5efa83c1$var$N && null !== $51da786a5efa83c1$var$N.next;
    $51da786a5efa83c1$var$Hh = 0;
    $51da786a5efa83c1$var$O = $51da786a5efa83c1$var$N = $51da786a5efa83c1$var$M = null;
    $51da786a5efa83c1$var$Ih = !1;
    if (b) throw Error($51da786a5efa83c1$var$p(300));
    return a;
}
function $51da786a5efa83c1$var$Sh() {
    var a = 0 !== $51da786a5efa83c1$var$Kh;
    $51da786a5efa83c1$var$Kh = 0;
    return a;
}
function $51da786a5efa83c1$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $51da786a5efa83c1$var$O ? $51da786a5efa83c1$var$M.memoizedState = $51da786a5efa83c1$var$O = a : $51da786a5efa83c1$var$O = $51da786a5efa83c1$var$O.next = a;
    return $51da786a5efa83c1$var$O;
}
function $51da786a5efa83c1$var$Uh() {
    if (null === $51da786a5efa83c1$var$N) {
        var a = $51da786a5efa83c1$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $51da786a5efa83c1$var$N.next;
    var b = null === $51da786a5efa83c1$var$O ? $51da786a5efa83c1$var$M.memoizedState : $51da786a5efa83c1$var$O.next;
    if (null !== b) $51da786a5efa83c1$var$O = b, $51da786a5efa83c1$var$N = a;
    else {
        if (null === a) throw Error($51da786a5efa83c1$var$p(310));
        $51da786a5efa83c1$var$N = a;
        a = {
            memoizedState: $51da786a5efa83c1$var$N.memoizedState,
            baseState: $51da786a5efa83c1$var$N.baseState,
            baseQueue: $51da786a5efa83c1$var$N.baseQueue,
            queue: $51da786a5efa83c1$var$N.queue,
            next: null
        };
        null === $51da786a5efa83c1$var$O ? $51da786a5efa83c1$var$M.memoizedState = $51da786a5efa83c1$var$O = a : $51da786a5efa83c1$var$O = $51da786a5efa83c1$var$O.next = a;
    }
    return $51da786a5efa83c1$var$O;
}
function $51da786a5efa83c1$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $51da786a5efa83c1$var$Wh(a) {
    var b = $51da786a5efa83c1$var$Uh(), c = b.queue;
    if (null === c) throw Error($51da786a5efa83c1$var$p(311));
    c.lastRenderedReducer = a;
    var d = $51da786a5efa83c1$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($51da786a5efa83c1$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $51da786a5efa83c1$var$M.lanes |= m;
                $51da786a5efa83c1$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $51da786a5efa83c1$var$He(d, b.memoizedState) || ($51da786a5efa83c1$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $51da786a5efa83c1$var$M.lanes |= f, $51da786a5efa83c1$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $51da786a5efa83c1$var$Xh(a) {
    var b = $51da786a5efa83c1$var$Uh(), c = b.queue;
    if (null === c) throw Error($51da786a5efa83c1$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $51da786a5efa83c1$var$He(f, b.memoizedState) || ($51da786a5efa83c1$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $51da786a5efa83c1$var$Yh() {}
function $51da786a5efa83c1$var$Zh(a, b) {
    var c = $51da786a5efa83c1$var$M, d = $51da786a5efa83c1$var$Uh(), e = b(), f = !$51da786a5efa83c1$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $51da786a5efa83c1$var$dh = !0);
    d = d.queue;
    $51da786a5efa83c1$var$$h($51da786a5efa83c1$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $51da786a5efa83c1$var$O && $51da786a5efa83c1$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $51da786a5efa83c1$var$bi(9, $51da786a5efa83c1$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $51da786a5efa83c1$var$Q) throw Error($51da786a5efa83c1$var$p(349));
        0 !== ($51da786a5efa83c1$var$Hh & 30) || $51da786a5efa83c1$var$di(c, b, e);
    }
    return e;
}
function $51da786a5efa83c1$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $51da786a5efa83c1$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $51da786a5efa83c1$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $51da786a5efa83c1$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $51da786a5efa83c1$var$ei(b) && $51da786a5efa83c1$var$fi(a);
}
function $51da786a5efa83c1$var$ai(a, b, c) {
    return c(function() {
        $51da786a5efa83c1$var$ei(b) && $51da786a5efa83c1$var$fi(a);
    });
}
function $51da786a5efa83c1$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$51da786a5efa83c1$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $51da786a5efa83c1$var$fi(a) {
    var b = $51da786a5efa83c1$var$ih(a, 1);
    null !== b && $51da786a5efa83c1$var$gi(b, a, 1, -1);
}
function $51da786a5efa83c1$var$hi(a) {
    var b = $51da786a5efa83c1$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $51da786a5efa83c1$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $51da786a5efa83c1$var$ii.bind(null, $51da786a5efa83c1$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $51da786a5efa83c1$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $51da786a5efa83c1$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $51da786a5efa83c1$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $51da786a5efa83c1$var$ji() {
    return $51da786a5efa83c1$var$Uh().memoizedState;
}
function $51da786a5efa83c1$var$ki(a, b, c, d) {
    var e = $51da786a5efa83c1$var$Th();
    $51da786a5efa83c1$var$M.flags |= a;
    e.memoizedState = $51da786a5efa83c1$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $51da786a5efa83c1$var$li(a, b, c, d) {
    var e = $51da786a5efa83c1$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $51da786a5efa83c1$var$N) {
        var g = $51da786a5efa83c1$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $51da786a5efa83c1$var$Mh(d, g.deps)) {
            e.memoizedState = $51da786a5efa83c1$var$bi(b, c, f, d);
            return;
        }
    }
    $51da786a5efa83c1$var$M.flags |= a;
    e.memoizedState = $51da786a5efa83c1$var$bi(1 | b, c, f, d);
}
function $51da786a5efa83c1$var$mi(a, b) {
    return $51da786a5efa83c1$var$ki(8390656, 8, a, b);
}
function $51da786a5efa83c1$var$$h(a, b) {
    return $51da786a5efa83c1$var$li(2048, 8, a, b);
}
function $51da786a5efa83c1$var$ni(a, b) {
    return $51da786a5efa83c1$var$li(4, 2, a, b);
}
function $51da786a5efa83c1$var$oi(a, b) {
    return $51da786a5efa83c1$var$li(4, 4, a, b);
}
function $51da786a5efa83c1$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $51da786a5efa83c1$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $51da786a5efa83c1$var$li(4, 4, $51da786a5efa83c1$var$pi.bind(null, b, a), c);
}
function $51da786a5efa83c1$var$ri() {}
function $51da786a5efa83c1$var$si(a, b) {
    var c = $51da786a5efa83c1$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $51da786a5efa83c1$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $51da786a5efa83c1$var$ti(a, b) {
    var c = $51da786a5efa83c1$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $51da786a5efa83c1$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $51da786a5efa83c1$var$ui(a, b, c) {
    if (0 === ($51da786a5efa83c1$var$Hh & 21)) return a.baseState && (a.baseState = !1, $51da786a5efa83c1$var$dh = !0), a.memoizedState = c;
    $51da786a5efa83c1$var$He(c, b) || (c = $51da786a5efa83c1$var$yc(), $51da786a5efa83c1$var$M.lanes |= c, $51da786a5efa83c1$var$rh |= c, a.baseState = !0);
    return b;
}
function $51da786a5efa83c1$var$vi(a, b) {
    var c = $51da786a5efa83c1$var$C;
    $51da786a5efa83c1$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $51da786a5efa83c1$var$Gh.transition;
    $51da786a5efa83c1$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $51da786a5efa83c1$var$C = c, $51da786a5efa83c1$var$Gh.transition = d;
    }
}
function $51da786a5efa83c1$var$wi() {
    return $51da786a5efa83c1$var$Uh().memoizedState;
}
function $51da786a5efa83c1$var$xi(a, b, c) {
    var d = $51da786a5efa83c1$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($51da786a5efa83c1$var$zi(a)) $51da786a5efa83c1$var$Ai(b, c);
    else if (c = $51da786a5efa83c1$var$hh(a, b, c, d), null !== c) {
        var e = $51da786a5efa83c1$var$R();
        $51da786a5efa83c1$var$gi(c, a, d, e);
        $51da786a5efa83c1$var$Bi(c, b, d);
    }
}
function $51da786a5efa83c1$var$ii(a, b, c) {
    var d = $51da786a5efa83c1$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($51da786a5efa83c1$var$zi(a)) $51da786a5efa83c1$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($51da786a5efa83c1$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $51da786a5efa83c1$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $51da786a5efa83c1$var$hh(a, b, e, d);
        null !== c && (e = $51da786a5efa83c1$var$R(), $51da786a5efa83c1$var$gi(c, a, d, e), $51da786a5efa83c1$var$Bi(c, b, d));
    }
}
function $51da786a5efa83c1$var$zi(a) {
    var b = a.alternate;
    return a === $51da786a5efa83c1$var$M || null !== b && b === $51da786a5efa83c1$var$M;
}
function $51da786a5efa83c1$var$Ai(a, b) {
    $51da786a5efa83c1$var$Jh = $51da786a5efa83c1$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $51da786a5efa83c1$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $51da786a5efa83c1$var$Cc(a, c);
    }
}
var $51da786a5efa83c1$var$Rh = {
    readContext: $51da786a5efa83c1$var$eh,
    useCallback: $51da786a5efa83c1$var$P,
    useContext: $51da786a5efa83c1$var$P,
    useEffect: $51da786a5efa83c1$var$P,
    useImperativeHandle: $51da786a5efa83c1$var$P,
    useInsertionEffect: $51da786a5efa83c1$var$P,
    useLayoutEffect: $51da786a5efa83c1$var$P,
    useMemo: $51da786a5efa83c1$var$P,
    useReducer: $51da786a5efa83c1$var$P,
    useRef: $51da786a5efa83c1$var$P,
    useState: $51da786a5efa83c1$var$P,
    useDebugValue: $51da786a5efa83c1$var$P,
    useDeferredValue: $51da786a5efa83c1$var$P,
    useTransition: $51da786a5efa83c1$var$P,
    useMutableSource: $51da786a5efa83c1$var$P,
    useSyncExternalStore: $51da786a5efa83c1$var$P,
    useId: $51da786a5efa83c1$var$P,
    unstable_isNewReconciler: !1
}, $51da786a5efa83c1$var$Oh = {
    readContext: $51da786a5efa83c1$var$eh,
    useCallback: function(a, b) {
        $51da786a5efa83c1$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $51da786a5efa83c1$var$eh,
    useEffect: $51da786a5efa83c1$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $51da786a5efa83c1$var$ki(4194308, 4, $51da786a5efa83c1$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $51da786a5efa83c1$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $51da786a5efa83c1$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $51da786a5efa83c1$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $51da786a5efa83c1$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $51da786a5efa83c1$var$xi.bind(null, $51da786a5efa83c1$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $51da786a5efa83c1$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $51da786a5efa83c1$var$hi,
    useDebugValue: $51da786a5efa83c1$var$ri,
    useDeferredValue: function(a) {
        return $51da786a5efa83c1$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $51da786a5efa83c1$var$hi(!1), b = a[0];
        a = $51da786a5efa83c1$var$vi.bind(null, a[1]);
        $51da786a5efa83c1$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $51da786a5efa83c1$var$M, e = $51da786a5efa83c1$var$Th();
        if ($51da786a5efa83c1$var$I) {
            if (void 0 === c) throw Error($51da786a5efa83c1$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $51da786a5efa83c1$var$Q) throw Error($51da786a5efa83c1$var$p(349));
            0 !== ($51da786a5efa83c1$var$Hh & 30) || $51da786a5efa83c1$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $51da786a5efa83c1$var$mi($51da786a5efa83c1$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $51da786a5efa83c1$var$bi(9, $51da786a5efa83c1$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $51da786a5efa83c1$var$Th(), b = $51da786a5efa83c1$var$Q.identifierPrefix;
        if ($51da786a5efa83c1$var$I) {
            var c = $51da786a5efa83c1$var$sg;
            var d = $51da786a5efa83c1$var$rg;
            c = (d & ~(1 << 32 - $51da786a5efa83c1$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $51da786a5efa83c1$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $51da786a5efa83c1$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $51da786a5efa83c1$var$Ph = {
    readContext: $51da786a5efa83c1$var$eh,
    useCallback: $51da786a5efa83c1$var$si,
    useContext: $51da786a5efa83c1$var$eh,
    useEffect: $51da786a5efa83c1$var$$h,
    useImperativeHandle: $51da786a5efa83c1$var$qi,
    useInsertionEffect: $51da786a5efa83c1$var$ni,
    useLayoutEffect: $51da786a5efa83c1$var$oi,
    useMemo: $51da786a5efa83c1$var$ti,
    useReducer: $51da786a5efa83c1$var$Wh,
    useRef: $51da786a5efa83c1$var$ji,
    useState: function() {
        return $51da786a5efa83c1$var$Wh($51da786a5efa83c1$var$Vh);
    },
    useDebugValue: $51da786a5efa83c1$var$ri,
    useDeferredValue: function(a) {
        var b = $51da786a5efa83c1$var$Uh();
        return $51da786a5efa83c1$var$ui(b, $51da786a5efa83c1$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $51da786a5efa83c1$var$Wh($51da786a5efa83c1$var$Vh)[0], b = $51da786a5efa83c1$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $51da786a5efa83c1$var$Yh,
    useSyncExternalStore: $51da786a5efa83c1$var$Zh,
    useId: $51da786a5efa83c1$var$wi,
    unstable_isNewReconciler: !1
}, $51da786a5efa83c1$var$Qh = {
    readContext: $51da786a5efa83c1$var$eh,
    useCallback: $51da786a5efa83c1$var$si,
    useContext: $51da786a5efa83c1$var$eh,
    useEffect: $51da786a5efa83c1$var$$h,
    useImperativeHandle: $51da786a5efa83c1$var$qi,
    useInsertionEffect: $51da786a5efa83c1$var$ni,
    useLayoutEffect: $51da786a5efa83c1$var$oi,
    useMemo: $51da786a5efa83c1$var$ti,
    useReducer: $51da786a5efa83c1$var$Xh,
    useRef: $51da786a5efa83c1$var$ji,
    useState: function() {
        return $51da786a5efa83c1$var$Xh($51da786a5efa83c1$var$Vh);
    },
    useDebugValue: $51da786a5efa83c1$var$ri,
    useDeferredValue: function(a) {
        var b = $51da786a5efa83c1$var$Uh();
        return null === $51da786a5efa83c1$var$N ? b.memoizedState = a : $51da786a5efa83c1$var$ui(b, $51da786a5efa83c1$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $51da786a5efa83c1$var$Xh($51da786a5efa83c1$var$Vh)[0], b = $51da786a5efa83c1$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $51da786a5efa83c1$var$Yh,
    useSyncExternalStore: $51da786a5efa83c1$var$Zh,
    useId: $51da786a5efa83c1$var$wi,
    unstable_isNewReconciler: !1
};
function $51da786a5efa83c1$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $51da786a5efa83c1$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $51da786a5efa83c1$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $51da786a5efa83c1$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $51da786a5efa83c1$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $51da786a5efa83c1$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $51da786a5efa83c1$var$R(), e = $51da786a5efa83c1$var$yi(a), f = $51da786a5efa83c1$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $51da786a5efa83c1$var$nh(a, f, e);
        null !== b && ($51da786a5efa83c1$var$gi(b, a, e, d), $51da786a5efa83c1$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $51da786a5efa83c1$var$R(), e = $51da786a5efa83c1$var$yi(a), f = $51da786a5efa83c1$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $51da786a5efa83c1$var$nh(a, f, e);
        null !== b && ($51da786a5efa83c1$var$gi(b, a, e, d), $51da786a5efa83c1$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $51da786a5efa83c1$var$R(), d = $51da786a5efa83c1$var$yi(a), e = $51da786a5efa83c1$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $51da786a5efa83c1$var$nh(a, e, d);
        null !== b && ($51da786a5efa83c1$var$gi(b, a, d, c), $51da786a5efa83c1$var$oh(b, a, d));
    }
};
function $51da786a5efa83c1$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$51da786a5efa83c1$var$Ie(c, d) || !$51da786a5efa83c1$var$Ie(e, f) : !0;
}
function $51da786a5efa83c1$var$Gi(a, b, c) {
    var d = !1, e = $51da786a5efa83c1$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $51da786a5efa83c1$var$eh(f) : (e = $51da786a5efa83c1$var$Zf(b) ? $51da786a5efa83c1$var$Xf : $51da786a5efa83c1$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $51da786a5efa83c1$var$Yf(a, e) : $51da786a5efa83c1$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $51da786a5efa83c1$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $51da786a5efa83c1$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $51da786a5efa83c1$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $51da786a5efa83c1$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $51da786a5efa83c1$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $51da786a5efa83c1$var$eh(f) : (f = $51da786a5efa83c1$var$Zf(b) ? $51da786a5efa83c1$var$Xf : $51da786a5efa83c1$var$H.current, e.context = $51da786a5efa83c1$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($51da786a5efa83c1$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $51da786a5efa83c1$var$Ei.enqueueReplaceState(e, e.state, null), $51da786a5efa83c1$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $51da786a5efa83c1$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $51da786a5efa83c1$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $51da786a5efa83c1$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $51da786a5efa83c1$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $51da786a5efa83c1$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $51da786a5efa83c1$var$Ni(a, b, c) {
    c = $51da786a5efa83c1$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $51da786a5efa83c1$var$Oi || ($51da786a5efa83c1$var$Oi = !0, $51da786a5efa83c1$var$Pi = d);
        $51da786a5efa83c1$var$Li(a, b);
    };
    return c;
}
function $51da786a5efa83c1$var$Qi(a, b, c) {
    c = $51da786a5efa83c1$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $51da786a5efa83c1$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $51da786a5efa83c1$var$Li(a, b);
        "function" !== typeof d && (null === $51da786a5efa83c1$var$Ri ? $51da786a5efa83c1$var$Ri = new Set([
            this
        ]) : $51da786a5efa83c1$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $51da786a5efa83c1$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $51da786a5efa83c1$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $51da786a5efa83c1$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $51da786a5efa83c1$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $51da786a5efa83c1$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $51da786a5efa83c1$var$mh(-1, 1), b.tag = 2, $51da786a5efa83c1$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $51da786a5efa83c1$var$Wi = $51da786a5efa83c1$var$ua.ReactCurrentOwner, $51da786a5efa83c1$var$dh = !1;
function $51da786a5efa83c1$var$Xi(a, b, c, d) {
    b.child = null === a ? $51da786a5efa83c1$var$Vg(b, null, c, d) : $51da786a5efa83c1$var$Ug(b, a.child, c, d);
}
function $51da786a5efa83c1$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $51da786a5efa83c1$var$ch(b, e);
    d = $51da786a5efa83c1$var$Nh(a, b, c, d, f, e);
    c = $51da786a5efa83c1$var$Sh();
    if (null !== a && !$51da786a5efa83c1$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $51da786a5efa83c1$var$Zi(a, b, e);
    $51da786a5efa83c1$var$I && c && $51da786a5efa83c1$var$vg(b);
    b.flags |= 1;
    $51da786a5efa83c1$var$Xi(a, b, d, e);
    return b.child;
}
function $51da786a5efa83c1$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$51da786a5efa83c1$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $51da786a5efa83c1$var$bj(a, b, f, d, e);
        a = $51da786a5efa83c1$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $51da786a5efa83c1$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $51da786a5efa83c1$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $51da786a5efa83c1$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $51da786a5efa83c1$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($51da786a5efa83c1$var$Ie(f, d) && a.ref === b.ref) {
            if ($51da786a5efa83c1$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($51da786a5efa83c1$var$dh = !0);
            else return b.lanes = a.lanes, $51da786a5efa83c1$var$Zi(a, b, e);
        }
    }
    return $51da786a5efa83c1$var$cj(a, b, c, d, e);
}
function $51da786a5efa83c1$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $51da786a5efa83c1$var$G($51da786a5efa83c1$var$ej, $51da786a5efa83c1$var$fj), $51da786a5efa83c1$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $51da786a5efa83c1$var$G($51da786a5efa83c1$var$ej, $51da786a5efa83c1$var$fj), $51da786a5efa83c1$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $51da786a5efa83c1$var$G($51da786a5efa83c1$var$ej, $51da786a5efa83c1$var$fj);
            $51da786a5efa83c1$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $51da786a5efa83c1$var$G($51da786a5efa83c1$var$ej, $51da786a5efa83c1$var$fj), $51da786a5efa83c1$var$fj |= d;
    $51da786a5efa83c1$var$Xi(a, b, e, c);
    return b.child;
}
function $51da786a5efa83c1$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $51da786a5efa83c1$var$cj(a, b, c, d, e) {
    var f = $51da786a5efa83c1$var$Zf(c) ? $51da786a5efa83c1$var$Xf : $51da786a5efa83c1$var$H.current;
    f = $51da786a5efa83c1$var$Yf(b, f);
    $51da786a5efa83c1$var$ch(b, e);
    c = $51da786a5efa83c1$var$Nh(a, b, c, d, f, e);
    d = $51da786a5efa83c1$var$Sh();
    if (null !== a && !$51da786a5efa83c1$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $51da786a5efa83c1$var$Zi(a, b, e);
    $51da786a5efa83c1$var$I && d && $51da786a5efa83c1$var$vg(b);
    b.flags |= 1;
    $51da786a5efa83c1$var$Xi(a, b, c, e);
    return b.child;
}
function $51da786a5efa83c1$var$hj(a, b, c, d, e) {
    if ($51da786a5efa83c1$var$Zf(c)) {
        var f = !0;
        $51da786a5efa83c1$var$cg(b);
    } else f = !1;
    $51da786a5efa83c1$var$ch(b, e);
    if (null === b.stateNode) $51da786a5efa83c1$var$ij(a, b), $51da786a5efa83c1$var$Gi(b, c, d), $51da786a5efa83c1$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $51da786a5efa83c1$var$eh(l) : (l = $51da786a5efa83c1$var$Zf(c) ? $51da786a5efa83c1$var$Xf : $51da786a5efa83c1$var$H.current, l = $51da786a5efa83c1$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $51da786a5efa83c1$var$Hi(b, g, d, l);
        $51da786a5efa83c1$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $51da786a5efa83c1$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $51da786a5efa83c1$var$Wf.current || $51da786a5efa83c1$var$jh ? ("function" === typeof m && ($51da786a5efa83c1$var$Di(b, c, m, d), k = b.memoizedState), (h = $51da786a5efa83c1$var$jh || $51da786a5efa83c1$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $51da786a5efa83c1$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $51da786a5efa83c1$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $51da786a5efa83c1$var$eh(k) : (k = $51da786a5efa83c1$var$Zf(c) ? $51da786a5efa83c1$var$Xf : $51da786a5efa83c1$var$H.current, k = $51da786a5efa83c1$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $51da786a5efa83c1$var$Hi(b, g, d, k);
        $51da786a5efa83c1$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $51da786a5efa83c1$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $51da786a5efa83c1$var$Wf.current || $51da786a5efa83c1$var$jh ? ("function" === typeof y && ($51da786a5efa83c1$var$Di(b, c, y, d), n = b.memoizedState), (l = $51da786a5efa83c1$var$jh || $51da786a5efa83c1$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $51da786a5efa83c1$var$jj(a, b, c, d, f, e);
}
function $51da786a5efa83c1$var$jj(a, b, c, d, e, f) {
    $51da786a5efa83c1$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $51da786a5efa83c1$var$dg(b, c, !1), $51da786a5efa83c1$var$Zi(a, b, f);
    d = b.stateNode;
    $51da786a5efa83c1$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $51da786a5efa83c1$var$Ug(b, a.child, null, f), b.child = $51da786a5efa83c1$var$Ug(b, null, h, f)) : $51da786a5efa83c1$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $51da786a5efa83c1$var$dg(b, c, !0);
    return b.child;
}
function $51da786a5efa83c1$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $51da786a5efa83c1$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $51da786a5efa83c1$var$ag(a, b.context, !1);
    $51da786a5efa83c1$var$yh(a, b.containerInfo);
}
function $51da786a5efa83c1$var$lj(a, b, c, d, e) {
    $51da786a5efa83c1$var$Ig();
    $51da786a5efa83c1$var$Jg(e);
    b.flags |= 256;
    $51da786a5efa83c1$var$Xi(a, b, c, d);
    return b.child;
}
var $51da786a5efa83c1$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $51da786a5efa83c1$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $51da786a5efa83c1$var$oj(a, b, c) {
    var d = b.pendingProps, e = $51da786a5efa83c1$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, e & 1);
    if (null === a) {
        $51da786a5efa83c1$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $51da786a5efa83c1$var$pj(g, d, 0, null), a = $51da786a5efa83c1$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $51da786a5efa83c1$var$nj(c), b.memoizedState = $51da786a5efa83c1$var$mj, a) : $51da786a5efa83c1$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $51da786a5efa83c1$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $51da786a5efa83c1$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $51da786a5efa83c1$var$Pg(h, f) : (f = $51da786a5efa83c1$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $51da786a5efa83c1$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $51da786a5efa83c1$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $51da786a5efa83c1$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $51da786a5efa83c1$var$qj(a, b) {
    b = $51da786a5efa83c1$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $51da786a5efa83c1$var$sj(a, b, c, d) {
    null !== d && $51da786a5efa83c1$var$Jg(d);
    $51da786a5efa83c1$var$Ug(b, a.child, null, c);
    a = $51da786a5efa83c1$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $51da786a5efa83c1$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $51da786a5efa83c1$var$Ki(Error($51da786a5efa83c1$var$p(422))), $51da786a5efa83c1$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $51da786a5efa83c1$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $51da786a5efa83c1$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $51da786a5efa83c1$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $51da786a5efa83c1$var$nj(g);
        b.memoizedState = $51da786a5efa83c1$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $51da786a5efa83c1$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($51da786a5efa83c1$var$p(419));
        d = $51da786a5efa83c1$var$Ki(f, d, void 0);
        return $51da786a5efa83c1$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($51da786a5efa83c1$var$dh || h) {
        d = $51da786a5efa83c1$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $51da786a5efa83c1$var$ih(a, e), $51da786a5efa83c1$var$gi(d, a, e, -1));
        }
        $51da786a5efa83c1$var$tj();
        d = $51da786a5efa83c1$var$Ki(Error($51da786a5efa83c1$var$p(421)));
        return $51da786a5efa83c1$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $51da786a5efa83c1$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $51da786a5efa83c1$var$yg = $51da786a5efa83c1$var$Lf(e.nextSibling);
    $51da786a5efa83c1$var$xg = b;
    $51da786a5efa83c1$var$I = !0;
    $51da786a5efa83c1$var$zg = null;
    null !== a && ($51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg++] = $51da786a5efa83c1$var$rg, $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg++] = $51da786a5efa83c1$var$sg, $51da786a5efa83c1$var$og[$51da786a5efa83c1$var$pg++] = $51da786a5efa83c1$var$qg, $51da786a5efa83c1$var$rg = a.id, $51da786a5efa83c1$var$sg = a.overflow, $51da786a5efa83c1$var$qg = b);
    b = $51da786a5efa83c1$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $51da786a5efa83c1$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $51da786a5efa83c1$var$bh(a.return, b, c);
}
function $51da786a5efa83c1$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $51da786a5efa83c1$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $51da786a5efa83c1$var$Xi(a, b, d.children, c);
    d = $51da786a5efa83c1$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $51da786a5efa83c1$var$vj(a, c, b);
            else if (19 === a.tag) $51da786a5efa83c1$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $51da786a5efa83c1$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $51da786a5efa83c1$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $51da786a5efa83c1$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $51da786a5efa83c1$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $51da786a5efa83c1$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $51da786a5efa83c1$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $51da786a5efa83c1$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $51da786a5efa83c1$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($51da786a5efa83c1$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $51da786a5efa83c1$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $51da786a5efa83c1$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $51da786a5efa83c1$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $51da786a5efa83c1$var$kj(b);
            $51da786a5efa83c1$var$Ig();
            break;
        case 5:
            $51da786a5efa83c1$var$Ah(b);
            break;
        case 1:
            $51da786a5efa83c1$var$Zf(b.type) && $51da786a5efa83c1$var$cg(b);
            break;
        case 4:
            $51da786a5efa83c1$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $51da786a5efa83c1$var$G($51da786a5efa83c1$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, $51da786a5efa83c1$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $51da786a5efa83c1$var$oj(a, b, c);
                $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, $51da786a5efa83c1$var$L.current & 1);
                a = $51da786a5efa83c1$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, $51da786a5efa83c1$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $51da786a5efa83c1$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, $51da786a5efa83c1$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $51da786a5efa83c1$var$dj(a, b, c);
    }
    return $51da786a5efa83c1$var$Zi(a, b, c);
}
var $51da786a5efa83c1$var$zj, $51da786a5efa83c1$var$Aj, $51da786a5efa83c1$var$Bj, $51da786a5efa83c1$var$Cj;
$51da786a5efa83c1$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$51da786a5efa83c1$var$Aj = function() {};
$51da786a5efa83c1$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $51da786a5efa83c1$var$Ya(a, e);
                d = $51da786a5efa83c1$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $51da786a5efa83c1$var$A({}, e, {
                    value: void 0
                });
                d = $51da786a5efa83c1$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $51da786a5efa83c1$var$gb(a, e);
                d = $51da786a5efa83c1$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $51da786a5efa83c1$var$Bf);
        }
        $51da786a5efa83c1$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($51da786a5efa83c1$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($51da786a5efa83c1$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $51da786a5efa83c1$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$51da786a5efa83c1$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $51da786a5efa83c1$var$Dj(a, b) {
    if (!$51da786a5efa83c1$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $51da786a5efa83c1$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $51da786a5efa83c1$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $51da786a5efa83c1$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $51da786a5efa83c1$var$S(b), null;
        case 1:
            return $51da786a5efa83c1$var$Zf(b.type) && $51da786a5efa83c1$var$$f(), $51da786a5efa83c1$var$S(b), null;
        case 3:
            d = b.stateNode;
            $51da786a5efa83c1$var$zh();
            $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wf);
            $51da786a5efa83c1$var$E($51da786a5efa83c1$var$H);
            $51da786a5efa83c1$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $51da786a5efa83c1$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $51da786a5efa83c1$var$zg && ($51da786a5efa83c1$var$Fj($51da786a5efa83c1$var$zg), $51da786a5efa83c1$var$zg = null));
            $51da786a5efa83c1$var$Aj(a, b);
            $51da786a5efa83c1$var$S(b);
            return null;
        case 5:
            $51da786a5efa83c1$var$Bh(b);
            var e = $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $51da786a5efa83c1$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($51da786a5efa83c1$var$p(166));
                    $51da786a5efa83c1$var$S(b);
                    return null;
                }
                a = $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$uh.current);
                if ($51da786a5efa83c1$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$51da786a5efa83c1$var$Of] = b;
                    d[$51da786a5efa83c1$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $51da786a5efa83c1$var$D("cancel", d);
                            $51da786a5efa83c1$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $51da786a5efa83c1$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $51da786a5efa83c1$var$lf.length; e++)$51da786a5efa83c1$var$D($51da786a5efa83c1$var$lf[e], d);
                            break;
                        case "source":
                            $51da786a5efa83c1$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $51da786a5efa83c1$var$D("error", d);
                            $51da786a5efa83c1$var$D("load", d);
                            break;
                        case "details":
                            $51da786a5efa83c1$var$D("toggle", d);
                            break;
                        case "input":
                            $51da786a5efa83c1$var$Za(d, f);
                            $51da786a5efa83c1$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $51da786a5efa83c1$var$D("invalid", d);
                            break;
                        case "textarea":
                            $51da786a5efa83c1$var$hb(d, f), $51da786a5efa83c1$var$D("invalid", d);
                    }
                    $51da786a5efa83c1$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $51da786a5efa83c1$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $51da786a5efa83c1$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $51da786a5efa83c1$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $51da786a5efa83c1$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $51da786a5efa83c1$var$Va(d);
                            $51da786a5efa83c1$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $51da786a5efa83c1$var$Va(d);
                            $51da786a5efa83c1$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $51da786a5efa83c1$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $51da786a5efa83c1$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$51da786a5efa83c1$var$Of] = b;
                    a[$51da786a5efa83c1$var$Pf] = d;
                    $51da786a5efa83c1$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $51da786a5efa83c1$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $51da786a5efa83c1$var$D("cancel", a);
                                $51da786a5efa83c1$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $51da786a5efa83c1$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $51da786a5efa83c1$var$lf.length; e++)$51da786a5efa83c1$var$D($51da786a5efa83c1$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $51da786a5efa83c1$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $51da786a5efa83c1$var$D("error", a);
                                $51da786a5efa83c1$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $51da786a5efa83c1$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $51da786a5efa83c1$var$Za(a, d);
                                e = $51da786a5efa83c1$var$Ya(a, d);
                                $51da786a5efa83c1$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $51da786a5efa83c1$var$A({}, d, {
                                    value: void 0
                                });
                                $51da786a5efa83c1$var$D("invalid", a);
                                break;
                            case "textarea":
                                $51da786a5efa83c1$var$hb(a, d);
                                e = $51da786a5efa83c1$var$gb(a, d);
                                $51da786a5efa83c1$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $51da786a5efa83c1$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $51da786a5efa83c1$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $51da786a5efa83c1$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $51da786a5efa83c1$var$ob(a, k) : "number" === typeof k && $51da786a5efa83c1$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($51da786a5efa83c1$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $51da786a5efa83c1$var$D("scroll", a) : null != k && $51da786a5efa83c1$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $51da786a5efa83c1$var$Va(a);
                                $51da786a5efa83c1$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $51da786a5efa83c1$var$Va(a);
                                $51da786a5efa83c1$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $51da786a5efa83c1$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $51da786a5efa83c1$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $51da786a5efa83c1$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $51da786a5efa83c1$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $51da786a5efa83c1$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $51da786a5efa83c1$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($51da786a5efa83c1$var$p(166));
                c = $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$wh.current);
                $51da786a5efa83c1$var$xh($51da786a5efa83c1$var$uh.current);
                if ($51da786a5efa83c1$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$51da786a5efa83c1$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $51da786a5efa83c1$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $51da786a5efa83c1$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $51da786a5efa83c1$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$51da786a5efa83c1$var$Of] = b, b.stateNode = d;
            }
            $51da786a5efa83c1$var$S(b);
            return null;
        case 13:
            $51da786a5efa83c1$var$E($51da786a5efa83c1$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($51da786a5efa83c1$var$I && null !== $51da786a5efa83c1$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $51da786a5efa83c1$var$Hg(), $51da786a5efa83c1$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $51da786a5efa83c1$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($51da786a5efa83c1$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($51da786a5efa83c1$var$p(317));
                        f[$51da786a5efa83c1$var$Of] = b;
                    } else $51da786a5efa83c1$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $51da786a5efa83c1$var$S(b);
                    f = !1;
                } else null !== $51da786a5efa83c1$var$zg && ($51da786a5efa83c1$var$Fj($51da786a5efa83c1$var$zg), $51da786a5efa83c1$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($51da786a5efa83c1$var$L.current & 1) ? 0 === $51da786a5efa83c1$var$T && ($51da786a5efa83c1$var$T = 3) : $51da786a5efa83c1$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $51da786a5efa83c1$var$S(b);
            return null;
        case 4:
            return $51da786a5efa83c1$var$zh(), $51da786a5efa83c1$var$Aj(a, b), null === a && $51da786a5efa83c1$var$sf(b.stateNode.containerInfo), $51da786a5efa83c1$var$S(b), null;
        case 10:
            return $51da786a5efa83c1$var$ah(b.type._context), $51da786a5efa83c1$var$S(b), null;
        case 17:
            return $51da786a5efa83c1$var$Zf(b.type) && $51da786a5efa83c1$var$$f(), $51da786a5efa83c1$var$S(b), null;
        case 19:
            $51da786a5efa83c1$var$E($51da786a5efa83c1$var$L);
            f = b.memoizedState;
            if (null === f) return $51da786a5efa83c1$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $51da786a5efa83c1$var$Dj(f, !1);
                else {
                    if (0 !== $51da786a5efa83c1$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $51da786a5efa83c1$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $51da786a5efa83c1$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, $51da786a5efa83c1$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $51da786a5efa83c1$var$B() > $51da786a5efa83c1$var$Gj && (b.flags |= 128, d = !0, $51da786a5efa83c1$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $51da786a5efa83c1$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $51da786a5efa83c1$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$51da786a5efa83c1$var$I) return $51da786a5efa83c1$var$S(b), null;
                    } else 2 * $51da786a5efa83c1$var$B() - f.renderingStartTime > $51da786a5efa83c1$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $51da786a5efa83c1$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $51da786a5efa83c1$var$B(), b.sibling = null, c = $51da786a5efa83c1$var$L.current, $51da786a5efa83c1$var$G($51da786a5efa83c1$var$L, d ? c & 1 | 2 : c & 1), b;
            $51da786a5efa83c1$var$S(b);
            return null;
        case 22:
        case 23:
            return $51da786a5efa83c1$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($51da786a5efa83c1$var$fj & 1073741824) && ($51da786a5efa83c1$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $51da786a5efa83c1$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($51da786a5efa83c1$var$p(156, b.tag));
}
function $51da786a5efa83c1$var$Ij(a, b) {
    $51da786a5efa83c1$var$wg(b);
    switch(b.tag){
        case 1:
            return $51da786a5efa83c1$var$Zf(b.type) && $51da786a5efa83c1$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $51da786a5efa83c1$var$zh(), $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wf), $51da786a5efa83c1$var$E($51da786a5efa83c1$var$H), $51da786a5efa83c1$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $51da786a5efa83c1$var$Bh(b), null;
        case 13:
            $51da786a5efa83c1$var$E($51da786a5efa83c1$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($51da786a5efa83c1$var$p(340));
                $51da786a5efa83c1$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $51da786a5efa83c1$var$E($51da786a5efa83c1$var$L), null;
        case 4:
            return $51da786a5efa83c1$var$zh(), null;
        case 10:
            return $51da786a5efa83c1$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $51da786a5efa83c1$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $51da786a5efa83c1$var$Jj = !1, $51da786a5efa83c1$var$U = !1, $51da786a5efa83c1$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $51da786a5efa83c1$var$V = null;
function $51da786a5efa83c1$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $51da786a5efa83c1$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $51da786a5efa83c1$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $51da786a5efa83c1$var$W(a, b, d);
    }
}
var $51da786a5efa83c1$var$Nj = !1;
function $51da786a5efa83c1$var$Oj(a, b) {
    $51da786a5efa83c1$var$Cf = $51da786a5efa83c1$var$dd;
    a = $51da786a5efa83c1$var$Me();
    if ($51da786a5efa83c1$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $51da786a5efa83c1$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $51da786a5efa83c1$var$dd = !1;
    for($51da786a5efa83c1$var$V = b; null !== $51da786a5efa83c1$var$V;)if (b = $51da786a5efa83c1$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $51da786a5efa83c1$var$V = a;
    else for(; null !== $51da786a5efa83c1$var$V;){
        b = $51da786a5efa83c1$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $51da786a5efa83c1$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($51da786a5efa83c1$var$p(163));
            }
        } catch (F) {
            $51da786a5efa83c1$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $51da786a5efa83c1$var$V = a;
            break;
        }
        $51da786a5efa83c1$var$V = b.return;
    }
    n = $51da786a5efa83c1$var$Nj;
    $51da786a5efa83c1$var$Nj = !1;
    return n;
}
function $51da786a5efa83c1$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $51da786a5efa83c1$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $51da786a5efa83c1$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $51da786a5efa83c1$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $51da786a5efa83c1$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $51da786a5efa83c1$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$51da786a5efa83c1$var$Of], delete b[$51da786a5efa83c1$var$Pf], delete b[$51da786a5efa83c1$var$of], delete b[$51da786a5efa83c1$var$Qf], delete b[$51da786a5efa83c1$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $51da786a5efa83c1$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $51da786a5efa83c1$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $51da786a5efa83c1$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $51da786a5efa83c1$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $51da786a5efa83c1$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($51da786a5efa83c1$var$Vj(a, b, c), a = a.sibling; null !== a;)$51da786a5efa83c1$var$Vj(a, b, c), a = a.sibling;
}
function $51da786a5efa83c1$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($51da786a5efa83c1$var$Wj(a, b, c), a = a.sibling; null !== a;)$51da786a5efa83c1$var$Wj(a, b, c), a = a.sibling;
}
var $51da786a5efa83c1$var$X = null, $51da786a5efa83c1$var$Xj = !1;
function $51da786a5efa83c1$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$51da786a5efa83c1$var$Zj(a, b, c), c = c.sibling;
}
function $51da786a5efa83c1$var$Zj(a, b, c) {
    if ($51da786a5efa83c1$var$lc && "function" === typeof $51da786a5efa83c1$var$lc.onCommitFiberUnmount) try {
        $51da786a5efa83c1$var$lc.onCommitFiberUnmount($51da786a5efa83c1$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $51da786a5efa83c1$var$U || $51da786a5efa83c1$var$Lj(c, b);
        case 6:
            var d = $51da786a5efa83c1$var$X, e = $51da786a5efa83c1$var$Xj;
            $51da786a5efa83c1$var$X = null;
            $51da786a5efa83c1$var$Yj(a, b, c);
            $51da786a5efa83c1$var$X = d;
            $51da786a5efa83c1$var$Xj = e;
            null !== $51da786a5efa83c1$var$X && ($51da786a5efa83c1$var$Xj ? (a = $51da786a5efa83c1$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $51da786a5efa83c1$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $51da786a5efa83c1$var$X && ($51da786a5efa83c1$var$Xj ? (a = $51da786a5efa83c1$var$X, c = c.stateNode, 8 === a.nodeType ? $51da786a5efa83c1$var$Kf(a.parentNode, c) : 1 === a.nodeType && $51da786a5efa83c1$var$Kf(a, c), $51da786a5efa83c1$var$bd(a)) : $51da786a5efa83c1$var$Kf($51da786a5efa83c1$var$X, c.stateNode));
            break;
        case 4:
            d = $51da786a5efa83c1$var$X;
            e = $51da786a5efa83c1$var$Xj;
            $51da786a5efa83c1$var$X = c.stateNode.containerInfo;
            $51da786a5efa83c1$var$Xj = !0;
            $51da786a5efa83c1$var$Yj(a, b, c);
            $51da786a5efa83c1$var$X = d;
            $51da786a5efa83c1$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$51da786a5efa83c1$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $51da786a5efa83c1$var$Mj(c, b, g) : 0 !== (f & 4) && $51da786a5efa83c1$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $51da786a5efa83c1$var$Yj(a, b, c);
            break;
        case 1:
            if (!$51da786a5efa83c1$var$U && ($51da786a5efa83c1$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $51da786a5efa83c1$var$W(c, b, h);
            }
            $51da786a5efa83c1$var$Yj(a, b, c);
            break;
        case 21:
            $51da786a5efa83c1$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($51da786a5efa83c1$var$U = (d = $51da786a5efa83c1$var$U) || null !== c.memoizedState, $51da786a5efa83c1$var$Yj(a, b, c), $51da786a5efa83c1$var$U = d) : $51da786a5efa83c1$var$Yj(a, b, c);
            break;
        default:
            $51da786a5efa83c1$var$Yj(a, b, c);
    }
}
function $51da786a5efa83c1$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $51da786a5efa83c1$var$Kj);
        b.forEach(function(b) {
            var d = $51da786a5efa83c1$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $51da786a5efa83c1$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $51da786a5efa83c1$var$X = h.stateNode;
                        $51da786a5efa83c1$var$Xj = !1;
                        break a;
                    case 3:
                        $51da786a5efa83c1$var$X = h.stateNode.containerInfo;
                        $51da786a5efa83c1$var$Xj = !0;
                        break a;
                    case 4:
                        $51da786a5efa83c1$var$X = h.stateNode.containerInfo;
                        $51da786a5efa83c1$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $51da786a5efa83c1$var$X) throw Error($51da786a5efa83c1$var$p(160));
            $51da786a5efa83c1$var$Zj(f, g, e);
            $51da786a5efa83c1$var$X = null;
            $51da786a5efa83c1$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $51da786a5efa83c1$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$51da786a5efa83c1$var$dk(b, a), b = b.sibling;
}
function $51da786a5efa83c1$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            if (d & 4) {
                try {
                    $51da786a5efa83c1$var$Pj(3, a, a.return), $51da786a5efa83c1$var$Qj(3, a);
                } catch (t) {
                    $51da786a5efa83c1$var$W(a, a.return, t);
                }
                try {
                    $51da786a5efa83c1$var$Pj(5, a, a.return);
                } catch (t) {
                    $51da786a5efa83c1$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            d & 512 && null !== c && $51da786a5efa83c1$var$Lj(c, c.return);
            break;
        case 5:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            d & 512 && null !== c && $51da786a5efa83c1$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $51da786a5efa83c1$var$ob(e, "");
                } catch (t) {
                    $51da786a5efa83c1$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $51da786a5efa83c1$var$ab(e, f);
                    $51da786a5efa83c1$var$vb(h, g);
                    var l = $51da786a5efa83c1$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $51da786a5efa83c1$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $51da786a5efa83c1$var$nb(e, q) : "children" === m ? $51da786a5efa83c1$var$ob(e, q) : $51da786a5efa83c1$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $51da786a5efa83c1$var$bb(e, f);
                            break;
                        case "textarea":
                            $51da786a5efa83c1$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $51da786a5efa83c1$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $51da786a5efa83c1$var$fb(e, !!f.multiple, f.defaultValue, !0) : $51da786a5efa83c1$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$51da786a5efa83c1$var$Pf] = f;
                } catch (t) {
                    $51da786a5efa83c1$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($51da786a5efa83c1$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $51da786a5efa83c1$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $51da786a5efa83c1$var$bd(b.containerInfo);
            } catch (t) {
                $51da786a5efa83c1$var$W(a, a.return, t);
            }
            break;
        case 4:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            break;
        case 13:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($51da786a5efa83c1$var$fk = $51da786a5efa83c1$var$B()));
            d & 4 && $51da786a5efa83c1$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($51da786a5efa83c1$var$U = (l = $51da786a5efa83c1$var$U) || m, $51da786a5efa83c1$var$ck(b, a), $51da786a5efa83c1$var$U = l) : $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($51da786a5efa83c1$var$V = a, m = a.child; null !== m;){
                    for(q = $51da786a5efa83c1$var$V = m; null !== $51da786a5efa83c1$var$V;){
                        r = $51da786a5efa83c1$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $51da786a5efa83c1$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $51da786a5efa83c1$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $51da786a5efa83c1$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $51da786a5efa83c1$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $51da786a5efa83c1$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $51da786a5efa83c1$var$V = y) : $51da786a5efa83c1$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $51da786a5efa83c1$var$rb("display", g));
                            } catch (t) {
                                $51da786a5efa83c1$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $51da786a5efa83c1$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $51da786a5efa83c1$var$ck(b, a);
            $51da786a5efa83c1$var$ek(a);
            d & 4 && $51da786a5efa83c1$var$ak(a);
            break;
        case 21:
            break;
        default:
            $51da786a5efa83c1$var$ck(b, a), $51da786a5efa83c1$var$ek(a);
    }
}
function $51da786a5efa83c1$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($51da786a5efa83c1$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($51da786a5efa83c1$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($51da786a5efa83c1$var$ob(e, ""), d.flags &= -33);
                    var f = $51da786a5efa83c1$var$Uj(a);
                    $51da786a5efa83c1$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $51da786a5efa83c1$var$Uj(a);
                    $51da786a5efa83c1$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($51da786a5efa83c1$var$p(161));
            }
        } catch (k) {
            $51da786a5efa83c1$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $51da786a5efa83c1$var$hk(a, b, c) {
    $51da786a5efa83c1$var$V = a;
    $51da786a5efa83c1$var$ik(a, b, c);
}
function $51da786a5efa83c1$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $51da786a5efa83c1$var$V;){
        var e = $51da786a5efa83c1$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $51da786a5efa83c1$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $51da786a5efa83c1$var$U;
                h = $51da786a5efa83c1$var$Jj;
                var l = $51da786a5efa83c1$var$U;
                $51da786a5efa83c1$var$Jj = g;
                if (($51da786a5efa83c1$var$U = k) && !l) for($51da786a5efa83c1$var$V = e; null !== $51da786a5efa83c1$var$V;)g = $51da786a5efa83c1$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $51da786a5efa83c1$var$jk(e) : null !== k ? (k.return = g, $51da786a5efa83c1$var$V = k) : $51da786a5efa83c1$var$jk(e);
                for(; null !== f;)$51da786a5efa83c1$var$V = f, $51da786a5efa83c1$var$ik(f, b, c), f = f.sibling;
                $51da786a5efa83c1$var$V = e;
                $51da786a5efa83c1$var$Jj = h;
                $51da786a5efa83c1$var$U = l;
            }
            $51da786a5efa83c1$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $51da786a5efa83c1$var$V = f) : $51da786a5efa83c1$var$kk(a, b, c);
    }
}
function $51da786a5efa83c1$var$kk(a) {
    for(; null !== $51da786a5efa83c1$var$V;){
        var b = $51da786a5efa83c1$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $51da786a5efa83c1$var$U || $51da786a5efa83c1$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$51da786a5efa83c1$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $51da786a5efa83c1$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $51da786a5efa83c1$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $51da786a5efa83c1$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $51da786a5efa83c1$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($51da786a5efa83c1$var$p(163));
                }
                $51da786a5efa83c1$var$U || b.flags & 512 && $51da786a5efa83c1$var$Rj(b);
            } catch (r) {
                $51da786a5efa83c1$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $51da786a5efa83c1$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $51da786a5efa83c1$var$V = c;
            break;
        }
        $51da786a5efa83c1$var$V = b.return;
    }
}
function $51da786a5efa83c1$var$gk(a) {
    for(; null !== $51da786a5efa83c1$var$V;){
        var b = $51da786a5efa83c1$var$V;
        if (b === a) {
            $51da786a5efa83c1$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $51da786a5efa83c1$var$V = c;
            break;
        }
        $51da786a5efa83c1$var$V = b.return;
    }
}
function $51da786a5efa83c1$var$jk(a) {
    for(; null !== $51da786a5efa83c1$var$V;){
        var b = $51da786a5efa83c1$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $51da786a5efa83c1$var$Qj(4, b);
                    } catch (k) {
                        $51da786a5efa83c1$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $51da786a5efa83c1$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $51da786a5efa83c1$var$Rj(b);
                    } catch (k) {
                        $51da786a5efa83c1$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $51da786a5efa83c1$var$Rj(b);
                    } catch (k) {
                        $51da786a5efa83c1$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $51da786a5efa83c1$var$W(b, b.return, k);
        }
        if (b === a) {
            $51da786a5efa83c1$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $51da786a5efa83c1$var$V = h;
            break;
        }
        $51da786a5efa83c1$var$V = b.return;
    }
}
var $51da786a5efa83c1$var$lk = Math.ceil, $51da786a5efa83c1$var$mk = $51da786a5efa83c1$var$ua.ReactCurrentDispatcher, $51da786a5efa83c1$var$nk = $51da786a5efa83c1$var$ua.ReactCurrentOwner, $51da786a5efa83c1$var$ok = $51da786a5efa83c1$var$ua.ReactCurrentBatchConfig, $51da786a5efa83c1$var$K = 0, $51da786a5efa83c1$var$Q = null, $51da786a5efa83c1$var$Y = null, $51da786a5efa83c1$var$Z = 0, $51da786a5efa83c1$var$fj = 0, $51da786a5efa83c1$var$ej = $51da786a5efa83c1$var$Uf(0), $51da786a5efa83c1$var$T = 0, $51da786a5efa83c1$var$pk = null, $51da786a5efa83c1$var$rh = 0, $51da786a5efa83c1$var$qk = 0, $51da786a5efa83c1$var$rk = 0, $51da786a5efa83c1$var$sk = null, $51da786a5efa83c1$var$tk = null, $51da786a5efa83c1$var$fk = 0, $51da786a5efa83c1$var$Gj = Infinity, $51da786a5efa83c1$var$uk = null, $51da786a5efa83c1$var$Oi = !1, $51da786a5efa83c1$var$Pi = null, $51da786a5efa83c1$var$Ri = null, $51da786a5efa83c1$var$vk = !1, $51da786a5efa83c1$var$wk = null, $51da786a5efa83c1$var$xk = 0, $51da786a5efa83c1$var$yk = 0, $51da786a5efa83c1$var$zk = null, $51da786a5efa83c1$var$Ak = -1, $51da786a5efa83c1$var$Bk = 0;
function $51da786a5efa83c1$var$R() {
    return 0 !== ($51da786a5efa83c1$var$K & 6) ? $51da786a5efa83c1$var$B() : -1 !== $51da786a5efa83c1$var$Ak ? $51da786a5efa83c1$var$Ak : $51da786a5efa83c1$var$Ak = $51da786a5efa83c1$var$B();
}
function $51da786a5efa83c1$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($51da786a5efa83c1$var$K & 2) && 0 !== $51da786a5efa83c1$var$Z) return $51da786a5efa83c1$var$Z & -$51da786a5efa83c1$var$Z;
    if (null !== $51da786a5efa83c1$var$Kg.transition) return 0 === $51da786a5efa83c1$var$Bk && ($51da786a5efa83c1$var$Bk = $51da786a5efa83c1$var$yc()), $51da786a5efa83c1$var$Bk;
    a = $51da786a5efa83c1$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $51da786a5efa83c1$var$jd(a.type);
    return a;
}
function $51da786a5efa83c1$var$gi(a, b, c, d) {
    if (50 < $51da786a5efa83c1$var$yk) throw $51da786a5efa83c1$var$yk = 0, $51da786a5efa83c1$var$zk = null, Error($51da786a5efa83c1$var$p(185));
    $51da786a5efa83c1$var$Ac(a, c, d);
    if (0 === ($51da786a5efa83c1$var$K & 2) || a !== $51da786a5efa83c1$var$Q) a === $51da786a5efa83c1$var$Q && (0 === ($51da786a5efa83c1$var$K & 2) && ($51da786a5efa83c1$var$qk |= c), 4 === $51da786a5efa83c1$var$T && $51da786a5efa83c1$var$Ck(a, $51da786a5efa83c1$var$Z)), $51da786a5efa83c1$var$Dk(a, d), 1 === c && 0 === $51da786a5efa83c1$var$K && 0 === (b.mode & 1) && ($51da786a5efa83c1$var$Gj = $51da786a5efa83c1$var$B() + 500, $51da786a5efa83c1$var$fg && $51da786a5efa83c1$var$jg());
}
function $51da786a5efa83c1$var$Dk(a, b) {
    var c = a.callbackNode;
    $51da786a5efa83c1$var$wc(a, b);
    var d = $51da786a5efa83c1$var$uc(a, a === $51da786a5efa83c1$var$Q ? $51da786a5efa83c1$var$Z : 0);
    if (0 === d) null !== c && $51da786a5efa83c1$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $51da786a5efa83c1$var$bc(c);
        if (1 === b) 0 === a.tag ? $51da786a5efa83c1$var$ig($51da786a5efa83c1$var$Ek.bind(null, a)) : $51da786a5efa83c1$var$hg($51da786a5efa83c1$var$Ek.bind(null, a)), $51da786a5efa83c1$var$Jf(function() {
            0 === ($51da786a5efa83c1$var$K & 6) && $51da786a5efa83c1$var$jg();
        }), c = null;
        else {
            switch($51da786a5efa83c1$var$Dc(d)){
                case 1:
                    c = $51da786a5efa83c1$var$fc;
                    break;
                case 4:
                    c = $51da786a5efa83c1$var$gc;
                    break;
                case 16:
                    c = $51da786a5efa83c1$var$hc;
                    break;
                case 536870912:
                    c = $51da786a5efa83c1$var$jc;
                    break;
                default:
                    c = $51da786a5efa83c1$var$hc;
            }
            c = $51da786a5efa83c1$var$Fk(c, $51da786a5efa83c1$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $51da786a5efa83c1$var$Gk(a, b) {
    $51da786a5efa83c1$var$Ak = -1;
    $51da786a5efa83c1$var$Bk = 0;
    if (0 !== ($51da786a5efa83c1$var$K & 6)) throw Error($51da786a5efa83c1$var$p(327));
    var c = a.callbackNode;
    if ($51da786a5efa83c1$var$Hk() && a.callbackNode !== c) return null;
    var d = $51da786a5efa83c1$var$uc(a, a === $51da786a5efa83c1$var$Q ? $51da786a5efa83c1$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $51da786a5efa83c1$var$Ik(a, d);
    else {
        b = d;
        var e = $51da786a5efa83c1$var$K;
        $51da786a5efa83c1$var$K |= 2;
        var f = $51da786a5efa83c1$var$Jk();
        if ($51da786a5efa83c1$var$Q !== a || $51da786a5efa83c1$var$Z !== b) $51da786a5efa83c1$var$uk = null, $51da786a5efa83c1$var$Gj = $51da786a5efa83c1$var$B() + 500, $51da786a5efa83c1$var$Kk(a, b);
        for(;;)try {
            $51da786a5efa83c1$var$Lk();
            break;
        } catch (h) {
            $51da786a5efa83c1$var$Mk(a, h);
        }
        $51da786a5efa83c1$var$$g();
        $51da786a5efa83c1$var$mk.current = f;
        $51da786a5efa83c1$var$K = e;
        null !== $51da786a5efa83c1$var$Y ? b = 0 : ($51da786a5efa83c1$var$Q = null, $51da786a5efa83c1$var$Z = 0, b = $51da786a5efa83c1$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $51da786a5efa83c1$var$xc(a), 0 !== e && (d = e, b = $51da786a5efa83c1$var$Nk(a, e)));
        if (1 === b) throw c = $51da786a5efa83c1$var$pk, $51da786a5efa83c1$var$Kk(a, 0), $51da786a5efa83c1$var$Ck(a, d), $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B()), c;
        if (6 === b) $51da786a5efa83c1$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$51da786a5efa83c1$var$Ok(e) && (b = $51da786a5efa83c1$var$Ik(a, d), 2 === b && (f = $51da786a5efa83c1$var$xc(a), 0 !== f && (d = f, b = $51da786a5efa83c1$var$Nk(a, f))), 1 === b)) throw c = $51da786a5efa83c1$var$pk, $51da786a5efa83c1$var$Kk(a, 0), $51da786a5efa83c1$var$Ck(a, d), $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($51da786a5efa83c1$var$p(345));
                case 2:
                    $51da786a5efa83c1$var$Pk(a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk);
                    break;
                case 3:
                    $51da786a5efa83c1$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $51da786a5efa83c1$var$fk + 500 - $51da786a5efa83c1$var$B(), 10 < b)) {
                        if (0 !== $51da786a5efa83c1$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $51da786a5efa83c1$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $51da786a5efa83c1$var$Ff($51da786a5efa83c1$var$Pk.bind(null, a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk), b);
                        break;
                    }
                    $51da786a5efa83c1$var$Pk(a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk);
                    break;
                case 4:
                    $51da786a5efa83c1$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $51da786a5efa83c1$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $51da786a5efa83c1$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $51da786a5efa83c1$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $51da786a5efa83c1$var$Ff($51da786a5efa83c1$var$Pk.bind(null, a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk), d);
                        break;
                    }
                    $51da786a5efa83c1$var$Pk(a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk);
                    break;
                case 5:
                    $51da786a5efa83c1$var$Pk(a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk);
                    break;
                default:
                    throw Error($51da786a5efa83c1$var$p(329));
            }
        }
    }
    $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B());
    return a.callbackNode === c ? $51da786a5efa83c1$var$Gk.bind(null, a) : null;
}
function $51da786a5efa83c1$var$Nk(a, b) {
    var c = $51da786a5efa83c1$var$sk;
    a.current.memoizedState.isDehydrated && ($51da786a5efa83c1$var$Kk(a, b).flags |= 256);
    a = $51da786a5efa83c1$var$Ik(a, b);
    2 !== a && (b = $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$tk = c, null !== b && $51da786a5efa83c1$var$Fj(b));
    return a;
}
function $51da786a5efa83c1$var$Fj(a) {
    null === $51da786a5efa83c1$var$tk ? $51da786a5efa83c1$var$tk = a : $51da786a5efa83c1$var$tk.push.apply($51da786a5efa83c1$var$tk, a);
}
function $51da786a5efa83c1$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$51da786a5efa83c1$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $51da786a5efa83c1$var$Ck(a, b) {
    b &= ~$51da786a5efa83c1$var$rk;
    b &= ~$51da786a5efa83c1$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $51da786a5efa83c1$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $51da786a5efa83c1$var$Ek(a) {
    if (0 !== ($51da786a5efa83c1$var$K & 6)) throw Error($51da786a5efa83c1$var$p(327));
    $51da786a5efa83c1$var$Hk();
    var b = $51da786a5efa83c1$var$uc(a, 0);
    if (0 === (b & 1)) return $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B()), null;
    var c = $51da786a5efa83c1$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $51da786a5efa83c1$var$xc(a);
        0 !== d && (b = d, c = $51da786a5efa83c1$var$Nk(a, d));
    }
    if (1 === c) throw c = $51da786a5efa83c1$var$pk, $51da786a5efa83c1$var$Kk(a, 0), $51da786a5efa83c1$var$Ck(a, b), $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B()), c;
    if (6 === c) throw Error($51da786a5efa83c1$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $51da786a5efa83c1$var$Pk(a, $51da786a5efa83c1$var$tk, $51da786a5efa83c1$var$uk);
    $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B());
    return null;
}
function $51da786a5efa83c1$var$Qk(a, b) {
    var c = $51da786a5efa83c1$var$K;
    $51da786a5efa83c1$var$K |= 1;
    try {
        return a(b);
    } finally{
        $51da786a5efa83c1$var$K = c, 0 === $51da786a5efa83c1$var$K && ($51da786a5efa83c1$var$Gj = $51da786a5efa83c1$var$B() + 500, $51da786a5efa83c1$var$fg && $51da786a5efa83c1$var$jg());
    }
}
function $51da786a5efa83c1$var$Rk(a) {
    null !== $51da786a5efa83c1$var$wk && 0 === $51da786a5efa83c1$var$wk.tag && 0 === ($51da786a5efa83c1$var$K & 6) && $51da786a5efa83c1$var$Hk();
    var b = $51da786a5efa83c1$var$K;
    $51da786a5efa83c1$var$K |= 1;
    var c = $51da786a5efa83c1$var$ok.transition, d = $51da786a5efa83c1$var$C;
    try {
        if ($51da786a5efa83c1$var$ok.transition = null, $51da786a5efa83c1$var$C = 1, a) return a();
    } finally{
        $51da786a5efa83c1$var$C = d, $51da786a5efa83c1$var$ok.transition = c, $51da786a5efa83c1$var$K = b, 0 === ($51da786a5efa83c1$var$K & 6) && $51da786a5efa83c1$var$jg();
    }
}
function $51da786a5efa83c1$var$Hj() {
    $51da786a5efa83c1$var$fj = $51da786a5efa83c1$var$ej.current;
    $51da786a5efa83c1$var$E($51da786a5efa83c1$var$ej);
}
function $51da786a5efa83c1$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $51da786a5efa83c1$var$Gf(c));
    if (null !== $51da786a5efa83c1$var$Y) for(c = $51da786a5efa83c1$var$Y.return; null !== c;){
        var d = c;
        $51da786a5efa83c1$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $51da786a5efa83c1$var$$f();
                break;
            case 3:
                $51da786a5efa83c1$var$zh();
                $51da786a5efa83c1$var$E($51da786a5efa83c1$var$Wf);
                $51da786a5efa83c1$var$E($51da786a5efa83c1$var$H);
                $51da786a5efa83c1$var$Eh();
                break;
            case 5:
                $51da786a5efa83c1$var$Bh(d);
                break;
            case 4:
                $51da786a5efa83c1$var$zh();
                break;
            case 13:
                $51da786a5efa83c1$var$E($51da786a5efa83c1$var$L);
                break;
            case 19:
                $51da786a5efa83c1$var$E($51da786a5efa83c1$var$L);
                break;
            case 10:
                $51da786a5efa83c1$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $51da786a5efa83c1$var$Hj();
        }
        c = c.return;
    }
    $51da786a5efa83c1$var$Q = a;
    $51da786a5efa83c1$var$Y = a = $51da786a5efa83c1$var$Pg(a.current, null);
    $51da786a5efa83c1$var$Z = $51da786a5efa83c1$var$fj = b;
    $51da786a5efa83c1$var$T = 0;
    $51da786a5efa83c1$var$pk = null;
    $51da786a5efa83c1$var$rk = $51da786a5efa83c1$var$qk = $51da786a5efa83c1$var$rh = 0;
    $51da786a5efa83c1$var$tk = $51da786a5efa83c1$var$sk = null;
    if (null !== $51da786a5efa83c1$var$fh) {
        for(b = 0; b < $51da786a5efa83c1$var$fh.length; b++)if (c = $51da786a5efa83c1$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $51da786a5efa83c1$var$fh = null;
    }
    return a;
}
function $51da786a5efa83c1$var$Mk(a, b) {
    do {
        var c = $51da786a5efa83c1$var$Y;
        try {
            $51da786a5efa83c1$var$$g();
            $51da786a5efa83c1$var$Fh.current = $51da786a5efa83c1$var$Rh;
            if ($51da786a5efa83c1$var$Ih) {
                for(var d = $51da786a5efa83c1$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $51da786a5efa83c1$var$Ih = !1;
            }
            $51da786a5efa83c1$var$Hh = 0;
            $51da786a5efa83c1$var$O = $51da786a5efa83c1$var$N = $51da786a5efa83c1$var$M = null;
            $51da786a5efa83c1$var$Jh = !1;
            $51da786a5efa83c1$var$Kh = 0;
            $51da786a5efa83c1$var$nk.current = null;
            if (null === c || null === c.return) {
                $51da786a5efa83c1$var$T = 1;
                $51da786a5efa83c1$var$pk = b;
                $51da786a5efa83c1$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $51da786a5efa83c1$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $51da786a5efa83c1$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $51da786a5efa83c1$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $51da786a5efa83c1$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $51da786a5efa83c1$var$Si(f, l, b);
                            $51da786a5efa83c1$var$tj();
                            break a;
                        }
                        k = Error($51da786a5efa83c1$var$p(426));
                    }
                } else if ($51da786a5efa83c1$var$I && h.mode & 1) {
                    var J = $51da786a5efa83c1$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $51da786a5efa83c1$var$Vi(J, g, h, f, b);
                        $51da786a5efa83c1$var$Jg($51da786a5efa83c1$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $51da786a5efa83c1$var$Ji(k, h);
                4 !== $51da786a5efa83c1$var$T && ($51da786a5efa83c1$var$T = 2);
                null === $51da786a5efa83c1$var$sk ? $51da786a5efa83c1$var$sk = [
                    f
                ] : $51da786a5efa83c1$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $51da786a5efa83c1$var$Ni(f, k, b);
                            $51da786a5efa83c1$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $51da786a5efa83c1$var$Ri || !$51da786a5efa83c1$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $51da786a5efa83c1$var$Qi(f, h, b);
                                $51da786a5efa83c1$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $51da786a5efa83c1$var$Sk(c);
        } catch (na) {
            b = na;
            $51da786a5efa83c1$var$Y === c && null !== c && ($51da786a5efa83c1$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $51da786a5efa83c1$var$Jk() {
    var a = $51da786a5efa83c1$var$mk.current;
    $51da786a5efa83c1$var$mk.current = $51da786a5efa83c1$var$Rh;
    return null === a ? $51da786a5efa83c1$var$Rh : a;
}
function $51da786a5efa83c1$var$tj() {
    if (0 === $51da786a5efa83c1$var$T || 3 === $51da786a5efa83c1$var$T || 2 === $51da786a5efa83c1$var$T) $51da786a5efa83c1$var$T = 4;
    null === $51da786a5efa83c1$var$Q || 0 === ($51da786a5efa83c1$var$rh & 268435455) && 0 === ($51da786a5efa83c1$var$qk & 268435455) || $51da786a5efa83c1$var$Ck($51da786a5efa83c1$var$Q, $51da786a5efa83c1$var$Z);
}
function $51da786a5efa83c1$var$Ik(a, b) {
    var c = $51da786a5efa83c1$var$K;
    $51da786a5efa83c1$var$K |= 2;
    var d = $51da786a5efa83c1$var$Jk();
    if ($51da786a5efa83c1$var$Q !== a || $51da786a5efa83c1$var$Z !== b) $51da786a5efa83c1$var$uk = null, $51da786a5efa83c1$var$Kk(a, b);
    for(;;)try {
        $51da786a5efa83c1$var$Tk();
        break;
    } catch (e) {
        $51da786a5efa83c1$var$Mk(a, e);
    }
    $51da786a5efa83c1$var$$g();
    $51da786a5efa83c1$var$K = c;
    $51da786a5efa83c1$var$mk.current = d;
    if (null !== $51da786a5efa83c1$var$Y) throw Error($51da786a5efa83c1$var$p(261));
    $51da786a5efa83c1$var$Q = null;
    $51da786a5efa83c1$var$Z = 0;
    return $51da786a5efa83c1$var$T;
}
function $51da786a5efa83c1$var$Tk() {
    for(; null !== $51da786a5efa83c1$var$Y;)$51da786a5efa83c1$var$Uk($51da786a5efa83c1$var$Y);
}
function $51da786a5efa83c1$var$Lk() {
    for(; null !== $51da786a5efa83c1$var$Y && !$51da786a5efa83c1$var$cc();)$51da786a5efa83c1$var$Uk($51da786a5efa83c1$var$Y);
}
function $51da786a5efa83c1$var$Uk(a) {
    var b = $51da786a5efa83c1$var$Vk(a.alternate, a, $51da786a5efa83c1$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $51da786a5efa83c1$var$Sk(a) : $51da786a5efa83c1$var$Y = b;
    $51da786a5efa83c1$var$nk.current = null;
}
function $51da786a5efa83c1$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $51da786a5efa83c1$var$Ej(c, b, $51da786a5efa83c1$var$fj), null !== c) {
                $51da786a5efa83c1$var$Y = c;
                return;
            }
        } else {
            c = $51da786a5efa83c1$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $51da786a5efa83c1$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $51da786a5efa83c1$var$T = 6;
                $51da786a5efa83c1$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $51da786a5efa83c1$var$Y = b;
            return;
        }
        $51da786a5efa83c1$var$Y = b = a;
    }while (null !== b);
    0 === $51da786a5efa83c1$var$T && ($51da786a5efa83c1$var$T = 5);
}
function $51da786a5efa83c1$var$Pk(a, b, c) {
    var d = $51da786a5efa83c1$var$C, e = $51da786a5efa83c1$var$ok.transition;
    try {
        $51da786a5efa83c1$var$ok.transition = null, $51da786a5efa83c1$var$C = 1, $51da786a5efa83c1$var$Wk(a, b, c, d);
    } finally{
        $51da786a5efa83c1$var$ok.transition = e, $51da786a5efa83c1$var$C = d;
    }
    return null;
}
function $51da786a5efa83c1$var$Wk(a, b, c, d) {
    do $51da786a5efa83c1$var$Hk();
    while (null !== $51da786a5efa83c1$var$wk);
    if (0 !== ($51da786a5efa83c1$var$K & 6)) throw Error($51da786a5efa83c1$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($51da786a5efa83c1$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $51da786a5efa83c1$var$Bc(a, f);
    a === $51da786a5efa83c1$var$Q && ($51da786a5efa83c1$var$Y = $51da786a5efa83c1$var$Q = null, $51da786a5efa83c1$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $51da786a5efa83c1$var$vk || ($51da786a5efa83c1$var$vk = !0, $51da786a5efa83c1$var$Fk($51da786a5efa83c1$var$hc, function() {
        $51da786a5efa83c1$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $51da786a5efa83c1$var$ok.transition;
        $51da786a5efa83c1$var$ok.transition = null;
        var g = $51da786a5efa83c1$var$C;
        $51da786a5efa83c1$var$C = 1;
        var h = $51da786a5efa83c1$var$K;
        $51da786a5efa83c1$var$K |= 4;
        $51da786a5efa83c1$var$nk.current = null;
        $51da786a5efa83c1$var$Oj(a, c);
        $51da786a5efa83c1$var$dk(c, a);
        $51da786a5efa83c1$var$Oe($51da786a5efa83c1$var$Df);
        $51da786a5efa83c1$var$dd = !!$51da786a5efa83c1$var$Cf;
        $51da786a5efa83c1$var$Df = $51da786a5efa83c1$var$Cf = null;
        a.current = c;
        $51da786a5efa83c1$var$hk(c, a, e);
        $51da786a5efa83c1$var$dc();
        $51da786a5efa83c1$var$K = h;
        $51da786a5efa83c1$var$C = g;
        $51da786a5efa83c1$var$ok.transition = f;
    } else a.current = c;
    $51da786a5efa83c1$var$vk && ($51da786a5efa83c1$var$vk = !1, $51da786a5efa83c1$var$wk = a, $51da786a5efa83c1$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($51da786a5efa83c1$var$Ri = null);
    $51da786a5efa83c1$var$mc(c.stateNode, d);
    $51da786a5efa83c1$var$Dk(a, $51da786a5efa83c1$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($51da786a5efa83c1$var$Oi) throw $51da786a5efa83c1$var$Oi = !1, a = $51da786a5efa83c1$var$Pi, $51da786a5efa83c1$var$Pi = null, a;
    0 !== ($51da786a5efa83c1$var$xk & 1) && 0 !== a.tag && $51da786a5efa83c1$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $51da786a5efa83c1$var$zk ? $51da786a5efa83c1$var$yk++ : ($51da786a5efa83c1$var$yk = 0, $51da786a5efa83c1$var$zk = a) : $51da786a5efa83c1$var$yk = 0;
    $51da786a5efa83c1$var$jg();
    return null;
}
function $51da786a5efa83c1$var$Hk() {
    if (null !== $51da786a5efa83c1$var$wk) {
        var a = $51da786a5efa83c1$var$Dc($51da786a5efa83c1$var$xk), b = $51da786a5efa83c1$var$ok.transition, c = $51da786a5efa83c1$var$C;
        try {
            $51da786a5efa83c1$var$ok.transition = null;
            $51da786a5efa83c1$var$C = 16 > a ? 16 : a;
            if (null === $51da786a5efa83c1$var$wk) var d = !1;
            else {
                a = $51da786a5efa83c1$var$wk;
                $51da786a5efa83c1$var$wk = null;
                $51da786a5efa83c1$var$xk = 0;
                if (0 !== ($51da786a5efa83c1$var$K & 6)) throw Error($51da786a5efa83c1$var$p(331));
                var e = $51da786a5efa83c1$var$K;
                $51da786a5efa83c1$var$K |= 4;
                for($51da786a5efa83c1$var$V = a.current; null !== $51da786a5efa83c1$var$V;){
                    var f = $51da786a5efa83c1$var$V, g = f.child;
                    if (0 !== ($51da786a5efa83c1$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($51da786a5efa83c1$var$V = l; null !== $51da786a5efa83c1$var$V;){
                                    var m = $51da786a5efa83c1$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $51da786a5efa83c1$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $51da786a5efa83c1$var$V = q;
                                    else for(; null !== $51da786a5efa83c1$var$V;){
                                        m = $51da786a5efa83c1$var$V;
                                        var r = m.sibling, y = m.return;
                                        $51da786a5efa83c1$var$Sj(m);
                                        if (m === l) {
                                            $51da786a5efa83c1$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $51da786a5efa83c1$var$V = r;
                                            break;
                                        }
                                        $51da786a5efa83c1$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $51da786a5efa83c1$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $51da786a5efa83c1$var$V = g;
                    else b: for(; null !== $51da786a5efa83c1$var$V;){
                        f = $51da786a5efa83c1$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $51da786a5efa83c1$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $51da786a5efa83c1$var$V = x;
                            break b;
                        }
                        $51da786a5efa83c1$var$V = f.return;
                    }
                }
                var w = a.current;
                for($51da786a5efa83c1$var$V = w; null !== $51da786a5efa83c1$var$V;){
                    g = $51da786a5efa83c1$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $51da786a5efa83c1$var$V = u;
                    else b: for(g = w; null !== $51da786a5efa83c1$var$V;){
                        h = $51da786a5efa83c1$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $51da786a5efa83c1$var$Qj(9, h);
                            }
                        } catch (na) {
                            $51da786a5efa83c1$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $51da786a5efa83c1$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $51da786a5efa83c1$var$V = F;
                            break b;
                        }
                        $51da786a5efa83c1$var$V = h.return;
                    }
                }
                $51da786a5efa83c1$var$K = e;
                $51da786a5efa83c1$var$jg();
                if ($51da786a5efa83c1$var$lc && "function" === typeof $51da786a5efa83c1$var$lc.onPostCommitFiberRoot) try {
                    $51da786a5efa83c1$var$lc.onPostCommitFiberRoot($51da786a5efa83c1$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $51da786a5efa83c1$var$C = c, $51da786a5efa83c1$var$ok.transition = b;
        }
    }
    return !1;
}
function $51da786a5efa83c1$var$Xk(a, b, c) {
    b = $51da786a5efa83c1$var$Ji(c, b);
    b = $51da786a5efa83c1$var$Ni(a, b, 1);
    a = $51da786a5efa83c1$var$nh(a, b, 1);
    b = $51da786a5efa83c1$var$R();
    null !== a && ($51da786a5efa83c1$var$Ac(a, 1, b), $51da786a5efa83c1$var$Dk(a, b));
}
function $51da786a5efa83c1$var$W(a, b, c) {
    if (3 === a.tag) $51da786a5efa83c1$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $51da786a5efa83c1$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $51da786a5efa83c1$var$Ri || !$51da786a5efa83c1$var$Ri.has(d))) {
                a = $51da786a5efa83c1$var$Ji(c, a);
                a = $51da786a5efa83c1$var$Qi(b, a, 1);
                b = $51da786a5efa83c1$var$nh(b, a, 1);
                a = $51da786a5efa83c1$var$R();
                null !== b && ($51da786a5efa83c1$var$Ac(b, 1, a), $51da786a5efa83c1$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $51da786a5efa83c1$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $51da786a5efa83c1$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $51da786a5efa83c1$var$Q === a && ($51da786a5efa83c1$var$Z & c) === c && (4 === $51da786a5efa83c1$var$T || 3 === $51da786a5efa83c1$var$T && ($51da786a5efa83c1$var$Z & 130023424) === $51da786a5efa83c1$var$Z && 500 > $51da786a5efa83c1$var$B() - $51da786a5efa83c1$var$fk ? $51da786a5efa83c1$var$Kk(a, 0) : $51da786a5efa83c1$var$rk |= c);
    $51da786a5efa83c1$var$Dk(a, b);
}
function $51da786a5efa83c1$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $51da786a5efa83c1$var$sc, $51da786a5efa83c1$var$sc <<= 1, 0 === ($51da786a5efa83c1$var$sc & 130023424) && ($51da786a5efa83c1$var$sc = 4194304)));
    var c = $51da786a5efa83c1$var$R();
    a = $51da786a5efa83c1$var$ih(a, b);
    null !== a && ($51da786a5efa83c1$var$Ac(a, b, c), $51da786a5efa83c1$var$Dk(a, c));
}
function $51da786a5efa83c1$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $51da786a5efa83c1$var$Yk(a, c);
}
function $51da786a5efa83c1$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($51da786a5efa83c1$var$p(314));
    }
    null !== d && d.delete(b);
    $51da786a5efa83c1$var$Yk(a, c);
}
var $51da786a5efa83c1$var$Vk;
$51da786a5efa83c1$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $51da786a5efa83c1$var$Wf.current) $51da786a5efa83c1$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $51da786a5efa83c1$var$dh = !1, $51da786a5efa83c1$var$yj(a, b, c);
            $51da786a5efa83c1$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $51da786a5efa83c1$var$dh = !1, $51da786a5efa83c1$var$I && 0 !== (b.flags & 1048576) && $51da786a5efa83c1$var$ug(b, $51da786a5efa83c1$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $51da786a5efa83c1$var$ij(a, b);
            a = b.pendingProps;
            var e = $51da786a5efa83c1$var$Yf(b, $51da786a5efa83c1$var$H.current);
            $51da786a5efa83c1$var$ch(b, c);
            e = $51da786a5efa83c1$var$Nh(null, b, d, a, e, c);
            var f = $51da786a5efa83c1$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $51da786a5efa83c1$var$Zf(d) ? (f = !0, $51da786a5efa83c1$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $51da786a5efa83c1$var$kh(b), e.updater = $51da786a5efa83c1$var$Ei, b.stateNode = e, e._reactInternals = b, $51da786a5efa83c1$var$Ii(b, d, a, c), b = $51da786a5efa83c1$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $51da786a5efa83c1$var$I && f && $51da786a5efa83c1$var$vg(b), $51da786a5efa83c1$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $51da786a5efa83c1$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $51da786a5efa83c1$var$Zk(d);
                a = $51da786a5efa83c1$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $51da786a5efa83c1$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $51da786a5efa83c1$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $51da786a5efa83c1$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $51da786a5efa83c1$var$$i(null, b, d, $51da786a5efa83c1$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($51da786a5efa83c1$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $51da786a5efa83c1$var$Ci(d, e), $51da786a5efa83c1$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $51da786a5efa83c1$var$Ci(d, e), $51da786a5efa83c1$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $51da786a5efa83c1$var$kj(b);
                if (null === a) throw Error($51da786a5efa83c1$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $51da786a5efa83c1$var$lh(a, b);
                $51da786a5efa83c1$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $51da786a5efa83c1$var$Ji(Error($51da786a5efa83c1$var$p(423)), b);
                        b = $51da786a5efa83c1$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $51da786a5efa83c1$var$Ji(Error($51da786a5efa83c1$var$p(424)), b);
                        b = $51da786a5efa83c1$var$lj(a, b, d, c, e);
                        break a;
                    } else for($51da786a5efa83c1$var$yg = $51da786a5efa83c1$var$Lf(b.stateNode.containerInfo.firstChild), $51da786a5efa83c1$var$xg = b, $51da786a5efa83c1$var$I = !0, $51da786a5efa83c1$var$zg = null, c = $51da786a5efa83c1$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $51da786a5efa83c1$var$Ig();
                    if (d === e) {
                        b = $51da786a5efa83c1$var$Zi(a, b, c);
                        break a;
                    }
                    $51da786a5efa83c1$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $51da786a5efa83c1$var$Ah(b), null === a && $51da786a5efa83c1$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $51da786a5efa83c1$var$Ef(d, e) ? g = null : null !== f && $51da786a5efa83c1$var$Ef(d, f) && (b.flags |= 32), $51da786a5efa83c1$var$gj(a, b), $51da786a5efa83c1$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $51da786a5efa83c1$var$Eg(b), null;
        case 13:
            return $51da786a5efa83c1$var$oj(a, b, c);
        case 4:
            return $51da786a5efa83c1$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $51da786a5efa83c1$var$Ug(b, null, d, c) : $51da786a5efa83c1$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $51da786a5efa83c1$var$Ci(d, e), $51da786a5efa83c1$var$Yi(a, b, d, e, c);
        case 7:
            return $51da786a5efa83c1$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $51da786a5efa83c1$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $51da786a5efa83c1$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $51da786a5efa83c1$var$G($51da786a5efa83c1$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($51da786a5efa83c1$var$He(f.value, g)) {
                        if (f.children === e.children && !$51da786a5efa83c1$var$Wf.current) {
                            b = $51da786a5efa83c1$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $51da786a5efa83c1$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $51da786a5efa83c1$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($51da786a5efa83c1$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $51da786a5efa83c1$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $51da786a5efa83c1$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $51da786a5efa83c1$var$ch(b, c), e = $51da786a5efa83c1$var$eh(e), d = d(e), b.flags |= 1, $51da786a5efa83c1$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $51da786a5efa83c1$var$Ci(d, b.pendingProps), e = $51da786a5efa83c1$var$Ci(d.type, e), $51da786a5efa83c1$var$$i(a, b, d, e, c);
        case 15:
            return $51da786a5efa83c1$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $51da786a5efa83c1$var$Ci(d, e), $51da786a5efa83c1$var$ij(a, b), b.tag = 1, $51da786a5efa83c1$var$Zf(d) ? (a = !0, $51da786a5efa83c1$var$cg(b)) : a = !1, $51da786a5efa83c1$var$ch(b, c), $51da786a5efa83c1$var$Gi(b, d, e), $51da786a5efa83c1$var$Ii(b, d, e, c), $51da786a5efa83c1$var$jj(null, b, d, !0, a, c);
        case 19:
            return $51da786a5efa83c1$var$xj(a, b, c);
        case 22:
            return $51da786a5efa83c1$var$dj(a, b, c);
    }
    throw Error($51da786a5efa83c1$var$p(156, b.tag));
};
function $51da786a5efa83c1$var$Fk(a, b) {
    return $51da786a5efa83c1$var$ac(a, b);
}
function $51da786a5efa83c1$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $51da786a5efa83c1$var$Bg(a, b, c, d) {
    return new $51da786a5efa83c1$var$$k(a, b, c, d);
}
function $51da786a5efa83c1$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $51da786a5efa83c1$var$Zk(a) {
    if ("function" === typeof a) return $51da786a5efa83c1$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $51da786a5efa83c1$var$Da) return 11;
        if (a === $51da786a5efa83c1$var$Ga) return 14;
    }
    return 2;
}
function $51da786a5efa83c1$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $51da786a5efa83c1$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $51da786a5efa83c1$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $51da786a5efa83c1$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $51da786a5efa83c1$var$ya:
            return $51da786a5efa83c1$var$Tg(c.children, e, f, b);
        case $51da786a5efa83c1$var$za:
            g = 8;
            e |= 8;
            break;
        case $51da786a5efa83c1$var$Aa:
            return a = $51da786a5efa83c1$var$Bg(12, c, b, e | 2), a.elementType = $51da786a5efa83c1$var$Aa, a.lanes = f, a;
        case $51da786a5efa83c1$var$Ea:
            return a = $51da786a5efa83c1$var$Bg(13, c, b, e), a.elementType = $51da786a5efa83c1$var$Ea, a.lanes = f, a;
        case $51da786a5efa83c1$var$Fa:
            return a = $51da786a5efa83c1$var$Bg(19, c, b, e), a.elementType = $51da786a5efa83c1$var$Fa, a.lanes = f, a;
        case $51da786a5efa83c1$var$Ia:
            return $51da786a5efa83c1$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $51da786a5efa83c1$var$Ba:
                    g = 10;
                    break a;
                case $51da786a5efa83c1$var$Ca:
                    g = 9;
                    break a;
                case $51da786a5efa83c1$var$Da:
                    g = 11;
                    break a;
                case $51da786a5efa83c1$var$Ga:
                    g = 14;
                    break a;
                case $51da786a5efa83c1$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($51da786a5efa83c1$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $51da786a5efa83c1$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $51da786a5efa83c1$var$Tg(a, b, c, d) {
    a = $51da786a5efa83c1$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $51da786a5efa83c1$var$pj(a, b, c, d) {
    a = $51da786a5efa83c1$var$Bg(22, a, d, b);
    a.elementType = $51da786a5efa83c1$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $51da786a5efa83c1$var$Qg(a, b, c) {
    a = $51da786a5efa83c1$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $51da786a5efa83c1$var$Sg(a, b, c) {
    b = $51da786a5efa83c1$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $51da786a5efa83c1$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $51da786a5efa83c1$var$zc(0);
    this.expirationTimes = $51da786a5efa83c1$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $51da786a5efa83c1$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $51da786a5efa83c1$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $51da786a5efa83c1$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $51da786a5efa83c1$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $51da786a5efa83c1$var$kh(f);
    return a;
}
function $51da786a5efa83c1$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $51da786a5efa83c1$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $51da786a5efa83c1$var$dl(a) {
    if (!a) return $51da786a5efa83c1$var$Vf;
    a = a._reactInternals;
    a: {
        if ($51da786a5efa83c1$var$Vb(a) !== a || 1 !== a.tag) throw Error($51da786a5efa83c1$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($51da786a5efa83c1$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($51da786a5efa83c1$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($51da786a5efa83c1$var$Zf(c)) return $51da786a5efa83c1$var$bg(a, c, b);
    }
    return b;
}
function $51da786a5efa83c1$var$el(a, b, c, d, e, f, g, h, k) {
    a = $51da786a5efa83c1$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $51da786a5efa83c1$var$dl(null);
    c = a.current;
    d = $51da786a5efa83c1$var$R();
    e = $51da786a5efa83c1$var$yi(c);
    f = $51da786a5efa83c1$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $51da786a5efa83c1$var$nh(c, f, e);
    a.current.lanes = e;
    $51da786a5efa83c1$var$Ac(a, e, d);
    $51da786a5efa83c1$var$Dk(a, d);
    return a;
}
function $51da786a5efa83c1$var$fl(a, b, c, d) {
    var e = b.current, f = $51da786a5efa83c1$var$R(), g = $51da786a5efa83c1$var$yi(e);
    c = $51da786a5efa83c1$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $51da786a5efa83c1$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $51da786a5efa83c1$var$nh(e, b, g);
    null !== a && ($51da786a5efa83c1$var$gi(a, e, g, f), $51da786a5efa83c1$var$oh(a, e, g));
    return g;
}
function $51da786a5efa83c1$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $51da786a5efa83c1$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $51da786a5efa83c1$var$il(a, b) {
    $51da786a5efa83c1$var$hl(a, b);
    (a = a.alternate) && $51da786a5efa83c1$var$hl(a, b);
}
function $51da786a5efa83c1$var$jl() {
    return null;
}
var $51da786a5efa83c1$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $51da786a5efa83c1$var$ll(a) {
    this._internalRoot = a;
}
$51da786a5efa83c1$var$ml.prototype.render = $51da786a5efa83c1$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($51da786a5efa83c1$var$p(409));
    $51da786a5efa83c1$var$fl(a, b, null, null);
};
$51da786a5efa83c1$var$ml.prototype.unmount = $51da786a5efa83c1$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $51da786a5efa83c1$var$Rk(function() {
            $51da786a5efa83c1$var$fl(null, a, null, null);
        });
        b[$51da786a5efa83c1$var$uf] = null;
    }
};
function $51da786a5efa83c1$var$ml(a) {
    this._internalRoot = a;
}
$51da786a5efa83c1$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $51da786a5efa83c1$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $51da786a5efa83c1$var$Qc.length && 0 !== b && b < $51da786a5efa83c1$var$Qc[c].priority; c++);
        $51da786a5efa83c1$var$Qc.splice(c, 0, a);
        0 === c && $51da786a5efa83c1$var$Vc(a);
    }
};
function $51da786a5efa83c1$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $51da786a5efa83c1$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $51da786a5efa83c1$var$pl() {}
function $51da786a5efa83c1$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $51da786a5efa83c1$var$gl(g);
                f.call(a);
            };
        }
        var g = $51da786a5efa83c1$var$el(b, d, a, 0, null, !1, !1, "", $51da786a5efa83c1$var$pl);
        a._reactRootContainer = g;
        a[$51da786a5efa83c1$var$uf] = g.current;
        $51da786a5efa83c1$var$sf(8 === a.nodeType ? a.parentNode : a);
        $51da786a5efa83c1$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $51da786a5efa83c1$var$gl(k);
            h.call(a);
        };
    }
    var k = $51da786a5efa83c1$var$bl(a, 0, !1, null, null, !1, !1, "", $51da786a5efa83c1$var$pl);
    a._reactRootContainer = k;
    a[$51da786a5efa83c1$var$uf] = k.current;
    $51da786a5efa83c1$var$sf(8 === a.nodeType ? a.parentNode : a);
    $51da786a5efa83c1$var$Rk(function() {
        $51da786a5efa83c1$var$fl(b, k, c, d);
    });
    return k;
}
function $51da786a5efa83c1$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $51da786a5efa83c1$var$gl(g);
                h.call(a);
            };
        }
        $51da786a5efa83c1$var$fl(b, g, a, e);
    } else g = $51da786a5efa83c1$var$ql(c, b, a, e, d);
    return $51da786a5efa83c1$var$gl(g);
}
$51da786a5efa83c1$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $51da786a5efa83c1$var$tc(b.pendingLanes);
                0 !== c && ($51da786a5efa83c1$var$Cc(b, c | 1), $51da786a5efa83c1$var$Dk(b, $51da786a5efa83c1$var$B()), 0 === ($51da786a5efa83c1$var$K & 6) && ($51da786a5efa83c1$var$Gj = $51da786a5efa83c1$var$B() + 500, $51da786a5efa83c1$var$jg()));
            }
            break;
        case 13:
            $51da786a5efa83c1$var$Rk(function() {
                var b = $51da786a5efa83c1$var$ih(a, 1);
                if (null !== b) {
                    var c = $51da786a5efa83c1$var$R();
                    $51da786a5efa83c1$var$gi(b, a, 1, c);
                }
            }), $51da786a5efa83c1$var$il(a, 1);
    }
};
$51da786a5efa83c1$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $51da786a5efa83c1$var$ih(a, 134217728);
        if (null !== b) {
            var c = $51da786a5efa83c1$var$R();
            $51da786a5efa83c1$var$gi(b, a, 134217728, c);
        }
        $51da786a5efa83c1$var$il(a, 134217728);
    }
};
$51da786a5efa83c1$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $51da786a5efa83c1$var$yi(a), c = $51da786a5efa83c1$var$ih(a, b);
        if (null !== c) {
            var d = $51da786a5efa83c1$var$R();
            $51da786a5efa83c1$var$gi(c, a, b, d);
        }
        $51da786a5efa83c1$var$il(a, b);
    }
};
$51da786a5efa83c1$var$Hc = function() {
    return $51da786a5efa83c1$var$C;
};
$51da786a5efa83c1$var$Ic = function(a, b) {
    var c = $51da786a5efa83c1$var$C;
    try {
        return $51da786a5efa83c1$var$C = a, b();
    } finally{
        $51da786a5efa83c1$var$C = c;
    }
};
$51da786a5efa83c1$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $51da786a5efa83c1$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $51da786a5efa83c1$var$Db(d);
                        if (!e) throw Error($51da786a5efa83c1$var$p(90));
                        $51da786a5efa83c1$var$Wa(d);
                        $51da786a5efa83c1$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $51da786a5efa83c1$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $51da786a5efa83c1$var$fb(a, !!c.multiple, b, !1);
    }
};
$51da786a5efa83c1$var$Gb = $51da786a5efa83c1$var$Qk;
$51da786a5efa83c1$var$Hb = $51da786a5efa83c1$var$Rk;
var $51da786a5efa83c1$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $51da786a5efa83c1$var$Cb,
        $51da786a5efa83c1$var$ue,
        $51da786a5efa83c1$var$Db,
        $51da786a5efa83c1$var$Eb,
        $51da786a5efa83c1$var$Fb,
        $51da786a5efa83c1$var$Qk
    ]
}, $51da786a5efa83c1$var$tl = {
    findFiberByHostInstance: $51da786a5efa83c1$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $51da786a5efa83c1$var$ul = {
    bundleType: $51da786a5efa83c1$var$tl.bundleType,
    version: $51da786a5efa83c1$var$tl.version,
    rendererPackageName: $51da786a5efa83c1$var$tl.rendererPackageName,
    rendererConfig: $51da786a5efa83c1$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $51da786a5efa83c1$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $51da786a5efa83c1$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $51da786a5efa83c1$var$tl.findFiberByHostInstance || $51da786a5efa83c1$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $51da786a5efa83c1$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$51da786a5efa83c1$var$vl.isDisabled && $51da786a5efa83c1$var$vl.supportsFiber) try {
        $51da786a5efa83c1$var$kc = $51da786a5efa83c1$var$vl.inject($51da786a5efa83c1$var$ul), $51da786a5efa83c1$var$lc = $51da786a5efa83c1$var$vl;
    } catch (a) {}
}
$51da786a5efa83c1$export$ae55be85d98224ed = $51da786a5efa83c1$var$sl;
$51da786a5efa83c1$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$51da786a5efa83c1$var$nl(b)) throw Error($51da786a5efa83c1$var$p(200));
    return $51da786a5efa83c1$var$cl(a, b, null, c);
};
$51da786a5efa83c1$export$882461b6382ed46c = function(a, b) {
    if (!$51da786a5efa83c1$var$nl(a)) throw Error($51da786a5efa83c1$var$p(299));
    var c = !1, d = "", e = $51da786a5efa83c1$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $51da786a5efa83c1$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$51da786a5efa83c1$var$uf] = b.current;
    $51da786a5efa83c1$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $51da786a5efa83c1$var$ll(b);
};
$51da786a5efa83c1$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($51da786a5efa83c1$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($51da786a5efa83c1$var$p(268, a));
    }
    a = $51da786a5efa83c1$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$51da786a5efa83c1$export$cd75ccfd720a3cd4 = function(a) {
    return $51da786a5efa83c1$var$Rk(a);
};
$51da786a5efa83c1$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$51da786a5efa83c1$var$ol(b)) throw Error($51da786a5efa83c1$var$p(200));
    return $51da786a5efa83c1$var$rl(null, a, b, !0, c);
};
$51da786a5efa83c1$export$757ceba2d55c277e = function(a, b, c) {
    if (!$51da786a5efa83c1$var$nl(a)) throw Error($51da786a5efa83c1$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $51da786a5efa83c1$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $51da786a5efa83c1$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$51da786a5efa83c1$var$uf] = b.current;
    $51da786a5efa83c1$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $51da786a5efa83c1$var$ml(b);
};
$51da786a5efa83c1$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$51da786a5efa83c1$var$ol(b)) throw Error($51da786a5efa83c1$var$p(200));
    return $51da786a5efa83c1$var$rl(null, a, b, !1, c);
};
$51da786a5efa83c1$export$502457920280e6be = function(a) {
    if (!$51da786a5efa83c1$var$ol(a)) throw Error($51da786a5efa83c1$var$p(40));
    return a._reactRootContainer ? ($51da786a5efa83c1$var$Rk(function() {
        $51da786a5efa83c1$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$51da786a5efa83c1$var$uf] = null;
        });
    }), !0) : !1;
};
$51da786a5efa83c1$export$c78a37762a8d58e1 = $51da786a5efa83c1$var$Qk;
$51da786a5efa83c1$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$51da786a5efa83c1$var$ol(c)) throw Error($51da786a5efa83c1$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($51da786a5efa83c1$var$p(38));
    return $51da786a5efa83c1$var$rl(a, b, c, !1, d);
};
$51da786a5efa83c1$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("dVdJZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("h6vnS"));

});
parcelRegister("h6vnS", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c73b576a1f51aaf8$export$c4744153514ff05d; }, function (v) { return $c73b576a1f51aaf8$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c73b576a1f51aaf8$export$3e506c1ccc9cc1a7; }, function (v) { return $c73b576a1f51aaf8$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c73b576a1f51aaf8$export$e26fe2ed2fa76875; }, function (v) { return $c73b576a1f51aaf8$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c73b576a1f51aaf8$export$502329bbf4b505b1; }, function (v) { return $c73b576a1f51aaf8$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c73b576a1f51aaf8$export$6e3807111c4874c4; }, function (v) { return $c73b576a1f51aaf8$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c73b576a1f51aaf8$export$c27134553091fb3a; }, function (v) { return $c73b576a1f51aaf8$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c73b576a1f51aaf8$export$33ee1acdc04fd2a2; }, function (v) { return $c73b576a1f51aaf8$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c73b576a1f51aaf8$export$b00a404bbd5edef2; }, function (v) { return $c73b576a1f51aaf8$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c73b576a1f51aaf8$export$8352ce38b91d0c62; }, function (v) { return $c73b576a1f51aaf8$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c73b576a1f51aaf8$export$d66a1c1c77bd778b; }, function (v) { return $c73b576a1f51aaf8$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c73b576a1f51aaf8$export$d3dfb8e4810cb555; }, function (v) { return $c73b576a1f51aaf8$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c73b576a1f51aaf8$export$839f9183b0465a69; }, function (v) { return $c73b576a1f51aaf8$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c73b576a1f51aaf8$export$72fdf0e06517287b; }, function (v) { return $c73b576a1f51aaf8$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c73b576a1f51aaf8$export$4b844e58a3e414b4; }, function (v) { return $c73b576a1f51aaf8$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c73b576a1f51aaf8$export$816d2913ae6b83b1; }, function (v) { return $c73b576a1f51aaf8$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c73b576a1f51aaf8$export$61bcfe829111a1d0; }, function (v) { return $c73b576a1f51aaf8$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c73b576a1f51aaf8$export$7ee8c9beb337bc3f; }, function (v) { return $c73b576a1f51aaf8$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c73b576a1f51aaf8$export$b5836b71941fa3ed; }, function (v) { return $c73b576a1f51aaf8$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c73b576a1f51aaf8$export$cf845f2c119da08a; }, function (v) { return $c73b576a1f51aaf8$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c73b576a1f51aaf8$export$c4744153514ff05d;
var $c73b576a1f51aaf8$export$3e506c1ccc9cc1a7;
var $c73b576a1f51aaf8$export$e26fe2ed2fa76875;
var $c73b576a1f51aaf8$export$502329bbf4b505b1;
var $c73b576a1f51aaf8$export$6e3807111c4874c4;
var $c73b576a1f51aaf8$export$c27134553091fb3a;
var $c73b576a1f51aaf8$export$33ee1acdc04fd2a2;
var $c73b576a1f51aaf8$export$b00a404bbd5edef2;
var $c73b576a1f51aaf8$export$8352ce38b91d0c62;
var $c73b576a1f51aaf8$export$d66a1c1c77bd778b;
var $c73b576a1f51aaf8$export$d3dfb8e4810cb555;
var $c73b576a1f51aaf8$export$839f9183b0465a69;
var $c73b576a1f51aaf8$export$72fdf0e06517287b;
var $c73b576a1f51aaf8$export$4b844e58a3e414b4;
var $c73b576a1f51aaf8$export$816d2913ae6b83b1;
var $c73b576a1f51aaf8$export$61bcfe829111a1d0;
var $c73b576a1f51aaf8$export$7ee8c9beb337bc3f;
var $c73b576a1f51aaf8$export$b5836b71941fa3ed;
var $c73b576a1f51aaf8$export$cf845f2c119da08a;
'use strict';
function $c73b576a1f51aaf8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $c73b576a1f51aaf8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $c73b576a1f51aaf8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $c73b576a1f51aaf8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $c73b576a1f51aaf8$var$g(C, c)) n < e && 0 > $c73b576a1f51aaf8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $c73b576a1f51aaf8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $c73b576a1f51aaf8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c73b576a1f51aaf8$var$l = performance;
    $c73b576a1f51aaf8$export$c4744153514ff05d = function() {
        return $c73b576a1f51aaf8$var$l.now();
    };
} else {
    var $c73b576a1f51aaf8$var$p = Date, $c73b576a1f51aaf8$var$q = $c73b576a1f51aaf8$var$p.now();
    $c73b576a1f51aaf8$export$c4744153514ff05d = function() {
        return $c73b576a1f51aaf8$var$p.now() - $c73b576a1f51aaf8$var$q;
    };
}
var $c73b576a1f51aaf8$var$r = [], $c73b576a1f51aaf8$var$t = [], $c73b576a1f51aaf8$var$u = 1, $c73b576a1f51aaf8$var$v = null, $c73b576a1f51aaf8$var$y = 3, $c73b576a1f51aaf8$var$z = !1, $c73b576a1f51aaf8$var$A = !1, $c73b576a1f51aaf8$var$B = !1, $c73b576a1f51aaf8$var$D = "function" === typeof setTimeout ? setTimeout : null, $c73b576a1f51aaf8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $c73b576a1f51aaf8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $c73b576a1f51aaf8$var$G(a) {
    for(var b = $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$t); null !== b;){
        if (null === b.callback) $c73b576a1f51aaf8$var$k($c73b576a1f51aaf8$var$t);
        else if (b.startTime <= a) $c73b576a1f51aaf8$var$k($c73b576a1f51aaf8$var$t), b.sortIndex = b.expirationTime, $c73b576a1f51aaf8$var$f($c73b576a1f51aaf8$var$r, b);
        else break;
        b = $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$t);
    }
}
function $c73b576a1f51aaf8$var$H(a) {
    $c73b576a1f51aaf8$var$B = !1;
    $c73b576a1f51aaf8$var$G(a);
    if (!$c73b576a1f51aaf8$var$A) {
        if (null !== $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$r)) $c73b576a1f51aaf8$var$A = !0, $c73b576a1f51aaf8$var$I($c73b576a1f51aaf8$var$J);
        else {
            var b = $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$t);
            null !== b && $c73b576a1f51aaf8$var$K($c73b576a1f51aaf8$var$H, b.startTime - a);
        }
    }
}
function $c73b576a1f51aaf8$var$J(a, b) {
    $c73b576a1f51aaf8$var$A = !1;
    $c73b576a1f51aaf8$var$B && ($c73b576a1f51aaf8$var$B = !1, $c73b576a1f51aaf8$var$E($c73b576a1f51aaf8$var$L), $c73b576a1f51aaf8$var$L = -1);
    $c73b576a1f51aaf8$var$z = !0;
    var c = $c73b576a1f51aaf8$var$y;
    try {
        $c73b576a1f51aaf8$var$G(b);
        for($c73b576a1f51aaf8$var$v = $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$r); null !== $c73b576a1f51aaf8$var$v && (!($c73b576a1f51aaf8$var$v.expirationTime > b) || a && !$c73b576a1f51aaf8$var$M());){
            var d = $c73b576a1f51aaf8$var$v.callback;
            if ("function" === typeof d) {
                $c73b576a1f51aaf8$var$v.callback = null;
                $c73b576a1f51aaf8$var$y = $c73b576a1f51aaf8$var$v.priorityLevel;
                var e = d($c73b576a1f51aaf8$var$v.expirationTime <= b);
                b = $c73b576a1f51aaf8$export$c4744153514ff05d();
                "function" === typeof e ? $c73b576a1f51aaf8$var$v.callback = e : $c73b576a1f51aaf8$var$v === $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$r) && $c73b576a1f51aaf8$var$k($c73b576a1f51aaf8$var$r);
                $c73b576a1f51aaf8$var$G(b);
            } else $c73b576a1f51aaf8$var$k($c73b576a1f51aaf8$var$r);
            $c73b576a1f51aaf8$var$v = $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$r);
        }
        if (null !== $c73b576a1f51aaf8$var$v) var w = !0;
        else {
            var m = $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$t);
            null !== m && $c73b576a1f51aaf8$var$K($c73b576a1f51aaf8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $c73b576a1f51aaf8$var$v = null, $c73b576a1f51aaf8$var$y = c, $c73b576a1f51aaf8$var$z = !1;
    }
}
var $c73b576a1f51aaf8$var$N = !1, $c73b576a1f51aaf8$var$O = null, $c73b576a1f51aaf8$var$L = -1, $c73b576a1f51aaf8$var$P = 5, $c73b576a1f51aaf8$var$Q = -1;
function $c73b576a1f51aaf8$var$M() {
    return $c73b576a1f51aaf8$export$c4744153514ff05d() - $c73b576a1f51aaf8$var$Q < $c73b576a1f51aaf8$var$P ? !1 : !0;
}
function $c73b576a1f51aaf8$var$R() {
    if (null !== $c73b576a1f51aaf8$var$O) {
        var a = $c73b576a1f51aaf8$export$c4744153514ff05d();
        $c73b576a1f51aaf8$var$Q = a;
        var b = !0;
        try {
            b = $c73b576a1f51aaf8$var$O(!0, a);
        } finally{
            b ? $c73b576a1f51aaf8$var$S() : ($c73b576a1f51aaf8$var$N = !1, $c73b576a1f51aaf8$var$O = null);
        }
    } else $c73b576a1f51aaf8$var$N = !1;
}
var $c73b576a1f51aaf8$var$S;
if ("function" === typeof $c73b576a1f51aaf8$var$F) $c73b576a1f51aaf8$var$S = function() {
    $c73b576a1f51aaf8$var$F($c73b576a1f51aaf8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c73b576a1f51aaf8$var$T = new MessageChannel, $c73b576a1f51aaf8$var$U = $c73b576a1f51aaf8$var$T.port2;
    $c73b576a1f51aaf8$var$T.port1.onmessage = $c73b576a1f51aaf8$var$R;
    $c73b576a1f51aaf8$var$S = function() {
        $c73b576a1f51aaf8$var$U.postMessage(null);
    };
} else $c73b576a1f51aaf8$var$S = function() {
    $c73b576a1f51aaf8$var$D($c73b576a1f51aaf8$var$R, 0);
};
function $c73b576a1f51aaf8$var$I(a) {
    $c73b576a1f51aaf8$var$O = a;
    $c73b576a1f51aaf8$var$N || ($c73b576a1f51aaf8$var$N = !0, $c73b576a1f51aaf8$var$S());
}
function $c73b576a1f51aaf8$var$K(a, b) {
    $c73b576a1f51aaf8$var$L = $c73b576a1f51aaf8$var$D(function() {
        a($c73b576a1f51aaf8$export$c4744153514ff05d());
    }, b);
}
$c73b576a1f51aaf8$export$3e506c1ccc9cc1a7 = 5;
$c73b576a1f51aaf8$export$e26fe2ed2fa76875 = 1;
$c73b576a1f51aaf8$export$502329bbf4b505b1 = 4;
$c73b576a1f51aaf8$export$6e3807111c4874c4 = 3;
$c73b576a1f51aaf8$export$c27134553091fb3a = null;
$c73b576a1f51aaf8$export$33ee1acdc04fd2a2 = 2;
$c73b576a1f51aaf8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$c73b576a1f51aaf8$export$8352ce38b91d0c62 = function() {
    $c73b576a1f51aaf8$var$A || $c73b576a1f51aaf8$var$z || ($c73b576a1f51aaf8$var$A = !0, $c73b576a1f51aaf8$var$I($c73b576a1f51aaf8$var$J));
};
$c73b576a1f51aaf8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c73b576a1f51aaf8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$c73b576a1f51aaf8$export$d3dfb8e4810cb555 = function() {
    return $c73b576a1f51aaf8$var$y;
};
$c73b576a1f51aaf8$export$839f9183b0465a69 = function() {
    return $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$r);
};
$c73b576a1f51aaf8$export$72fdf0e06517287b = function(a) {
    switch($c73b576a1f51aaf8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $c73b576a1f51aaf8$var$y;
    }
    var c = $c73b576a1f51aaf8$var$y;
    $c73b576a1f51aaf8$var$y = b;
    try {
        return a();
    } finally{
        $c73b576a1f51aaf8$var$y = c;
    }
};
$c73b576a1f51aaf8$export$4b844e58a3e414b4 = function() {};
$c73b576a1f51aaf8$export$816d2913ae6b83b1 = function() {};
$c73b576a1f51aaf8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $c73b576a1f51aaf8$var$y;
    $c73b576a1f51aaf8$var$y = a;
    try {
        return b();
    } finally{
        $c73b576a1f51aaf8$var$y = c;
    }
};
$c73b576a1f51aaf8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $c73b576a1f51aaf8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $c73b576a1f51aaf8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $c73b576a1f51aaf8$var$f($c73b576a1f51aaf8$var$t, a), null === $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$r) && a === $c73b576a1f51aaf8$var$h($c73b576a1f51aaf8$var$t) && ($c73b576a1f51aaf8$var$B ? ($c73b576a1f51aaf8$var$E($c73b576a1f51aaf8$var$L), $c73b576a1f51aaf8$var$L = -1) : $c73b576a1f51aaf8$var$B = !0, $c73b576a1f51aaf8$var$K($c73b576a1f51aaf8$var$H, c - d))) : (a.sortIndex = e, $c73b576a1f51aaf8$var$f($c73b576a1f51aaf8$var$r, a), $c73b576a1f51aaf8$var$A || $c73b576a1f51aaf8$var$z || ($c73b576a1f51aaf8$var$A = !0, $c73b576a1f51aaf8$var$I($c73b576a1f51aaf8$var$J)));
    return a;
};
$c73b576a1f51aaf8$export$b5836b71941fa3ed = $c73b576a1f51aaf8$var$M;
$c73b576a1f51aaf8$export$cf845f2c119da08a = function(a) {
    var b = $c73b576a1f51aaf8$var$y;
    return function() {
        var c = $c73b576a1f51aaf8$var$y;
        $c73b576a1f51aaf8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $c73b576a1f51aaf8$var$y = c;
        }
    };
};

});



parcelRegister("gP8Aj", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $c3f8117da72007b5$export$306c0aa65ff9ec16; }, function (v) { return $c3f8117da72007b5$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c3f8117da72007b5$export$306c0aa65ff9ec16;
"use strict";

var $6kl77 = parcelRequire("6kl77");
function $c3f8117da72007b5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c3f8117da72007b5$var$objectIs = "function" === typeof Object.is ? Object.is : $c3f8117da72007b5$var$is, $c3f8117da72007b5$var$useState = $6kl77.useState, $c3f8117da72007b5$var$useEffect = $6kl77.useEffect, $c3f8117da72007b5$var$useLayoutEffect = $6kl77.useLayoutEffect, $c3f8117da72007b5$var$useDebugValue = $6kl77.useDebugValue;
function $c3f8117da72007b5$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c3f8117da72007b5$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c3f8117da72007b5$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c3f8117da72007b5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c3f8117da72007b5$var$useEffect(function() {
        $c3f8117da72007b5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c3f8117da72007b5$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c3f8117da72007b5$var$useDebugValue(value);
    return value;
}
function $c3f8117da72007b5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c3f8117da72007b5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c3f8117da72007b5$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c3f8117da72007b5$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c3f8117da72007b5$var$useSyncExternalStore$1 : $c3f8117da72007b5$var$useSyncExternalStore$2;
$c3f8117da72007b5$export$306c0aa65ff9ec16 = void 0 !== $6kl77.useSyncExternalStore ? $6kl77.useSyncExternalStore : $c3f8117da72007b5$var$shim;

});

parcelRegister("jNImf", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $e6a5007b1729443b$export$bf730a2d8bf68b42; }, function (v) { return $e6a5007b1729443b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e6a5007b1729443b$export$bf730a2d8bf68b42;
"use strict";

var $6kl77 = parcelRequire("6kl77");

var $bJKTO = parcelRequire("bJKTO");
function $e6a5007b1729443b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e6a5007b1729443b$var$objectIs = "function" === typeof Object.is ? Object.is : $e6a5007b1729443b$var$is, $e6a5007b1729443b$var$useSyncExternalStore = $bJKTO.useSyncExternalStore, $e6a5007b1729443b$var$useRef = $6kl77.useRef, $e6a5007b1729443b$var$useEffect = $6kl77.useEffect, $e6a5007b1729443b$var$useMemo = $6kl77.useMemo, $e6a5007b1729443b$var$useDebugValue = $6kl77.useDebugValue;
$e6a5007b1729443b$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $e6a5007b1729443b$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $e6a5007b1729443b$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($e6a5007b1729443b$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $e6a5007b1729443b$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $e6a5007b1729443b$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $e6a5007b1729443b$var$useDebugValue(value);
    return value;
};

});
parcelRegister("bJKTO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gP8Aj"));

});


parcelRegister("c5rKu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $8ccb79fcee78e410$export$2b8d127b894957b9; }, function (v) { return $8ccb79fcee78e410$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $8ccb79fcee78e410$export$cea3a54a6425200c; }, function (v) { return $8ccb79fcee78e410$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $8ccb79fcee78e410$export$a7c73072b1a182ae; }, function (v) { return $8ccb79fcee78e410$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8ccb79fcee78e410$export$9f27bc3417b4524d; }, function (v) { return $8ccb79fcee78e410$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8ccb79fcee78e410$export$db77ccec0bb4ccac; }, function (v) { return $8ccb79fcee78e410$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8ccb79fcee78e410$export$8392c0c9d3dcbd35; }, function (v) { return $8ccb79fcee78e410$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8ccb79fcee78e410$export$ffb0004e005737fa; }, function (v) { return $8ccb79fcee78e410$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8ccb79fcee78e410$export$b624eff549462981; }, function (v) { return $8ccb79fcee78e410$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8ccb79fcee78e410$export$7897aa7841a5380c; }, function (v) { return $8ccb79fcee78e410$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8ccb79fcee78e410$export$602eac185826482c; }, function (v) { return $8ccb79fcee78e410$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8ccb79fcee78e410$export$e2c29f18771995cb; }, function (v) { return $8ccb79fcee78e410$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8ccb79fcee78e410$export$5f8d39834fd61797; }, function (v) { return $8ccb79fcee78e410$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8ccb79fcee78e410$export$74bf444e3cd11ea5; }, function (v) { return $8ccb79fcee78e410$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8ccb79fcee78e410$export$92387174baf9b227; }, function (v) { return $8ccb79fcee78e410$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8ccb79fcee78e410$export$ec112efeb987d9c6; }, function (v) { return $8ccb79fcee78e410$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8ccb79fcee78e410$export$b706b080d889d2c9; }, function (v) { return $8ccb79fcee78e410$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8ccb79fcee78e410$export$5be5a87408f70ddc; }, function (v) { return $8ccb79fcee78e410$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8ccb79fcee78e410$export$45a5e7f76e0caa8d; }, function (v) { return $8ccb79fcee78e410$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8ccb79fcee78e410$export$455c2e768291efa6; }, function (v) { return $8ccb79fcee78e410$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8ccb79fcee78e410$export$9522e17588c12572; }, function (v) { return $8ccb79fcee78e410$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8ccb79fcee78e410$export$2110ac352bb060b9; }, function (v) { return $8ccb79fcee78e410$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8ccb79fcee78e410$export$56885ab8b9c456ab; }, function (v) { return $8ccb79fcee78e410$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8ccb79fcee78e410$export$d927fcb6adf8f9de; }, function (v) { return $8ccb79fcee78e410$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8ccb79fcee78e410$export$b82d16f27459e05a; }, function (v) { return $8ccb79fcee78e410$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8ccb79fcee78e410$export$522c17b4f5e123e8; }, function (v) { return $8ccb79fcee78e410$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8ccb79fcee78e410$export$1aabd8a0274ecfd6; }, function (v) { return $8ccb79fcee78e410$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8ccb79fcee78e410$export$9b621391a187a31a; }, function (v) { return $8ccb79fcee78e410$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8ccb79fcee78e410$export$f5bbd400c2f4426f; }, function (v) { return $8ccb79fcee78e410$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ccb79fcee78e410$export$2b8d127b894957b9;
var $8ccb79fcee78e410$export$cea3a54a6425200c;
var $8ccb79fcee78e410$export$a7c73072b1a182ae;
var $8ccb79fcee78e410$export$9f27bc3417b4524d;
var $8ccb79fcee78e410$export$db77ccec0bb4ccac;
var $8ccb79fcee78e410$export$8392c0c9d3dcbd35;
var $8ccb79fcee78e410$export$ffb0004e005737fa;
var $8ccb79fcee78e410$export$b624eff549462981;
var $8ccb79fcee78e410$export$7897aa7841a5380c;
var $8ccb79fcee78e410$export$602eac185826482c;
var $8ccb79fcee78e410$export$e2c29f18771995cb;
var $8ccb79fcee78e410$export$5f8d39834fd61797;
var $8ccb79fcee78e410$export$74bf444e3cd11ea5;
var $8ccb79fcee78e410$export$92387174baf9b227;
var $8ccb79fcee78e410$export$ec112efeb987d9c6;
var $8ccb79fcee78e410$export$b706b080d889d2c9;
var $8ccb79fcee78e410$export$5be5a87408f70ddc;
var $8ccb79fcee78e410$export$45a5e7f76e0caa8d;
var $8ccb79fcee78e410$export$455c2e768291efa6;
var $8ccb79fcee78e410$export$9522e17588c12572;
var $8ccb79fcee78e410$export$2110ac352bb060b9;
var $8ccb79fcee78e410$export$56885ab8b9c456ab;
var $8ccb79fcee78e410$export$d927fcb6adf8f9de;
var $8ccb79fcee78e410$export$b82d16f27459e05a;
var $8ccb79fcee78e410$export$522c17b4f5e123e8;
var $8ccb79fcee78e410$export$1aabd8a0274ecfd6;
var $8ccb79fcee78e410$export$9b621391a187a31a;
var $8ccb79fcee78e410$export$f5bbd400c2f4426f;
'use strict';
var $8ccb79fcee78e410$var$b = "function" === typeof Symbol && Symbol.for, $8ccb79fcee78e410$var$c = $8ccb79fcee78e410$var$b ? Symbol.for("react.element") : 60103, $8ccb79fcee78e410$var$d = $8ccb79fcee78e410$var$b ? Symbol.for("react.portal") : 60106, $8ccb79fcee78e410$var$e = $8ccb79fcee78e410$var$b ? Symbol.for("react.fragment") : 60107, $8ccb79fcee78e410$var$f = $8ccb79fcee78e410$var$b ? Symbol.for("react.strict_mode") : 60108, $8ccb79fcee78e410$var$g = $8ccb79fcee78e410$var$b ? Symbol.for("react.profiler") : 60114, $8ccb79fcee78e410$var$h = $8ccb79fcee78e410$var$b ? Symbol.for("react.provider") : 60109, $8ccb79fcee78e410$var$k = $8ccb79fcee78e410$var$b ? Symbol.for("react.context") : 60110, $8ccb79fcee78e410$var$l = $8ccb79fcee78e410$var$b ? Symbol.for("react.async_mode") : 60111, $8ccb79fcee78e410$var$m = $8ccb79fcee78e410$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8ccb79fcee78e410$var$n = $8ccb79fcee78e410$var$b ? Symbol.for("react.forward_ref") : 60112, $8ccb79fcee78e410$var$p = $8ccb79fcee78e410$var$b ? Symbol.for("react.suspense") : 60113, $8ccb79fcee78e410$var$q = $8ccb79fcee78e410$var$b ? Symbol.for("react.suspense_list") : 60120, $8ccb79fcee78e410$var$r = $8ccb79fcee78e410$var$b ? Symbol.for("react.memo") : 60115, $8ccb79fcee78e410$var$t = $8ccb79fcee78e410$var$b ? Symbol.for("react.lazy") : 60116, $8ccb79fcee78e410$var$v = $8ccb79fcee78e410$var$b ? Symbol.for("react.block") : 60121, $8ccb79fcee78e410$var$w = $8ccb79fcee78e410$var$b ? Symbol.for("react.fundamental") : 60117, $8ccb79fcee78e410$var$x = $8ccb79fcee78e410$var$b ? Symbol.for("react.responder") : 60118, $8ccb79fcee78e410$var$y = $8ccb79fcee78e410$var$b ? Symbol.for("react.scope") : 60119;
function $8ccb79fcee78e410$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8ccb79fcee78e410$var$c:
                switch(a = a.type, a){
                    case $8ccb79fcee78e410$var$l:
                    case $8ccb79fcee78e410$var$m:
                    case $8ccb79fcee78e410$var$e:
                    case $8ccb79fcee78e410$var$g:
                    case $8ccb79fcee78e410$var$f:
                    case $8ccb79fcee78e410$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ccb79fcee78e410$var$k:
                            case $8ccb79fcee78e410$var$n:
                            case $8ccb79fcee78e410$var$t:
                            case $8ccb79fcee78e410$var$r:
                            case $8ccb79fcee78e410$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8ccb79fcee78e410$var$d:
                return u;
        }
    }
}
function $8ccb79fcee78e410$var$A(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$m;
}
$8ccb79fcee78e410$export$2b8d127b894957b9 = $8ccb79fcee78e410$var$l;
$8ccb79fcee78e410$export$cea3a54a6425200c = $8ccb79fcee78e410$var$m;
$8ccb79fcee78e410$export$a7c73072b1a182ae = $8ccb79fcee78e410$var$k;
$8ccb79fcee78e410$export$9f27bc3417b4524d = $8ccb79fcee78e410$var$h;
$8ccb79fcee78e410$export$db77ccec0bb4ccac = $8ccb79fcee78e410$var$c;
$8ccb79fcee78e410$export$8392c0c9d3dcbd35 = $8ccb79fcee78e410$var$n;
$8ccb79fcee78e410$export$ffb0004e005737fa = $8ccb79fcee78e410$var$e;
$8ccb79fcee78e410$export$b624eff549462981 = $8ccb79fcee78e410$var$t;
$8ccb79fcee78e410$export$7897aa7841a5380c = $8ccb79fcee78e410$var$r;
$8ccb79fcee78e410$export$602eac185826482c = $8ccb79fcee78e410$var$d;
$8ccb79fcee78e410$export$e2c29f18771995cb = $8ccb79fcee78e410$var$g;
$8ccb79fcee78e410$export$5f8d39834fd61797 = $8ccb79fcee78e410$var$f;
$8ccb79fcee78e410$export$74bf444e3cd11ea5 = $8ccb79fcee78e410$var$p;
$8ccb79fcee78e410$export$92387174baf9b227 = function(a) {
    return $8ccb79fcee78e410$var$A(a) || $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$l;
};
$8ccb79fcee78e410$export$ec112efeb987d9c6 = $8ccb79fcee78e410$var$A;
$8ccb79fcee78e410$export$b706b080d889d2c9 = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$k;
};
$8ccb79fcee78e410$export$5be5a87408f70ddc = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$h;
};
$8ccb79fcee78e410$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ccb79fcee78e410$var$c;
};
$8ccb79fcee78e410$export$455c2e768291efa6 = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$n;
};
$8ccb79fcee78e410$export$9522e17588c12572 = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$e;
};
$8ccb79fcee78e410$export$2110ac352bb060b9 = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$t;
};
$8ccb79fcee78e410$export$56885ab8b9c456ab = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$r;
};
$8ccb79fcee78e410$export$d927fcb6adf8f9de = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$d;
};
$8ccb79fcee78e410$export$b82d16f27459e05a = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$g;
};
$8ccb79fcee78e410$export$522c17b4f5e123e8 = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$f;
};
$8ccb79fcee78e410$export$1aabd8a0274ecfd6 = function(a) {
    return $8ccb79fcee78e410$var$z(a) === $8ccb79fcee78e410$var$p;
};
$8ccb79fcee78e410$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ccb79fcee78e410$var$e || a === $8ccb79fcee78e410$var$m || a === $8ccb79fcee78e410$var$g || a === $8ccb79fcee78e410$var$f || a === $8ccb79fcee78e410$var$p || a === $8ccb79fcee78e410$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8ccb79fcee78e410$var$t || a.$$typeof === $8ccb79fcee78e410$var$r || a.$$typeof === $8ccb79fcee78e410$var$h || a.$$typeof === $8ccb79fcee78e410$var$k || a.$$typeof === $8ccb79fcee78e410$var$n || a.$$typeof === $8ccb79fcee78e410$var$w || a.$$typeof === $8ccb79fcee78e410$var$x || a.$$typeof === $8ccb79fcee78e410$var$y || a.$$typeof === $8ccb79fcee78e410$var$v);
};
$8ccb79fcee78e410$export$f5bbd400c2f4426f = $8ccb79fcee78e410$var$z;

});

parcelRegister("jat59", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $df458295203a43a8$export$a7c73072b1a182ae; }, function (v) { return $df458295203a43a8$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $df458295203a43a8$export$9f27bc3417b4524d; }, function (v) { return $df458295203a43a8$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $df458295203a43a8$export$db77ccec0bb4ccac; }, function (v) { return $df458295203a43a8$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $df458295203a43a8$export$8392c0c9d3dcbd35; }, function (v) { return $df458295203a43a8$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $df458295203a43a8$export$ffb0004e005737fa; }, function (v) { return $df458295203a43a8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $df458295203a43a8$export$b624eff549462981; }, function (v) { return $df458295203a43a8$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $df458295203a43a8$export$7897aa7841a5380c; }, function (v) { return $df458295203a43a8$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $df458295203a43a8$export$602eac185826482c; }, function (v) { return $df458295203a43a8$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $df458295203a43a8$export$e2c29f18771995cb; }, function (v) { return $df458295203a43a8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $df458295203a43a8$export$5f8d39834fd61797; }, function (v) { return $df458295203a43a8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $df458295203a43a8$export$74bf444e3cd11ea5; }, function (v) { return $df458295203a43a8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $df458295203a43a8$export$998bcd577473dd93; }, function (v) { return $df458295203a43a8$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $df458295203a43a8$export$92387174baf9b227; }, function (v) { return $df458295203a43a8$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $df458295203a43a8$export$ec112efeb987d9c6; }, function (v) { return $df458295203a43a8$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $df458295203a43a8$export$b706b080d889d2c9; }, function (v) { return $df458295203a43a8$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $df458295203a43a8$export$5be5a87408f70ddc; }, function (v) { return $df458295203a43a8$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $df458295203a43a8$export$45a5e7f76e0caa8d; }, function (v) { return $df458295203a43a8$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $df458295203a43a8$export$455c2e768291efa6; }, function (v) { return $df458295203a43a8$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $df458295203a43a8$export$9522e17588c12572; }, function (v) { return $df458295203a43a8$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $df458295203a43a8$export$2110ac352bb060b9; }, function (v) { return $df458295203a43a8$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $df458295203a43a8$export$56885ab8b9c456ab; }, function (v) { return $df458295203a43a8$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $df458295203a43a8$export$d927fcb6adf8f9de; }, function (v) { return $df458295203a43a8$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $df458295203a43a8$export$b82d16f27459e05a; }, function (v) { return $df458295203a43a8$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $df458295203a43a8$export$522c17b4f5e123e8; }, function (v) { return $df458295203a43a8$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $df458295203a43a8$export$1aabd8a0274ecfd6; }, function (v) { return $df458295203a43a8$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $df458295203a43a8$export$3d6c20d97e46b957; }, function (v) { return $df458295203a43a8$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $df458295203a43a8$export$9b621391a187a31a; }, function (v) { return $df458295203a43a8$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $df458295203a43a8$export$f5bbd400c2f4426f; }, function (v) { return $df458295203a43a8$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $df458295203a43a8$export$a7c73072b1a182ae;
var $df458295203a43a8$export$9f27bc3417b4524d;
var $df458295203a43a8$export$db77ccec0bb4ccac;
var $df458295203a43a8$export$8392c0c9d3dcbd35;
var $df458295203a43a8$export$ffb0004e005737fa;
var $df458295203a43a8$export$b624eff549462981;
var $df458295203a43a8$export$7897aa7841a5380c;
var $df458295203a43a8$export$602eac185826482c;
var $df458295203a43a8$export$e2c29f18771995cb;
var $df458295203a43a8$export$5f8d39834fd61797;
var $df458295203a43a8$export$74bf444e3cd11ea5;
var $df458295203a43a8$export$998bcd577473dd93;
var $df458295203a43a8$export$92387174baf9b227;
var $df458295203a43a8$export$ec112efeb987d9c6;
var $df458295203a43a8$export$b706b080d889d2c9;
var $df458295203a43a8$export$5be5a87408f70ddc;
var $df458295203a43a8$export$45a5e7f76e0caa8d;
var $df458295203a43a8$export$455c2e768291efa6;
var $df458295203a43a8$export$9522e17588c12572;
var $df458295203a43a8$export$2110ac352bb060b9;
var $df458295203a43a8$export$56885ab8b9c456ab;
var $df458295203a43a8$export$d927fcb6adf8f9de;
var $df458295203a43a8$export$b82d16f27459e05a;
var $df458295203a43a8$export$522c17b4f5e123e8;
var $df458295203a43a8$export$1aabd8a0274ecfd6;
var $df458295203a43a8$export$3d6c20d97e46b957;
var $df458295203a43a8$export$9b621391a187a31a;
var $df458295203a43a8$export$f5bbd400c2f4426f;
'use strict';
var $df458295203a43a8$var$b = Symbol.for("react.element"), $df458295203a43a8$var$c = Symbol.for("react.portal"), $df458295203a43a8$var$d = Symbol.for("react.fragment"), $df458295203a43a8$var$e = Symbol.for("react.strict_mode"), $df458295203a43a8$var$f = Symbol.for("react.profiler"), $df458295203a43a8$var$g = Symbol.for("react.provider"), $df458295203a43a8$var$h = Symbol.for("react.context"), $df458295203a43a8$var$k = Symbol.for("react.server_context"), $df458295203a43a8$var$l = Symbol.for("react.forward_ref"), $df458295203a43a8$var$m = Symbol.for("react.suspense"), $df458295203a43a8$var$n = Symbol.for("react.suspense_list"), $df458295203a43a8$var$p = Symbol.for("react.memo"), $df458295203a43a8$var$q = Symbol.for("react.lazy"), $df458295203a43a8$var$t = Symbol.for("react.offscreen"), $df458295203a43a8$var$u;
$df458295203a43a8$var$u = Symbol.for("react.module.reference");
function $df458295203a43a8$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $df458295203a43a8$var$b:
                switch(a = a.type, a){
                    case $df458295203a43a8$var$d:
                    case $df458295203a43a8$var$f:
                    case $df458295203a43a8$var$e:
                    case $df458295203a43a8$var$m:
                    case $df458295203a43a8$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $df458295203a43a8$var$k:
                            case $df458295203a43a8$var$h:
                            case $df458295203a43a8$var$l:
                            case $df458295203a43a8$var$q:
                            case $df458295203a43a8$var$p:
                            case $df458295203a43a8$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $df458295203a43a8$var$c:
                return r;
        }
    }
}
$df458295203a43a8$export$a7c73072b1a182ae = $df458295203a43a8$var$h;
$df458295203a43a8$export$9f27bc3417b4524d = $df458295203a43a8$var$g;
$df458295203a43a8$export$db77ccec0bb4ccac = $df458295203a43a8$var$b;
$df458295203a43a8$export$8392c0c9d3dcbd35 = $df458295203a43a8$var$l;
$df458295203a43a8$export$ffb0004e005737fa = $df458295203a43a8$var$d;
$df458295203a43a8$export$b624eff549462981 = $df458295203a43a8$var$q;
$df458295203a43a8$export$7897aa7841a5380c = $df458295203a43a8$var$p;
$df458295203a43a8$export$602eac185826482c = $df458295203a43a8$var$c;
$df458295203a43a8$export$e2c29f18771995cb = $df458295203a43a8$var$f;
$df458295203a43a8$export$5f8d39834fd61797 = $df458295203a43a8$var$e;
$df458295203a43a8$export$74bf444e3cd11ea5 = $df458295203a43a8$var$m;
$df458295203a43a8$export$998bcd577473dd93 = $df458295203a43a8$var$n;
$df458295203a43a8$export$92387174baf9b227 = function() {
    return !1;
};
$df458295203a43a8$export$ec112efeb987d9c6 = function() {
    return !1;
};
$df458295203a43a8$export$b706b080d889d2c9 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$h;
};
$df458295203a43a8$export$5be5a87408f70ddc = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$g;
};
$df458295203a43a8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $df458295203a43a8$var$b;
};
$df458295203a43a8$export$455c2e768291efa6 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$l;
};
$df458295203a43a8$export$9522e17588c12572 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$d;
};
$df458295203a43a8$export$2110ac352bb060b9 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$q;
};
$df458295203a43a8$export$56885ab8b9c456ab = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$p;
};
$df458295203a43a8$export$d927fcb6adf8f9de = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$c;
};
$df458295203a43a8$export$b82d16f27459e05a = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$f;
};
$df458295203a43a8$export$522c17b4f5e123e8 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$e;
};
$df458295203a43a8$export$1aabd8a0274ecfd6 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$m;
};
$df458295203a43a8$export$3d6c20d97e46b957 = function(a) {
    return $df458295203a43a8$var$v(a) === $df458295203a43a8$var$n;
};
$df458295203a43a8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $df458295203a43a8$var$d || a === $df458295203a43a8$var$f || a === $df458295203a43a8$var$e || a === $df458295203a43a8$var$m || a === $df458295203a43a8$var$n || a === $df458295203a43a8$var$t || "object" === typeof a && null !== a && (a.$$typeof === $df458295203a43a8$var$q || a.$$typeof === $df458295203a43a8$var$p || a.$$typeof === $df458295203a43a8$var$g || a.$$typeof === $df458295203a43a8$var$h || a.$$typeof === $df458295203a43a8$var$l || a.$$typeof === $df458295203a43a8$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$df458295203a43a8$export$f5bbd400c2f4426f = $df458295203a43a8$var$v;

});

parcelRegister("cseje", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("8tTAh")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("df6Yn")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("8tTAh")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("6ROz1")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("gT8sP")).createPopper; });

var $2EYpo = parcelRequire("2EYpo");

var $1olRC = parcelRequire("1olRC");

var $8tTAh = parcelRequire("8tTAh");
var $df6Yn = parcelRequire("df6Yn");

var $6ROz1 = parcelRequire("6ROz1");

var $gT8sP = parcelRequire("gT8sP");
$parcel$exportWildcard(module.exports, $2EYpo);
$parcel$exportWildcard(module.exports, $1olRC);

});
parcelRegister("2EYpo", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $1efe2d0ea4e8d8d4$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $1efe2d0ea4e8d8d4$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $1efe2d0ea4e8d8d4$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $1efe2d0ea4e8d8d4$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $1efe2d0ea4e8d8d4$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $1efe2d0ea4e8d8d4$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $1efe2d0ea4e8d8d4$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $1efe2d0ea4e8d8d4$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $1efe2d0ea4e8d8d4$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $1efe2d0ea4e8d8d4$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $1efe2d0ea4e8d8d4$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $1efe2d0ea4e8d8d4$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $1efe2d0ea4e8d8d4$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $1efe2d0ea4e8d8d4$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $1efe2d0ea4e8d8d4$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $1efe2d0ea4e8d8d4$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $1efe2d0ea4e8d8d4$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $1efe2d0ea4e8d8d4$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $1efe2d0ea4e8d8d4$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $1efe2d0ea4e8d8d4$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $1efe2d0ea4e8d8d4$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $1efe2d0ea4e8d8d4$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $1efe2d0ea4e8d8d4$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $1efe2d0ea4e8d8d4$export$d087d3878fdf71d5; });
var $1efe2d0ea4e8d8d4$export$1e95b668f3b82d = 'top';
var $1efe2d0ea4e8d8d4$export$40e543e69a8b3fbb = 'bottom';
var $1efe2d0ea4e8d8d4$export$79ffe56a765070d2 = 'right';
var $1efe2d0ea4e8d8d4$export$eabcd2c8791e7bf4 = 'left';
var $1efe2d0ea4e8d8d4$export$dfb5619354ba860 = 'auto';
var $1efe2d0ea4e8d8d4$export$aec2ce47c367b8c3 = [
    $1efe2d0ea4e8d8d4$export$1e95b668f3b82d,
    $1efe2d0ea4e8d8d4$export$40e543e69a8b3fbb,
    $1efe2d0ea4e8d8d4$export$79ffe56a765070d2,
    $1efe2d0ea4e8d8d4$export$eabcd2c8791e7bf4
];
var $1efe2d0ea4e8d8d4$export$b3571188c770cc5a = 'start';
var $1efe2d0ea4e8d8d4$export$bd5df0f255a350f8 = 'end';
var $1efe2d0ea4e8d8d4$export$390fd549c5303b4d = 'clippingParents';
var $1efe2d0ea4e8d8d4$export$d7b7311ec04a3e8f = 'viewport';
var $1efe2d0ea4e8d8d4$export$ae5ab1c730825774 = 'popper';
var $1efe2d0ea4e8d8d4$export$ca50aac9f3ba507f = 'reference';
var $1efe2d0ea4e8d8d4$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1efe2d0ea4e8d8d4$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1efe2d0ea4e8d8d4$export$b3571188c770cc5a,
        placement + "-" + $1efe2d0ea4e8d8d4$export$bd5df0f255a350f8
    ]);
}, []);
var $1efe2d0ea4e8d8d4$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1efe2d0ea4e8d8d4$export$aec2ce47c367b8c3, [
    $1efe2d0ea4e8d8d4$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1efe2d0ea4e8d8d4$export$b3571188c770cc5a,
        placement + "-" + $1efe2d0ea4e8d8d4$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1efe2d0ea4e8d8d4$export$421679a7c3d56e = 'beforeRead';
var $1efe2d0ea4e8d8d4$export$aafa59e2e03f2942 = 'read';
var $1efe2d0ea4e8d8d4$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1efe2d0ea4e8d8d4$export$c65e99957a05207c = 'beforeMain';
var $1efe2d0ea4e8d8d4$export$f22da7240b7add18 = 'main';
var $1efe2d0ea4e8d8d4$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1efe2d0ea4e8d8d4$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1efe2d0ea4e8d8d4$export$68d8715fc104d294 = 'write';
var $1efe2d0ea4e8d8d4$export$70a6e5159acce2e6 = 'afterWrite';
var $1efe2d0ea4e8d8d4$export$d087d3878fdf71d5 = [
    $1efe2d0ea4e8d8d4$export$421679a7c3d56e,
    $1efe2d0ea4e8d8d4$export$aafa59e2e03f2942,
    $1efe2d0ea4e8d8d4$export$6964f6c886723980,
    $1efe2d0ea4e8d8d4$export$c65e99957a05207c,
    $1efe2d0ea4e8d8d4$export$f22da7240b7add18,
    $1efe2d0ea4e8d8d4$export$bab79516f2d662fe,
    $1efe2d0ea4e8d8d4$export$8d4d2d70e7d46032,
    $1efe2d0ea4e8d8d4$export$68d8715fc104d294,
    $1efe2d0ea4e8d8d4$export$70a6e5159acce2e6
];

});

parcelRegister("1olRC", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("f8tKh")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("8DiJ3")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("jsDgI")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("2AH0t")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("6yBxl")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("4Iu3u")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("fZql2")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("abimq")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("73R1f")).default; });

var $f8tKh = parcelRequire("f8tKh");

var $8DiJ3 = parcelRequire("8DiJ3");

var $jsDgI = parcelRequire("jsDgI");

var $2AH0t = parcelRequire("2AH0t");

var $6yBxl = parcelRequire("6yBxl");

var $4Iu3u = parcelRequire("4Iu3u");

var $fZql2 = parcelRequire("fZql2");

var $abimq = parcelRequire("abimq");

var $73R1f = parcelRequire("73R1f");

});
parcelRegister("f8tKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b04ead36fbae0251$export$2e2bcd8739ae039; });

var $3lxeQ = parcelRequire("3lxeQ");

var $3wOoL = parcelRequire("3wOoL");
// and applies them to the HTMLElements such as popper and arrow
function $b04ead36fbae0251$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $3wOoL.isHTMLElement)(element) || !(0, $3lxeQ.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $b04ead36fbae0251$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $3wOoL.isHTMLElement)(element) || !(0, $3lxeQ.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b04ead36fbae0251$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $b04ead36fbae0251$var$applyStyles,
    effect: $b04ead36fbae0251$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("3lxeQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26fd1db936b72782$export$2e2bcd8739ae039; });
function $26fd1db936b72782$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("3wOoL", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $291b745af6537a04$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $291b745af6537a04$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $291b745af6537a04$export$af51f0f06c0f328a; });

var $5YdjW = parcelRequire("5YdjW");
function $291b745af6537a04$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5YdjW.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $291b745af6537a04$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5YdjW.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $291b745af6537a04$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5YdjW.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("5YdjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $458ce38779e7b0d8$export$2e2bcd8739ae039; });
function $458ce38779e7b0d8$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("8DiJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64907dc6e1cab274$export$2e2bcd8739ae039; });

var $6Qkvp = parcelRequire("6Qkvp");

var $cfMXJ = parcelRequire("cfMXJ");

var $854tN = parcelRequire("854tN");

var $aE5Sz = parcelRequire("aE5Sz");

var $M50jn = parcelRequire("M50jn");

var $8Y7eS = parcelRequire("8Y7eS");

var $hPnmL = parcelRequire("hPnmL");

var $cttNb = parcelRequire("cttNb");

var $2EYpo = parcelRequire("2EYpo");
var $64907dc6e1cab274$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $hPnmL.default)(typeof padding !== 'number' ? padding : (0, $cttNb.default)(padding, (0, $2EYpo.basePlacements)));
};
function $64907dc6e1cab274$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6Qkvp.default)(state.placement);
    var axis = (0, $M50jn.default)(basePlacement);
    var isVertical = [
        (0, $2EYpo.left),
        (0, $2EYpo.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $64907dc6e1cab274$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $cfMXJ.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $2EYpo.top) : (0, $2EYpo.left);
    var maxProp = axis === 'y' ? (0, $2EYpo.bottom) : (0, $2EYpo.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aE5Sz.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $8Y7eS.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $64907dc6e1cab274$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $854tN.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $64907dc6e1cab274$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $64907dc6e1cab274$var$arrow,
    effect: $64907dc6e1cab274$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("6Qkvp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fb7816814a5276a$export$2e2bcd8739ae039; });

function $4fb7816814a5276a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cfMXJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ebcdda913432d36$export$2e2bcd8739ae039; });

var $fozlG = parcelRequire("fozlG");
function $8ebcdda913432d36$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $fozlG.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("fozlG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b354846a04ce7404$export$2e2bcd8739ae039; });

var $3wOoL = parcelRequire("3wOoL");

var $bzJi7 = parcelRequire("bzJi7");

var $5YdjW = parcelRequire("5YdjW");

var $bzkJe = parcelRequire("bzkJe");
function $b354846a04ce7404$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $3wOoL.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $bzJi7.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $bzJi7.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $3wOoL.isElement)(element) ? (0, $5YdjW.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bzkJe.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("bzJi7", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $86d6187fdd04323a$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $86d6187fdd04323a$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $86d6187fdd04323a$export$2077e0241d6afd3c; });
var $86d6187fdd04323a$export$8960430cfd85939f = Math.max;
var $86d6187fdd04323a$export$96ec731ed4dcb222 = Math.min;
var $86d6187fdd04323a$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bzkJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86c30adf4d302c10$export$2e2bcd8739ae039; });

var $cNYJi = parcelRequire("cNYJi");
function $86c30adf4d302c10$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cNYJi.default)());
}

});
parcelRegister("cNYJi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95292b44bf05100d$export$2e2bcd8739ae039; });
function $95292b44bf05100d$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("854tN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2243ea232c45f8$export$2e2bcd8739ae039; });

var $3wOoL = parcelRequire("3wOoL");
function $5e2243ea232c45f8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $3wOoL.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("aE5Sz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c0233475ded9d7a$export$2e2bcd8739ae039; });

var $5YdjW = parcelRequire("5YdjW");

var $3lxeQ = parcelRequire("3lxeQ");

var $1gKXS = parcelRequire("1gKXS");

var $3wOoL = parcelRequire("3wOoL");

var $58sz8 = parcelRequire("58sz8");

var $3sNKo = parcelRequire("3sNKo");

var $cNYJi = parcelRequire("cNYJi");
function $7c0233475ded9d7a$var$getTrueOffsetParent(element) {
    if (!(0, $3wOoL.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1gKXS.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7c0233475ded9d7a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cNYJi.default)());
    var isIE = /Trident/i.test((0, $cNYJi.default)());
    if (isIE && (0, $3wOoL.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1gKXS.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $3sNKo.default)(element);
    if ((0, $3wOoL.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $3wOoL.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3lxeQ.default)(currentNode)) < 0){
        var css = (0, $1gKXS.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7c0233475ded9d7a$export$2e2bcd8739ae039(element) {
    var window = (0, $5YdjW.default)(element);
    var offsetParent = $7c0233475ded9d7a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $58sz8.default)(offsetParent) && (0, $1gKXS.default)(offsetParent).position === 'static')offsetParent = $7c0233475ded9d7a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3lxeQ.default)(offsetParent) === 'html' || (0, $3lxeQ.default)(offsetParent) === 'body' && (0, $1gKXS.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $7c0233475ded9d7a$var$getContainingBlock(element) || window;
}

});
parcelRegister("1gKXS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ecbb74f9ffc7de7$export$2e2bcd8739ae039; });

var $5YdjW = parcelRequire("5YdjW");
function $0ecbb74f9ffc7de7$export$2e2bcd8739ae039(element) {
    return (0, $5YdjW.default)(element).getComputedStyle(element);
}

});

parcelRegister("58sz8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bd3dba8747c26a5$export$2e2bcd8739ae039; });

var $3lxeQ = parcelRequire("3lxeQ");
function $3bd3dba8747c26a5$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3lxeQ.default)(element)) >= 0;
}

});

parcelRegister("3sNKo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $285a93671fb80ff7$export$2e2bcd8739ae039; });

var $3lxeQ = parcelRequire("3lxeQ");

var $1MgVG = parcelRequire("1MgVG");

var $3wOoL = parcelRequire("3wOoL");
function $285a93671fb80ff7$export$2e2bcd8739ae039(element) {
    if ((0, $3lxeQ.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $3wOoL.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1MgVG.default)(element) // fallback
    );
}

});
parcelRegister("1MgVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14b767f6776f21fd$export$2e2bcd8739ae039; });

var $3wOoL = parcelRequire("3wOoL");
function $14b767f6776f21fd$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $3wOoL.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("M50jn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09085d8117e9f410$export$2e2bcd8739ae039; });
function $09085d8117e9f410$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("8Y7eS", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $68798acf77b94bc6$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $68798acf77b94bc6$export$86c8af6d3ef0b4a; });

var $bzJi7 = parcelRequire("bzJi7");
function $68798acf77b94bc6$export$f28d906d67a997f3(min, value, max) {
    return (0, $bzJi7.max)(min, (0, $bzJi7.min)(value, max));
}
function $68798acf77b94bc6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $68798acf77b94bc6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("hPnmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfa9531c04a62c2a$export$2e2bcd8739ae039; });

var $dxNQ4 = parcelRequire("dxNQ4");
function $cfa9531c04a62c2a$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dxNQ4.default)(), paddingObject);
}

});
parcelRegister("dxNQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dc5045cd59486f5$export$2e2bcd8739ae039; });
function $9dc5045cd59486f5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("cttNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $914f4d975867c49b$export$2e2bcd8739ae039; });
function $914f4d975867c49b$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("jsDgI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2af17c8cbb0ab1d$export$2e2bcd8739ae039; });

var $2EYpo = parcelRequire("2EYpo");

var $aE5Sz = parcelRequire("aE5Sz");

var $5YdjW = parcelRequire("5YdjW");

var $1MgVG = parcelRequire("1MgVG");

var $1gKXS = parcelRequire("1gKXS");

var $6Qkvp = parcelRequire("6Qkvp");

var $fEiat = parcelRequire("fEiat");

var $bzJi7 = parcelRequire("bzJi7");
var $e2af17c8cbb0ab1d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $e2af17c8cbb0ab1d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $bzJi7.round)(x * dpr) / dpr || 0,
        y: (0, $bzJi7.round)(y * dpr) / dpr || 0
    };
}
function $e2af17c8cbb0ab1d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $2EYpo.left);
    var sideY = (0, $2EYpo.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aE5Sz.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5YdjW.default)(popper)) {
            offsetParent = (0, $1MgVG.default)(popper);
            if ((0, $1gKXS.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $2EYpo.top) || (placement === (0, $2EYpo.left) || placement === (0, $2EYpo.right)) && variation === (0, $2EYpo.end)) {
            sideY = (0, $2EYpo.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $2EYpo.left) || (placement === (0, $2EYpo.top) || placement === (0, $2EYpo.bottom)) && variation === (0, $2EYpo.end)) {
            sideX = (0, $2EYpo.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $e2af17c8cbb0ab1d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $e2af17c8cbb0ab1d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5YdjW.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $e2af17c8cbb0ab1d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6Qkvp.default)(state.placement),
        variation: (0, $fEiat.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $e2af17c8cbb0ab1d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $e2af17c8cbb0ab1d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e2af17c8cbb0ab1d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $e2af17c8cbb0ab1d$var$computeStyles,
    data: {}
};

});
parcelRegister("fEiat", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b648af31e1554815$export$2e2bcd8739ae039; });
function $b648af31e1554815$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("2AH0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e304dc5e066c77e$export$2e2bcd8739ae039; });

var $5YdjW = parcelRequire("5YdjW");
var $1e304dc5e066c77e$var$passive = {
    passive: true
};
function $1e304dc5e066c77e$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5YdjW.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1e304dc5e066c77e$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1e304dc5e066c77e$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1e304dc5e066c77e$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1e304dc5e066c77e$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1e304dc5e066c77e$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1e304dc5e066c77e$var$effect,
    data: {}
};

});

parcelRegister("6yBxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c630914708b017e$export$2e2bcd8739ae039; });

var $1fqM2 = parcelRequire("1fqM2");

var $6Qkvp = parcelRequire("6Qkvp");

var $dd2vK = parcelRequire("dd2vK");

var $df6Yn = parcelRequire("df6Yn");

var $fnc1P = parcelRequire("fnc1P");

var $2EYpo = parcelRequire("2EYpo");

var $fEiat = parcelRequire("fEiat");
function $4c630914708b017e$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6Qkvp.default)(placement) === (0, $2EYpo.auto)) return [];
    var oppositePlacement = (0, $1fqM2.default)(placement);
    return [
        (0, $dd2vK.default)(placement),
        oppositePlacement,
        (0, $dd2vK.default)(oppositePlacement)
    ];
}
function $4c630914708b017e$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6Qkvp.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1fqM2.default)(preferredPlacement)
    ] : $4c630914708b017e$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6Qkvp.default)(placement) === (0, $2EYpo.auto) ? (0, $fnc1P.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6Qkvp.default)(placement);
        var isStartVariation = (0, $fEiat.default)(placement) === (0, $2EYpo.start);
        var isVertical = [
            (0, $2EYpo.top),
            (0, $2EYpo.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $df6Yn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $2EYpo.right) : (0, $2EYpo.left) : isStartVariation ? (0, $2EYpo.bottom) : (0, $2EYpo.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1fqM2.default)(mainVariationSide);
        var altVariationSide = (0, $1fqM2.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4c630914708b017e$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4c630914708b017e$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1fqM2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e8bf5e29eccd61f$export$2e2bcd8739ae039; });
var $0e8bf5e29eccd61f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $0e8bf5e29eccd61f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $0e8bf5e29eccd61f$var$hash[matched];
    });
}

});

parcelRegister("dd2vK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99de6fe7c715762e$export$2e2bcd8739ae039; });
var $99de6fe7c715762e$var$hash = {
    start: 'end',
    end: 'start'
};
function $99de6fe7c715762e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $99de6fe7c715762e$var$hash[matched];
    });
}

});

parcelRegister("df6Yn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a4215bc485bb338$export$2e2bcd8739ae039; });

var $e5eap = parcelRequire("e5eap");

var $1MgVG = parcelRequire("1MgVG");

var $fozlG = parcelRequire("fozlG");

var $kzOdu = parcelRequire("kzOdu");

var $kkesR = parcelRequire("kkesR");

var $2EYpo = parcelRequire("2EYpo");

var $3wOoL = parcelRequire("3wOoL");

var $hPnmL = parcelRequire("hPnmL");

var $cttNb = parcelRequire("cttNb");
function $9a4215bc485bb338$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $2EYpo.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $2EYpo.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $2EYpo.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $hPnmL.default)(typeof padding !== 'number' ? padding : (0, $cttNb.default)(padding, (0, $2EYpo.basePlacements)));
    var altContext = elementContext === (0, $2EYpo.popper) ? (0, $2EYpo.reference) : (0, $2EYpo.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $e5eap.default)((0, $3wOoL.isElement)(element) ? element : element.contextElement || (0, $1MgVG.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $fozlG.default)(state.elements.reference);
    var popperOffsets = (0, $kzOdu.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $kkesR.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $2EYpo.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $2EYpo.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $2EYpo.right),
                (0, $2EYpo.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $2EYpo.top),
                (0, $2EYpo.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("e5eap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a40c85938761aa7b$export$2e2bcd8739ae039; });

var $2EYpo = parcelRequire("2EYpo");

var $krhsM = parcelRequire("krhsM");

var $2LSmW = parcelRequire("2LSmW");

var $hHMBa = parcelRequire("hHMBa");

var $aE5Sz = parcelRequire("aE5Sz");

var $1MgVG = parcelRequire("1MgVG");

var $1gKXS = parcelRequire("1gKXS");

var $3wOoL = parcelRequire("3wOoL");

var $fozlG = parcelRequire("fozlG");

var $3sNKo = parcelRequire("3sNKo");

var $854tN = parcelRequire("854tN");

var $3lxeQ = parcelRequire("3lxeQ");

var $kkesR = parcelRequire("kkesR");

var $bzJi7 = parcelRequire("bzJi7");
function $a40c85938761aa7b$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $fozlG.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a40c85938761aa7b$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $2EYpo.viewport) ? (0, $kkesR.default)((0, $krhsM.default)(element, strategy)) : (0, $3wOoL.isElement)(clippingParent) ? $a40c85938761aa7b$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $kkesR.default)((0, $2LSmW.default)((0, $1MgVG.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a40c85938761aa7b$var$getClippingParents(element) {
    var clippingParents = (0, $hHMBa.default)((0, $3sNKo.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1gKXS.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $3wOoL.isHTMLElement)(element) ? (0, $aE5Sz.default)(element) : element;
    if (!(0, $3wOoL.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $3wOoL.isElement)(clippingParent) && (0, $854tN.default)(clippingParent, clipperElement) && (0, $3lxeQ.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a40c85938761aa7b$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a40c85938761aa7b$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a40c85938761aa7b$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $bzJi7.max)(rect.top, accRect.top);
        accRect.right = (0, $bzJi7.min)(rect.right, accRect.right);
        accRect.bottom = (0, $bzJi7.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $bzJi7.max)(rect.left, accRect.left);
        return accRect;
    }, $a40c85938761aa7b$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("krhsM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee13e01cad769334$export$2e2bcd8739ae039; });

var $5YdjW = parcelRequire("5YdjW");

var $1MgVG = parcelRequire("1MgVG");

var $gfTW0 = parcelRequire("gfTW0");

var $bzkJe = parcelRequire("bzkJe");
function $ee13e01cad769334$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5YdjW.default)(element);
    var html = (0, $1MgVG.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bzkJe.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gfTW0.default)(element),
        y: y
    };
}

});
parcelRegister("gfTW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd596f7d74ecf670$export$2e2bcd8739ae039; });

var $fozlG = parcelRequire("fozlG");

var $1MgVG = parcelRequire("1MgVG");

var $gnNgs = parcelRequire("gnNgs");
function $bd596f7d74ecf670$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $fozlG.default)((0, $1MgVG.default)(element)).left + (0, $gnNgs.default)(element).scrollLeft;
}

});
parcelRegister("gnNgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bed502386114fd47$export$2e2bcd8739ae039; });

var $5YdjW = parcelRequire("5YdjW");
function $bed502386114fd47$export$2e2bcd8739ae039(node) {
    var win = (0, $5YdjW.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("2LSmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $204a251c5f493cea$export$2e2bcd8739ae039; });

var $1MgVG = parcelRequire("1MgVG");

var $1gKXS = parcelRequire("1gKXS");

var $gfTW0 = parcelRequire("gfTW0");

var $gnNgs = parcelRequire("gnNgs");

var $bzJi7 = parcelRequire("bzJi7");
function $204a251c5f493cea$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1MgVG.default)(element);
    var winScroll = (0, $gnNgs.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $bzJi7.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $bzJi7.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gfTW0.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1gKXS.default)(body || html).direction === 'rtl') x += (0, $bzJi7.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("hHMBa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce3c26712eb9bc93$export$2e2bcd8739ae039; });

var $d4iMI = parcelRequire("d4iMI");

var $3sNKo = parcelRequire("3sNKo");

var $5YdjW = parcelRequire("5YdjW");

var $3mgDF = parcelRequire("3mgDF");
function $ce3c26712eb9bc93$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $d4iMI.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5YdjW.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $3mgDF.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ce3c26712eb9bc93$export$2e2bcd8739ae039((0, $3sNKo.default)(target)));
}

});
parcelRegister("d4iMI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983a38573ed63d14$export$2e2bcd8739ae039; });

var $3sNKo = parcelRequire("3sNKo");

var $3mgDF = parcelRequire("3mgDF");

var $3lxeQ = parcelRequire("3lxeQ");

var $3wOoL = parcelRequire("3wOoL");
function $983a38573ed63d14$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3lxeQ.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $3wOoL.isHTMLElement)(node) && (0, $3mgDF.default)(node)) return node;
    return $983a38573ed63d14$export$2e2bcd8739ae039((0, $3sNKo.default)(node));
}

});
parcelRegister("3mgDF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2720554afd94d2e9$export$2e2bcd8739ae039; });

var $1gKXS = parcelRequire("1gKXS");
function $2720554afd94d2e9$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1gKXS.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("kkesR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc0e53e0a6e0017$export$2e2bcd8739ae039; });
function $ecc0e53e0a6e0017$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("kzOdu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efae077bc81d7f8a$export$2e2bcd8739ae039; });

var $6Qkvp = parcelRequire("6Qkvp");

var $fEiat = parcelRequire("fEiat");

var $M50jn = parcelRequire("M50jn");

var $2EYpo = parcelRequire("2EYpo");
function $efae077bc81d7f8a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6Qkvp.default)(placement) : null;
    var variation = placement ? (0, $fEiat.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $2EYpo.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $2EYpo.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $2EYpo.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $2EYpo.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $M50jn.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $2EYpo.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $2EYpo.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("fnc1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b31255956d845d2b$export$2e2bcd8739ae039; });

var $fEiat = parcelRequire("fEiat");

var $2EYpo = parcelRequire("2EYpo");

var $df6Yn = parcelRequire("df6Yn");

var $6Qkvp = parcelRequire("6Qkvp");
function $b31255956d845d2b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $2EYpo.placements) : _options$allowedAutoP;
    var variation = (0, $fEiat.default)(placement);
    var placements = variation ? flipVariations ? (0, $2EYpo.variationPlacements) : (0, $2EYpo.variationPlacements).filter(function(placement) {
        return (0, $fEiat.default)(placement) === variation;
    }) : (0, $2EYpo.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $df6Yn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6Qkvp.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("4Iu3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36f295d7733b878c$export$2e2bcd8739ae039; });

var $2EYpo = parcelRequire("2EYpo");

var $df6Yn = parcelRequire("df6Yn");
function $36f295d7733b878c$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $36f295d7733b878c$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $2EYpo.top),
        (0, $2EYpo.right),
        (0, $2EYpo.bottom),
        (0, $2EYpo.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $36f295d7733b878c$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $df6Yn.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $df6Yn.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $36f295d7733b878c$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $36f295d7733b878c$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $36f295d7733b878c$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $36f295d7733b878c$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $36f295d7733b878c$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $36f295d7733b878c$var$hide
};

});

parcelRegister("fZql2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba40fbc467ddac27$export$2e2bcd8739ae039; });

var $6Qkvp = parcelRequire("6Qkvp");

var $2EYpo = parcelRequire("2EYpo");
function $ba40fbc467ddac27$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6Qkvp.default)(placement);
    var invertDistance = [
        (0, $2EYpo.left),
        (0, $2EYpo.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $2EYpo.left),
        (0, $2EYpo.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ba40fbc467ddac27$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $2EYpo.placements).reduce(function(acc, placement) {
        acc[placement] = $ba40fbc467ddac27$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ba40fbc467ddac27$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ba40fbc467ddac27$var$offset
};

});

parcelRegister("abimq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76992c7ee56bb866$export$2e2bcd8739ae039; });

var $kzOdu = parcelRequire("kzOdu");
function $76992c7ee56bb866$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kzOdu.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $76992c7ee56bb866$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $76992c7ee56bb866$var$popperOffsets,
    data: {}
};

});

parcelRegister("73R1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5241f0b1e3bbc3ca$export$2e2bcd8739ae039; });

var $2EYpo = parcelRequire("2EYpo");

var $6Qkvp = parcelRequire("6Qkvp");

var $M50jn = parcelRequire("M50jn");

var $hcbdt = parcelRequire("hcbdt");

var $8Y7eS = parcelRequire("8Y7eS");

var $cfMXJ = parcelRequire("cfMXJ");

var $aE5Sz = parcelRequire("aE5Sz");

var $df6Yn = parcelRequire("df6Yn");

var $fEiat = parcelRequire("fEiat");

var $dxNQ4 = parcelRequire("dxNQ4");

var $bzJi7 = parcelRequire("bzJi7");
function $5241f0b1e3bbc3ca$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $df6Yn.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6Qkvp.default)(state.placement);
    var variation = (0, $fEiat.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $M50jn.default)(basePlacement);
    var altAxis = (0, $hcbdt.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $2EYpo.top) : (0, $2EYpo.left);
        var altSide = mainAxis === 'y' ? (0, $2EYpo.bottom) : (0, $2EYpo.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $2EYpo.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $2EYpo.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $cfMXJ.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dxNQ4.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $8Y7eS.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aE5Sz.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $8Y7eS.within)(tether ? (0, $bzJi7.min)(min, tetherMin) : min, offset, tether ? (0, $bzJi7.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $2EYpo.top) : (0, $2EYpo.left);
        var _altSide = mainAxis === 'x' ? (0, $2EYpo.bottom) : (0, $2EYpo.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $2EYpo.top),
            (0, $2EYpo.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $8Y7eS.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $8Y7eS.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5241f0b1e3bbc3ca$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5241f0b1e3bbc3ca$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("hcbdt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c84c41f9f60524e1$export$2e2bcd8739ae039; });
function $c84c41f9f60524e1$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("8tTAh", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $62cc260af1535abb$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $62cc260af1535abb$export$8f7491d57c8f97a9; });

var $brc2i = parcelRequire("brc2i");

var $cfMXJ = parcelRequire("cfMXJ");

var $hHMBa = parcelRequire("hHMBa");

var $aE5Sz = parcelRequire("aE5Sz");

var $jpBgx = parcelRequire("jpBgx");

var $fh4m5 = parcelRequire("fh4m5");

var $3SWcj = parcelRequire("3SWcj");

var $df6Yn = parcelRequire("df6Yn");

var $3wOoL = parcelRequire("3wOoL");
var $62cc260af1535abb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $62cc260af1535abb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $62cc260af1535abb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $62cc260af1535abb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $62cc260af1535abb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $3wOoL.isElement)(reference) ? (0, $hHMBa.default)(reference) : reference.contextElement ? (0, $hHMBa.default)(reference.contextElement) : [],
                    popper: (0, $hHMBa.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $jpBgx.default)((0, $3SWcj.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$62cc260af1535abb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $brc2i.default)(reference, (0, $aE5Sz.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $cfMXJ.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fh4m5.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$62cc260af1535abb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $62cc260af1535abb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $62cc260af1535abb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("brc2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $853b8d6cc873f4ba$export$2e2bcd8739ae039; });

var $fozlG = parcelRequire("fozlG");

var $j9hYH = parcelRequire("j9hYH");

var $3lxeQ = parcelRequire("3lxeQ");

var $3wOoL = parcelRequire("3wOoL");

var $gfTW0 = parcelRequire("gfTW0");

var $1MgVG = parcelRequire("1MgVG");

var $3mgDF = parcelRequire("3mgDF");

var $bzJi7 = parcelRequire("bzJi7");
function $853b8d6cc873f4ba$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $bzJi7.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $bzJi7.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $853b8d6cc873f4ba$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $3wOoL.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $3wOoL.isHTMLElement)(offsetParent) && $853b8d6cc873f4ba$var$isElementScaled(offsetParent);
    var documentElement = (0, $1MgVG.default)(offsetParent);
    var rect = (0, $fozlG.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3lxeQ.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $3mgDF.default)(documentElement)) scroll = (0, $j9hYH.default)(offsetParent);
        if ((0, $3wOoL.isHTMLElement)(offsetParent)) {
            offsets = (0, $fozlG.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gfTW0.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("j9hYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df0ccda601694fe1$export$2e2bcd8739ae039; });

var $gnNgs = parcelRequire("gnNgs");

var $5YdjW = parcelRequire("5YdjW");

var $3wOoL = parcelRequire("3wOoL");

var $ibDav = parcelRequire("ibDav");
function $df0ccda601694fe1$export$2e2bcd8739ae039(node) {
    if (node === (0, $5YdjW.default)(node) || !(0, $3wOoL.isHTMLElement)(node)) return (0, $gnNgs.default)(node);
    else return (0, $ibDav.default)(node);
}

});
parcelRegister("ibDav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d7a31c6abde2d3$export$2e2bcd8739ae039; });
function $d3d7a31c6abde2d3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("jpBgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e21d424d84dd1dbd$export$2e2bcd8739ae039; });

var $2EYpo = parcelRequire("2EYpo");
function $e21d424d84dd1dbd$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $e21d424d84dd1dbd$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $e21d424d84dd1dbd$var$order(modifiers); // order based on phase
    return (0, $2EYpo.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("fh4m5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1ebd2644c2dc0ed$export$2e2bcd8739ae039; });
function $b1ebd2644c2dc0ed$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("3SWcj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d438f14f616c723$export$2e2bcd8739ae039; });
function $2d438f14f616c723$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("6ROz1", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $4ffeea3ebe6fc573$export$8f7491d57c8f97a9; });

var $8tTAh = parcelRequire("8tTAh");

var $2AH0t = parcelRequire("2AH0t");

var $abimq = parcelRequire("abimq");

var $jsDgI = parcelRequire("jsDgI");

var $f8tKh = parcelRequire("f8tKh");

var $fZql2 = parcelRequire("fZql2");

var $6yBxl = parcelRequire("6yBxl");

var $73R1f = parcelRequire("73R1f");

var $8DiJ3 = parcelRequire("8DiJ3");

var $4Iu3u = parcelRequire("4Iu3u");


var $4ffeea3ebe6fc573$export$d34966752335dd47 = [
    (0, $2AH0t.default),
    (0, $abimq.default),
    (0, $jsDgI.default),
    (0, $f8tKh.default),
    (0, $fZql2.default),
    (0, $6yBxl.default),
    (0, $73R1f.default),
    (0, $8DiJ3.default),
    (0, $4Iu3u.default)
];
var $4ffeea3ebe6fc573$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8tTAh.popperGenerator)({
    defaultModifiers: $4ffeea3ebe6fc573$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("gT8sP", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $c4b8592977bbbca8$export$8f7491d57c8f97a9; });

var $8tTAh = parcelRequire("8tTAh");

var $2AH0t = parcelRequire("2AH0t");

var $abimq = parcelRequire("abimq");

var $jsDgI = parcelRequire("jsDgI");

var $f8tKh = parcelRequire("f8tKh");
var $c4b8592977bbbca8$export$d34966752335dd47 = [
    (0, $2AH0t.default),
    (0, $abimq.default),
    (0, $jsDgI.default),
    (0, $f8tKh.default)
];
var $c4b8592977bbbca8$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8tTAh.popperGenerator)({
    defaultModifiers: $c4b8592977bbbca8$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


parcelRegister("lPcV8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iWjIA = parcelRequire("iWjIA");
function $fe386228e980ae03$var$emptyFunction() {}
function $fe386228e980ae03$var$emptyFunctionWithReset() {}
$fe386228e980ae03$var$emptyFunctionWithReset.resetWarningCache = $fe386228e980ae03$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iWjIA) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $fe386228e980ae03$var$emptyFunctionWithReset,
        resetWarningCache: $fe386228e980ae03$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iWjIA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $dc9cf065d702bd78$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $dc9cf065d702bd78$var$ReactPropTypesSecret;

});


var $1035e1f676e04af4$exports = {};
$parcel$extendImportMap({
    "esn4O": "identifiers_logo.9d30579d.png",
    "1Ui0B": "elixir_kitemark-60px.d5d618fa.png"
});

var $8939768198127506$exports = {};
'use strict';

$8939768198127506$exports = (parcelRequire("joTVV"));


parcelRequire("6kl77");
var $f995a7d9315d4218$export$882461b6382ed46c;
var $f995a7d9315d4218$export$757ceba2d55c277e;
'use strict';
var $9081a4cee253faa5$exports = {};
'use strict';
function $9081a4cee253faa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9081a4cee253faa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9081a4cee253faa5$var$checkDCE();

$9081a4cee253faa5$exports = (parcelRequire("71HD7"));


var $f995a7d9315d4218$var$i;
$f995a7d9315d4218$export$882461b6382ed46c = $9081a4cee253faa5$exports.createRoot;
$f995a7d9315d4218$export$757ceba2d55c277e = $9081a4cee253faa5$exports.hydrateRoot;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $bJKTO = parcelRequire("bJKTO");
var $9d089ba9cdc47f34$exports = {};
'use strict';

$9d089ba9cdc47f34$exports = (parcelRequire("jNImf"));





// Default to a dummy "batch" implementation that just runs the callback
function $8e4bf54a03d11516$var$defaultNoopBatch(callback) {
    callback();
}
let $8e4bf54a03d11516$var$batch = $8e4bf54a03d11516$var$defaultNoopBatch; // Allow injecting another batching function later
const $8e4bf54a03d11516$export$4b9874722d0da7bc = (newBatch)=>$8e4bf54a03d11516$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $8e4bf54a03d11516$export$fc47d4c0ba3bd2c6 = ()=>$8e4bf54a03d11516$var$batch;



var $6kl77 = parcelRequire("6kl77");

var $6kl77 = parcelRequire("6kl77");

var $6kl77 = parcelRequire("6kl77");
const $47594c0edf7b953d$var$ContextKey = Symbol.for(`react-redux-context`);
const $47594c0edf7b953d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $47594c0edf7b953d$var$getContext() {
    var _gT$ContextKey;
    if (!$6kl77.createContext) return {};
    const contextMap = (_gT$ContextKey = $47594c0edf7b953d$var$gT[$47594c0edf7b953d$var$ContextKey]) != null ? _gT$ContextKey : $47594c0edf7b953d$var$gT[$47594c0edf7b953d$var$ContextKey] = new Map();
    let realContext = contextMap.get($6kl77.createContext);
    if (!realContext) {
        realContext = $6kl77.createContext(null);
        contextMap.set($6kl77.createContext, realContext);
    }
    return realContext;
}
const $47594c0edf7b953d$export$cc80c08dc91f1c00 = /*#__PURE__*/ $47594c0edf7b953d$var$getContext();
var $47594c0edf7b953d$export$2e2bcd8739ae039 = $47594c0edf7b953d$export$cc80c08dc91f1c00;


function $acbe87e4eb870238$export$d4d6226d5fc61558(context = (0, $47594c0edf7b953d$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $6kl77.useContext)(context);
        return contextValue;
    };
}
const $acbe87e4eb870238$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $acbe87e4eb870238$export$d4d6226d5fc61558();



const $2b28e2c66490822e$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};


let $696d5200b2f2bbff$var$useSyncExternalStoreWithSelector = (0, $2b28e2c66490822e$export$20656a4825650bd0);
const $696d5200b2f2bbff$export$e2e6e3f3f3b782e3 = (fn)=>{
    $696d5200b2f2bbff$var$useSyncExternalStoreWithSelector = fn;
};
const $696d5200b2f2bbff$var$refEquality = (a, b)=>a === b;
function $696d5200b2f2bbff$export$2b53f90d2bd1cbfb(context = (0, $47594c0edf7b953d$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $47594c0edf7b953d$export$cc80c08dc91f1c00) ? (0, $acbe87e4eb870238$export$c1275ca9a6fd3ec5) : (0, $acbe87e4eb870238$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $696d5200b2f2bbff$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $6kl77.useRef)(true);
        const wrappedSelector = (0, $6kl77.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $696d5200b2f2bbff$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $6kl77.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $696d5200b2f2bbff$export$2105062e25df4afe = /*#__PURE__*/ $696d5200b2f2bbff$export$2b53f90d2bd1cbfb();


function $0c679bd09ade8a09$export$2e2bcd8739ae039() {
    return $0c679bd09ade8a09$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0c679bd09ade8a09$export$2e2bcd8739ae039.apply(null, arguments);
}


function $d63a197e1ee00793$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $20db02a4be2d8986$exports = {};
'use strict';
var $a578a9e637e01662$exports = {};
'use strict';

$a578a9e637e01662$exports = (parcelRequire("c5rKu"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $20db02a4be2d8986$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $20db02a4be2d8986$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $20db02a4be2d8986$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $20db02a4be2d8986$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $20db02a4be2d8986$var$TYPE_STATICS = {};
$20db02a4be2d8986$var$TYPE_STATICS[$a578a9e637e01662$exports.ForwardRef] = $20db02a4be2d8986$var$FORWARD_REF_STATICS;
$20db02a4be2d8986$var$TYPE_STATICS[$a578a9e637e01662$exports.Memo] = $20db02a4be2d8986$var$MEMO_STATICS;
function $20db02a4be2d8986$var$getStatics(component) {
    // React v16.11 and below
    if ($a578a9e637e01662$exports.isMemo(component)) return $20db02a4be2d8986$var$MEMO_STATICS;
     // React v16.12 and above
    return $20db02a4be2d8986$var$TYPE_STATICS[component['$$typeof']] || $20db02a4be2d8986$var$REACT_STATICS;
}
var $20db02a4be2d8986$var$defineProperty = Object.defineProperty;
var $20db02a4be2d8986$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $20db02a4be2d8986$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $20db02a4be2d8986$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $20db02a4be2d8986$var$getPrototypeOf = Object.getPrototypeOf;
var $20db02a4be2d8986$var$objectPrototype = Object.prototype;
function $20db02a4be2d8986$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($20db02a4be2d8986$var$objectPrototype) {
            var inheritedComponent = $20db02a4be2d8986$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $20db02a4be2d8986$var$objectPrototype) $20db02a4be2d8986$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $20db02a4be2d8986$var$getOwnPropertyNames(sourceComponent);
        if ($20db02a4be2d8986$var$getOwnPropertySymbols) keys = keys.concat($20db02a4be2d8986$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $20db02a4be2d8986$var$getStatics(targetComponent);
        var sourceStatics = $20db02a4be2d8986$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$20db02a4be2d8986$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $20db02a4be2d8986$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $20db02a4be2d8986$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$20db02a4be2d8986$exports = $20db02a4be2d8986$var$hoistNonReactStatics;



var $6kl77 = parcelRequire("6kl77");
var $ba22fcd95a44b1da$exports = {};
'use strict';

$ba22fcd95a44b1da$exports = (parcelRequire("jat59"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $05f069582520a76f$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $9928849d300a31fa$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $05f069582520a76f$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $9928849d300a31fa$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $9928849d300a31fa$var$verify(mapStateToProps, 'mapStateToProps');
    $9928849d300a31fa$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $9928849d300a31fa$var$verify(mergeProps, 'mergeProps');
}


const $467ed082012a477e$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $467ed082012a477e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $467ed082012a477e$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $d63a197e1ee00793$export$2e2bcd8739ae039)(_ref, $467ed082012a477e$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $467ed082012a477e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $6612d1626f1ed874$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $4ffbf7821e70515c$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $49c49f3effe0ff63$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $4ffbf7821e70515c$export$2e2bcd8739ae039)(value)) (0, $05f069582520a76f$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $b2ca50b06a32129b$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $b2ca50b06a32129b$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $b2ca50b06a32129b$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b2ca50b06a32129b$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b2ca50b06a32129b$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $5145a7f4f6eca4a6$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $c157fdc3e821b6a2$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $b2ca50b06a32129b$export$710f7c60f68acd3e)((dispatch)=>(0, $6612d1626f1ed874$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $b2ca50b06a32129b$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $b2ca50b06a32129b$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $5145a7f4f6eca4a6$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $79800a46376d9695$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $b2ca50b06a32129b$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $b2ca50b06a32129b$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $5145a7f4f6eca4a6$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}





function $8bb1e3aabbf04a8c$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $0c679bd09ade8a09$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $8bb1e3aabbf04a8c$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $8bb1e3aabbf04a8c$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$8bb1e3aabbf04a8c$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $8bb1e3aabbf04a8c$export$5b105939c84b5234(mergeProps) : (0, $5145a7f4f6eca4a6$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $6e46dceea5a103ad$var$createListenerCollection() {
    const batch = (0, $8e4bf54a03d11516$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $6e46dceea5a103ad$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $6e46dceea5a103ad$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $6e46dceea5a103ad$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $6e46dceea5a103ad$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $6e46dceea5a103ad$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $6kl77 = parcelRequire("6kl77");
const $05c4b5ba51fa36e4$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $05c4b5ba51fa36e4$export$700979bc83e7db82 = $05c4b5ba51fa36e4$export$71594e8a50f746f4 ? $6kl77.useLayoutEffect : $6kl77.useEffect;


function $16119ad6f0e3ae5c$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $16119ad6f0e3ae5c$export$2e2bcd8739ae039(objA, objB) {
    if ($16119ad6f0e3ae5c$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$16119ad6f0e3ae5c$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $128f50888c77ce5a$var$_excluded = [
    "reactReduxForwardedRef"
];
let $128f50888c77ce5a$var$useSyncExternalStore = (0, $2b28e2c66490822e$export$20656a4825650bd0);
const $128f50888c77ce5a$export$36d45daa6a4925b8 = (fn)=>{
    $128f50888c77ce5a$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $128f50888c77ce5a$var$EMPTY_ARRAY = [
    null,
    0
];
const $128f50888c77ce5a$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $128f50888c77ce5a$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $128f50888c77ce5a$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $05c4b5ba51fa36e4$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $128f50888c77ce5a$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $128f50888c77ce5a$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $128f50888c77ce5a$var$initStateUpdates = ()=>$128f50888c77ce5a$var$EMPTY_ARRAY;
function $128f50888c77ce5a$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $128f50888c77ce5a$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $128f50888c77ce5a$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $128f50888c77ce5a$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $16119ad6f0e3ae5c$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $16119ad6f0e3ae5c$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $16119ad6f0e3ae5c$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $47594c0edf7b953d$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $79800a46376d9695$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $c157fdc3e821b6a2$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $8bb1e3aabbf04a8c$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $6kl77.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $d63a197e1ee00793$export$2e2bcd8739ae039)(props, $128f50888c77ce5a$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $6kl77.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $ba22fcd95a44b1da$exports.isContextConsumer)(/*#__PURE__*/ $6kl77.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $6kl77.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $6kl77.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $467ed082012a477e$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $6kl77.useMemo(()=>{
                if (!shouldHandleStateChanges) return $128f50888c77ce5a$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $6e46dceea5a103ad$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $6kl77.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $0c679bd09ade8a09$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $6kl77.useRef();
            const lastWrapperProps = $6kl77.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $6kl77.useRef();
            const renderIsScheduled = $6kl77.useRef(false);
            const isProcessingDispatch = $6kl77.useRef(false);
            const isMounted = $6kl77.useRef(false);
            const latestSubscriptionCallbackError = $6kl77.useRef();
            (0, $05c4b5ba51fa36e4$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $6kl77.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $6kl77.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $128f50888c77ce5a$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $128f50888c77ce5a$var$useIsomorphicLayoutEffectWithArgs($128f50888c77ce5a$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $128f50888c77ce5a$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $05c4b5ba51fa36e4$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $6kl77.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $6kl77.createElement(WrappedComponent, (0, $0c679bd09ade8a09$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $6kl77.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $6kl77.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $6kl77.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $6kl77.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $6kl77.createElement(Connect, (0, $0c679bd09ade8a09$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($20db02a4be2d8986$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($20db02a4be2d8986$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $128f50888c77ce5a$export$2e2bcd8739ae039 = $128f50888c77ce5a$var$connect;



var $6kl77 = parcelRequire("6kl77");



function $947b4ef5dc45af9b$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $6kl77.useMemo(()=>{
        const subscription = (0, $6e46dceea5a103ad$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $6kl77.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $05c4b5ba51fa36e4$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $47594c0edf7b953d$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $6kl77.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $947b4ef5dc45af9b$export$2e2bcd8739ae039 = $947b4ef5dc45af9b$var$Provider;







function $22353d93bda2050e$export$671dba69185d0304(context = (0, $47594c0edf7b953d$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $47594c0edf7b953d$export$cc80c08dc91f1c00) ? (0, $acbe87e4eb870238$export$c1275ca9a6fd3ec5) : (0, $acbe87e4eb870238$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $22353d93bda2050e$export$6ccbb43953eebf8 = /*#__PURE__*/ $22353d93bda2050e$export$671dba69185d0304();


function $7977f33ef65198ba$export$bc9b55530897c558(context = (0, $47594c0edf7b953d$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $47594c0edf7b953d$export$cc80c08dc91f1c00) ? (0, $22353d93bda2050e$export$6ccbb43953eebf8) : (0, $22353d93bda2050e$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $7977f33ef65198ba$export$8ad76b76a4c905f8 = /*#__PURE__*/ $7977f33ef65198ba$export$bc9b55530897c558();









(0, $696d5200b2f2bbff$export$e2e6e3f3f3b782e3)((0, $9d089ba9cdc47f34$exports.useSyncExternalStoreWithSelector));
(0, $128f50888c77ce5a$export$36d45daa6a4925b8)((0, $bJKTO.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $8e4bf54a03d11516$export$4b9874722d0da7bc)((0, $9081a4cee253faa5$exports.unstable_batchedUpdates));


/*!
  * Bootstrap v5.3.5 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $cseje = parcelRequire("cseje");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$elementMap = new Map();
const $36993a23339f9fb9$var$Data = {
    set (element, key, instance) {
        if (!$36993a23339f9fb9$var$elementMap.has(element)) $36993a23339f9fb9$var$elementMap.set(element, new Map());
        const instanceMap = $36993a23339f9fb9$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($36993a23339f9fb9$var$elementMap.has(element)) return $36993a23339f9fb9$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$36993a23339f9fb9$var$elementMap.has(element)) return;
        const instanceMap = $36993a23339f9fb9$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $36993a23339f9fb9$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $36993a23339f9fb9$var$MAX_UID = 1000000;
const $36993a23339f9fb9$var$MILLISECONDS_MULTIPLIER = 1000;
const $36993a23339f9fb9$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $36993a23339f9fb9$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $36993a23339f9fb9$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $36993a23339f9fb9$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $36993a23339f9fb9$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $36993a23339f9fb9$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $36993a23339f9fb9$var$MILLISECONDS_MULTIPLIER;
};
const $36993a23339f9fb9$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($36993a23339f9fb9$var$TRANSITION_END));
};
const $36993a23339f9fb9$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $36993a23339f9fb9$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($36993a23339f9fb9$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($36993a23339f9fb9$var$parseSelector(object));
    return null;
};
const $36993a23339f9fb9$var$isVisible = (element)=>{
    if (!$36993a23339f9fb9$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $36993a23339f9fb9$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $36993a23339f9fb9$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $36993a23339f9fb9$var$findShadowRoot(element.parentNode);
};
const $36993a23339f9fb9$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $36993a23339f9fb9$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $36993a23339f9fb9$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $36993a23339f9fb9$var$DOMContentLoadedCallbacks = [];
const $36993a23339f9fb9$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$36993a23339f9fb9$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $36993a23339f9fb9$var$DOMContentLoadedCallbacks)callback();
        });
        $36993a23339f9fb9$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $36993a23339f9fb9$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $36993a23339f9fb9$var$defineJQueryPlugin = (plugin)=>{
    $36993a23339f9fb9$var$onDOMContentLoaded(()=>{
        const $ = $36993a23339f9fb9$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $36993a23339f9fb9$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $36993a23339f9fb9$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $36993a23339f9fb9$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $36993a23339f9fb9$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($36993a23339f9fb9$var$TRANSITION_END, handler);
        $36993a23339f9fb9$var$execute(callback);
    };
    transitionElement.addEventListener($36993a23339f9fb9$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $36993a23339f9fb9$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $36993a23339f9fb9$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $36993a23339f9fb9$var$stripNameRegex = /\..*/;
const $36993a23339f9fb9$var$stripUidRegex = /::\d+$/;
const $36993a23339f9fb9$var$eventRegistry = {}; // Events storage
let $36993a23339f9fb9$var$uidEvent = 1;
const $36993a23339f9fb9$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $36993a23339f9fb9$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $36993a23339f9fb9$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$36993a23339f9fb9$var$uidEvent++}` || element.uidEvent || $36993a23339f9fb9$var$uidEvent++;
}
function $36993a23339f9fb9$var$getElementEvents(element) {
    const uid = $36993a23339f9fb9$var$makeEventUid(element);
    element.uidEvent = uid;
    $36993a23339f9fb9$var$eventRegistry[uid] = $36993a23339f9fb9$var$eventRegistry[uid] || {};
    return $36993a23339f9fb9$var$eventRegistry[uid];
}
function $36993a23339f9fb9$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $36993a23339f9fb9$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $36993a23339f9fb9$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $36993a23339f9fb9$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $36993a23339f9fb9$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $36993a23339f9fb9$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $36993a23339f9fb9$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $36993a23339f9fb9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $36993a23339f9fb9$var$getTypeEvent(originalTypeEvent);
    if (!$36993a23339f9fb9$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $36993a23339f9fb9$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $36993a23339f9fb9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $36993a23339f9fb9$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $36993a23339f9fb9$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $36993a23339f9fb9$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $36993a23339f9fb9$var$makeEventUid(callable, originalTypeEvent.replace($36993a23339f9fb9$var$namespaceRegex, ''));
    const fn = isDelegated ? $36993a23339f9fb9$var$bootstrapDelegationHandler(element, handler, callable) : $36993a23339f9fb9$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $36993a23339f9fb9$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $36993a23339f9fb9$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $36993a23339f9fb9$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $36993a23339f9fb9$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $36993a23339f9fb9$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($36993a23339f9fb9$var$stripNameRegex, '');
    return $36993a23339f9fb9$var$customEvents[event] || event;
}
const $36993a23339f9fb9$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $36993a23339f9fb9$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $36993a23339f9fb9$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $36993a23339f9fb9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $36993a23339f9fb9$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $36993a23339f9fb9$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$36993a23339f9fb9$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($36993a23339f9fb9$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $36993a23339f9fb9$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $36993a23339f9fb9$var$getjQuery();
        const typeEvent = $36993a23339f9fb9$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $36993a23339f9fb9$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $36993a23339f9fb9$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $36993a23339f9fb9$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $36993a23339f9fb9$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $36993a23339f9fb9$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$36993a23339f9fb9$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$36993a23339f9fb9$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $36993a23339f9fb9$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $36993a23339f9fb9$var$normalizeData(element.getAttribute(`data-bs-${$36993a23339f9fb9$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $36993a23339f9fb9$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $36993a23339f9fb9$var$isElement(element) ? $36993a23339f9fb9$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$36993a23339f9fb9$var$isElement(element) ? $36993a23339f9fb9$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $36993a23339f9fb9$var$isElement(value) ? 'element' : $36993a23339f9fb9$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$VERSION = '5.3.5';
/**
 * Class definition
 */ class $36993a23339f9fb9$var$BaseComponent extends $36993a23339f9fb9$var$Config {
    constructor(element, config){
        super();
        element = $36993a23339f9fb9$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $36993a23339f9fb9$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $36993a23339f9fb9$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $36993a23339f9fb9$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $36993a23339f9fb9$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $36993a23339f9fb9$var$Data.get($36993a23339f9fb9$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $36993a23339f9fb9$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $36993a23339f9fb9$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$36993a23339f9fb9$var$parseSelector(sel)).join(',') : null;
};
const $36993a23339f9fb9$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$36993a23339f9fb9$var$isDisabled(el) && $36993a23339f9fb9$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $36993a23339f9fb9$var$getSelector(element);
        if (selector) return $36993a23339f9fb9$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $36993a23339f9fb9$var$getSelector(element);
        return selector ? $36993a23339f9fb9$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $36993a23339f9fb9$var$getSelector(element);
        return selector ? $36993a23339f9fb9$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $36993a23339f9fb9$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $36993a23339f9fb9$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($36993a23339f9fb9$var$isDisabled(this)) return;
        const target = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$f = 'alert';
const $36993a23339f9fb9$var$DATA_KEY$a = 'bs.alert';
const $36993a23339f9fb9$var$EVENT_KEY$b = `.${$36993a23339f9fb9$var$DATA_KEY$a}`;
const $36993a23339f9fb9$var$EVENT_CLOSE = `close${$36993a23339f9fb9$var$EVENT_KEY$b}`;
const $36993a23339f9fb9$var$EVENT_CLOSED = `closed${$36993a23339f9fb9$var$EVENT_KEY$b}`;
const $36993a23339f9fb9$var$CLASS_NAME_FADE$5 = 'fade';
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $36993a23339f9fb9$export$caec2af78bcc877f extends $36993a23339f9fb9$var$BaseComponent {
    // Getters
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$enableDismissTrigger($36993a23339f9fb9$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$e = 'button';
const $36993a23339f9fb9$var$DATA_KEY$9 = 'bs.button';
const $36993a23339f9fb9$var$EVENT_KEY$a = `.${$36993a23339f9fb9$var$DATA_KEY$9}`;
const $36993a23339f9fb9$var$DATA_API_KEY$6 = '.data-api';
const $36993a23339f9fb9$var$CLASS_NAME_ACTIVE$3 = 'active';
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$6 = `click${$36993a23339f9fb9$var$EVENT_KEY$a}${$36993a23339f9fb9$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $36993a23339f9fb9$export$353f5b6fc5456de1 extends $36993a23339f9fb9$var$BaseComponent {
    // Getters
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$6, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$5);
    const data = $36993a23339f9fb9$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$d = 'swipe';
const $36993a23339f9fb9$var$EVENT_KEY$9 = '.bs.swipe';
const $36993a23339f9fb9$var$EVENT_TOUCHSTART = `touchstart${$36993a23339f9fb9$var$EVENT_KEY$9}`;
const $36993a23339f9fb9$var$EVENT_TOUCHMOVE = `touchmove${$36993a23339f9fb9$var$EVENT_KEY$9}`;
const $36993a23339f9fb9$var$EVENT_TOUCHEND = `touchend${$36993a23339f9fb9$var$EVENT_KEY$9}`;
const $36993a23339f9fb9$var$EVENT_POINTERDOWN = `pointerdown${$36993a23339f9fb9$var$EVENT_KEY$9}`;
const $36993a23339f9fb9$var$EVENT_POINTERUP = `pointerup${$36993a23339f9fb9$var$EVENT_KEY$9}`;
const $36993a23339f9fb9$var$POINTER_TYPE_TOUCH = 'touch';
const $36993a23339f9fb9$var$POINTER_TYPE_PEN = 'pen';
const $36993a23339f9fb9$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $36993a23339f9fb9$var$SWIPE_THRESHOLD = 40;
const $36993a23339f9fb9$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $36993a23339f9fb9$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$var$Swipe extends $36993a23339f9fb9$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$36993a23339f9fb9$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$c;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$c;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$d;
    }
    // Public
    dispose() {
        $36993a23339f9fb9$var$EventHandler.off(this._element, $36993a23339f9fb9$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $36993a23339f9fb9$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $36993a23339f9fb9$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $36993a23339f9fb9$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $36993a23339f9fb9$var$POINTER_TYPE_PEN || event.pointerType === $36993a23339f9fb9$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$c = 'carousel';
const $36993a23339f9fb9$var$DATA_KEY$8 = 'bs.carousel';
const $36993a23339f9fb9$var$EVENT_KEY$8 = `.${$36993a23339f9fb9$var$DATA_KEY$8}`;
const $36993a23339f9fb9$var$DATA_API_KEY$5 = '.data-api';
const $36993a23339f9fb9$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $36993a23339f9fb9$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $36993a23339f9fb9$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $36993a23339f9fb9$var$ORDER_NEXT = 'next';
const $36993a23339f9fb9$var$ORDER_PREV = 'prev';
const $36993a23339f9fb9$var$DIRECTION_LEFT = 'left';
const $36993a23339f9fb9$var$DIRECTION_RIGHT = 'right';
const $36993a23339f9fb9$var$EVENT_SLIDE = `slide${$36993a23339f9fb9$var$EVENT_KEY$8}`;
const $36993a23339f9fb9$var$EVENT_SLID = `slid${$36993a23339f9fb9$var$EVENT_KEY$8}`;
const $36993a23339f9fb9$var$EVENT_KEYDOWN$1 = `keydown${$36993a23339f9fb9$var$EVENT_KEY$8}`;
const $36993a23339f9fb9$var$EVENT_MOUSEENTER$1 = `mouseenter${$36993a23339f9fb9$var$EVENT_KEY$8}`;
const $36993a23339f9fb9$var$EVENT_MOUSELEAVE$1 = `mouseleave${$36993a23339f9fb9$var$EVENT_KEY$8}`;
const $36993a23339f9fb9$var$EVENT_DRAG_START = `dragstart${$36993a23339f9fb9$var$EVENT_KEY$8}`;
const $36993a23339f9fb9$var$EVENT_LOAD_DATA_API$3 = `load${$36993a23339f9fb9$var$EVENT_KEY$8}${$36993a23339f9fb9$var$DATA_API_KEY$5}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$5 = `click${$36993a23339f9fb9$var$EVENT_KEY$8}${$36993a23339f9fb9$var$DATA_API_KEY$5}`;
const $36993a23339f9fb9$var$CLASS_NAME_CAROUSEL = 'carousel';
const $36993a23339f9fb9$var$CLASS_NAME_ACTIVE$2 = 'active';
const $36993a23339f9fb9$var$CLASS_NAME_SLIDE = 'slide';
const $36993a23339f9fb9$var$CLASS_NAME_END = 'carousel-item-end';
const $36993a23339f9fb9$var$CLASS_NAME_START = 'carousel-item-start';
const $36993a23339f9fb9$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $36993a23339f9fb9$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $36993a23339f9fb9$var$SELECTOR_ACTIVE = '.active';
const $36993a23339f9fb9$var$SELECTOR_ITEM = '.carousel-item';
const $36993a23339f9fb9$var$SELECTOR_ACTIVE_ITEM = $36993a23339f9fb9$var$SELECTOR_ACTIVE + $36993a23339f9fb9$var$SELECTOR_ITEM;
const $36993a23339f9fb9$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $36993a23339f9fb9$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $36993a23339f9fb9$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $36993a23339f9fb9$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $36993a23339f9fb9$var$KEY_TO_DIRECTION = {
    [$36993a23339f9fb9$var$ARROW_LEFT_KEY$1]: $36993a23339f9fb9$var$DIRECTION_RIGHT,
    [$36993a23339f9fb9$var$ARROW_RIGHT_KEY$1]: $36993a23339f9fb9$var$DIRECTION_LEFT
};
const $36993a23339f9fb9$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $36993a23339f9fb9$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$144901db2ea8e967 extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $36993a23339f9fb9$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$b;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$b;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$c;
    }
    // Public
    next() {
        this._slide($36993a23339f9fb9$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $36993a23339f9fb9$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($36993a23339f9fb9$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $36993a23339f9fb9$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $36993a23339f9fb9$var$EventHandler.one(this._element, $36993a23339f9fb9$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $36993a23339f9fb9$var$EventHandler.one(this._element, $36993a23339f9fb9$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $36993a23339f9fb9$var$ORDER_NEXT : $36993a23339f9fb9$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $36993a23339f9fb9$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_ITEM_IMG, this._element))$36993a23339f9fb9$var$EventHandler.on(img, $36993a23339f9fb9$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $36993a23339f9fb9$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($36993a23339f9fb9$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($36993a23339f9fb9$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $36993a23339f9fb9$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $36993a23339f9fb9$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $36993a23339f9fb9$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $36993a23339f9fb9$var$ORDER_NEXT;
        const nextElement = element || $36993a23339f9fb9$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $36993a23339f9fb9$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($36993a23339f9fb9$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $36993a23339f9fb9$var$CLASS_NAME_START : $36993a23339f9fb9$var$CLASS_NAME_END;
        const orderClassName = isNext ? $36993a23339f9fb9$var$CLASS_NAME_NEXT : $36993a23339f9fb9$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $36993a23339f9fb9$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($36993a23339f9fb9$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($36993a23339f9fb9$var$isRTL()) return direction === $36993a23339f9fb9$var$DIRECTION_LEFT ? $36993a23339f9fb9$var$ORDER_PREV : $36993a23339f9fb9$var$ORDER_NEXT;
        return direction === $36993a23339f9fb9$var$DIRECTION_LEFT ? $36993a23339f9fb9$var$ORDER_NEXT : $36993a23339f9fb9$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($36993a23339f9fb9$var$isRTL()) return order === $36993a23339f9fb9$var$ORDER_PREV ? $36993a23339f9fb9$var$DIRECTION_LEFT : $36993a23339f9fb9$var$DIRECTION_RIGHT;
        return order === $36993a23339f9fb9$var$ORDER_PREV ? $36993a23339f9fb9$var$DIRECTION_RIGHT : $36993a23339f9fb9$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$5, $36993a23339f9fb9$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($36993a23339f9fb9$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $36993a23339f9fb9$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($36993a23339f9fb9$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$36993a23339f9fb9$var$EventHandler.on(window, $36993a23339f9fb9$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$36993a23339f9fb9$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$b = 'collapse';
const $36993a23339f9fb9$var$DATA_KEY$7 = 'bs.collapse';
const $36993a23339f9fb9$var$EVENT_KEY$7 = `.${$36993a23339f9fb9$var$DATA_KEY$7}`;
const $36993a23339f9fb9$var$DATA_API_KEY$4 = '.data-api';
const $36993a23339f9fb9$var$EVENT_SHOW$6 = `show${$36993a23339f9fb9$var$EVENT_KEY$7}`;
const $36993a23339f9fb9$var$EVENT_SHOWN$6 = `shown${$36993a23339f9fb9$var$EVENT_KEY$7}`;
const $36993a23339f9fb9$var$EVENT_HIDE$6 = `hide${$36993a23339f9fb9$var$EVENT_KEY$7}`;
const $36993a23339f9fb9$var$EVENT_HIDDEN$6 = `hidden${$36993a23339f9fb9$var$EVENT_KEY$7}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$4 = `click${$36993a23339f9fb9$var$EVENT_KEY$7}${$36993a23339f9fb9$var$DATA_API_KEY$4}`;
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$7 = 'show';
const $36993a23339f9fb9$var$CLASS_NAME_COLLAPSE = 'collapse';
const $36993a23339f9fb9$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $36993a23339f9fb9$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $36993a23339f9fb9$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$36993a23339f9fb9$var$CLASS_NAME_COLLAPSE} .${$36993a23339f9fb9$var$CLASS_NAME_COLLAPSE}`;
const $36993a23339f9fb9$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $36993a23339f9fb9$var$WIDTH = 'width';
const $36993a23339f9fb9$var$HEIGHT = 'height';
const $36993a23339f9fb9$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $36993a23339f9fb9$var$Default$a = {
    parent: null,
    toggle: true
};
const $36993a23339f9fb9$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$78768a9af065a7b extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $36993a23339f9fb9$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $36993a23339f9fb9$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$a;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$a;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($36993a23339f9fb9$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$36993a23339f9fb9$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_COLLAPSE, $36993a23339f9fb9$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $36993a23339f9fb9$var$reflow(this._element);
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_COLLAPSE, $36993a23339f9fb9$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_COLLAPSE);
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $36993a23339f9fb9$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_HORIZONTAL) ? $36993a23339f9fb9$var$WIDTH : $36993a23339f9fb9$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $36993a23339f9fb9$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($36993a23339f9fb9$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $36993a23339f9fb9$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$4, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $36993a23339f9fb9$var$SelectorEngine.getMultipleElementsFromSelector(this))$36993a23339f9fb9$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$a = 'dropdown';
const $36993a23339f9fb9$var$DATA_KEY$6 = 'bs.dropdown';
const $36993a23339f9fb9$var$EVENT_KEY$6 = `.${$36993a23339f9fb9$var$DATA_KEY$6}`;
const $36993a23339f9fb9$var$DATA_API_KEY$3 = '.data-api';
const $36993a23339f9fb9$var$ESCAPE_KEY$2 = 'Escape';
const $36993a23339f9fb9$var$TAB_KEY$1 = 'Tab';
const $36993a23339f9fb9$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $36993a23339f9fb9$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $36993a23339f9fb9$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $36993a23339f9fb9$var$EVENT_HIDE$5 = `hide${$36993a23339f9fb9$var$EVENT_KEY$6}`;
const $36993a23339f9fb9$var$EVENT_HIDDEN$5 = `hidden${$36993a23339f9fb9$var$EVENT_KEY$6}`;
const $36993a23339f9fb9$var$EVENT_SHOW$5 = `show${$36993a23339f9fb9$var$EVENT_KEY$6}`;
const $36993a23339f9fb9$var$EVENT_SHOWN$5 = `shown${$36993a23339f9fb9$var$EVENT_KEY$6}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$3 = `click${$36993a23339f9fb9$var$EVENT_KEY$6}${$36993a23339f9fb9$var$DATA_API_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_KEYDOWN_DATA_API = `keydown${$36993a23339f9fb9$var$EVENT_KEY$6}${$36993a23339f9fb9$var$DATA_API_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_KEYUP_DATA_API = `keyup${$36993a23339f9fb9$var$EVENT_KEY$6}${$36993a23339f9fb9$var$DATA_API_KEY$3}`;
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$6 = 'show';
const $36993a23339f9fb9$var$CLASS_NAME_DROPUP = 'dropup';
const $36993a23339f9fb9$var$CLASS_NAME_DROPEND = 'dropend';
const $36993a23339f9fb9$var$CLASS_NAME_DROPSTART = 'dropstart';
const $36993a23339f9fb9$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $36993a23339f9fb9$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3}.${$36993a23339f9fb9$var$CLASS_NAME_SHOW$6}`;
const $36993a23339f9fb9$var$SELECTOR_MENU = '.dropdown-menu';
const $36993a23339f9fb9$var$SELECTOR_NAVBAR = '.navbar';
const $36993a23339f9fb9$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $36993a23339f9fb9$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $36993a23339f9fb9$var$PLACEMENT_TOP = $36993a23339f9fb9$var$isRTL() ? 'top-end' : 'top-start';
const $36993a23339f9fb9$var$PLACEMENT_TOPEND = $36993a23339f9fb9$var$isRTL() ? 'top-start' : 'top-end';
const $36993a23339f9fb9$var$PLACEMENT_BOTTOM = $36993a23339f9fb9$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $36993a23339f9fb9$var$PLACEMENT_BOTTOMEND = $36993a23339f9fb9$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $36993a23339f9fb9$var$PLACEMENT_RIGHT = $36993a23339f9fb9$var$isRTL() ? 'left-start' : 'right-start';
const $36993a23339f9fb9$var$PLACEMENT_LEFT = $36993a23339f9fb9$var$isRTL() ? 'right-start' : 'left-start';
const $36993a23339f9fb9$var$PLACEMENT_TOPCENTER = 'top';
const $36993a23339f9fb9$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $36993a23339f9fb9$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $36993a23339f9fb9$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$931cbfb6bfb85fc extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $36993a23339f9fb9$var$SelectorEngine.next(this._element, $36993a23339f9fb9$var$SELECTOR_MENU)[0] || $36993a23339f9fb9$var$SelectorEngine.prev(this._element, $36993a23339f9fb9$var$SELECTOR_MENU)[0] || $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$9;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$9;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($36993a23339f9fb9$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($36993a23339f9fb9$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$36993a23339f9fb9$var$EventHandler.on(element, 'mouseover', $36993a23339f9fb9$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$6);
        $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($36993a23339f9fb9$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$36993a23339f9fb9$var$EventHandler.off(element, 'mouseover', $36993a23339f9fb9$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $36993a23339f9fb9$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$36993a23339f9fb9$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$36993a23339f9fb9$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cseje === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($36993a23339f9fb9$var$isElement(this._config.reference)) referenceElement = $36993a23339f9fb9$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cseje.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($36993a23339f9fb9$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($36993a23339f9fb9$var$CLASS_NAME_DROPEND)) return $36993a23339f9fb9$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($36993a23339f9fb9$var$CLASS_NAME_DROPSTART)) return $36993a23339f9fb9$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($36993a23339f9fb9$var$CLASS_NAME_DROPUP_CENTER)) return $36993a23339f9fb9$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($36993a23339f9fb9$var$CLASS_NAME_DROPDOWN_CENTER)) return $36993a23339f9fb9$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($36993a23339f9fb9$var$CLASS_NAME_DROPUP)) return isEnd ? $36993a23339f9fb9$var$PLACEMENT_TOPEND : $36993a23339f9fb9$var$PLACEMENT_TOP;
        return isEnd ? $36993a23339f9fb9$var$PLACEMENT_BOTTOMEND : $36993a23339f9fb9$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($36993a23339f9fb9$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $36993a23339f9fb9$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$36993a23339f9fb9$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$36993a23339f9fb9$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $36993a23339f9fb9$var$getNextActiveElement(items, target, key === $36993a23339f9fb9$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $36993a23339f9fb9$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $36993a23339f9fb9$var$TAB_KEY$1) return;
        const openToggles = $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $36993a23339f9fb9$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $36993a23339f9fb9$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $36993a23339f9fb9$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $36993a23339f9fb9$var$ARROW_UP_KEY$1,
            $36993a23339f9fb9$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3) ? this : $36993a23339f9fb9$var$SelectorEngine.prev(this, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3)[0] || $36993a23339f9fb9$var$SelectorEngine.next(this, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3)[0] || $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $36993a23339f9fb9$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_KEYDOWN_DATA_API, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3, $36993a23339f9fb9$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_KEYDOWN_DATA_API, $36993a23339f9fb9$var$SELECTOR_MENU, $36993a23339f9fb9$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$3, $36993a23339f9fb9$export$931cbfb6bfb85fc.clearMenus);
$36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_KEYUP_DATA_API, $36993a23339f9fb9$export$931cbfb6bfb85fc.clearMenus);
$36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$3, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $36993a23339f9fb9$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$9 = 'backdrop';
const $36993a23339f9fb9$var$CLASS_NAME_FADE$4 = 'fade';
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$5 = 'show';
const $36993a23339f9fb9$var$EVENT_MOUSEDOWN = `mousedown.bs.${$36993a23339f9fb9$var$NAME$9}`;
const $36993a23339f9fb9$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $36993a23339f9fb9$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$var$Backdrop extends $36993a23339f9fb9$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$8;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$8;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $36993a23339f9fb9$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $36993a23339f9fb9$var$reflow(element);
        element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $36993a23339f9fb9$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $36993a23339f9fb9$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $36993a23339f9fb9$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $36993a23339f9fb9$var$EventHandler.off(this._element, $36993a23339f9fb9$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($36993a23339f9fb9$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $36993a23339f9fb9$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $36993a23339f9fb9$var$EventHandler.on(element, $36993a23339f9fb9$var$EVENT_MOUSEDOWN, ()=>{
            $36993a23339f9fb9$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $36993a23339f9fb9$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$8 = 'focustrap';
const $36993a23339f9fb9$var$DATA_KEY$5 = 'bs.focustrap';
const $36993a23339f9fb9$var$EVENT_KEY$5 = `.${$36993a23339f9fb9$var$DATA_KEY$5}`;
const $36993a23339f9fb9$var$EVENT_FOCUSIN$2 = `focusin${$36993a23339f9fb9$var$EVENT_KEY$5}`;
const $36993a23339f9fb9$var$EVENT_KEYDOWN_TAB = `keydown.tab${$36993a23339f9fb9$var$EVENT_KEY$5}`;
const $36993a23339f9fb9$var$TAB_KEY = 'Tab';
const $36993a23339f9fb9$var$TAB_NAV_FORWARD = 'forward';
const $36993a23339f9fb9$var$TAB_NAV_BACKWARD = 'backward';
const $36993a23339f9fb9$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $36993a23339f9fb9$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$var$FocusTrap extends $36993a23339f9fb9$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$7;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$7;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $36993a23339f9fb9$var$EventHandler.off(document, $36993a23339f9fb9$var$EVENT_KEY$5); // guard against infinite focus loop
        $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $36993a23339f9fb9$var$EventHandler.off(document, $36993a23339f9fb9$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $36993a23339f9fb9$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $36993a23339f9fb9$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $36993a23339f9fb9$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $36993a23339f9fb9$var$TAB_NAV_BACKWARD : $36993a23339f9fb9$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $36993a23339f9fb9$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $36993a23339f9fb9$var$PROPERTY_PADDING = 'padding-right';
const $36993a23339f9fb9$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $36993a23339f9fb9$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $36993a23339f9fb9$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($36993a23339f9fb9$var$SELECTOR_FIXED_CONTENT, $36993a23339f9fb9$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($36993a23339f9fb9$var$SELECTOR_STICKY_CONTENT, $36993a23339f9fb9$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $36993a23339f9fb9$var$PROPERTY_PADDING);
        this._resetElementAttributes($36993a23339f9fb9$var$SELECTOR_FIXED_CONTENT, $36993a23339f9fb9$var$PROPERTY_PADDING);
        this._resetElementAttributes($36993a23339f9fb9$var$SELECTOR_STICKY_CONTENT, $36993a23339f9fb9$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $36993a23339f9fb9$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $36993a23339f9fb9$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $36993a23339f9fb9$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($36993a23339f9fb9$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $36993a23339f9fb9$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$7 = 'modal';
const $36993a23339f9fb9$var$DATA_KEY$4 = 'bs.modal';
const $36993a23339f9fb9$var$EVENT_KEY$4 = `.${$36993a23339f9fb9$var$DATA_KEY$4}`;
const $36993a23339f9fb9$var$DATA_API_KEY$2 = '.data-api';
const $36993a23339f9fb9$var$ESCAPE_KEY$1 = 'Escape';
const $36993a23339f9fb9$var$EVENT_HIDE$4 = `hide${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_HIDDEN$4 = `hidden${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_SHOW$4 = `show${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_SHOWN$4 = `shown${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_RESIZE$1 = `resize${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DISMISS = `click.dismiss${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$36993a23339f9fb9$var$EVENT_KEY$4}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$2 = `click${$36993a23339f9fb9$var$EVENT_KEY$4}${$36993a23339f9fb9$var$DATA_API_KEY$2}`;
const $36993a23339f9fb9$var$CLASS_NAME_OPEN = 'modal-open';
const $36993a23339f9fb9$var$CLASS_NAME_FADE$3 = 'fade';
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$4 = 'show';
const $36993a23339f9fb9$var$CLASS_NAME_STATIC = 'modal-static';
const $36993a23339f9fb9$var$OPEN_SELECTOR$1 = '.modal.show';
const $36993a23339f9fb9$var$SELECTOR_DIALOG = '.modal-dialog';
const $36993a23339f9fb9$var$SELECTOR_MODAL_BODY = '.modal-body';
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $36993a23339f9fb9$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $36993a23339f9fb9$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$2b77a92f1a5ad772 extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $36993a23339f9fb9$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$6;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$6;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($36993a23339f9fb9$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $36993a23339f9fb9$var$EventHandler.off(window, $36993a23339f9fb9$var$EVENT_KEY$4);
        $36993a23339f9fb9$var$EventHandler.off(this._dialog, $36993a23339f9fb9$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $36993a23339f9fb9$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $36993a23339f9fb9$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $36993a23339f9fb9$var$reflow(this._element);
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $36993a23339f9fb9$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $36993a23339f9fb9$var$EventHandler.on(window, $36993a23339f9fb9$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $36993a23339f9fb9$var$EventHandler.one(this._element, $36993a23339f9fb9$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($36993a23339f9fb9$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $36993a23339f9fb9$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $36993a23339f9fb9$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$2, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $36993a23339f9fb9$var$EventHandler.one(target, $36993a23339f9fb9$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $36993a23339f9fb9$var$EventHandler.one(target, $36993a23339f9fb9$var$EVENT_HIDDEN$4, ()=>{
            if ($36993a23339f9fb9$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $36993a23339f9fb9$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $36993a23339f9fb9$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$36993a23339f9fb9$var$enableDismissTrigger($36993a23339f9fb9$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$6 = 'offcanvas';
const $36993a23339f9fb9$var$DATA_KEY$3 = 'bs.offcanvas';
const $36993a23339f9fb9$var$EVENT_KEY$3 = `.${$36993a23339f9fb9$var$DATA_KEY$3}`;
const $36993a23339f9fb9$var$DATA_API_KEY$1 = '.data-api';
const $36993a23339f9fb9$var$EVENT_LOAD_DATA_API$2 = `load${$36993a23339f9fb9$var$EVENT_KEY$3}${$36993a23339f9fb9$var$DATA_API_KEY$1}`;
const $36993a23339f9fb9$var$ESCAPE_KEY = 'Escape';
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$3 = 'show';
const $36993a23339f9fb9$var$CLASS_NAME_SHOWING$1 = 'showing';
const $36993a23339f9fb9$var$CLASS_NAME_HIDING = 'hiding';
const $36993a23339f9fb9$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $36993a23339f9fb9$var$OPEN_SELECTOR = '.offcanvas.show';
const $36993a23339f9fb9$var$EVENT_SHOW$3 = `show${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_SHOWN$3 = `shown${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_HIDE$3 = `hide${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_HIDE_PREVENTED = `hidePrevented${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_HIDDEN$3 = `hidden${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_RESIZE = `resize${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$1 = `click${$36993a23339f9fb9$var$EVENT_KEY$3}${$36993a23339f9fb9$var$DATA_API_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$36993a23339f9fb9$var$EVENT_KEY$3}`;
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $36993a23339f9fb9$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $36993a23339f9fb9$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$591ca0244c9dfcd4 extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$5;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$5;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $36993a23339f9fb9$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOWING$1);
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$3, $36993a23339f9fb9$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $36993a23339f9fb9$var$ScrollBarHelper().reset();
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $36993a23339f9fb9$var$Backdrop({
            className: $36993a23339f9fb9$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $36993a23339f9fb9$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $36993a23339f9fb9$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API$1, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($36993a23339f9fb9$var$isDisabled(this)) return;
    $36993a23339f9fb9$var$EventHandler.one(target, $36993a23339f9fb9$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($36993a23339f9fb9$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $36993a23339f9fb9$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $36993a23339f9fb9$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$36993a23339f9fb9$var$EventHandler.on(window, $36993a23339f9fb9$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$OPEN_SELECTOR))$36993a23339f9fb9$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$36993a23339f9fb9$var$EventHandler.on(window, $36993a23339f9fb9$var$EVENT_RESIZE, ()=>{
    for (const element of $36993a23339f9fb9$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $36993a23339f9fb9$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$36993a23339f9fb9$var$enableDismissTrigger($36993a23339f9fb9$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $36993a23339f9fb9$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $36993a23339f9fb9$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $36993a23339f9fb9$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $36993a23339f9fb9$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $36993a23339f9fb9$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $36993a23339f9fb9$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($36993a23339f9fb9$var$uriAttributes.has(attributeName)) return Boolean($36993a23339f9fb9$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $36993a23339f9fb9$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$36993a23339f9fb9$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$5 = 'TemplateFactory';
const $36993a23339f9fb9$var$Default$4 = {
    allowList: $36993a23339f9fb9$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $36993a23339f9fb9$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $36993a23339f9fb9$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$var$TemplateFactory extends $36993a23339f9fb9$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$4;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$4;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $36993a23339f9fb9$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $36993a23339f9fb9$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($36993a23339f9fb9$var$isElement(content)) {
            this._putElementInTemplate($36993a23339f9fb9$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $36993a23339f9fb9$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $36993a23339f9fb9$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$4 = 'tooltip';
const $36993a23339f9fb9$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $36993a23339f9fb9$var$CLASS_NAME_FADE$2 = 'fade';
const $36993a23339f9fb9$var$CLASS_NAME_MODAL = 'modal';
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$2 = 'show';
const $36993a23339f9fb9$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $36993a23339f9fb9$var$SELECTOR_MODAL = `.${$36993a23339f9fb9$var$CLASS_NAME_MODAL}`;
const $36993a23339f9fb9$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $36993a23339f9fb9$var$TRIGGER_HOVER = 'hover';
const $36993a23339f9fb9$var$TRIGGER_FOCUS = 'focus';
const $36993a23339f9fb9$var$TRIGGER_CLICK = 'click';
const $36993a23339f9fb9$var$TRIGGER_MANUAL = 'manual';
const $36993a23339f9fb9$var$EVENT_HIDE$2 = 'hide';
const $36993a23339f9fb9$var$EVENT_HIDDEN$2 = 'hidden';
const $36993a23339f9fb9$var$EVENT_SHOW$2 = 'show';
const $36993a23339f9fb9$var$EVENT_SHOWN$2 = 'shown';
const $36993a23339f9fb9$var$EVENT_INSERTED = 'inserted';
const $36993a23339f9fb9$var$EVENT_CLICK$1 = 'click';
const $36993a23339f9fb9$var$EVENT_FOCUSIN$1 = 'focusin';
const $36993a23339f9fb9$var$EVENT_FOCUSOUT$1 = 'focusout';
const $36993a23339f9fb9$var$EVENT_MOUSEENTER = 'mouseenter';
const $36993a23339f9fb9$var$EVENT_MOUSELEAVE = 'mouseleave';
const $36993a23339f9fb9$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $36993a23339f9fb9$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $36993a23339f9fb9$var$isRTL() ? 'right' : 'left'
};
const $36993a23339f9fb9$var$Default$3 = {
    allowList: $36993a23339f9fb9$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $36993a23339f9fb9$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$28c660c63b792dea extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        if (typeof $cseje === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$3;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$3;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $36993a23339f9fb9$var$EventHandler.off(this._element.closest($36993a23339f9fb9$var$SELECTOR_MODAL), $36993a23339f9fb9$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, this.constructor.eventName($36993a23339f9fb9$var$EVENT_SHOW$2));
        const shadowRoot = $36993a23339f9fb9$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, this.constructor.eventName($36993a23339f9fb9$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$36993a23339f9fb9$var$EventHandler.on(element, 'mouseover', $36993a23339f9fb9$var$noop);
        const complete = ()=>{
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, this.constructor.eventName($36993a23339f9fb9$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, this.constructor.eventName($36993a23339f9fb9$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$36993a23339f9fb9$var$EventHandler.off(element, 'mouseover', $36993a23339f9fb9$var$noop);
        this._activeTrigger[$36993a23339f9fb9$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$36993a23339f9fb9$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$36993a23339f9fb9$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, this.constructor.eventName($36993a23339f9fb9$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($36993a23339f9fb9$var$CLASS_NAME_FADE$2, $36993a23339f9fb9$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $36993a23339f9fb9$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($36993a23339f9fb9$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $36993a23339f9fb9$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$36993a23339f9fb9$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($36993a23339f9fb9$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($36993a23339f9fb9$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $36993a23339f9fb9$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $36993a23339f9fb9$var$AttachmentMap[placement.toUpperCase()];
        return $cseje.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $36993a23339f9fb9$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$36993a23339f9fb9$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $36993a23339f9fb9$var$EventHandler.on(this._element, this.constructor.eventName($36993a23339f9fb9$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $36993a23339f9fb9$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $36993a23339f9fb9$var$TRIGGER_HOVER ? this.constructor.eventName($36993a23339f9fb9$var$EVENT_MOUSEENTER) : this.constructor.eventName($36993a23339f9fb9$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $36993a23339f9fb9$var$TRIGGER_HOVER ? this.constructor.eventName($36993a23339f9fb9$var$EVENT_MOUSELEAVE) : this.constructor.eventName($36993a23339f9fb9$var$EVENT_FOCUSOUT$1);
                $36993a23339f9fb9$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $36993a23339f9fb9$var$TRIGGER_FOCUS : $36993a23339f9fb9$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $36993a23339f9fb9$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $36993a23339f9fb9$var$TRIGGER_FOCUS : $36993a23339f9fb9$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $36993a23339f9fb9$var$EventHandler.on(this._element.closest($36993a23339f9fb9$var$SELECTOR_MODAL), $36993a23339f9fb9$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $36993a23339f9fb9$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($36993a23339f9fb9$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $36993a23339f9fb9$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$3 = 'popover';
const $36993a23339f9fb9$var$SELECTOR_TITLE = '.popover-header';
const $36993a23339f9fb9$var$SELECTOR_CONTENT = '.popover-body';
const $36993a23339f9fb9$var$Default$2 = {
    ...$36993a23339f9fb9$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $36993a23339f9fb9$var$DefaultType$2 = {
    ...$36993a23339f9fb9$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$5b6b19405a83ff9d extends $36993a23339f9fb9$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$2;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$2;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$36993a23339f9fb9$var$SELECTOR_TITLE]: this._getTitle(),
            [$36993a23339f9fb9$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$2 = 'scrollspy';
const $36993a23339f9fb9$var$DATA_KEY$2 = 'bs.scrollspy';
const $36993a23339f9fb9$var$EVENT_KEY$2 = `.${$36993a23339f9fb9$var$DATA_KEY$2}`;
const $36993a23339f9fb9$var$DATA_API_KEY = '.data-api';
const $36993a23339f9fb9$var$EVENT_ACTIVATE = `activate${$36993a23339f9fb9$var$EVENT_KEY$2}`;
const $36993a23339f9fb9$var$EVENT_CLICK = `click${$36993a23339f9fb9$var$EVENT_KEY$2}`;
const $36993a23339f9fb9$var$EVENT_LOAD_DATA_API$1 = `load${$36993a23339f9fb9$var$EVENT_KEY$2}${$36993a23339f9fb9$var$DATA_API_KEY}`;
const $36993a23339f9fb9$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1 = 'active';
const $36993a23339f9fb9$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $36993a23339f9fb9$var$SELECTOR_TARGET_LINKS = '[href]';
const $36993a23339f9fb9$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $36993a23339f9fb9$var$SELECTOR_NAV_LINKS = '.nav-link';
const $36993a23339f9fb9$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $36993a23339f9fb9$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $36993a23339f9fb9$var$SELECTOR_LINK_ITEMS = `${$36993a23339f9fb9$var$SELECTOR_NAV_LINKS}, ${$36993a23339f9fb9$var$SELECTOR_NAV_ITEMS} > ${$36993a23339f9fb9$var$SELECTOR_NAV_LINKS}, ${$36993a23339f9fb9$var$SELECTOR_LIST_ITEMS}`;
const $36993a23339f9fb9$var$SELECTOR_DROPDOWN = '.dropdown';
const $36993a23339f9fb9$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $36993a23339f9fb9$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $36993a23339f9fb9$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$a6472a5298a374be extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default$1;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType$1;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $36993a23339f9fb9$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $36993a23339f9fb9$var$EventHandler.off(this._config.target, $36993a23339f9fb9$var$EVENT_CLICK);
        $36993a23339f9fb9$var$EventHandler.on(this._config.target, $36993a23339f9fb9$var$EVENT_CLICK, $36993a23339f9fb9$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $36993a23339f9fb9$var$isDisabled(anchor)) continue;
            const observableSection = $36993a23339f9fb9$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($36993a23339f9fb9$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($36993a23339f9fb9$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($36993a23339f9fb9$var$SELECTOR_DROPDOWN)).classList.add($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $36993a23339f9fb9$var$SelectorEngine.parents(target, $36993a23339f9fb9$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $36993a23339f9fb9$var$SelectorEngine.prev(listGroup, $36993a23339f9fb9$var$SELECTOR_LINK_ITEMS))item.classList.add($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $36993a23339f9fb9$var$SelectorEngine.find(`${$36993a23339f9fb9$var$SELECTOR_TARGET_LINKS}.${$36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($36993a23339f9fb9$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(window, $36993a23339f9fb9$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_DATA_SPY))$36993a23339f9fb9$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME$1 = 'tab';
const $36993a23339f9fb9$var$DATA_KEY$1 = 'bs.tab';
const $36993a23339f9fb9$var$EVENT_KEY$1 = `.${$36993a23339f9fb9$var$DATA_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_HIDE$1 = `hide${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_HIDDEN$1 = `hidden${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_SHOW$1 = `show${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_SHOWN$1 = `shown${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_CLICK_DATA_API = `click${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_KEYDOWN = `keydown${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$EVENT_LOAD_DATA_API = `load${$36993a23339f9fb9$var$EVENT_KEY$1}`;
const $36993a23339f9fb9$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $36993a23339f9fb9$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $36993a23339f9fb9$var$ARROW_UP_KEY = 'ArrowUp';
const $36993a23339f9fb9$var$ARROW_DOWN_KEY = 'ArrowDown';
const $36993a23339f9fb9$var$HOME_KEY = 'Home';
const $36993a23339f9fb9$var$END_KEY = 'End';
const $36993a23339f9fb9$var$CLASS_NAME_ACTIVE = 'active';
const $36993a23339f9fb9$var$CLASS_NAME_FADE$1 = 'fade';
const $36993a23339f9fb9$var$CLASS_NAME_SHOW$1 = 'show';
const $36993a23339f9fb9$var$CLASS_DROPDOWN = 'dropdown';
const $36993a23339f9fb9$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $36993a23339f9fb9$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $36993a23339f9fb9$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$36993a23339f9fb9$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $36993a23339f9fb9$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $36993a23339f9fb9$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $36993a23339f9fb9$var$SELECTOR_INNER = `.nav-link${$36993a23339f9fb9$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$36993a23339f9fb9$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$36993a23339f9fb9$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $36993a23339f9fb9$var$SELECTOR_INNER_ELEM = `${$36993a23339f9fb9$var$SELECTOR_INNER}, ${$36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE}`;
const $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$36993a23339f9fb9$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$36993a23339f9fb9$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$36993a23339f9fb9$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $36993a23339f9fb9$export$3e41faf802a29e71 extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($36993a23339f9fb9$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $36993a23339f9fb9$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $36993a23339f9fb9$var$EventHandler.trigger(active, $36993a23339f9fb9$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $36993a23339f9fb9$var$EventHandler.trigger(innerElem, $36993a23339f9fb9$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($36993a23339f9fb9$var$CLASS_NAME_ACTIVE);
        this._activate($36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $36993a23339f9fb9$var$EventHandler.trigger(element, $36993a23339f9fb9$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $36993a23339f9fb9$var$EventHandler.trigger(element, $36993a23339f9fb9$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $36993a23339f9fb9$var$ARROW_LEFT_KEY,
            $36993a23339f9fb9$var$ARROW_RIGHT_KEY,
            $36993a23339f9fb9$var$ARROW_UP_KEY,
            $36993a23339f9fb9$var$ARROW_DOWN_KEY,
            $36993a23339f9fb9$var$HOME_KEY,
            $36993a23339f9fb9$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$36993a23339f9fb9$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $36993a23339f9fb9$var$HOME_KEY,
            $36993a23339f9fb9$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $36993a23339f9fb9$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $36993a23339f9fb9$var$ARROW_RIGHT_KEY,
                $36993a23339f9fb9$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $36993a23339f9fb9$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $36993a23339f9fb9$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $36993a23339f9fb9$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($36993a23339f9fb9$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $36993a23339f9fb9$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($36993a23339f9fb9$var$SELECTOR_DROPDOWN_TOGGLE, $36993a23339f9fb9$var$CLASS_NAME_ACTIVE);
        toggle($36993a23339f9fb9$var$SELECTOR_DROPDOWN_MENU, $36993a23339f9fb9$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($36993a23339f9fb9$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($36993a23339f9fb9$var$SELECTOR_INNER_ELEM) ? elem : $36993a23339f9fb9$var$SelectorEngine.findOne($36993a23339f9fb9$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($36993a23339f9fb9$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$EventHandler.on(document, $36993a23339f9fb9$var$EVENT_CLICK_DATA_API, $36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($36993a23339f9fb9$var$isDisabled(this)) return;
    $36993a23339f9fb9$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $36993a23339f9fb9$var$EventHandler.on(window, $36993a23339f9fb9$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $36993a23339f9fb9$var$SelectorEngine.find($36993a23339f9fb9$var$SELECTOR_DATA_TOGGLE_ACTIVE))$36993a23339f9fb9$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $36993a23339f9fb9$var$NAME = 'toast';
const $36993a23339f9fb9$var$DATA_KEY = 'bs.toast';
const $36993a23339f9fb9$var$EVENT_KEY = `.${$36993a23339f9fb9$var$DATA_KEY}`;
const $36993a23339f9fb9$var$EVENT_MOUSEOVER = `mouseover${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_MOUSEOUT = `mouseout${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_FOCUSIN = `focusin${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_FOCUSOUT = `focusout${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_HIDE = `hide${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_HIDDEN = `hidden${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_SHOW = `show${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$EVENT_SHOWN = `shown${$36993a23339f9fb9$var$EVENT_KEY}`;
const $36993a23339f9fb9$var$CLASS_NAME_FADE = 'fade';
const $36993a23339f9fb9$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $36993a23339f9fb9$var$CLASS_NAME_SHOW = 'show';
const $36993a23339f9fb9$var$CLASS_NAME_SHOWING = 'showing';
const $36993a23339f9fb9$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $36993a23339f9fb9$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $36993a23339f9fb9$export$8d8dc7d5f743331b extends $36993a23339f9fb9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $36993a23339f9fb9$var$Default;
    }
    static get DefaultType() {
        return $36993a23339f9fb9$var$DefaultType;
    }
    static get NAME() {
        return $36993a23339f9fb9$var$NAME;
    }
    // Public
    show() {
        const showEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOWING);
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_HIDE); // @deprecated
        $36993a23339f9fb9$var$reflow(this._element);
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOW, $36993a23339f9fb9$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOWING, $36993a23339f9fb9$var$CLASS_NAME_SHOW);
            $36993a23339f9fb9$var$EventHandler.trigger(this._element, $36993a23339f9fb9$var$EVENT_HIDDEN);
        };
        this._element.classList.add($36993a23339f9fb9$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($36993a23339f9fb9$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($36993a23339f9fb9$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $36993a23339f9fb9$var$EventHandler.on(this._element, $36993a23339f9fb9$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36993a23339f9fb9$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $36993a23339f9fb9$var$enableDismissTrigger($36993a23339f9fb9$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $36993a23339f9fb9$var$defineJQueryPlugin($36993a23339f9fb9$export$8d8dc7d5f743331b);


//
// config actions.
//
// Get config from devops endpoint.
const $f345da7c359121ca$export$f02ab100cc0f1b0c = (url)=>{
    return async (dispatch)=>{
        let requestUrl = new URL(`${url}/devopsApi/getSpaConfiguration`);
        try {
            const response = await fetch(requestUrl);
            const data = await response.json();
            dispatch($f345da7c359121ca$export$940a7873bb071df8(data));
            return data;
        } catch (err) {
            console.error('Error fetching config, falling back to defaults.', err);
        }
    };
};
const $f345da7c359121ca$export$940a7873bb071df8 = (config)=>{
    return {
        type: 'SET_CONFIG',
        config: config
    };
};


// Utils.
function $85dfcf2dd2d77e56$export$eea578708101341f(contents) {
    const script = document.getElementById('schemaorg-metadata') || document.createElement('script');
    script.id = 'schemaorg-metadata';
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(contents, null, 2);
    document.head.appendChild(script);
}


const $1a23819793c0c1da$export$78572dfc0a558ba6 = (namespaceId)=>{
    return async (dispatch, getState)=>{
        const config = getState().config;
        let requestUrl = !namespaceId ? `${config.registryApi}/${config.schemaOrgPlatformEndpoint}` : `${config.registryApi}/${config.schemaOrgNamespaceEndpoint}/${namespaceId}`;
        const response = await fetch(requestUrl);
        let json = {};
        if (response.ok) json = await response.json();
        dispatch($1a23819793c0c1da$export$102255af3b72336(json));
    };
};
const $1a23819793c0c1da$export$358ac8bb95c77f0c = (prefix)=>{
    return async (dispatch, getState)=>{
        const config = getState().config;
        let requestUrl = `${config.registryApi}/${config.schemaOrgNamespacePrefixEndpoint}/${prefix}`;
        const response = await fetch(requestUrl);
        let json = {};
        if (response.ok) json = response.json();
        dispatch($1a23819793c0c1da$export$102255af3b72336(json));
    };
};
const $1a23819793c0c1da$export$102255af3b72336 = (schemaOrgMetadata)=>{
    // Inject metadata in DOM.
    (0, $85dfcf2dd2d77e56$export$eea578708101341f)(schemaOrgMetadata);
    return {
        type: 'SET_SCHEMAORGMETADATA',
        schemaOrgMetadata: schemaOrgMetadata
    };
};



parcelRequire("6kl77");
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6kl77 = parcelRequire("6kl77");

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6kl77 = parcelRequire("6kl77");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $752b3505f31cd997$var$_extends() {
    $752b3505f31cd997$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $752b3505f31cd997$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $752b3505f31cd997$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($752b3505f31cd997$export$e19cd5f9376f8cee || ($752b3505f31cd997$export$e19cd5f9376f8cee = {}));
const $752b3505f31cd997$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $752b3505f31cd997$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $752b3505f31cd997$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $752b3505f31cd997$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $752b3505f31cd997$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $752b3505f31cd997$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $752b3505f31cd997$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $752b3505f31cd997$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $752b3505f31cd997$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $752b3505f31cd997$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $752b3505f31cd997$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $752b3505f31cd997$export$fe53371bee54353d(to);
    }
    return $752b3505f31cd997$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $752b3505f31cd997$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $752b3505f31cd997$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $752b3505f31cd997$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $752b3505f31cd997$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $752b3505f31cd997$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $752b3505f31cd997$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $752b3505f31cd997$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $752b3505f31cd997$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $752b3505f31cd997$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $752b3505f31cd997$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $752b3505f31cd997$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $752b3505f31cd997$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $752b3505f31cd997$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $752b3505f31cd997$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $752b3505f31cd997$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $752b3505f31cd997$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $752b3505f31cd997$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($752b3505f31cd997$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $752b3505f31cd997$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $752b3505f31cd997$export$e19cd5f9376f8cee.Push;
        let location = $752b3505f31cd997$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $752b3505f31cd997$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $752b3505f31cd997$export$e19cd5f9376f8cee.Replace;
        let location = $752b3505f31cd997$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $752b3505f31cd997$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $752b3505f31cd997$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $752b3505f31cd997$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($752b3505f31cd997$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($752b3505f31cd997$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $752b3505f31cd997$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($752b3505f31cd997$var$ResultType || ($752b3505f31cd997$var$ResultType = {}));
const $752b3505f31cd997$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $752b3505f31cd997$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $752b3505f31cd997$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $752b3505f31cd997$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $752b3505f31cd997$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($752b3505f31cd997$var$isIndexRoute(route)) {
            let indexRoute = $752b3505f31cd997$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $752b3505f31cd997$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $752b3505f31cd997$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $752b3505f31cd997$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $752b3505f31cd997$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $752b3505f31cd997$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $752b3505f31cd997$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $752b3505f31cd997$var$flattenRoutes(routes);
    $752b3505f31cd997$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $752b3505f31cd997$export$30d21fd6d7295f52(pathname);
        matches = $752b3505f31cd997$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $752b3505f31cd997$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $752b3505f31cd997$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $752b3505f31cd997$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $752b3505f31cd997$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $752b3505f31cd997$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $752b3505f31cd997$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $752b3505f31cd997$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $752b3505f31cd997$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $752b3505f31cd997$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $752b3505f31cd997$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $752b3505f31cd997$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $752b3505f31cd997$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $752b3505f31cd997$var$paramRe = /^:[\w-]+$/;
const $752b3505f31cd997$var$dynamicSegmentValue = 3;
const $752b3505f31cd997$var$indexRouteValue = 2;
const $752b3505f31cd997$var$emptySegmentValue = 1;
const $752b3505f31cd997$var$staticSegmentValue = 10;
const $752b3505f31cd997$var$splatPenalty = -2;
const $752b3505f31cd997$var$isSplat = (s)=>s === "*";
function $752b3505f31cd997$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($752b3505f31cd997$var$isSplat)) initialScore += $752b3505f31cd997$var$splatPenalty;
    if (index) initialScore += $752b3505f31cd997$var$indexRouteValue;
    return segments.filter((s)=>!$752b3505f31cd997$var$isSplat(s)).reduce((score, segment)=>score + ($752b3505f31cd997$var$paramRe.test(segment) ? $752b3505f31cd997$var$dynamicSegmentValue : segment === "" ? $752b3505f31cd997$var$emptySegmentValue : $752b3505f31cd997$var$staticSegmentValue), initialScore);
}
function $752b3505f31cd997$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $752b3505f31cd997$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $752b3505f31cd997$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $752b3505f31cd997$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $752b3505f31cd997$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $752b3505f31cd997$export$a5c6d149b50c1d86($752b3505f31cd997$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $752b3505f31cd997$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $752b3505f31cd997$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $752b3505f31cd997$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $752b3505f31cd997$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $752b3505f31cd997$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $752b3505f31cd997$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $752b3505f31cd997$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $752b3505f31cd997$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $752b3505f31cd997$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $752b3505f31cd997$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $752b3505f31cd997$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $752b3505f31cd997$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $752b3505f31cd997$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $752b3505f31cd997$var$normalizeSearch(search),
        hash: $752b3505f31cd997$var$normalizeHash(hash)
    };
}
function $752b3505f31cd997$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $752b3505f31cd997$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $752b3505f31cd997$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $752b3505f31cd997$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $752b3505f31cd997$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $752b3505f31cd997$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $752b3505f31cd997$export$8ccf933b0513f8d0(toArg);
    else {
        to = $752b3505f31cd997$var$_extends({}, toArg);
        $752b3505f31cd997$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $752b3505f31cd997$var$getInvalidPathError("?", "pathname", "search", to));
        $752b3505f31cd997$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $752b3505f31cd997$var$getInvalidPathError("#", "pathname", "hash", to));
        $752b3505f31cd997$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $752b3505f31cd997$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $752b3505f31cd997$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $752b3505f31cd997$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $752b3505f31cd997$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $752b3505f31cd997$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $752b3505f31cd997$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $752b3505f31cd997$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $752b3505f31cd997$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $752b3505f31cd997$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $752b3505f31cd997$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $752b3505f31cd997$export$4051a07651545597(data, init) {
    return new $752b3505f31cd997$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $752b3505f31cd997$export$42a99a7a4bc0e76a extends Error {
}
class $752b3505f31cd997$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $752b3505f31cd997$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $752b3505f31cd997$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $752b3505f31cd997$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $752b3505f31cd997$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $752b3505f31cd997$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $752b3505f31cd997$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $752b3505f31cd997$var$unwrapTrackedPromise(value) {
    if (!$752b3505f31cd997$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $752b3505f31cd997$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $752b3505f31cd997$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $752b3505f31cd997$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $752b3505f31cd997$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $752b3505f31cd997$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $752b3505f31cd997$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $752b3505f31cd997$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $752b3505f31cd997$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $752b3505f31cd997$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $752b3505f31cd997$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $752b3505f31cd997$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $752b3505f31cd997$var$validMutationMethods = new Set($752b3505f31cd997$var$validMutationMethodsArr);
const $752b3505f31cd997$var$validRequestMethodsArr = [
    "get",
    ...$752b3505f31cd997$var$validMutationMethodsArr
];
const $752b3505f31cd997$var$validRequestMethods = new Set($752b3505f31cd997$var$validRequestMethodsArr);
const $752b3505f31cd997$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $752b3505f31cd997$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $752b3505f31cd997$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $752b3505f31cd997$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $752b3505f31cd997$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $752b3505f31cd997$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $752b3505f31cd997$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $752b3505f31cd997$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $752b3505f31cd997$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $752b3505f31cd997$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $752b3505f31cd997$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $752b3505f31cd997$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $752b3505f31cd997$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $752b3505f31cd997$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $752b3505f31cd997$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $752b3505f31cd997$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $752b3505f31cd997$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$752b3505f31cd997$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$752b3505f31cd997$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $752b3505f31cd997$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $752b3505f31cd997$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $752b3505f31cd997$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $752b3505f31cd997$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $752b3505f31cd997$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$752b3505f31cd997$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($752b3505f31cd997$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $752b3505f31cd997$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $752b3505f31cd997$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $752b3505f31cd997$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $752b3505f31cd997$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $752b3505f31cd997$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $752b3505f31cd997$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $752b3505f31cd997$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $752b3505f31cd997$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $752b3505f31cd997$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($752b3505f31cd997$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $752b3505f31cd997$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $752b3505f31cd997$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $752b3505f31cd997$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $752b3505f31cd997$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $752b3505f31cd997$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $752b3505f31cd997$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $752b3505f31cd997$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $752b3505f31cd997$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $752b3505f31cd997$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $752b3505f31cd997$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $752b3505f31cd997$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $752b3505f31cd997$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $752b3505f31cd997$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $752b3505f31cd997$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $752b3505f31cd997$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $752b3505f31cd997$var$findNearestBoundary(matches).route.id,
            {
                type: $752b3505f31cd997$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $752b3505f31cd997$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($752b3505f31cd997$var$isErrorResult(result) && $752b3505f31cd997$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $752b3505f31cd997$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $752b3505f31cd997$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $752b3505f31cd997$var$_extends({
            matches: updatedMatches || matches
        }, $752b3505f31cd997$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $752b3505f31cd997$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $752b3505f31cd997$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $752b3505f31cd997$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $752b3505f31cd997$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $752b3505f31cd997$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $752b3505f31cd997$var$ResultType.error,
            error: $752b3505f31cd997$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($752b3505f31cd997$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $752b3505f31cd997$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($752b3505f31cd997$var$isDeferredResult(result)) throw $752b3505f31cd997$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($752b3505f31cd997$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $752b3505f31cd997$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $752b3505f31cd997$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $752b3505f31cd997$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $752b3505f31cd997$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($752b3505f31cd997$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $752b3505f31cd997$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $752b3505f31cd997$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $752b3505f31cd997$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $752b3505f31cd997$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $752b3505f31cd997$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $752b3505f31cd997$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $752b3505f31cd997$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $752b3505f31cd997$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $752b3505f31cd997$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $752b3505f31cd997$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$752b3505f31cd997$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $752b3505f31cd997$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $752b3505f31cd997$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $752b3505f31cd997$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $752b3505f31cd997$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $752b3505f31cd997$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $752b3505f31cd997$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $752b3505f31cd997$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $752b3505f31cd997$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $752b3505f31cd997$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $752b3505f31cd997$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $752b3505f31cd997$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $752b3505f31cd997$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($752b3505f31cd997$var$isRedirectResult(actionResult) || $752b3505f31cd997$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $752b3505f31cd997$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($752b3505f31cd997$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $752b3505f31cd997$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $752b3505f31cd997$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($752b3505f31cd997$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($752b3505f31cd997$var$isDeferredResult(actionResult)) throw $752b3505f31cd997$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $752b3505f31cd997$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $752b3505f31cd997$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $752b3505f31cd997$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $752b3505f31cd997$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $752b3505f31cd997$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $752b3505f31cd997$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $752b3505f31cd997$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $752b3505f31cd997$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $752b3505f31cd997$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $752b3505f31cd997$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $752b3505f31cd997$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $752b3505f31cd997$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $752b3505f31cd997$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $752b3505f31cd997$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $752b3505f31cd997$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $752b3505f31cd997$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($752b3505f31cd997$var$isDeferredResult(result)) result = await $752b3505f31cd997$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $752b3505f31cd997$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($752b3505f31cd997$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $752b3505f31cd997$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($752b3505f31cd997$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $752b3505f31cd997$export$3e9cee6b33872309(!$752b3505f31cd997$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $752b3505f31cd997$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $752b3505f31cd997$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $752b3505f31cd997$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $752b3505f31cd997$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($752b3505f31cd997$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $752b3505f31cd997$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $752b3505f31cd997$export$e19cd5f9376f8cee.Replace : $752b3505f31cd997$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $752b3505f31cd997$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($752b3505f31cd997$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $752b3505f31cd997$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $752b3505f31cd997$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $752b3505f31cd997$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $752b3505f31cd997$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $752b3505f31cd997$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($752b3505f31cd997$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $752b3505f31cd997$var$ResultType.redirect,
                response: $752b3505f31cd997$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $752b3505f31cd997$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $752b3505f31cd997$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $752b3505f31cd997$var$ResultType.error,
                    error: $752b3505f31cd997$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $752b3505f31cd997$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $752b3505f31cd997$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $752b3505f31cd997$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $752b3505f31cd997$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $752b3505f31cd997$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $752b3505f31cd997$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $752b3505f31cd997$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $752b3505f31cd997$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $752b3505f31cd997$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $752b3505f31cd997$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $752b3505f31cd997$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $752b3505f31cd997$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $752b3505f31cd997$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $752b3505f31cd997$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$752b3505f31cd997$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $752b3505f31cd997$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $752b3505f31cd997$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $752b3505f31cd997$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $752b3505f31cd997$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $752b3505f31cd997$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $752b3505f31cd997$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $752b3505f31cd997$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $752b3505f31cd997$export$4d0306f8f6a4585b = Symbol("deferred");
function $752b3505f31cd997$export$3336b097a6fbc59a(routes, opts) {
    $752b3505f31cd997$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $752b3505f31cd997$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $752b3505f31cd997$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $752b3505f31cd997$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $752b3505f31cd997$var$createLocation("", $752b3505f31cd997$export$fe53371bee54353d(url), null, "default");
        let matches = $752b3505f31cd997$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$752b3505f31cd997$var$isValidMethod(method) && method !== "HEAD") {
            let error = $752b3505f31cd997$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $752b3505f31cd997$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $752b3505f31cd997$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $752b3505f31cd997$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($752b3505f31cd997$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $752b3505f31cd997$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $752b3505f31cd997$var$createLocation("", $752b3505f31cd997$export$fe53371bee54353d(url), null, "default");
        let matches = $752b3505f31cd997$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$752b3505f31cd997$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $752b3505f31cd997$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $752b3505f31cd997$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $752b3505f31cd997$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $752b3505f31cd997$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $752b3505f31cd997$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($752b3505f31cd997$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$752b3505f31cd997$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $752b3505f31cd997$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($752b3505f31cd997$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $752b3505f31cd997$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $752b3505f31cd997$var$isResponse(result) ? result : $752b3505f31cd997$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($752b3505f31cd997$var$isDataStrategyResult(e) && $752b3505f31cd997$var$isResponse(e.result)) {
                if (e.type === $752b3505f31cd997$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($752b3505f31cd997$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $752b3505f31cd997$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $752b3505f31cd997$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $752b3505f31cd997$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($752b3505f31cd997$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($752b3505f31cd997$var$isDeferredResult(result)) {
            let error = $752b3505f31cd997$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $752b3505f31cd997$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($752b3505f31cd997$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($752b3505f31cd997$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $752b3505f31cd997$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $752b3505f31cd997$var$_extends({}, context, {
                statusCode: $752b3505f31cd997$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $752b3505f31cd997$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $752b3505f31cd997$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $752b3505f31cd997$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $752b3505f31cd997$var$isErrorResult(pendingActionResult[1]) ? $752b3505f31cd997$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $752b3505f31cd997$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $752b3505f31cd997$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $752b3505f31cd997$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $752b3505f31cd997$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $752b3505f31cd997$var$callDataStrategyImpl(dataStrategy || $752b3505f31cd997$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($752b3505f31cd997$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $752b3505f31cd997$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($752b3505f31cd997$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $752b3505f31cd997$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $752b3505f31cd997$export$fec11da027c70692(routes, context, error) {
    let newContext = $752b3505f31cd997$var$_extends({}, context, {
        statusCode: $752b3505f31cd997$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $752b3505f31cd997$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $752b3505f31cd997$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $752b3505f31cd997$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $752b3505f31cd997$export$cae722b0cc860f13(to ? to : ".", $752b3505f31cd997$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $752b3505f31cd997$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $752b3505f31cd997$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $752b3505f31cd997$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $752b3505f31cd997$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $752b3505f31cd997$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$752b3505f31cd997$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$752b3505f31cd997$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $752b3505f31cd997$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $752b3505f31cd997$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $752b3505f31cd997$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$752b3505f31cd997$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$752b3505f31cd997$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $752b3505f31cd997$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $752b3505f31cd997$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $752b3505f31cd997$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $752b3505f31cd997$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $752b3505f31cd997$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($752b3505f31cd997$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $752b3505f31cd997$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $752b3505f31cd997$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $752b3505f31cd997$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $752b3505f31cd997$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $752b3505f31cd997$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $752b3505f31cd997$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $752b3505f31cd997$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $752b3505f31cd997$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $752b3505f31cd997$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $752b3505f31cd997$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($752b3505f31cd997$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $752b3505f31cd997$var$shouldRevalidateLoader(match, $752b3505f31cd997$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $752b3505f31cd997$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $752b3505f31cd997$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $752b3505f31cd997$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $752b3505f31cd997$var$shouldRevalidateLoader(fetcherMatch, $752b3505f31cd997$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $752b3505f31cd997$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $752b3505f31cd997$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $752b3505f31cd997$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $752b3505f31cd997$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $752b3505f31cd997$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $752b3505f31cd997$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$752b3505f31cd997$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $752b3505f31cd997$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $752b3505f31cd997$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$752b3505f31cd997$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $752b3505f31cd997$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $752b3505f31cd997$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $752b3505f31cd997$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$752b3505f31cd997$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $752b3505f31cd997$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $752b3505f31cd997$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $752b3505f31cd997$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $752b3505f31cd997$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $752b3505f31cd997$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $752b3505f31cd997$var$ResultType.data,
                result: undefined
            });
        };
        return $752b3505f31cd997$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $752b3505f31cd997$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $752b3505f31cd997$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $752b3505f31cd997$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $752b3505f31cd997$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $752b3505f31cd997$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $752b3505f31cd997$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $752b3505f31cd997$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($752b3505f31cd997$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $752b3505f31cd997$var$ResultType.error,
                error: e
            };
        }
        if (type === $752b3505f31cd997$var$ResultType.error) return {
            type: $752b3505f31cd997$var$ResultType.error,
            error: new $752b3505f31cd997$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $752b3505f31cd997$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $752b3505f31cd997$var$ResultType.error) {
        if ($752b3505f31cd997$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $752b3505f31cd997$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $752b3505f31cd997$var$ResultType.error,
                error: new $752b3505f31cd997$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $752b3505f31cd997$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $752b3505f31cd997$var$ResultType.error,
            error: result,
            statusCode: $752b3505f31cd997$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($752b3505f31cd997$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $752b3505f31cd997$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($752b3505f31cd997$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $752b3505f31cd997$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $752b3505f31cd997$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $752b3505f31cd997$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $752b3505f31cd997$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$752b3505f31cd997$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $752b3505f31cd997$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $752b3505f31cd997$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($752b3505f31cd997$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $752b3505f31cd997$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $752b3505f31cd997$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($752b3505f31cd997$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $752b3505f31cd997$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $752b3505f31cd997$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $752b3505f31cd997$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $752b3505f31cd997$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $752b3505f31cd997$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $752b3505f31cd997$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $752b3505f31cd997$export$3e9cee6b33872309(!$752b3505f31cd997$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($752b3505f31cd997$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $752b3505f31cd997$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $752b3505f31cd997$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($752b3505f31cd997$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $752b3505f31cd997$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $752b3505f31cd997$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $752b3505f31cd997$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($752b3505f31cd997$var$isErrorResult(result)) {
            let boundaryMatch = $752b3505f31cd997$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $752b3505f31cd997$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($752b3505f31cd997$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $752b3505f31cd997$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($752b3505f31cd997$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $752b3505f31cd997$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $752b3505f31cd997$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $752b3505f31cd997$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $752b3505f31cd997$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $752b3505f31cd997$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $752b3505f31cd997$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $752b3505f31cd997$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $752b3505f31cd997$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $752b3505f31cd997$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $752b3505f31cd997$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $752b3505f31cd997$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($752b3505f31cd997$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $752b3505f31cd997$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(path) : path;
    return $752b3505f31cd997$export$fe53371bee54353d($752b3505f31cd997$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $752b3505f31cd997$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $752b3505f31cd997$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $752b3505f31cd997$var$ResultType.data || result.type === $752b3505f31cd997$var$ResultType.error);
}
function $752b3505f31cd997$var$isRedirectDataStrategyResultResult(result) {
    return $752b3505f31cd997$var$isResponse(result.result) && $752b3505f31cd997$var$redirectStatusCodes.has(result.result.status);
}
function $752b3505f31cd997$var$isDeferredResult(result) {
    return result.type === $752b3505f31cd997$var$ResultType.deferred;
}
function $752b3505f31cd997$var$isErrorResult(result) {
    return result.type === $752b3505f31cd997$var$ResultType.error;
}
function $752b3505f31cd997$var$isRedirectResult(result) {
    return (result && result.type) === $752b3505f31cd997$var$ResultType.redirect;
}
function $752b3505f31cd997$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $752b3505f31cd997$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $752b3505f31cd997$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $752b3505f31cd997$var$isRedirectResponse(result) {
    if (!$752b3505f31cd997$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $752b3505f31cd997$var$isValidMethod(method) {
    return $752b3505f31cd997$var$validRequestMethods.has(method.toLowerCase());
}
function $752b3505f31cd997$var$isMutationMethod(method) {
    return $752b3505f31cd997$var$validMutationMethods.has(method.toLowerCase());
}
async function $752b3505f31cd997$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$752b3505f31cd997$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($752b3505f31cd997$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $752b3505f31cd997$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $752b3505f31cd997$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($752b3505f31cd997$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $752b3505f31cd997$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $752b3505f31cd997$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $752b3505f31cd997$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $752b3505f31cd997$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $752b3505f31cd997$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $752b3505f31cd997$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $752b3505f31cd997$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $752b3505f31cd997$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $752b3505f31cd997$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $752b3505f31cd997$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $752b3505f31cd997$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $752b3505f31cd997$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $752b3505f31cd997$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $752b3505f31cd997$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $752b3505f31cd997$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $752b3505f31cd997$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $752b3505f31cd997$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $752b3505f31cd997$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($752b3505f31cd997$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $752b3505f31cd997$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($752b3505f31cd997$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $752b3505f31cd997$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $f500c00b0505d3a1$var$_extends() {
    $f500c00b0505d3a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f500c00b0505d3a1$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $f500c00b0505d3a1$export$3add0d5dce533e2e = /*#__PURE__*/ $6kl77.createContext(null);
const $f500c00b0505d3a1$export$145dfa71566a64dc = /*#__PURE__*/ $6kl77.createContext(null);
const $f500c00b0505d3a1$var$AwaitContext = /*#__PURE__*/ $6kl77.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $f500c00b0505d3a1$export$26749e8557646306 = /*#__PURE__*/ $6kl77.createContext(null);
const $f500c00b0505d3a1$export$c7914228fb69b0f5 = /*#__PURE__*/ $6kl77.createContext(null);
const $f500c00b0505d3a1$export$9072aa6dd1f93057 = /*#__PURE__*/ $6kl77.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $f500c00b0505d3a1$var$RouteErrorContext = /*#__PURE__*/ $6kl77.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $f500c00b0505d3a1$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6kl77.useContext($f500c00b0505d3a1$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $f500c00b0505d3a1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $752b3505f31cd997$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $f500c00b0505d3a1$export$9c954a9d03d32f4a() {
    return $6kl77.useContext($f500c00b0505d3a1$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $f500c00b0505d3a1$export$45d76561a5302f2b() {
    !$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return $6kl77.useContext($f500c00b0505d3a1$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $f500c00b0505d3a1$export$1b3f31771c5d07c() {
    return $6kl77.useContext($f500c00b0505d3a1$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $f500c00b0505d3a1$export$6c330e8992e8a295(pattern) {
    !$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $f500c00b0505d3a1$export$45d76561a5302f2b();
    return $6kl77.useMemo(()=>(0, $752b3505f31cd997$export$81336c211d5ff295)(pattern, (0, $752b3505f31cd997$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $f500c00b0505d3a1$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f500c00b0505d3a1$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6kl77.useContext($f500c00b0505d3a1$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6kl77.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $f500c00b0505d3a1$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f500c00b0505d3a1$var$useNavigateStable() : $f500c00b0505d3a1$var$useNavigateUnstable();
}
function $f500c00b0505d3a1$var$useNavigateUnstable() {
    !$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6kl77.useContext($f500c00b0505d3a1$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6kl77.useContext($f500c00b0505d3a1$export$26749e8557646306);
    let { matches: matches } = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f500c00b0505d3a1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $752b3505f31cd997$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6kl77.useRef(false);
    $f500c00b0505d3a1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6kl77.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $752b3505f31cd997$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $752b3505f31cd997$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $f500c00b0505d3a1$var$OutletContext = /*#__PURE__*/ $6kl77.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $f500c00b0505d3a1$export$4138103a3ae699cc() {
    return $6kl77.useContext($f500c00b0505d3a1$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $f500c00b0505d3a1$export$a3be3530d8e40d0b(context) {
    let outlet = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $f500c00b0505d3a1$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $f500c00b0505d3a1$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6kl77.useContext($f500c00b0505d3a1$export$26749e8557646306);
    let { matches: matches } = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f500c00b0505d3a1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $752b3505f31cd997$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6kl77.useMemo(()=>(0, $752b3505f31cd997$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $f500c00b0505d3a1$export$5d3fca4a98652595(routes, locationArg) {
    return $f500c00b0505d3a1$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f500c00b0505d3a1$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $6kl77.useContext($f500c00b0505d3a1$export$26749e8557646306);
    let { matches: parentMatches } = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $f500c00b0505d3a1$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $752b3505f31cd997$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $752b3505f31cd997$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f500c00b0505d3a1$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $752b3505f31cd997$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $752b3505f31cd997$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f500c00b0505d3a1$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $752b3505f31cd997$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f500c00b0505d3a1$var$DefaultErrorComponent() {
    let error = $f500c00b0505d3a1$export$ed527bf60f6e05f2();
    let message = (0, $752b3505f31cd997$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6kl77.createElement($6kl77.Fragment, null, /*#__PURE__*/ $6kl77.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6kl77.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6kl77.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $f500c00b0505d3a1$var$defaultErrorElement = /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$DefaultErrorComponent, null);
class $f500c00b0505d3a1$var$RenderErrorBoundary extends $6kl77.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $f500c00b0505d3a1$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6kl77.useContext($f500c00b0505d3a1$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f500c00b0505d3a1$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $f500c00b0505d3a1$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f500c00b0505d3a1$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6kl77.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f500c00b0505d3a1$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($f500c00b0505d3a1$var$DataRouterHook || {});
var $f500c00b0505d3a1$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($f500c00b0505d3a1$var$DataRouterStateHook || {});
function $f500c00b0505d3a1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $f500c00b0505d3a1$var$useDataRouterContext(hookName) {
    let ctx = $6kl77.useContext($f500c00b0505d3a1$export$3add0d5dce533e2e);
    !ctx && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f500c00b0505d3a1$var$useDataRouterState(hookName) {
    let state = $6kl77.useContext($f500c00b0505d3a1$export$145dfa71566a64dc);
    !state && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return state;
}
function $f500c00b0505d3a1$var$useRouteContext(hookName) {
    let route = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    !route && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f500c00b0505d3a1$var$useCurrentRouteId(hookName) {
    let route = $f500c00b0505d3a1$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f500c00b0505d3a1$export$5fc8298006ad9e58() {
    return $f500c00b0505d3a1$var$useCurrentRouteId($f500c00b0505d3a1$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f500c00b0505d3a1$export$d0fd4b7106de2769() {
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f500c00b0505d3a1$export$600dc272ed516c15() {
    let dataRouterContext = $f500c00b0505d3a1$var$useDataRouterContext($f500c00b0505d3a1$var$DataRouterHook.UseRevalidator);
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseRevalidator);
    return $6kl77.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f500c00b0505d3a1$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseMatches);
    return $6kl77.useMemo(()=>matches.map((m)=>(0, $752b3505f31cd997$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f500c00b0505d3a1$export$1448a5050d252c4d() {
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseLoaderData);
    let routeId = $f500c00b0505d3a1$var$useCurrentRouteId($f500c00b0505d3a1$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f500c00b0505d3a1$export$fd5d37484eab868d(routeId) {
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f500c00b0505d3a1$export$fdc00f3f26066d5e() {
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseActionData);
    let routeId = $f500c00b0505d3a1$var$useCurrentRouteId($f500c00b0505d3a1$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f500c00b0505d3a1$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6kl77.useContext($f500c00b0505d3a1$var$RouteErrorContext);
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseRouteError);
    let routeId = $f500c00b0505d3a1$var$useCurrentRouteId($f500c00b0505d3a1$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $f500c00b0505d3a1$export$78a72ddb39bdd145() {
    let value = $6kl77.useContext($f500c00b0505d3a1$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $f500c00b0505d3a1$export$17f53340677d5831() {
    let value = $6kl77.useContext($f500c00b0505d3a1$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $f500c00b0505d3a1$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f500c00b0505d3a1$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f500c00b0505d3a1$var$useDataRouterContext($f500c00b0505d3a1$var$DataRouterHook.UseBlocker);
    let state = $f500c00b0505d3a1$var$useDataRouterState($f500c00b0505d3a1$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6kl77.useState("");
    let blockerFunction = $6kl77.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $f500c00b0505d3a1$var$_extends({}, currentLocation, {
                pathname: (0, $752b3505f31cd997$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f500c00b0505d3a1$var$_extends({}, nextLocation, {
                pathname: (0, $752b3505f31cd997$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6kl77.useEffect(()=>{
        let key = String(++$f500c00b0505d3a1$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6kl77.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $752b3505f31cd997$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f500c00b0505d3a1$var$useNavigateStable() {
    let { router: router } = $f500c00b0505d3a1$var$useDataRouterContext($f500c00b0505d3a1$var$DataRouterHook.UseNavigateStable);
    let id = $f500c00b0505d3a1$var$useCurrentRouteId($f500c00b0505d3a1$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6kl77.useRef(false);
    $f500c00b0505d3a1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6kl77.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f500c00b0505d3a1$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $f500c00b0505d3a1$var$alreadyWarned$1 = {};
function $f500c00b0505d3a1$var$warningOnce(key, cond, message) {
    if (!cond && !$f500c00b0505d3a1$var$alreadyWarned$1[key]) $f500c00b0505d3a1$var$alreadyWarned$1[key] = true;
}
const $f500c00b0505d3a1$var$alreadyWarned = {};
function $f500c00b0505d3a1$var$warnOnce(key, message) {}
const $f500c00b0505d3a1$var$logDeprecation = (flag, msg, link)=>$f500c00b0505d3a1$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $f500c00b0505d3a1$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $f500c00b0505d3a1$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $f500c00b0505d3a1$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $f500c00b0505d3a1$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $f500c00b0505d3a1$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $f500c00b0505d3a1$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $f500c00b0505d3a1$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f500c00b0505d3a1$var$START_TRANSITION = "startTransition";
const $f500c00b0505d3a1$var$startTransitionImpl = $6kl77[$f500c00b0505d3a1$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f500c00b0505d3a1$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6kl77.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6kl77.useCallback((newState)=>{
        if (v7_startTransition && $f500c00b0505d3a1$var$startTransitionImpl) $f500c00b0505d3a1$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6kl77.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6kl77.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6kl77.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6kl77.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $6kl77.useEffect(()=>$f500c00b0505d3a1$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6kl77.createElement($6kl77.Fragment, null, /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $f500c00b0505d3a1$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $f500c00b0505d3a1$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $f500c00b0505d3a1$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6kl77.useRef();
    if (historyRef.current == null) historyRef.current = (0, $752b3505f31cd997$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6kl77.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6kl77.useCallback((newState)=>{
        v7_startTransition && $f500c00b0505d3a1$var$startTransitionImpl ? $f500c00b0505d3a1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6kl77.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6kl77.useEffect(()=>$f500c00b0505d3a1$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $f500c00b0505d3a1$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6kl77.useContext($f500c00b0505d3a1$export$26749e8557646306);
    let { matches: matches } = $6kl77.useContext($f500c00b0505d3a1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f500c00b0505d3a1$export$45d76561a5302f2b();
    let navigate = $f500c00b0505d3a1$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $752b3505f31cd997$export$cae722b0cc860f13)(to, (0, $752b3505f31cd997$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6kl77.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $f500c00b0505d3a1$export$910ae8079b2c2852(props) {
    return $f500c00b0505d3a1$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $f500c00b0505d3a1$export$e7b0ac011bb776c6(_props) {
    (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $f500c00b0505d3a1$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $752b3505f31cd997$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$f500c00b0505d3a1$export$9c954a9d03d32f4a() && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6kl77.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $f500c00b0505d3a1$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $752b3505f31cd997$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6kl77.useMemo(()=>{
        let trailingPathname = (0, $752b3505f31cd997$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $f500c00b0505d3a1$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $f500c00b0505d3a1$export$5d3fca4a98652595($f500c00b0505d3a1$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f500c00b0505d3a1$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$ResolveAwait, null, children));
}
var $f500c00b0505d3a1$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($f500c00b0505d3a1$var$AwaitRenderStatus || {});
const $f500c00b0505d3a1$var$neverSettledPromise = new Promise(()=>{});
class $f500c00b0505d3a1$var$AwaitErrorBoundary extends $6kl77.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $f500c00b0505d3a1$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $f500c00b0505d3a1$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $f500c00b0505d3a1$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $f500c00b0505d3a1$var$AwaitRenderStatus.error : "_data" in promise ? $f500c00b0505d3a1$var$AwaitRenderStatus.success : $f500c00b0505d3a1$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $f500c00b0505d3a1$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $f500c00b0505d3a1$var$AwaitRenderStatus.error && promise._error instanceof (0, $752b3505f31cd997$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $f500c00b0505d3a1$var$neverSettledPromise;
        if (status === $f500c00b0505d3a1$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $f500c00b0505d3a1$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $f500c00b0505d3a1$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6kl77.createElement($f500c00b0505d3a1$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $f500c00b0505d3a1$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $f500c00b0505d3a1$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6kl77.createElement($6kl77.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $f500c00b0505d3a1$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6kl77.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6kl77.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6kl77.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f500c00b0505d3a1$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f500c00b0505d3a1$export$e7b0ac011bb776c6) && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f500c00b0505d3a1$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f500c00b0505d3a1$export$daf73786167a7f72(matches) {
    return $f500c00b0505d3a1$var$_renderMatches(matches);
}
function $f500c00b0505d3a1$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6kl77.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6kl77.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6kl77.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f500c00b0505d3a1$export$f30f7e456d254e83(routes, opts) {
    return (0, $752b3505f31cd997$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f500c00b0505d3a1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $752b3505f31cd997$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f500c00b0505d3a1$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $f2b0a7bd8c2e9c22$var$_extends() {
    $f2b0a7bd8c2e9c22$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f2b0a7bd8c2e9c22$var$_extends.apply(this, arguments);
}
function $f2b0a7bd8c2e9c22$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $f2b0a7bd8c2e9c22$var$defaultMethod = "get";
const $f2b0a7bd8c2e9c22$var$defaultEncType = "application/x-www-form-urlencoded";
function $f2b0a7bd8c2e9c22$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $f2b0a7bd8c2e9c22$var$isButtonElement(object) {
    return $f2b0a7bd8c2e9c22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f2b0a7bd8c2e9c22$var$isFormElement(object) {
    return $f2b0a7bd8c2e9c22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f2b0a7bd8c2e9c22$var$isInputElement(object) {
    return $f2b0a7bd8c2e9c22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f2b0a7bd8c2e9c22$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f2b0a7bd8c2e9c22$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$f2b0a7bd8c2e9c22$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $f2b0a7bd8c2e9c22$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f2b0a7bd8c2e9c22$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $f2b0a7bd8c2e9c22$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $f2b0a7bd8c2e9c22$var$_formDataSupportsSubmitter = null;
function $f2b0a7bd8c2e9c22$var$isFormDataSubmitterSupported() {
    if ($f2b0a7bd8c2e9c22$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $f2b0a7bd8c2e9c22$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $f2b0a7bd8c2e9c22$var$_formDataSupportsSubmitter = true;
    }
    return $f2b0a7bd8c2e9c22$var$_formDataSupportsSubmitter;
}
const $f2b0a7bd8c2e9c22$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f2b0a7bd8c2e9c22$var$getFormEncType(encType) {
    if (encType != null && !$f2b0a7bd8c2e9c22$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $f2b0a7bd8c2e9c22$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f2b0a7bd8c2e9c22$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $752b3505f31cd997$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $f2b0a7bd8c2e9c22$var$defaultMethod;
        encType = $f2b0a7bd8c2e9c22$var$getFormEncType(target.getAttribute("enctype")) || $f2b0a7bd8c2e9c22$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f2b0a7bd8c2e9c22$var$isButtonElement(target) || $f2b0a7bd8c2e9c22$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $752b3505f31cd997$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $f2b0a7bd8c2e9c22$var$defaultMethod;
        encType = $f2b0a7bd8c2e9c22$var$getFormEncType(target.getAttribute("formenctype")) || $f2b0a7bd8c2e9c22$var$getFormEncType(form.getAttribute("enctype")) || $f2b0a7bd8c2e9c22$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$f2b0a7bd8c2e9c22$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f2b0a7bd8c2e9c22$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $f2b0a7bd8c2e9c22$var$defaultMethod;
        action = null;
        encType = $f2b0a7bd8c2e9c22$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $f2b0a7bd8c2e9c22$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $f2b0a7bd8c2e9c22$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $f2b0a7bd8c2e9c22$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $f2b0a7bd8c2e9c22$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $f2b0a7bd8c2e9c22$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $f2b0a7bd8c2e9c22$export$1f3f55432a00e06d(routes, opts) {
    return (0, $752b3505f31cd997$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f2b0a7bd8c2e9c22$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $752b3505f31cd997$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f2b0a7bd8c2e9c22$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f500c00b0505d3a1$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f2b0a7bd8c2e9c22$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $752b3505f31cd997$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f2b0a7bd8c2e9c22$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $752b3505f31cd997$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f2b0a7bd8c2e9c22$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f500c00b0505d3a1$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f2b0a7bd8c2e9c22$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $f2b0a7bd8c2e9c22$var$_extends({}, state, {
        errors: $f2b0a7bd8c2e9c22$var$deserializeErrors(state.errors)
    });
    return state;
}
function $f2b0a7bd8c2e9c22$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $752b3505f31cd997$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $f2b0a7bd8c2e9c22$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6kl77.createContext({
    isTransitioning: false
});
const $f2b0a7bd8c2e9c22$export$148fd98d095596d4 = /*#__PURE__*/ $6kl77.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f2b0a7bd8c2e9c22$var$START_TRANSITION = "startTransition";
const $f2b0a7bd8c2e9c22$var$startTransitionImpl = $6kl77[$f2b0a7bd8c2e9c22$var$START_TRANSITION];
const $f2b0a7bd8c2e9c22$var$FLUSH_SYNC = "flushSync";
const $f2b0a7bd8c2e9c22$var$flushSyncImpl = $9081a4cee253faa5$exports[$f2b0a7bd8c2e9c22$var$FLUSH_SYNC];
const $f2b0a7bd8c2e9c22$var$USE_ID = "useId";
const $f2b0a7bd8c2e9c22$var$useIdImpl = $6kl77[$f2b0a7bd8c2e9c22$var$USE_ID];
function $f2b0a7bd8c2e9c22$var$startTransitionSafe(cb) {
    if ($f2b0a7bd8c2e9c22$var$startTransitionImpl) $f2b0a7bd8c2e9c22$var$startTransitionImpl(cb);
    else cb();
}
function $f2b0a7bd8c2e9c22$var$flushSyncSafe(cb) {
    if ($f2b0a7bd8c2e9c22$var$flushSyncImpl) $f2b0a7bd8c2e9c22$var$flushSyncImpl(cb);
    else cb();
}
class $f2b0a7bd8c2e9c22$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f2b0a7bd8c2e9c22$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6kl77.useState(router.state);
    let [pendingState, setPendingState] = $6kl77.useState();
    let [vtContext, setVtContext] = $6kl77.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6kl77.useState();
    let [transition, setTransition] = $6kl77.useState();
    let [interruption, setInterruption] = $6kl77.useState();
    let fetcherData = $6kl77.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6kl77.useCallback((cb)=>{
        if (v7_startTransition) $f2b0a7bd8c2e9c22$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6kl77.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $f2b0a7bd8c2e9c22$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $f2b0a7bd8c2e9c22$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $f2b0a7bd8c2e9c22$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $f2b0a7bd8c2e9c22$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $f2b0a7bd8c2e9c22$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6kl77.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6kl77.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $f2b0a7bd8c2e9c22$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6kl77.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6kl77.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6kl77.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6kl77.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6kl77.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6kl77.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $6kl77.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $6kl77.useEffect(()=>(0, $f500c00b0505d3a1$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6kl77.createElement($6kl77.Fragment, null, /*#__PURE__*/ $6kl77.createElement((0, $f500c00b0505d3a1$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6kl77.createElement((0, $f500c00b0505d3a1$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6kl77.createElement($f2b0a7bd8c2e9c22$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6kl77.createElement($f2b0a7bd8c2e9c22$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6kl77.createElement((0, $f500c00b0505d3a1$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6kl77.createElement($f2b0a7bd8c2e9c22$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $f2b0a7bd8c2e9c22$var$MemoizedDataRoutes = /*#__PURE__*/ $6kl77.memo($f2b0a7bd8c2e9c22$var$DataRoutes);
function $f2b0a7bd8c2e9c22$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $f500c00b0505d3a1$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $f2b0a7bd8c2e9c22$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6kl77.useRef();
    if (historyRef.current == null) historyRef.current = (0, $752b3505f31cd997$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6kl77.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6kl77.useCallback((newState)=>{
        v7_startTransition && $f2b0a7bd8c2e9c22$var$startTransitionImpl ? $f2b0a7bd8c2e9c22$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6kl77.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6kl77.useEffect(()=>(0, $f500c00b0505d3a1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $6kl77.createElement((0, $f500c00b0505d3a1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $f2b0a7bd8c2e9c22$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6kl77.useRef();
    if (historyRef.current == null) historyRef.current = (0, $752b3505f31cd997$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6kl77.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6kl77.useCallback((newState)=>{
        v7_startTransition && $f2b0a7bd8c2e9c22$var$startTransitionImpl ? $f2b0a7bd8c2e9c22$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6kl77.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6kl77.useEffect(()=>(0, $f500c00b0505d3a1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $6kl77.createElement((0, $f500c00b0505d3a1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $f2b0a7bd8c2e9c22$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6kl77.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6kl77.useCallback((newState)=>{
        v7_startTransition && $f2b0a7bd8c2e9c22$var$startTransitionImpl ? $f2b0a7bd8c2e9c22$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6kl77.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6kl77.useEffect(()=>(0, $f500c00b0505d3a1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $6kl77.createElement((0, $f500c00b0505d3a1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $f2b0a7bd8c2e9c22$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $f2b0a7bd8c2e9c22$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $f2b0a7bd8c2e9c22$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6kl77.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $f2b0a7bd8c2e9c22$var$_objectWithoutPropertiesLoose(_ref7, $f2b0a7bd8c2e9c22$var$_excluded);
    let { basename: basename } = $6kl77.useContext((0, $f500c00b0505d3a1$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $f2b0a7bd8c2e9c22$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($f2b0a7bd8c2e9c22$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $752b3505f31cd997$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $f500c00b0505d3a1$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $f2b0a7bd8c2e9c22$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6kl77.createElement("a", $f2b0a7bd8c2e9c22$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $f2b0a7bd8c2e9c22$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6kl77.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $f2b0a7bd8c2e9c22$var$_objectWithoutPropertiesLoose(_ref8, $f2b0a7bd8c2e9c22$var$_excluded2);
    let path = (0, $f500c00b0505d3a1$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    let routerState = $6kl77.useContext((0, $f500c00b0505d3a1$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $6kl77.useContext((0, $f500c00b0505d3a1$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f2b0a7bd8c2e9c22$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $752b3505f31cd997$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6kl77.createElement($f2b0a7bd8c2e9c22$export$a6c7ac8248d6e38a, $f2b0a7bd8c2e9c22$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $f2b0a7bd8c2e9c22$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6kl77.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $f2b0a7bd8c2e9c22$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $f2b0a7bd8c2e9c22$var$_objectWithoutPropertiesLoose(_ref9, $f2b0a7bd8c2e9c22$var$_excluded3);
    let submit = $f2b0a7bd8c2e9c22$export$47c85c6e3a081d3();
    let formAction = $f2b0a7bd8c2e9c22$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $6kl77.createElement("form", $f2b0a7bd8c2e9c22$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $f2b0a7bd8c2e9c22$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $f2b0a7bd8c2e9c22$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $f2b0a7bd8c2e9c22$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($f2b0a7bd8c2e9c22$var$DataRouterHook || ($f2b0a7bd8c2e9c22$var$DataRouterHook = {}));
var $f2b0a7bd8c2e9c22$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($f2b0a7bd8c2e9c22$var$DataRouterStateHook || ($f2b0a7bd8c2e9c22$var$DataRouterStateHook = {}));
// Internal hooks
function $f2b0a7bd8c2e9c22$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $f2b0a7bd8c2e9c22$var$useDataRouterContext(hookName) {
    let ctx = $6kl77.useContext((0, $f500c00b0505d3a1$export$3add0d5dce533e2e));
    !ctx && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f2b0a7bd8c2e9c22$var$useDataRouterState(hookName) {
    let state = $6kl77.useContext((0, $f500c00b0505d3a1$export$145dfa71566a64dc));
    !state && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $f2b0a7bd8c2e9c22$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $f500c00b0505d3a1$export$9770f232ac06a008)();
    let location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    let path = (0, $f500c00b0505d3a1$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6kl77.useCallback((event)=>{
        if ($f2b0a7bd8c2e9c22$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $752b3505f31cd997$export$fe53371bee54353d)(location) === (0, $752b3505f31cd997$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $f2b0a7bd8c2e9c22$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6kl77.useRef($f2b0a7bd8c2e9c22$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6kl77.useRef(false);
    let location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    let searchParams = $6kl77.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $f2b0a7bd8c2e9c22$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $f500c00b0505d3a1$export$9770f232ac06a008)();
    let setSearchParams = $6kl77.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $f2b0a7bd8c2e9c22$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $f2b0a7bd8c2e9c22$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $f2b0a7bd8c2e9c22$var$fetcherId = 0;
let $f2b0a7bd8c2e9c22$var$getUniqueFetcherId = ()=>"__" + String(++$f2b0a7bd8c2e9c22$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $f2b0a7bd8c2e9c22$export$47c85c6e3a081d3() {
    let { router: router } = $f2b0a7bd8c2e9c22$var$useDataRouterContext($f2b0a7bd8c2e9c22$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6kl77.useContext((0, $f500c00b0505d3a1$export$26749e8557646306));
    let currentRouteId = (0, $f500c00b0505d3a1$export$5fc8298006ad9e58)();
    return $6kl77.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $f2b0a7bd8c2e9c22$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f2b0a7bd8c2e9c22$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $f2b0a7bd8c2e9c22$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $f2b0a7bd8c2e9c22$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6kl77.useContext((0, $f500c00b0505d3a1$export$26749e8557646306));
    let routeContext = $6kl77.useContext((0, $f500c00b0505d3a1$export$9072aa6dd1f93057));
    !routeContext && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $f2b0a7bd8c2e9c22$var$_extends({}, (0, $f500c00b0505d3a1$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $752b3505f31cd997$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $752b3505f31cd997$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $f2b0a7bd8c2e9c22$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $f2b0a7bd8c2e9c22$var$useDataRouterContext($f2b0a7bd8c2e9c22$var$DataRouterHook.UseFetcher);
    let state = $f2b0a7bd8c2e9c22$var$useDataRouterState($f2b0a7bd8c2e9c22$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6kl77.useContext($f2b0a7bd8c2e9c22$export$148fd98d095596d4);
    let route = $6kl77.useContext((0, $f500c00b0505d3a1$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    !route && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $f2b0a7bd8c2e9c22$var$useIdImpl ? $f2b0a7bd8c2e9c22$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $6kl77.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($f2b0a7bd8c2e9c22$var$getUniqueFetcherId());
    // Registration/cleanup
    $6kl77.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6kl77.useCallback((href, opts)=>{
        !routeId && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $f2b0a7bd8c2e9c22$export$47c85c6e3a081d3();
    let submit = $6kl77.useCallback((target, opts)=>{
        submitImpl(target, $f2b0a7bd8c2e9c22$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6kl77.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6kl77.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6kl77.createElement($f2b0a7bd8c2e9c22$export$a7fed597f4b8afd8, $f2b0a7bd8c2e9c22$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $752b3505f31cd997$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6kl77.useMemo(()=>$f2b0a7bd8c2e9c22$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $f2b0a7bd8c2e9c22$export$fa996778a3a31087() {
    let state = $f2b0a7bd8c2e9c22$var$useDataRouterState($f2b0a7bd8c2e9c22$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $f2b0a7bd8c2e9c22$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $f2b0a7bd8c2e9c22$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $f2b0a7bd8c2e9c22$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $f2b0a7bd8c2e9c22$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $f2b0a7bd8c2e9c22$var$useDataRouterContext($f2b0a7bd8c2e9c22$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f2b0a7bd8c2e9c22$var$useDataRouterState($f2b0a7bd8c2e9c22$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6kl77.useContext((0, $f500c00b0505d3a1$export$26749e8557646306));
    let location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    let matches = (0, $f500c00b0505d3a1$export$2378eb7f5ff86053)();
    let navigation = (0, $f500c00b0505d3a1$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6kl77.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $f2b0a7bd8c2e9c22$var$usePageHide($6kl77.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $f2b0a7bd8c2e9c22$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f2b0a7bd8c2e9c22$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f2b0a7bd8c2e9c22$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6kl77.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f2b0a7bd8c2e9c22$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f2b0a7bd8c2e9c22$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6kl77.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($f2b0a7bd8c2e9c22$var$_extends({}, location, {
                    pathname: (0, $752b3505f31cd997$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($f2b0a7bd8c2e9c22$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6kl77.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f2b0a7bd8c2e9c22$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6kl77.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f2b0a7bd8c2e9c22$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6kl77.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $f2b0a7bd8c2e9c22$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $f500c00b0505d3a1$export$b273b3273281a049)(when);
    $6kl77.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6kl77.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $f2b0a7bd8c2e9c22$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6kl77.useContext($f2b0a7bd8c2e9c22$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $752b3505f31cd997$export$3e9cee6b33872309)(false);
    let { basename: basename } = $f2b0a7bd8c2e9c22$var$useDataRouterContext($f2b0a7bd8c2e9c22$var$DataRouterHook.useViewTransitionState);
    let path = (0, $f500c00b0505d3a1$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $752b3505f31cd997$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $752b3505f31cd997$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $752b3505f31cd997$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $752b3505f31cd997$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $6kl77 = parcelRequire("6kl77");
const $daaee31eed9617db$export$e506a1d27d1eaa20 = {
    // Url used for resolving a resource to get its providers. Used when clicking 'resolve' in the home page.
    resolverApi: 'https://resolver.api.identifiers.org',
    // Hardcoded Url used to build the links shown in the resolver page.
    resolverHardcodedUrl: 'http://identifiers.org',
    // Registry API Url used to fetch namespaces for the suggestions box.
    registryApi: 'https://registry.api.identifiers.org',
    metadataRetrieverApiBaseUrl: 'https://metadata.api.identifiers.org/retrievers/',
    // This requires a working HQ architecture with a central registry.
    showSearchSuggestions: true,
    suggestionListSize: 10,
    suggestionQuerySize: 25,
    // Show beta banner:
    showBetaBanner: false,
    // We don't predict resources in suggestions box for now.
    enableResourcePrediction: false,
    // HQ Registry Url used in navbar and in link buttons in suggestions.
    registryUrl: 'https://registry.identifiers.org',
    // Documentation Url.
    documentationUrl: '//docs.identifiers.org',
    // HQ Prefix registration request used in navbar.
    registryPrefixRegistrationRequestFormUrl: 'https://registry.identifiers.org/prefixregistrationrequest',
    // Feedback Url. Links to github 'new issue' in our github pages repository.
    feedbackUrl: '//github.com/identifiers-org/identifiers-org.github.io/issues/new',
    // Old platform Url. Used in navbar.
    oldIdentifiersUrl: 'https://ebi.identifiers.org',
    apiVersion: '1.0',
    // Schema.org metadata endpoints.
    schemaOrgPlatformEndpoint: 'schemaOrgApi/getMetadataForPlatform',
    schemaOrgNamespacePrefixEndpoint: 'schemaOrgApi/getMetadataForNamespacePrefix',
    ebiSearchDomainEndpoint: 'https://www.ebi.ac.uk/ebisearch/ws/rest/identifiers_registry',
    ebiSearchResponseSize: 100,
    ebiSearchRescoreWhenSingleIdDetected: true,
    daysPeriodToShowLatestUpdatePost: 90
};



var $585203cf2ca61400$exports = {};
var $220632401708cd2a$exports = {};
var $95b8c354821da3bb$exports = {};
function $95b8c354821da3bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $95b8c354821da3bb$exports = $95b8c354821da3bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95b8c354821da3bb$exports.__esModule = true, $95b8c354821da3bb$exports["default"] = $95b8c354821da3bb$exports, $95b8c354821da3bb$var$_typeof(o);
}
$95b8c354821da3bb$exports = $95b8c354821da3bb$var$_typeof, $95b8c354821da3bb$exports.__esModule = true, $95b8c354821da3bb$exports["default"] = $95b8c354821da3bb$exports;


var $220632401708cd2a$var$_typeof = $95b8c354821da3bb$exports.default;
var $2e11f2b246c77a24$exports = {};

var $2e11f2b246c77a24$var$_typeof = $95b8c354821da3bb$exports.default;
function $2e11f2b246c77a24$var$toPrimitive(t, r) {
    if ("object" != $2e11f2b246c77a24$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2e11f2b246c77a24$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$2e11f2b246c77a24$exports = $2e11f2b246c77a24$var$toPrimitive, $2e11f2b246c77a24$exports.__esModule = true, $2e11f2b246c77a24$exports["default"] = $2e11f2b246c77a24$exports;


function $220632401708cd2a$var$toPropertyKey(t) {
    var i = $2e11f2b246c77a24$exports(t, "string");
    return "symbol" == $220632401708cd2a$var$_typeof(i) ? i : i + "";
}
$220632401708cd2a$exports = $220632401708cd2a$var$toPropertyKey, $220632401708cd2a$exports.__esModule = true, $220632401708cd2a$exports["default"] = $220632401708cd2a$exports;


function $585203cf2ca61400$var$_defineProperty(e, r, t) {
    return (r = $220632401708cd2a$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$585203cf2ca61400$exports = $585203cf2ca61400$var$_defineProperty, $585203cf2ca61400$exports.__esModule = true, $585203cf2ca61400$exports["default"] = $585203cf2ca61400$exports;



var $6kl77 = parcelRequire("6kl77");

var $f376d40762308610$export$2e2bcd8739ae039 = Object.freeze({
    NO_CURIE: Symbol('Query doesnt look like a curie'),
    QUERYING_NAMESPACES: Symbol('Query is for searching thru namespaces'),
    PREFIX_ONLY: Symbol('Only prefix seem to be present'),
    PREFIX_WITH_COLON: Symbol('Only prefix with a colon is present'),
    VALID_CURIE: Symbol('The query seems to be a valid curie'),
    INVALID_LOCAL_ID: Symbol('The query seems to be a curie with invalid ID'),
    INVALID_PREFIX: Symbol('The query seems to be a curie with invalid prefix')
});





var $6kl77 = parcelRequire("6kl77");


var $6kl77 = parcelRequire("6kl77");

var $7aea0e2d8c18a52e$exports = {};
/*!
* sweetalert2 v11.19.1
* Released under the MIT License.
*/ (function(global, factory) {
    $7aea0e2d8c18a52e$exports = factory();
})($7aea0e2d8c18a52e$exports, function() {
    'use strict';
    function _assertClassBrand(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
        return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
        _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
        return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ const globalState = {};
    const focusPreviousActiveElement = ()=>{
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ const restoreActiveElement = (returnFocus)=>{
        return new Promise((resolve)=>{
            if (!returnFocus) return resolve();
            const x = window.scrollX;
            const y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(()=>{
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    const swalPrefix = 'swal2-';
    /**
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ const classNames = [
        'container',
        'shown',
        'height-auto',
        'iosfix',
        'popup',
        'modal',
        'no-backdrop',
        'no-transition',
        'toast',
        'toast-shown',
        'show',
        'hide',
        'close',
        'title',
        'html-container',
        'actions',
        'confirm',
        'deny',
        'cancel',
        'footer',
        'icon',
        'icon-content',
        'image',
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'label',
        'textarea',
        'inputerror',
        'input-label',
        'validation-message',
        'progress-steps',
        'active-progress-step',
        'progress-step',
        'progress-step-line',
        'loader',
        'loading',
        'styled',
        'top',
        'top-start',
        'top-end',
        'top-left',
        'top-right',
        'center',
        'center-start',
        'center-end',
        'center-left',
        'center-right',
        'bottom',
        'bottom-start',
        'bottom-end',
        'bottom-left',
        'bottom-right',
        'grow-row',
        'grow-column',
        'grow-fullscreen',
        'rtl',
        'timer-progress-bar',
        'timer-progress-bar-container',
        'scrollbar-measure',
        'icon-success',
        'icon-warning',
        'icon-info',
        'icon-question',
        'icon-error',
        'draggable',
        'dragging'
    ];
    const swalClasses = classNames.reduce((acc, className)=>{
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ const icons = [
        'success',
        'warning',
        'info',
        'question',
        'error'
    ];
    const iconTypes = icons.reduce((acc, icon)=>{
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    const consolePrefix = 'SweetAlert2:';
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ const warn = (message)=>{
        console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ const error = (message)=>{
        console.error(`${consolePrefix} ${message}`);
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ const previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ const warnOnce = (message)=>{
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string?} useInstead
   */ const warnAboutDeprecation = function(deprecatedParam) {
        let useInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {Function | any} arg
   * @returns {any}
   */ const callIfFunction = (arg)=>typeof arg === 'function' ? arg() : arg;
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const hasToPromiseFn = (arg)=>arg && typeof arg.toPromise === 'function';
    /**
   * @param {any} arg
   * @returns {Promise<any>}
   */ const asPromise = (arg)=>hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const isPromise = (arg)=>arg && Promise.resolve(arg) === arg;
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ const getContainer = ()=>document.body.querySelector(`.${swalClasses.container}`);
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ const elementBySelector = (selectorString)=>{
        const container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ const elementByClass = (className)=>{
        return elementBySelector(`.${className}`);
    };
    /**
   * @returns {HTMLElement | null}
   */ const getPopup = ()=>elementByClass(swalClasses.popup);
    /**
   * @returns {HTMLElement | null}
   */ const getIcon = ()=>elementByClass(swalClasses.icon);
    /**
   * @returns {HTMLElement | null}
   */ const getIconContent = ()=>elementByClass(swalClasses['icon-content']);
    /**
   * @returns {HTMLElement | null}
   */ const getTitle = ()=>elementByClass(swalClasses.title);
    /**
   * @returns {HTMLElement | null}
   */ const getHtmlContainer = ()=>elementByClass(swalClasses['html-container']);
    /**
   * @returns {HTMLElement | null}
   */ const getImage = ()=>elementByClass(swalClasses.image);
    /**
   * @returns {HTMLElement | null}
   */ const getProgressSteps = ()=>elementByClass(swalClasses['progress-steps']);
    /**
   * @returns {HTMLElement | null}
   */ const getValidationMessage = ()=>elementByClass(swalClasses['validation-message']);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getConfirmButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getCancelButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getDenyButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`);
    /**
   * @returns {HTMLElement | null}
   */ const getInputLabel = ()=>elementByClass(swalClasses['input-label']);
    /**
   * @returns {HTMLElement | null}
   */ const getLoader = ()=>elementBySelector(`.${swalClasses.loader}`);
    /**
   * @returns {HTMLElement | null}
   */ const getActions = ()=>elementByClass(swalClasses.actions);
    /**
   * @returns {HTMLElement | null}
   */ const getFooter = ()=>elementByClass(swalClasses.footer);
    /**
   * @returns {HTMLElement | null}
   */ const getTimerProgressBar = ()=>elementByClass(swalClasses['timer-progress-bar']);
    /**
   * @returns {HTMLElement | null}
   */ const getCloseButton = ()=>elementByClass(swalClasses.close);
    // https://github.com/jkup/focusable/blob/master/index.js
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    /**
   * @returns {HTMLElement[]}
   */ const getFocusableElements = ()=>{
        const popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort((a, b)=>{
            const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
            const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ const otherFocusableElements = popup.querySelectorAll(focusable);
        const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter((el)=>el.getAttribute('tabindex') !== '-1');
        return [
            ...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))
        ].filter((el)=>isVisible$1(el));
    };
    /**
   * @returns {boolean}
   */ const isModal = ()=>{
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    /**
   * @returns {boolean}
   */ const isToast = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ const isLoading = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute('data-loading');
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ const setInnerHtml = (elem, html)=>{
        elem.textContent = '';
        if (html) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(html, `text/html`);
            const head = parsed.querySelector('head');
            if (head) Array.from(head.childNodes).forEach((child)=>{
                elem.appendChild(child);
            });
            const body = parsed.querySelector('body');
            if (body) Array.from(body.childNodes).forEach((child)=>{
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ const hasClass = (elem, className)=>{
        if (!className) return false;
        const classList = className.split(/\s+/);
        for(let i = 0; i < classList.length; i++){
            if (!elem.classList.contains(classList[i])) return false;
        }
        return true;
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ const removeCustomClasses = (elem, params)=>{
        Array.from(elem.classList).forEach((className)=>{
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ const applyCustomClass = (elem, params, className)=>{
        removeCustomClasses(elem, params);
        if (!params.customClass) return;
        const customClass = params.customClass[/** @type {keyof SweetAlertCustomClass} */ className];
        if (!customClass) return;
        if (typeof customClass !== 'string' && !customClass.forEach) {
            warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
            return;
        }
        addClass(elem, customClass);
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ const getInput$1 = (popup, inputClass)=>{
        if (!inputClass) return null;
        switch(inputClass){
            case 'select':
            case 'textarea':
            case 'file':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
            case 'checkbox':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
            case 'radio':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
            case 'range':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
            default:
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ const focusInput = (input)=>{
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== 'file') {
            // http://stackoverflow.com/a/2345915
            const val = input.value;
            input.value = '';
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ const toggleClass = (target, classList, condition)=>{
        if (!target || !classList) return;
        if (typeof classList === 'string') classList = classList.split(/\s+/).filter(Boolean);
        classList.forEach((className)=>{
            if (Array.isArray(target)) target.forEach((elem)=>{
                if (condition) elem.classList.add(className);
                else elem.classList.remove(className);
            });
            else if (condition) target.classList.add(className);
            else target.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const addClass = (target, classList)=>{
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const removeClass = (target, classList)=>{
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ const getDirectChildByClass = (elem, className)=>{
        const children = Array.from(elem.children);
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child instanceof HTMLElement && hasClass(child, className)) return child;
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {*} value
   */ const applyNumericalStyle = (elem, property, value)=>{
        if (value === `${parseInt(value)}`) value = parseInt(value);
        if (value || parseInt(value) === 0) elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : value);
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const show = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
        if (!elem) return;
        elem.style.display = display;
    };
    /**
   * @param {HTMLElement | null} elem
   */ const hide = (elem)=>{
        if (!elem) return;
        elem.style.display = 'none';
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const showWhenInnerHtmlPresent = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
        if (!elem) return;
        new MutationObserver(()=>{
            toggle(elem, elem.innerHTML, display);
        }).observe(elem, {
            childList: true,
            subtree: true
        });
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ const setStyle = (parent, selector, property, value)=>{
        /** @type {HTMLElement | null} */ const el = parent.querySelector(selector);
        if (el) el.style.setProperty(property, value);
    };
    /**
   * @param {HTMLElement} elem
   * @param {any} condition
   * @param {string} display
   */ const toggle = function(elem, condition) {
        let display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';
        if (condition) show(elem, display);
        else hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ const isVisible$1 = (elem)=>!!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    /**
   * @returns {boolean}
   */ const allButtonsAreHidden = ()=>!isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const isScrollable = (elem)=>!!(elem.scrollHeight > elem.clientHeight);
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const hasCssAnimation = (elem)=>{
        const style = window.getComputedStyle(elem);
        const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
        const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ const animateTimerProgressBar = function(timer) {
        let reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = 'none';
                timerProgressBar.style.width = '100%';
            }
            setTimeout(()=>{
                timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
                timerProgressBar.style.width = '0%';
            }, 10);
        }
    };
    const stopTimerProgressBar = ()=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty('transition');
        timerProgressBar.style.width = '100%';
        const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ const isNodeEnv = ()=>typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    /**
   * @returns {boolean}
   */ const resetOldContainer = ()=>{
        const oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses['no-backdrop'],
            swalClasses['toast-shown'],
            swalClasses['has-column']
        ]);
        return true;
    };
    const resetValidationMessage$1 = ()=>{
        globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = ()=>{
        const popup = getPopup();
        const input = getDirectChildByClass(popup, swalClasses.input);
        const file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement} */ const range = popup.querySelector(`.${swalClasses.range} input`);
        /** @type {HTMLOutputElement} */ const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
        const select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement} */ const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
        const textarea = getDirectChildByClass(popup, swalClasses.textarea);
        input.oninput = resetValidationMessage$1;
        file.onchange = resetValidationMessage$1;
        select.onchange = resetValidationMessage$1;
        checkbox.onchange = resetValidationMessage$1;
        textarea.oninput = resetValidationMessage$1;
        range.oninput = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
        range.onchange = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ const getTarget = (target)=>typeof target === 'string' ? document.querySelector(target) : target;
    /**
   * @param {SweetAlertOptions} params
   */ const setupAccessibility = (params)=>{
        const popup = getPopup();
        popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
        popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
        if (!params.toast) popup.setAttribute('aria-modal', 'true');
    };
    /**
   * @param {HTMLElement} targetElement
   */ const setupRTL = (targetElement)=>{
        if (window.getComputedStyle(targetElement).direction === 'rtl') addClass(getContainer(), swalClasses.rtl);
    };
    /**
   * Add modal + backdrop + no-war message for Russians to DOM
   *
   * @param {SweetAlertOptions} params
   */ const init = (params)=>{
        // Clean up the old popup container if it exists
        const oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error('SweetAlert2 requires document to initialize');
            return;
        }
        const container = document.createElement('div');
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses['no-transition']);
        setInnerHtml(container, sweetHTML);
        container.dataset['swal2Theme'] = params.theme;
        const targetElement = getTarget(params.target);
        targetElement.appendChild(container);
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ const parseHtmlToContainer = (param, target)=>{
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (typeof param === 'object') handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {any} param
   * @param {HTMLElement} target
   */ const handleObject = (param, target)=>{
        // JQuery element(s)
        if (param.jquery) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ const handleJqueryElem = (target, elem)=>{
        target.textContent = '';
        if (0 in elem) for(let i = 0; i in elem; i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderActions = (instance, params)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, 'actions');
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || '');
        applyCustomClass(loader, params, 'loader');
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, 'confirm', params);
        renderButton(denyButton, 'deny', params);
        renderButton(cancelButton, 'cancel', params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Apply custom background colors to action buttons
        if (params.confirmButtonColor) confirmButton.style.setProperty('--swal2-confirm-button-background-color', params.confirmButtonColor);
        if (params.denyButtonColor) denyButton.style.setProperty('--swal2-deny-button-background-color', params.denyButtonColor);
        if (params.cancelButtonColor) cancelButton.style.setProperty('--swal2-cancel-button-background-color', params.cancelButtonColor);
        // Apply the outline color to action buttons
        applyOutlineColor(confirmButton);
        applyOutlineColor(denyButton);
        applyOutlineColor(cancelButton);
    }
    /**
   * @param {HTMLElement} button
   */ function applyOutlineColor(button) {
        const buttonStyle = window.getComputedStyle(button);
        const outlineColor = buttonStyle.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, 'rgba($1, $2, $3, 0.5)');
        button.style.setProperty('--swal2-action-button-outline', buttonStyle.getPropertyValue('--swal2-outline').replace(/ rgba\(.*/, ` ${outlineColor}`));
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        const buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params[`show${buttonName}Button`], 'inline-block');
        setInnerHtml(button, params[`${buttonType}ButtonText`] || ''); // Set caption text
        button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || ''); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, `${buttonType}Button`);
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderCloseButton = (instance, params)=>{
        const closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || '');
        // Custom class
        applyCustomClass(closeButton, params, 'closeButton');
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContainer = (instance, params)=>{
        const container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, 'container');
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === 'string') container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses['no-backdrop']);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses[`grow-${grow}`]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap()
    };
    /// <reference path="../../../../sweetalert2.d.ts"/>
    /** @type {InputClass[]} */ const inputClasses = [
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'textarea'
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderInput = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        const innerParams = privateProps.innerParams.get(instance);
        const rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach((inputClass)=>{
            const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ const showInput = (params)=>{
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
            return;
        }
        const inputContainer = getInputContainer(params.input);
        if (!inputContainer) return;
        const input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(()=>{
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ const removeAttributes = (input)=>{
        for(let i = 0; i < input.attributes.length; i++){
            const attrName = input.attributes[i].name;
            if (![
                'id',
                'type',
                'value',
                'style'
            ].includes(attrName)) input.removeAttribute(attrName);
        }
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ const setAttributes = (inputClass, inputAttributes)=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getInput$1(popup, inputClass);
        if (!input) return;
        removeAttributes(input);
        for(const attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setCustomClass = (params)=>{
        if (!params.input) return;
        const inputContainer = getInputContainer(params.input);
        if (inputContainer) applyCustomClass(inputContainer, params, 'input');
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ const setInputPlaceholder = (input, params)=>{
        if (!input.placeholder && params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ const setInputLabel = (input, prependTo, params)=>{
        if (params.inputLabel) {
            const label = document.createElement('label');
            const labelClass = swalClasses['input-label'];
            label.setAttribute('for', input.id);
            label.className = labelClass;
            if (typeof params.customClass === 'object') addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement('beforebegin', label);
        }
    };
    /**
   * @param {SweetAlertInput} inputType
   * @returns {HTMLElement | undefined}
   */ const getInputContainer = (inputType)=>{
        const popup = getPopup();
        if (!popup) return;
        return getDirectChildByClass(popup, swalClasses[/** @type {SwalClass} */ inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ const checkAndSetInputValue = (input, inputValue)=>{
        if ([
            'string',
            'number'
        ].includes(typeof inputValue)) input.value = `${inputValue}`;
        else if (!isPromise(inputValue)) warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ const renderInputType = {};
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */ (input, params)=>{
        checkAndSetInputValue(input, params.inputValue);
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        input.type = params.input;
        return input;
    };
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.file = (input, params)=>{
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        return input;
    };
    /**
   * @param {HTMLInputElement} range
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.range = (range, params)=>{
        const rangeInput = range.querySelector('input');
        const rangeOutput = range.querySelector('output');
        checkAndSetInputValue(rangeInput, params.inputValue);
        rangeInput.type = params.input;
        checkAndSetInputValue(rangeOutput, params.inputValue);
        setInputLabel(rangeInput, range, params);
        return range;
    };
    /**
   * @param {HTMLSelectElement} select
   * @param {SweetAlertOptions} params
   * @returns {HTMLSelectElement}
   */ renderInputType.select = (select, params)=>{
        select.textContent = '';
        if (params.inputPlaceholder) {
            const placeholder = document.createElement('option');
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            select.appendChild(placeholder);
        }
        setInputLabel(select, select, params);
        return select;
    };
    /**
   * @param {HTMLInputElement} radio
   * @returns {HTMLInputElement}
   */ renderInputType.radio = (radio)=>{
        radio.textContent = '';
        return radio;
    };
    /**
   * @param {HTMLLabelElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.checkbox = (checkboxContainer, params)=>{
        const checkbox = getInput$1(getPopup(), 'checkbox');
        checkbox.value = '1';
        checkbox.checked = Boolean(params.inputValue);
        const label = checkboxContainer.querySelector('span');
        setInnerHtml(label, params.inputPlaceholder || params.inputLabel);
        return checkbox;
    };
    /**
   * @param {HTMLTextAreaElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {HTMLTextAreaElement}
   */ renderInputType.textarea = (textarea, params)=>{
        checkAndSetInputValue(textarea, params.inputValue);
        setInputPlaceholder(textarea, params);
        setInputLabel(textarea, textarea, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ const getMargin = (el)=>parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(()=>{
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ('MutationObserver' in window) {
                const initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
                const textareaResizeHandler = ()=>{
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textarea)) return;
                    const textareaWidth = textarea.offsetWidth + getMargin(textarea);
                    if (textareaWidth > initialPopupWidth) getPopup().style.width = `${textareaWidth}px`;
                    else applyNumericalStyle(getPopup(), 'width', params.width);
                };
                new MutationObserver(textareaResizeHandler).observe(textarea, {
                    attributes: true,
                    attributeFilter: [
                        'style'
                    ]
                });
            }
        });
        return textarea;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContent = (instance, params)=>{
        const htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        showWhenInnerHtmlPresent(htmlContainer);
        applyCustomClass(htmlContainer, params, 'htmlContainer');
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, 'block');
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, 'block');
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderFooter = (instance, params)=>{
        const footer = getFooter();
        if (!footer) return;
        showWhenInnerHtmlPresent(footer);
        toggle(footer, params.footer, 'block');
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, 'footer');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderIcon = (instance, params)=>{
        const innerParams = privateProps.innerParams.get(instance);
        const icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
        // Re-adjust the success icon on system theme change
        const colorSchemeQueryList = window.matchMedia('(prefers-color-scheme: dark)');
        colorSchemeQueryList.addEventListener('change', adjustSuccessIconBackgroundColor);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const applyStyles = (icon, params)=>{
        for (const [iconType, iconClassName] of Object.entries(iconTypes))if (params.icon !== iconType) removeClass(icon, iconClassName);
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, 'icon');
    };
    // Adjust success icon background color to match the popup background color
    const adjustSuccessIconBackgroundColor = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
        /** @type {NodeListOf<HTMLElement>} */ const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
        for(let i = 0; i < successIconParts.length; i++)successIconParts[i].style.backgroundColor = popupBackgroundColor;
    };
    const successIconHtml = `
  <div class="swal2-success-circular-line-left"></div>
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>
  <div class="swal2-success-circular-line-right"></div>
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setContent = (icon, params)=>{
        if (!params.icon && !params.iconHtml) return;
        let oldContent = icon.innerHTML;
        let newContent = '';
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === 'success') {
            newContent = successIconHtml;
            oldContent = oldContent.replace(/ style=".*?"/g, ''); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === 'error') newContent = errorIconHtml;
        else if (params.icon) {
            const defaultIconHtml = {
                question: '?',
                warning: '!',
                info: 'i'
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setColor = (icon, params)=>{
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for (const sel of [
            '.swal2-success-line-tip',
            '.swal2-success-line-long',
            '.swal2-x-mark-line-left',
            '.swal2-x-mark-line-right'
        ])setStyle(icon, sel, 'background-color', params.iconColor);
        setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ const iconContent = (content)=>`<div class="${swalClasses['icon-content']}">${content}</div>`;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderImage = (instance, params)=>{
        const image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, '');
        // Src, alt
        image.setAttribute('src', params.imageUrl);
        image.setAttribute('alt', params.imageAlt || '');
        // Width, height
        applyNumericalStyle(image, 'width', params.imageWidth);
        applyNumericalStyle(image, 'height', params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, 'image');
    };
    let dragging = false;
    let mousedownX = 0;
    let mousedownY = 0;
    let initialX = 0;
    let initialY = 0;
    /**
   * @param {HTMLElement} popup
   */ const addDraggableListeners = (popup)=>{
        popup.addEventListener('mousedown', down);
        document.body.addEventListener('mousemove', move);
        popup.addEventListener('mouseup', up);
        popup.addEventListener('touchstart', down);
        document.body.addEventListener('touchmove', move);
        popup.addEventListener('touchend', up);
    };
    /**
   * @param {HTMLElement} popup
   */ const removeDraggableListeners = (popup)=>{
        popup.removeEventListener('mousedown', down);
        document.body.removeEventListener('mousemove', move);
        popup.removeEventListener('mouseup', up);
        popup.removeEventListener('touchstart', down);
        document.body.removeEventListener('touchmove', move);
        popup.removeEventListener('touchend', up);
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const down = (event)=>{
        const popup = getPopup();
        if (event.target === popup || getIcon().contains(/** @type {HTMLElement} */ event.target)) {
            dragging = true;
            const clientXY = getClientXY(event);
            mousedownX = clientXY.clientX;
            mousedownY = clientXY.clientY;
            initialX = parseInt(popup.style.insetInlineStart) || 0;
            initialY = parseInt(popup.style.insetBlockStart) || 0;
            addClass(popup, 'swal2-dragging');
        }
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const move = (event)=>{
        const popup = getPopup();
        if (dragging) {
            let { clientX: clientX, clientY: clientY } = getClientXY(event);
            popup.style.insetInlineStart = `${initialX + (clientX - mousedownX)}px`;
            popup.style.insetBlockStart = `${initialY + (clientY - mousedownY)}px`;
        }
    };
    const up = ()=>{
        const popup = getPopup();
        dragging = false;
        removeClass(popup, 'swal2-dragging');
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   * @returns {{ clientX: number, clientY: number }}
   */ const getClientXY = (event)=>{
        let clientX = 0, clientY = 0;
        if (event.type.startsWith('mouse')) {
            clientX = /** @type {MouseEvent} */ event.clientX;
            clientY = /** @type {MouseEvent} */ event.clientY;
        } else if (event.type.startsWith('touch')) {
            clientX = /** @type {TouchEvent} */ event.touches[0].clientX;
            clientY = /** @type {TouchEvent} */ event.touches[0].clientY;
        }
        return {
            clientX: clientX,
            clientY: clientY
        };
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderPopup = (instance, params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, 'width', params.width);
            popup.style.width = '100%';
            const loader = getLoader();
            if (loader) popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, 'width', params.width);
        // Padding
        applyNumericalStyle(popup, 'padding', params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
        if (params.draggable && !params.toast) {
            addClass(popup, swalClasses.draggable);
            addDraggableListeners(popup);
        } else {
            removeClass(popup, swalClasses.draggable);
            removeDraggableListeners(popup);
        }
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses$1 = (popup, params)=>{
        const showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses['toast-shown']);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, 'popup');
        // TODO: remove in the next major
        if (typeof params.customClass === 'string') addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses[`icon-${params.icon}`]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderProgressSteps = (instance, params)=>{
        const progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        const { progressSteps: progressSteps, currentProgressStep: currentProgressStep } = params;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = '';
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach((step, index)=>{
            const stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses['active-progress-step']);
            if (index !== progressSteps.length - 1) {
                const lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ const createStepElement = (step)=>{
        const stepEl = document.createElement('li');
        addClass(stepEl, swalClasses['progress-step']);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ const createLineElement = (params)=>{
        const lineEl = document.createElement('li');
        addClass(lineEl, swalClasses['progress-step-line']);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderTitle = (instance, params)=>{
        const title = getTitle();
        if (!title) return;
        showWhenInnerHtmlPresent(title);
        toggle(title, params.title || params.titleText, 'block');
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, 'title');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const render = (instance, params)=>{
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        const popup = getPopup();
        if (typeof params.didRender === 'function' && popup) params.didRender(popup);
        globalState.eventEmitter.emit('didRender', popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ const isVisible = ()=>{
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ const clickConfirm = ()=>{
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ const clickDeny = ()=>{
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ const clickCancel = ()=>{
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @typedef {'cancel' | 'backdrop' | 'close' | 'esc' | 'timer'} DismissReason */ /** @type {Record<DismissReason, DismissReason>} */ const DismissReason = Object.freeze({
        cancel: 'cancel',
        backdrop: 'backdrop',
        close: 'close',
        esc: 'esc',
        timer: 'timer'
    });
    /**
   * @param {GlobalState} globalState
   */ const removeKeydownHandler = (globalState)=>{
        if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
            globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {*} dismissWith
   */ const addKeydownHandler = (globalState, innerParams, dismissWith)=>{
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            globalState.keydownHandler = (e)=>keydownHandler(innerParams, e, dismissWith);
            globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
            globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
            globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = true;
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   */ const setFocus = (index, increment)=>{
        var _dom$getPopup;
        const focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // shift + tab when .swal2-popup is focused
            if (index === -2) index = focusableElements.length - 1;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            return;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    const arrowKeysNextButton = [
        'ArrowRight',
        'ArrowDown'
    ];
    const arrowKeysPreviousButton = [
        'ArrowLeft',
        'ArrowUp'
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {Function} dismissWith
   */ const keydownHandler = (innerParams, event, dismissWith)=>{
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === 'Enter') handleEnter(event, innerParams);
        else if (event.key === 'Tab') handleTab(event);
        else if ([
            ...arrowKeysNextButton,
            ...arrowKeysPreviousButton
        ].includes(event.key)) handleArrows(event.key);
        else if (event.key === 'Escape') handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ const handleEnter = (event, innerParams)=>{
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        const input = getInput$1(getPopup(), innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                'textarea',
                'file'
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ const handleTab = (event)=>{
        const targetElement = event.target;
        const focusableElements = getFocusableElements();
        let btnIndex = -1;
        for(let i = 0; i < focusableElements.length; i++)if (targetElement === focusableElements[i]) {
            btnIndex = i;
            break;
        }
        // Cycle to the next button
        if (!event.shiftKey) setFocus(btnIndex, 1);
        else setFocus(btnIndex, -1);
        event.stopPropagation();
        event.preventDefault();
    };
    /**
   * @param {string} key
   */ const handleArrows = (key)=>{
        const actions = getActions();
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ const buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
        let buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(let i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const handleEsc = (event, innerParams, dismissWith)=>{
        if (callIfFunction(innerParams.allowEscapeKey)) {
            event.preventDefault();
            dismissWith(DismissReason.esc);
        }
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    const setAriaHidden = ()=>{
        const container = getContainer();
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.contains(container)) return;
            if (el.hasAttribute('aria-hidden')) el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
            el.setAttribute('aria-hidden', 'true');
        });
    };
    const unsetAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.hasAttribute('data-previous-aria-hidden')) {
                el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
                el.removeAttribute('data-previous-aria-hidden');
            } else el.removeAttribute('aria-hidden');
        });
    };
    // @ts-ignore
    const isSafariOrIOS = typeof window !== 'undefined' && !!window.GestureEvent; // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ const iOSfix = ()=>{
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            const offset = document.body.scrollTop;
            document.body.style.top = `${offset * -1}px`;
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ const lockBodyScroll = ()=>{
        const container = getContainer();
        if (!container) return;
        /** @type {boolean} */ let preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = (event)=>{
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = (event)=>{
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const shouldPreventTouchMove = (event)=>{
        const target = event.target;
        const container = getContainer();
        const htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== 'INPUT' && // #1603
        target.tagName !== 'TEXTAREA' && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {*} event
   * @returns {boolean}
   */ const isStylus = (event)=>{
        return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isZoom = (event)=>{
        return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = ()=>{
        if (hasClass(document.body, swalClasses.iosfix)) {
            const offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = '';
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ const measureScrollbar = ()=>{
        const scrollDiv = document.createElement('div');
        scrollDiv.className = swalClasses['scrollbar-measure'];
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ let previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ const replaceScrollbarWithPadding = (initialBodyOverflow)=>{
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll' // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
            document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
        }
    };
    const undoReplaceScrollbarWithPadding = ()=>{
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = `${previousBodyPadding}px`;
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(()=>triggerDidCloseAndDispose(instance, didClose));
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute('style', 'display:none !important');
            container.removeAttribute('class');
            container.innerHTML = '';
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses['height-auto'],
            swalClasses['no-backdrop'],
            swalClasses['toast-shown']
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {any} resolveValue
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        const didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    const triggerClosePopup = (instance)=>{
        const popup = getPopup();
        if (!popup) return false;
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        const backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {any} error
   */ function rejectPromise(error) {
        const rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ const handleAwaitingPromise = (instance)=>{
        if (instance.isAwaitingPromise) {
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {any} resolveValue
   * @returns {SweetAlertResult}
   */ const prepareResolveValue = (resolveValue)=>{
        // When user calls Swal.close()
        if (typeof resolveValue === 'undefined') return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ const handlePopupAnimation = (instance, popup, innerParams)=>{
        var _globalState$eventEmi;
        const container = getContainer();
        // If animation is supported, animate
        const animationIsSupported = hasCssAnimation(popup);
        if (typeof innerParams.willClose === 'function') innerParams.willClose(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willClose', popup);
        if (animationIsSupported) animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
        else // Otherwise, remove immediately
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ const animatePopup = (instance, popup, container, returnFocus, didClose)=>{
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        /**
     * @param {AnimationEvent | TransitionEvent} e
     */ const swalCloseAnimationFinished = function(e) {
            if (e.target === popup) {
                var _globalState$swalClos;
                (_globalState$swalClos = globalState.swalCloseEventFinishedCallback) === null || _globalState$swalClos === void 0 || _globalState$swalClos.call(globalState);
                delete globalState.swalCloseEventFinishedCallback;
                popup.removeEventListener('animationend', swalCloseAnimationFinished);
                popup.removeEventListener('transitionend', swalCloseAnimationFinished);
            }
        };
        popup.addEventListener('animationend', swalCloseAnimationFinished);
        popup.addEventListener('transitionend', swalCloseAnimationFinished);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} didClose
   */ const triggerDidCloseAndDispose = (instance, didClose)=>{
        setTimeout(()=>{
            var _globalState$eventEmi2;
            if (typeof didClose === 'function') didClose.bind(instance.params)();
            (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didClose');
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const showLoading = (buttonToReplace)=>{
        let popup = getPopup();
        if (!popup) new Swal();
        popup = getPopup();
        if (!popup) return;
        const loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute('data-loading', 'true');
        popup.setAttribute('aria-busy', 'true');
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const replaceButton = (popup, buttonToReplace)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute('data-button-to-replace', buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptionsAndValue = (instance, params)=>{
        if (params.input === 'select' || params.input === 'radio') handleInputOptions(instance, params);
        else if ([
            'text',
            'email',
            'number',
            'tel',
            'textarea'
        ].some((i)=>i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ const getInputValue = (instance, innerParams)=>{
        const input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case 'checkbox':
                return getCheckboxValue(input);
            case 'radio':
                return getRadioValue(input);
            case 'file':
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ const getCheckboxValue = (input)=>input.checked ? 1 : 0;
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ const getRadioValue = (input)=>input.checked ? input.value : null;
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ const getFileValue = (input)=>input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptions = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        /**
     * @param {Record<string, any>} inputOptions
     */ const processInputOptions = (inputOptions)=>{
            if (params.input === 'select') populateSelectOptions(popup, formatInputOptions(inputOptions), params);
            else if (params.input === 'radio') populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then((inputOptions)=>{
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (typeof params.inputOptions === 'object') processInputOptions(params.inputOptions);
        else error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputValue = (instance, params)=>{
        const input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then((inputValue)=>{
            input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
            show(input);
            input.focus();
            instance.hideLoading();
        }).catch((err)=>{
            error(`Error in inputValue promise: ${err}`);
            input.value = '';
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        const select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ const renderOption = (parent, optionLabel, optionValue)=>{
            const option = document.createElement('option');
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach((inputOption)=>{
            const optionValue = inputOption[0];
            const optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                const optgroup = document.createElement('optgroup');
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach((o)=>renderOption(optgroup, o[1], o[0]));
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        const radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach((inputOption)=>{
            const radioValue = inputOption[0];
            const radioLabel = inputOption[1];
            const radioInput = document.createElement('input');
            const radioLabelElement = document.createElement('label');
            radioInput.type = 'radio';
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            const label = document.createElement('span');
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        const radios = radio.querySelectorAll('input');
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {Record<string, any>} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ const formatInputOptions = (inputOptions)=>{
        /** @type {InputOptionFlattened[]} */ const result = [];
        if (inputOptions instanceof Map) inputOptions.forEach((value, key)=>{
            let valueFormatted = value;
            if (typeof valueFormatted === 'object') // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        else Object.keys(inputOptions).forEach((key)=>{
            let valueFormatted = inputOptions[key];
            if (typeof valueFormatted === 'object') // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        return result;
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ const isSelected = (optionValue, inputValue)=>{
        return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    /**
   * @param {SweetAlert} instance
   */ const handleConfirmButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, 'confirm');
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ const handleDenyButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, 'deny');
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} dismissWith
   */ const handleCancelButtonClick = (instance, dismissWith)=>{
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ const handleConfirmOrDenyWithInput = (instance, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
            return;
        }
        const input = instance.getInput();
        const inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
        } else if (type === 'deny') deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ const handleInputValidator = (instance, inputValue, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        const validationPromise = Promise.resolve().then(()=>asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
        validationPromise.then((validationMessage)=>{
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === 'deny') deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const deny = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            const preDenyPromise = Promise.resolve().then(()=>asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
            preDenyPromise.then((preDenyValue)=>{
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close({
                    isDenied: true,
                    value: typeof preDenyValue === 'undefined' ? value : preDenyValue
                });
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else instance.close({
            isDenied: true,
            value: value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const succeedWith = (instance, value)=>{
        instance.close({
            isConfirmed: true,
            value: value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ const rejectWith = (instance, error)=>{
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {any} value
   */ const confirm = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            const preConfirmPromise = Promise.resolve().then(()=>asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
            preConfirmPromise.then((preConfirmValue)=>{
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */ function hideLoading() {
        // do nothing if popup is closed
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        const domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute('aria-busy');
        domCache.popup.removeAttribute('data-loading');
        domCache.confirmButton.disabled = false;
        domCache.denyButton.disabled = false;
        domCache.cancelButton.disabled = false;
    }
    const showRelatedButton = (domCache)=>{
        const buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
        if (buttonToReplace.length) show(buttonToReplace[0], 'inline-block');
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   */ function getInput() {
        const innerParams = privateProps.innerParams.get(this);
        const domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        const domCache = privateProps.domCache.get(instance);
        buttons.forEach((button)=>{
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        const popup = getPopup();
        if (!popup || !input) return;
        if (input.type === 'radio') {
            /** @type {NodeListOf<HTMLInputElement>} */ const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
            for(let i = 0; i < radios.length; i++)radios[i].disabled = disabled;
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], false);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        const domCache = privateProps.domCache.get(this);
        const params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses['validation-message'];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', swalClasses['validation-message']);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        const domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
            removeClass(input, swalClasses.inputerror);
        }
    }
    const defaultParams = {
        title: '',
        titleText: '',
        text: '',
        html: '',
        footer: '',
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        draggable: false,
        animation: true,
        theme: 'light',
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
            icon: 'swal2-icon-show'
        },
        hideClass: {
            popup: 'swal2-hide',
            backdrop: 'swal2-backdrop-hide',
            icon: 'swal2-icon-hide'
        },
        customClass: {},
        target: 'body',
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: '',
        confirmButtonColor: undefined,
        denyButtonText: 'No',
        denyButtonAriaLabel: '',
        denyButtonColor: undefined,
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: '',
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: '&times;',
        closeButtonAriaLabel: 'Close this dialog',
        loaderHtml: '',
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: '',
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: '',
        inputLabel: '',
        inputValue: '',
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: 'center',
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true
    };
    const updatableParams = [
        'allowEscapeKey',
        'allowOutsideClick',
        'background',
        'buttonsStyling',
        'cancelButtonAriaLabel',
        'cancelButtonColor',
        'cancelButtonText',
        'closeButtonAriaLabel',
        'closeButtonHtml',
        'color',
        'confirmButtonAriaLabel',
        'confirmButtonColor',
        'confirmButtonText',
        'currentProgressStep',
        'customClass',
        'denyButtonAriaLabel',
        'denyButtonColor',
        'denyButtonText',
        'didClose',
        'didDestroy',
        'draggable',
        'footer',
        'hideClass',
        'html',
        'icon',
        'iconColor',
        'iconHtml',
        'imageAlt',
        'imageHeight',
        'imageUrl',
        'imageWidth',
        'preConfirm',
        'preDeny',
        'progressSteps',
        'returnFocus',
        'reverseButtons',
        'showCancelButton',
        'showCloseButton',
        'showConfirmButton',
        'showDenyButton',
        'text',
        'title',
        'titleText',
        'theme',
        'willClose'
    ];
    /** @type {Record<string, string | undefined>} */ const deprecatedParams = {
        allowEnterKey: undefined
    };
    const toastIncompatibleParams = [
        'allowOutsideClick',
        'allowEnterKey',
        'backdrop',
        'draggable',
        'focusConfirm',
        'focusDeny',
        'focusCancel',
        'returnFocus',
        'heightAuto',
        'keydownListenerCapture'
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isValidParameter = (paramName)=>{
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isUpdatableParameter = (paramName)=>{
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ const isDeprecatedParameter = (paramName)=>{
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ const checkIfParamIsValid = (param)=>{
        if (!isValidParameter(param)) warn(`Unknown parameter "${param}"`);
    };
    /**
   * @param {string} param
   */ const checkIfToastParamIsValid = (param)=>{
        if (toastIncompatibleParams.includes(param)) warn(`The parameter "${param}" is incompatible with toasts`);
    };
    /**
   * @param {string} param
   */ const checkIfParamIsDeprecated = (param)=>{
        const isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ const showWarningsForParams = (params)=>{
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        if (params.theme && ![
            'light',
            'dark',
            'auto',
            'borderless',
            'embed-iframe'
        ].includes(params.theme)) warn(`Invalid theme "${params.theme}". Expected "light", "dark", "auto", "borderless", or "embed-iframe"`);
        for(const param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @param {SweetAlertOptions} params
   */ function update(params) {
        const container = getContainer();
        const popup = getPopup();
        const innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
            return;
        }
        const validUpdatableParams = filterValidParams(params);
        const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        showWarningsForParams(updatedParams);
        container.dataset['swal2Theme'] = updatedParams.theme;
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const filterValidParams = (params)=>{
        const validUpdatableParams = {};
        Object.keys(params).forEach((param)=>{
            if (isUpdatableParameter(param)) validUpdatableParams[param] = params[param];
            else warn(`Invalid parameter to update: ${param}`);
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   */ function _destroy() {
        const domCache = privateProps.domCache.get(this);
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === 'function') innerParams.didDestroy();
        globalState.eventEmitter.emit('didDestroy');
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ const disposeSwal = (instance)=>{
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ const disposeWeakMaps = (instance)=>{
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            delete instance.isAwaitingPromise;
            // Unset instance methods
            delete instance.disableButtons;
            delete instance.enableButtons;
            delete instance.getInput;
            delete instance.disableInput;
            delete instance.enableInput;
            delete instance.hideLoading;
            delete instance.disableLoading;
            delete instance.showValidationMessage;
            delete instance.resetValidationMessage;
            delete instance.close;
            delete instance.closePopup;
            delete instance.closeModal;
            delete instance.closeToast;
            delete instance.rejectPromise;
            delete instance.update;
            delete instance._destroy;
        }
    };
    /**
   * @param {object} obj
   * @param {SweetAlert} instance
   */ const unsetWeakMaps = (obj, instance)=>{
        for(const i in obj)obj[i].delete(instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handlePopupClick = (innerParams, domCache, dismissWith)=>{
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleToastClick = (innerParams, domCache, dismissWith)=>{
        // Closing toast by internal click
        domCache.popup.onclick = ()=>{
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const isAnyButtonShown = (innerParams)=>{
        return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ const handleModalMousedown = (domCache)=>{
        domCache.popup.onmousedown = ()=>{
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = ()=>{};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ const handleContainerMousedown = (domCache)=>{
        domCache.container.onmousedown = (e)=>{
            // prevent the modal text from being selected on double click on the container (allowOutsideClick: false)
            if (e.target === domCache.container) e.preventDefault();
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = ()=>{};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleModalClick = (innerParams, domCache, dismissWith)=>{
        domCache.container.onclick = (e)=>{
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    const isJqueryElement = (elem)=>typeof elem === 'object' && elem.jquery;
    const isElement = (elem)=>elem instanceof Element || isJqueryElement(elem);
    const argsToParams = (args)=>{
        const params = {};
        if (typeof args[0] === 'object' && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            'title',
            'html',
            'icon'
        ].forEach((name, index)=>{
            const arg = args[index];
            if (typeof arg === 'string' || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
        });
        return params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return new this(...args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   */ function mixin(mixinParams) {
        class MixinSwal extends this {
            _main(params, priorityMixinParams) {
                return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
            }
        }
        // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ const getTimerLeft = ()=>{
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const stopTimer = ()=>{
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const resumeTimer = ()=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const toggleTimer = ()=>{
        const timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ const increaseTimer = (ms)=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ const isTimerRunning = ()=>{
        return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    const clickHandlers = {};
    /**
   * @param {string} attr
   */ function bindClickHandler() {
        let attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener('click', bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    const bodyClickListener = (event)=>{
        for(let el = event.target; el && el !== document; el = el.parentNode)for(const attr in clickHandlers){
            const template = el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template: template
                });
                return;
            }
        }
    };
    // Source: https://gist.github.com/mudge/5830382?permalink_comment_id=2691957#gistcomment-2691957
    class EventEmitter {
        constructor(){
            /** @type {Events} */ this.events = {};
        }
        /**
     * @param {string} eventName
     * @returns {EventHandlers}
     */ _getHandlersByEventName(eventName) {
            if (typeof this.events[eventName] === 'undefined') // not Set because we need to keep the FIFO order
            // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1748990334
            this.events[eventName] = [];
            return this.events[eventName];
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ on(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            if (!currentHandlers.includes(eventHandler)) currentHandlers.push(eventHandler);
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ once(eventName, eventHandler) {
            var _this = this;
            /**
       * @param {Array} args
       */ const onceFn = function() {
                _this.removeListener(eventName, onceFn);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                eventHandler.apply(_this, args);
            };
            this.on(eventName, onceFn);
        }
        /**
     * @param {string} eventName
     * @param {Array} args
     */ emit(eventName) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            this._getHandlersByEventName(eventName).forEach(/**
       * @param {EventHandler} eventHandler
       */ (eventHandler)=>{
                try {
                    eventHandler.apply(this, args);
                } catch (error) {
                    console.error(error);
                }
            });
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ removeListener(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            const index = currentHandlers.indexOf(eventHandler);
            if (index > -1) currentHandlers.splice(index, 1);
        }
        /**
     * @param {string} eventName
     */ removeAllListeners(eventName) {
            if (this.events[eventName] !== undefined) // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1749239222
            this.events[eventName].length = 0;
        }
        reset() {
            this.events = {};
        }
    }
    globalState.eventEmitter = new EventEmitter();
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const on = (eventName, eventHandler)=>{
        globalState.eventEmitter.on(eventName, eventHandler);
    };
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const once = (eventName, eventHandler)=>{
        globalState.eventEmitter.once(eventName, eventHandler);
    };
    /**
   * @param {string} [eventName]
   * @param {EventHandler} [eventHandler]
   */ const off = (eventName, eventHandler)=>{
        // Remove all handlers for all events
        if (!eventName) {
            globalState.eventEmitter.reset();
            return;
        }
        if (eventHandler) // Remove a specific handler
        globalState.eventEmitter.removeListener(eventName, eventHandler);
        else // Remove all handlers for a specific event
        globalState.eventEmitter.removeAllListeners(eventName);
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        off: off,
        on: on,
        once: once,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    class Timer {
        /**
     * @param {Function} callback
     * @param {number} delay
     */ constructor(callback, delay){
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ start() {
            if (!this.running) {
                this.running = true;
                this.started = new Date();
                this.id = setTimeout(this.callback, this.remaining);
            }
            return this.remaining;
        }
        /**
     * @returns {number}
     */ stop() {
            if (this.started && this.running) {
                this.running = false;
                clearTimeout(this.id);
                this.remaining -= new Date().getTime() - this.started.getTime();
            }
            return this.remaining;
        }
        /**
     * @param {number} n
     * @returns {number}
     */ increase(n) {
            const running = this.running;
            if (running) this.stop();
            this.remaining += n;
            if (running) this.start();
            return this.remaining;
        }
        /**
     * @returns {number}
     */ getTimerLeft() {
            if (this.running) {
                this.stop();
                this.start();
            }
            return this.remaining;
        }
        /**
     * @returns {boolean}
     */ isRunning() {
            return this.running;
        }
    }
    const swalStringParams = [
        'swal-title',
        'swal-html',
        'swal-footer'
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const getTemplateParams = (params)=>{
        const template = typeof params.template === 'string' ? /** @type {HTMLTemplateElement} */ document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ const templateContent = template.content;
        showWarningsForElements(templateContent);
        const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalParams = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
        swalParams.forEach((param)=>{
            showWarningsForAttributes(param, [
                'name',
                'value'
            ]);
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            if (typeof defaultParams[paramName] === 'boolean') result[paramName] = value !== 'false';
            else if (typeof defaultParams[paramName] === 'object') result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalFunctionParams = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
        swalFunctions.forEach((param)=>{
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            result[paramName] = new Function(`return ${value}`)();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalButtons = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
        swalButtons.forEach((button)=>{
            showWarningsForAttributes(button, [
                'type',
                'color',
                'aria-label'
            ]);
            const type = button.getAttribute('type');
            if (!type || ![
                'confirm',
                'cancel',
                'deny'
            ].includes(type)) return;
            result[`${type}ButtonText`] = button.innerHTML;
            result[`show${capitalizeFirstLetter(type)}Button`] = true;
            if (button.hasAttribute('color')) result[`${type}ButtonColor`] = button.getAttribute('color');
            if (button.hasAttribute('aria-label')) result[`${type}ButtonAriaLabel`] = button.getAttribute('aria-label');
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Pick<SweetAlertOptions, 'imageUrl' | 'imageWidth' | 'imageHeight' | 'imageAlt'>}
   */ const getSwalImage = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const image = templateContent.querySelector('swal-image');
        if (image) {
            showWarningsForAttributes(image, [
                'src',
                'width',
                'height',
                'alt'
            ]);
            if (image.hasAttribute('src')) result.imageUrl = image.getAttribute('src') || undefined;
            if (image.hasAttribute('width')) result.imageWidth = image.getAttribute('width') || undefined;
            if (image.hasAttribute('height')) result.imageHeight = image.getAttribute('height') || undefined;
            if (image.hasAttribute('alt')) result.imageAlt = image.getAttribute('alt') || undefined;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalIcon = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const icon = templateContent.querySelector('swal-icon');
        if (icon) {
            showWarningsForAttributes(icon, [
                'type',
                'color'
            ]);
            if (icon.hasAttribute('type')) result.icon = icon.getAttribute('type');
            if (icon.hasAttribute('color')) result.iconColor = icon.getAttribute('color');
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalInput = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement | null} */ const input = templateContent.querySelector('swal-input');
        if (input) {
            showWarningsForAttributes(input, [
                'type',
                'label',
                'placeholder',
                'value'
            ]);
            result.input = input.getAttribute('type') || 'text';
            if (input.hasAttribute('label')) result.inputLabel = input.getAttribute('label');
            if (input.hasAttribute('placeholder')) result.inputPlaceholder = input.getAttribute('placeholder');
            if (input.hasAttribute('value')) result.inputValue = input.getAttribute('value');
        }
        /** @type {HTMLElement[]} */ const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach((option)=>{
                showWarningsForAttributes(option, [
                    'value'
                ]);
                const optionValue = option.getAttribute('value');
                if (!optionValue) return;
                const optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {Record<string, any>}
   */ const getSwalStringParams = (templateContent, paramNames)=>{
        /** @type {Record<string, any>} */ const result = {};
        for(const i in paramNames){
            const paramName = paramNames[i];
            /** @type {HTMLElement | null} */ const tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ const showWarningsForElements = (templateContent)=>{
        const allowedElements = swalStringParams.concat([
            'swal-param',
            'swal-function-param',
            'swal-button',
            'swal-image',
            'swal-icon',
            'swal-input',
            'swal-input-option'
        ]);
        Array.from(templateContent.children).forEach((el)=>{
            const tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn(`Unrecognized element <${tagName}>`);
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ const showWarningsForAttributes = (el, allowedAttributes)=>{
        Array.from(el.attributes).forEach((attribute)=>{
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                `Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`,
                `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`
            ]);
        });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ const openPopup = (params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (typeof params.willOpen === 'function') params.willOpen(popup);
        globalState.eventEmitter.emit('willOpen', popup);
        const bodyStyles = window.getComputedStyle(document.body);
        const initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(()=>{
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
            setAriaHidden();
        }
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === 'function') setTimeout(()=>params.didOpen(popup));
        globalState.eventEmitter.emit('didOpen', popup);
        removeClass(container, swalClasses['no-transition']);
    };
    /**
   * @param {AnimationEvent} event
   */ const swalOpenAnimationFinished = (event)=>{
        const popup = getPopup();
        if (event.target !== popup) return;
        const container = getContainer();
        popup.removeEventListener('animationend', swalOpenAnimationFinished);
        popup.removeEventListener('transitionend', swalOpenAnimationFinished);
        container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ const setScrollingVisibility = (container, popup)=>{
        if (hasCssAnimation(popup)) {
            container.style.overflowY = 'hidden';
            popup.addEventListener('animationend', swalOpenAnimationFinished);
            popup.addEventListener('transitionend', swalOpenAnimationFinished);
        } else container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow)=>{
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== 'hidden') replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(()=>{
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses = (container, popup, params)=>{
        addClass(container, params.showClass.backdrop);
        if (params.animation) {
            // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
            popup.style.setProperty('opacity', '0', 'important');
            show(popup, 'grid');
            setTimeout(()=>{
                // Animate popup right after showing it
                addClass(popup, params.showClass.popup);
                // and remove the opacity workaround
                popup.style.removeProperty('opacity');
            }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        } else show(popup, 'grid');
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses['height-auto']);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: (string, validationMessage)=>{
            return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: (string, validationMessage)=>{
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === 'email') params.inputValidator = defaultInputValidators['email'];
        if (params.input === 'url') params.inputValidator = defaultInputValidators['url'];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = 'body';
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === 'string') params.title = params.title.split('\n').join('<br />');
        init(params);
    }
    /** @type {SweetAlert} */ let currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    class SweetAlert {
        /**
     * @param {...any} args
     * @this {SweetAlert}
     */ constructor(){
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, void 0);
            // Prevent run in Node env
            if (typeof window === 'undefined') return;
            currentInstance = this;
            // @ts-ignore
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
        }
        _main(userParams) {
            let mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            showWarningsForParams(Object.assign({}, mixinParams, userParams));
            if (globalState.currentInstance) {
                const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
                const { isAwaitingPromise: isAwaitingPromise } = globalState.currentInstance;
                globalState.currentInstance._destroy();
                if (!isAwaitingPromise) swalPromiseResolve({
                    isDismissed: true
                });
                if (isModal()) unsetAriaHidden();
            }
            globalState.currentInstance = currentInstance;
            const innerParams = prepareParams(userParams, mixinParams);
            setParameters(innerParams);
            Object.freeze(innerParams);
            // clear the previous timer
            if (globalState.timeout) {
                globalState.timeout.stop();
                delete globalState.timeout;
            }
            // clear the restore focus timeout
            clearTimeout(globalState.restoreFocusTimeout);
            const domCache = populateDomCache(currentInstance);
            render(currentInstance, innerParams);
            privateProps.innerParams.set(currentInstance, innerParams);
            return swalPromise(currentInstance, domCache, innerParams);
        }
        // `catch` cannot be the name of a module export, so we define our thenable methods here instead
        then(onFulfilled) {
            return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
        }
        finally(onFinally) {
            return _classPrivateFieldGet2(_promise, this).finally(onFinally);
        }
    }
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise}
   */ const swalPromise = (instance, domCache, innerParams)=>{
        return new Promise((resolve, reject)=>{
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ const dismissWith = (dismiss)=>{
                instance.close({
                    isDismissed: true,
                    dismiss: dismiss
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = ()=>{
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = ()=>{
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = ()=>{
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = ()=>{
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(()=>{
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ const prepareParams = (userParams, mixinParams)=>{
        const templateParams = getTemplateParams(userParams);
        const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        if (params.animation === false) {
            params.showClass = {
                backdrop: 'swal2-noanimation'
            };
            params.hideClass = {};
        }
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ const populateDomCache = (instance)=>{
        const domCache = {
            popup: getPopup(),
            container: getContainer(),
            actions: getActions(),
            confirmButton: getConfirmButton(),
            denyButton: getDenyButton(),
            cancelButton: getCancelButton(),
            loader: getLoader(),
            closeButton: getCloseButton(),
            validationMessage: getValidationMessage(),
            progressSteps: getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const setupTimer = (globalState, innerParams, dismissWith)=>{
        const timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(()=>{
                dismissWith('timer');
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
                setTimeout(()=>{
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(innerParams.timer);
                });
            }
        }
    };
    /**
   * Initialize focus in the popup:
   *
   * 1. If `toast` is `true`, don't steal focus from the document.
   * 2. Else if there is an [autofocus] element, focus it.
   * 3. Else if `focusConfirm` is `true` and confirm button is visible, focus it.
   * 4. Else if `focusDeny` is `true` and deny button is visible, focus it.
   * 5. Else if `focusCancel` is `true` and cancel button is visible, focus it.
   * 6. Else focus the first focusable element in a popup (if any).
   *
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ const initFocus = (domCache, innerParams)=>{
        if (innerParams.toast) return;
        // TODO: this is dumb, remove `allowEnterKey` param in the next major version
        if (!callIfFunction(innerParams.allowEnterKey)) {
            warnAboutDeprecation('allowEnterKey');
            blurActiveElement();
            return;
        }
        if (focusAutofocus(domCache)) return;
        if (focusButton(domCache, innerParams)) return;
        setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @returns {boolean}
   */ const focusAutofocus = (domCache)=>{
        const autofocusElements = Array.from(domCache.popup.querySelectorAll('[autofocus]'));
        for (const autofocusElement of autofocusElements)if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
            autofocusElement.focus();
            return true;
        }
        return false;
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const focusButton = (domCache, innerParams)=>{
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    const blurActiveElement = ()=>{
        if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
    };
    // Dear russian users visiting russian sites. Let's have fun.
    if (typeof window !== 'undefined' && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
        const now = new Date();
        const initiationDate = localStorage.getItem('swal-initiation');
        if (!initiationDate) localStorage.setItem('swal-initiation', `${now}`);
        else if ((now.getTime() - Date.parse(initiationDate)) / 86400000 > 3) setTimeout(()=>{
            document.body.style.pointerEvents = 'none';
            const ukrainianAnthem = document.createElement('audio');
            ukrainianAnthem.src = 'https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3';
            ukrainianAnthem.loop = true;
            document.body.appendChild(ukrainianAnthem);
            setTimeout(()=>{
                ukrainianAnthem.play().catch(()=>{
                // ignore
                });
            }, 2500);
        }, 500);
    }
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach((key)=>{
        /**
     * @param {...any} args
     * @returns {any | undefined}
     */ SweetAlert[key] = function() {
            if (currentInstance && currentInstance[key]) return currentInstance[key](...arguments);
            return null;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.19.1';
    const Swal = SweetAlert;
    // @ts-ignore
    Swal.default = Swal;
    return Swal;
});
if (typeof $7aea0e2d8c18a52e$exports !== 'undefined' && $7aea0e2d8c18a52e$exports.Sweetalert2) $7aea0e2d8c18a52e$exports.swal = $7aea0e2d8c18a52e$exports.sweetAlert = $7aea0e2d8c18a52e$exports.Swal = $7aea0e2d8c18a52e$exports.SweetAlert = $7aea0e2d8c18a52e$exports.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, ":root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-footer-border-color: #eee;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-background: transparent;--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.1s, box-shadow 0.1s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-confirm-button-background-color: #7066e0;--swal2-deny-button-background-color: #dc3741;--swal2-cancel-button-background-color: #6e7881}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border:0;border-radius:.25em;background:initial;background-color:var(--swal2-confirm-button-background-color);color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border:0;border-radius:.25em;background:initial;background-color:var(--swal2-deny-button-background-color);color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border:0;border-radius:.25em;background:initial;background-color:var(--swal2-cancel-button-background-color);color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-outline)}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);color:inherit;font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:var(--swal2-input-background);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:var(--swal2-background);box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}");


const $b6441ce4f4950cd1$export$7172c8e9d7696d9b = (0, (/*@__PURE__*/$parcel$interopDefault($7aea0e2d8c18a52e$exports))).mixin({
    customClass: {
        cancelButton: 'btn btn-danger mx-2',
        confirmButton: 'btn btn-success mx-2'
    },
    buttonsStyling: false,
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Confirm',
    showCancelButton: true,
    type: 'question'
});
const $b6441ce4f4950cd1$export$e8ef7fe519636aa2 = (0, (/*@__PURE__*/$parcel$interopDefault($7aea0e2d8c18a52e$exports))).mixin({
    customClass: {
        confirmButton: 'btn btn-success mx-2'
    },
    buttonsStyling: false,
    type: 'success'
});
const $b6441ce4f4950cd1$export$438b25931d46d7ec = (0, (/*@__PURE__*/$parcel$interopDefault($7aea0e2d8c18a52e$exports))).mixin({
    customClass: {
        confirmButton: 'btn btn-success mx-2'
    },
    buttonsStyling: false,
    type: 'error'
});
const $b6441ce4f4950cd1$export$2d0aa172fa76a9bf = (0, (/*@__PURE__*/$parcel$interopDefault($7aea0e2d8c18a52e$exports))).mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 15000
});
const $b6441ce4f4950cd1$export$d80014e59849ee30 = (0, (/*@__PURE__*/$parcel$interopDefault($7aea0e2d8c18a52e$exports))).mixin({
    animation: false,
    customClass: {
        actions: 'beta-banner__actions',
        confirmButton: 'btn btn-light mx-2',
        content: 'beta-banner__content',
        popup: 'beta-banner'
    },
    buttonsStyling: false,
    confirmButtonText: 'Dismiss',
    toast: true,
    position: 'top',
    timer: 15000
});
const $b6441ce4f4950cd1$export$633d761a4bd5a2cf = (0, (/*@__PURE__*/$parcel$interopDefault($7aea0e2d8c18a52e$exports))).mixin({
    animation: false,
    customClass: {
        confirmButton: 'btn btn-light mx-2'
    },
    buttonsStyling: false,
    confirmButtonText: 'Dismiss'
});


const $cce97f359217af33$export$2cdf1b96a9f86d16 = (text, ev)=>{
    ev.preventDefault();
    ev.stopPropagation();
    navigator.clipboard.writeText(text).then(()=>{
        (0, $b6441ce4f4950cd1$export$2d0aa172fa76a9bf).fire({
            icon: 'success',
            title: 'Copied to clipboard'
        });
    }, (err)=>{
        (0, $b6441ce4f4950cd1$export$2d0aa172fa76a9bf).fire({
            icon: 'error',
            title: `Failed to copy to clipboard: ${err}`
        });
    });
};



//
// evaluateSearch: evaluates the correctness of a search query. Returns a result ('ok', 'warn', 'fail') and
// a description message.
//

const $918429d3bafe7f46$export$cff099afb59fe050 = function(query, namespaceList) {
    if (!query) return [
        (0, $f376d40762308610$export$2e2bcd8739ae039).NO_CURIE,
        {}
    ];
    if (query.split(/\s+/).length > 1) return [
        (0, $f376d40762308610$export$2e2bcd8739ae039).NO_CURIE,
        {}
    ];
    const queryParts = $918429d3bafe7f46$export$c067719c5fdda563(query);
    // Case analysis for incorrect identifier strings:
    // 1. Empty prefix.
    if (!queryParts.prefix) return [
        (0, $f376d40762308610$export$2e2bcd8739ae039).NO_CURIE,
        queryParts
    ];
    // 2. Non-existant prefix.
    if (namespaceList.filter((namespace)=>namespace.prefix === queryParts.prefixEffectiveValue).length === 0) return [
        (0, $f376d40762308610$export$2e2bcd8739ae039).INVALID_PREFIX,
        queryParts
    ];
    // Below here, we are supposed to have a namespace.
    const currentNamespace = namespaceList.filter((namespace)=>namespace.prefix === queryParts.prefixEffectiveValue)[0];
    // 3. Empty local id.
    if (queryParts.id === '') {
        if (query.endsWith(':')) return [
            (0, $f376d40762308610$export$2e2bcd8739ae039).PREFIX_WITH_COLON,
            queryParts
        ];
        else return [
            (0, $f376d40762308610$export$2e2bcd8739ae039).PREFIX_ONLY,
            queryParts
        ];
    }
    // 4. Non-conforming local id.
    const regex = new RegExp(currentNamespace.lui_pattern);
    const matches = queryParts.idWithEmbeddedPrefix.match(regex) || queryParts.id.match(regex);
    if (!matches) return [
        (0, $f376d40762308610$export$2e2bcd8739ae039).INVALID_LOCAL_ID,
        queryParts
    ];
    // 99. All ok.
    return [
        (0, $f376d40762308610$export$2e2bcd8739ae039).VALID_CURIE,
        queryParts
    ];
};
const $918429d3bafe7f46$export$c067719c5fdda563 = function(query) {
    if (!query) return {};
    const [prefixSide, ...idSide] = query.split(':');
    const prefixParts = prefixSide.split('/');
    let resource = '';
    if (prefixParts.length > 1) resource = prefixParts.shift();
    const prefix = prefixParts.join('/');
    const prefixEffectiveValue = prefix.toLowerCase();
    const id = idSide ? idSide.join(':') : '';
    const idWithEmbeddedPrefix = `${prefix}:${id}`;
    return {
        prefix: prefix,
        prefixEffectiveValue: prefixEffectiveValue,
        id: id,
        idWithEmbeddedPrefix: idWithEmbeddedPrefix,
        resource: resource
    };
};
const $918429d3bafe7f46$export$c1150cf884ef4a31 = (resource, namespace, id)=>{
    const prefix = namespace.namespaceEmbeddedInLui ? namespace.pattern.slice(1).split(':')[0].replace(/[\(\/\\\)]/gm, '') : namespace.prefix;
    return `${resource ? resource + '/' : ''}${prefix}:${id}`;
};


var $d7f0115ca29a2eb5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7f0115ca29a2eb5$var$ReactIs, $d7f0115ca29a2eb5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$d7f0115ca29a2eb5$exports = (parcelRequire("lPcV8"))();


class $00936cea697217b2$var$SearchHelper extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        this.state = {
            evaluation: null,
            queryParts: null
        };
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !nextProps.loading;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { namespaceList: namespaceList, query: query, setSearchState: setSearchState } = this.props;
        const [evaluation, queryParts] = (0, $918429d3bafe7f46$export$cff099afb59fe050)(query, namespaceList);
        if (evaluation !== prevState.evaluation || query !== prevProps.query) {
            this.setState({
                evaluation: evaluation,
                queryParts: queryParts
            });
            setSearchState(evaluation);
        }
    }
    render() {
        const { namespaceList: namespaceList, query: query } = this.props;
        const { evaluation: evaluation, queryParts: queryParts } = this.state;
        if (!evaluation || !queryParts) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $8939768198127506$exports.Fragment), {});
        const idorgURI = evaluation === (0, $f376d40762308610$export$2e2bcd8739ae039).VALID_CURIE && queryParts?.id && queryParts?.prefix ? `${(0, $daaee31eed9617db$export$e506a1d27d1eaa20).resolverHardcodedUrl}/${queryParts.prefix}:${queryParts.id}` : null;
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    className: "row g-0 ms-3 me-2",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        className: "col d-flex align-items-center",
                        children: [
                            (()=>{
                                switch(evaluation){
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).VALID_CURIE:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-check-circle size-200 text-success me-2"
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).NO_CURIE:
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).QUERYING_NAMESPACES:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-info size-200 text-primary me-2"
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).PREFIX_ONLY:
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).PREFIX_WITH_COLON:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-exclamation-triangle size-200 text-warning me-2"
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).INVALID_PREFIX:
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).INVALID_LOCAL_ID:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-times-circle size-200 text-danger me-2"
                                        });
                                }
                            })(),
                            (()=>{
                                switch(evaluation){
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).VALID_CURIE:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                                            className: "text-block me-0",
                                            children: [
                                                "Your compact identifier appears to be valid. ",
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {}),
                                                " Make sure the URI takes you where you expect it to."
                                            ]
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).NO_CURIE:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                                            className: "text-block me-1 mt-2 mb-3",
                                            children: [
                                                "Please type a ",
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                                    target: "_blank",
                                                    href: "https://docs.identifiers.org/pages/identification_scheme.html",
                                                    children: "compact identifier"
                                                }),
                                                " in this box in the format ",
                                                '[prefix]:[id]',
                                                ". ",
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {}),
                                                "If you don't know which prefix to use for a data object:",
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                                            children: "Describe its repository or its data type, then try the suggested prefixes."
                                                        }),
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                                            children: "Avoid describing data objects. We don't index individual objects."
                                                        }),
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                                            children: "Short text works better."
                                                        }),
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                                            children: "Adding the ID of an object will sort results using the registry's ID patterns, aiming to show best matches first."
                                                        }),
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                                            children: "If you can't find a good prefix, request help via the feedback button above."
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).INVALID_PREFIX:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                                            className: "text-block me-0",
                                            children: [
                                                "Your compact identifier appears to be incorrect.",
                                                ' ',
                                                query.split(/\s+/).length === 1 && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
                                                    children: [
                                                        "The prefix",
                                                        ' ',
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                                            className: "fw-bold",
                                                            children: queryParts.prefixEffectiveValue
                                                        }),
                                                        ' ',
                                                        "does not exist in the registry.",
                                                        ' '
                                                    ]
                                                }),
                                                namespaceList.length > 0 && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $8939768198127506$exports.Fragment), {
                                                    children: "Try one of the suggestions above or try a different search."
                                                })
                                            ]
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).PREFIX_ONLY:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                            className: "text-block me-0",
                                            children: "You have a valid prefix, but your compact identifier is incomplete. Please add a colon and object ID."
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).PREFIX_WITH_COLON:
                                        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                            className: "text-block me-0",
                                            children: "You are just missing the object ID to finish the compact identifier."
                                        });
                                    case (0, $f376d40762308610$export$2e2bcd8739ae039).INVALID_LOCAL_ID:
                                        {
                                            const currentNamespace = namespaceList.filter((namespace)=>namespace.prefix === queryParts.prefixEffectiveValue)[0];
                                            return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                                                className: "text-block me-0",
                                                children: [
                                                    "Your compact identifier appears to be incorrect: The local id",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                                        className: "fw-bold",
                                                        children: queryParts.id
                                                    }),
                                                    ' ',
                                                    "does not match the pattern",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                                        className: "font-monospace",
                                                        children: currentNamespace ? currentNamespace.lui_pattern : ''
                                                    }),
                                                    "."
                                                ]
                                            });
                                        }
                                }
                            })()
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    className: "row g-0 ms-3 me-2",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        className: "col ms-5",
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("table", {
                                className: "table table-borderless",
                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("tbody", {
                                    children: [
                                        queryParts?.resource && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "w-25 p-0 fw-light font-italic text-muted",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: "Resource:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "p-0 text-block",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: queryParts.resource || 'default'
                                                    })
                                                })
                                            ]
                                        }),
                                        queryParts?.prefix && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "w-25 p-0 fw-light fst-italic text-muted",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: "Prefix:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "p-0 text-block",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: queryParts.prefix || 'empty'
                                                    })
                                                })
                                            ]
                                        }),
                                        queryParts?.id && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "w-25 p-0 fw-light font-italic text-muted",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: "Local id:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "p-0 text-block",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: queryParts.id || 'empty'
                                                    })
                                                })
                                            ]
                                        }),
                                        idorgURI && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "w-25 p-0 fw-light font-italic text-muted",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                                        children: "URI:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("td", {
                                                    className: "p-0 text-block",
                                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                                                href: idorgURI,
                                                                target: "_blank",
                                                                children: idorgURI
                                                            }),
                                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                                                                className: "text-muted ms-1",
                                                                title: "copy to clipboard",
                                                                onClick: (ev)=>this.copyToClipboard(idorgURI, ev),
                                                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-copy"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        });
    }
}
$00936cea697217b2$var$SearchHelper.propTypes = {
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).bool,
    setSearchState: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).func.isRequired,
    query: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).string.isRequired,
    namespaceList: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).array.isRequired
};
var $00936cea697217b2$export$2e2bcd8739ae039 = $00936cea697217b2$var$SearchHelper;


const $a3cbc33b37bba001$export$cbc7c17b7602658a = ()=>window.matchMedia('(max-width: 768px)').matches;
const $a3cbc33b37bba001$export$9265a4c0580e69f6 = ()=>window.matchMedia('(max-width: 1280px)').matches;





class $223437e755faf776$var$SearchSuggestions extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "componentDidUpdate", (prevProps)=>{
            if (prevProps.query !== this.props.query) {
                clearTimeout(this.updateDebounceRef.current);
                this.updateDebounceRef.current = setTimeout(()=>this.setState({
                        loading: true
                    }, this.updateNamespaces), 600);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "componentWillUnmount", ()=>{
            clearTimeout(this.updateDebounceRef.current);
            this.props.suggestionListRef.current = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "updateNamespaces", async ()=>{
            const { query: query } = this.props;
            if (!query) this.setState({
                loading: false
            });
            else {
                const { prefix: prefix } = (0, $918429d3bafe7f46$export$c067719c5fdda563)(query);
                const namespaces = (await this.queryEbiSearchForRelevantNamespaces())?.slice(0, (0, $daaee31eed9617db$export$e506a1d27d1eaa20).suggestionQuerySize) || [];
                this.setState({
                    namespaceList: namespaces,
                    selectedNamespace: namespaces.findIndex((ns)=>ns.prefix === prefix)
                }, ()=>this.setState({
                        loading: false
                    }));
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "queryEbiSearchForRelevantNamespaces", async ()=>{
            const { query: query } = this.props;
            const { ebiSearchDomainEndpoint: ebiSearchDomainEndpoint, ebiSearchResponseSize: ebiSearchResponseSize } = (0, $daaee31eed9617db$export$e506a1d27d1eaa20);
            const preprocessedQuery = this.preprocessQueryString(query);
            const params = new URLSearchParams({
                fields: 'name,prefix,lui_pattern,sample_id',
                size: ebiSearchResponseSize.toString(),
                query: preprocessedQuery,
                format: 'JSON',
                entryattrs: 'score'
            });
            return await fetch(ebiSearchDomainEndpoint + '?' + params).then((r)=>r.json()).then((json)=>json.entries?.map((e)=>{
                    return {
                        score: e.score,
                        ...e.fields
                    };
                }) || []).then((namespaces)=>namespaces.map((namespace)=>{
                    const newEntries = Object.entries(namespace).map(([attr, val])=>[
                            attr,
                            Array.isArray(val) ? val[0] : val
                        ]);
                    return Object.fromEntries(newEntries);
                })).then((namespaces)=>{
                this.updateScoreInPlaceByMatchingLuis(namespaces);
                return namespaces;
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "hasSelection", ()=>{
            // This is used by the parent component
            return this.state.selectedNamespace !== -1;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "clickSelection", async ()=>{
            // This is used by the parent component
            const { selectedNamespace: selectedNamespace, namespaceList: namespaceList } = this.state;
            if (selectedNamespace === -1) return;
            const prefix = namespaceList[selectedNamespace].prefix;
            document.getElementById(`suggestion-${prefix}`)?.click();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "upSelection", async (n = 1)=>{
            // This is used by the parent component
            const { selectedNamespace: selectedNamespace, namespaceList: namespaceList } = this.state;
            if (selectedNamespace === 0 || namespaceList.length === 0) return;
            let newPosition = -1;
            if (selectedNamespace === -1) {
                if (namespaceList.length !== 0) newPosition = 0;
            } else newPosition = Math.max(0, selectedNamespace - n);
            this.setState({
                selectedNamespace: newPosition
            }, ()=>{
                document.getElementById('suggestion-' + namespaceList[newPosition].prefix)?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "downSelection", async (n = 1)=>{
            // This is used by the parent component
            const { selectedNamespace: selectedNamespace, namespaceList: namespaceList } = this.state;
            if (selectedNamespace === namespaceList.length - 1 || namespaceList.length === 0) return;
            let newPosition = -1;
            if (selectedNamespace === -1) {
                if (namespaceList.length !== 0) newPosition = 0;
            } else newPosition = Math.min(namespaceList.length - 1, selectedNamespace + n);
            this.setState({
                selectedNamespace: newPosition
            }, ()=>{
                document.getElementById('suggestion-' + namespaceList[newPosition].prefix)?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "setSelectedNamespace", async (idx)=>{
            this.setState({
                selectedNamespace: idx
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleSuggestionClick", async (namespace)=>{
            const { query: query } = this.props;
            const splitQuery = query.replace('"', ' ').replace(':', ' ').split(/\s+/);
            const possibleId = this.getPossibleLocalIdFromQuery(splitQuery, namespace.lui_pattern) || '';
            const effectivePrefix = $223437e755faf776$var$getEffectivePrefix(namespace);
            this.props.setSuggestion(`${effectivePrefix || namespace.prefix}:${possibleId}`);
        });
        /**
     * Replaces colors to whitespace to prevent EBI search errors.
     * Then, splits the query by whitespace without splitting double-quoted sections,
     * then joins the sections with OR. This has better results when a query
     * includes a local ID.
     * @param query raw string query issued by user
     * @returns {string}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "preprocessQueryString", (query)=>{
            // First remove characters that may cause lucene syntax problems
            const luceneProblemChars = [
                '+',
                '-',
                '&',
                '|',
                '!',
                '(',
                ')',
                '{',
                '}',
                '[',
                ']',
                '^',
                '~',
                '*',
                '?',
                ':',
                '\\',
                '/'
            ];
            for (const char of luceneProblemChars)query = query.replaceAll(char, ' ');
            // Then split terms by whitespace or quotes
            const quoteSplitQuery = query.split('"');
            let terms;
            if (quoteSplitQuery.length < 3) // No quotes
            terms = query.split(/\s+/);
            else {
                // With quotes. Try to preserve quoted terms.
                terms = [];
                for(let idx in quoteSplitQuery){
                    let val = quoteSplitQuery[idx];
                    if (idx % 2 === 1) // quoted parts
                    terms.push('"' + val + '"');
                    else // unquoted parts
                    terms.push(...val.split(/\s+/));
                }
            }
            // On single search term without quotes, add a prefix search for auto-completion
            const peek = terms[0];
            if (terms.length === 1 && peek.length > 2 && !(peek.startsWith("\"") && peek.endsWith("\""))) terms.push(`prefix:${peek}*^3`);
            // Remove blanks and join terms with OR operator among search terms
            //  The OR operator work since an identifier is likely to be a term of the search
            return terms.map((s)=>s?.trim()).filter(Boolean).join(" OR ");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "updateScoreInPlaceByMatchingLuis", (namespaces)=>{
            const { query: query } = this.props;
            if (!query || !(0, $daaee31eed9617db$export$e506a1d27d1eaa20).ebiSearchRescoreWhenSingleIdDetected) return;
            const splitQuery = query.replace('"', ' ').replace(':', ' ').split(/\s+/);
            const maxScore = Math.max(...namespaces.map((n)=>n.score));
            namespaces?.forEach((namespace)=>{
                const possibleId = this.getPossibleLocalIdFromQuery(splitQuery, namespace.lui_pattern);
                if (possibleId) // Increase score if one of the query elements may be an ID
                namespace.score += maxScore;
            });
            namespaces.sort((n1, n2)=>n2.score - n1.score);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleSuggestionLinkClick", (prefix)=>{
            window.open(`${(0, $daaee31eed9617db$export$e506a1d27d1eaa20).registryUrl}/registry/${prefix}`, '_blank');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "getPossibleLocalIdFromQuery", (splitQuery, lui_pattern)=>{
            if (splitQuery.length < 2) return null;
            const luiPattern = new RegExp(lui_pattern);
            const matches = splitQuery.filter((queryToken)=>luiPattern.test(queryToken));
            if (matches.length === 1) return matches.pop();
            else return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "render", ()=>{
            const { props: { query: query, setSearchState: setSearchState, closeSuggestions: closeSuggestions }, state: { namespaceList: namespaceList, selectedNamespace: selectedNamespace, loading: loading } } = this;
            // Resource name conditional tag.
            const ResourceNameTag = (0, $a3cbc33b37bba001$export$cbc7c17b7602658a)() ? 'small' : 'p';
            return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                id: "search-suggestions-container",
                className: "inline-search-container",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                        type: "button",
                        onClick: closeSuggestions,
                        className: "closeBttn",
                        title: "Close suggestion box",
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                            className: "icon icon-common icon-close"
                        })
                    }),
                    // Render search suggestion list if it contains elements.
                    namespaceList.length > 0 && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        className: "suggestions-box",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                className: "row mx-1",
                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                    className: "col align-self-end",
                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                                        className: "text-muted text-end me-4 my-0",
                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                            children: "Suggestions"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("ul", {
                                className: "suggestion-list pb-2",
                                children: [
                                    loading && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                        children: " Loading... "
                                    }),
                                    !loading && namespaceList.map((namespace, index)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                                            className: `suggestion ${selectedNamespace === index ? 'suggestion__selected' : ''}`,
                                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                                                className: "row g-0 py-1 mx-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                                        className: "col col-11",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "clear-link d-flex align-items-center",
                                                            id: 'suggestion-' + namespace.prefix,
                                                            onClick: ()=>this.handleSuggestionClick(namespace),
                                                            onMouseOver: ()=>{
                                                                this.setSelectedNamespace(index);
                                                            },
                                                            onFocus: ()=>{
                                                                this.setSelectedNamespace(index);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                                                    className: `badge ${selectedNamespace === index ? 'bg-secondary border border-dark' : 'bg-dark border border-secondary'} fw-normal`,
                                                                    children: $223437e755faf776$var$getEffectivePrefix(namespace) || namespace.prefix
                                                                }),
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)(ResourceNameTag, {
                                                                    className: `mb-0 ms-2 ${selectedNamespace === index ? 'text-white' : ''} text-ellipsis`,
                                                                    children: [
                                                                        namespace.name,
                                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                                                                            className: `${selectedNamespace === index ? 'text-white bg-gray' : 'text-muted bg-white'} small ms-1 ml-sm-2`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                                                                    className: "d-none d-sm-inline",
                                                                                    children: "sample:"
                                                                                }),
                                                                                " ",
                                                                                namespace.sample_id
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                                        className: "col col-1",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                                                            className: `ml-auto ${selectedNamespace === index ? 'text-white' : ''}`,
                                                            onClick: ()=>{
                                                                this.handleSuggestionLinkClick(namespace.prefix);
                                                            },
                                                            title: "See namespace page",
                                                            type: "button",
                                                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                className: "icon icon-common icon-external-link-alt ms-1"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }, 'li-suggestion-' + namespace.prefix))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        className: "hints-box",
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $00936cea697217b2$export$2e2bcd8739ae039), {
                            setSearchState: setSearchState,
                            query: query,
                            namespaceList: namespaceList,
                            loading: loading
                        })
                    })
                ]
            });
        });
        props.suggestionListRef.current = this;
        this.state = {
            namespaceList: [],
            selectedNamespace: -1,
            loading: false
        };
        this.updateDebounceRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).createRef();
        this.updateDebounceRef.current = setTimeout(()=>this.setState({
                loading: true
            }, this.updateNamespaces), 50);
    }
}
const $223437e755faf776$var$getEffectivePrefix = (namespace)=>{
    if (namespace) {
        const colonIdx = namespace.lui_pattern.indexOf(":");
        if (colonIdx > 1) {
            const startPositionPrefix = namespace.lui_pattern[0] === '^' ? 1 : 0;
            const embeddedPrefix = namespace.lui_pattern.slice(startPositionPrefix, namespace.lui_pattern.indexOf(":"));
            if (embeddedPrefix.toLowerCase() === namespace.prefix.toLowerCase()) return embeddedPrefix;
        }
        return namespace.prefix;
    }
    return undefined;
};
$223437e755faf776$var$SearchSuggestions.propTypes = {
    query: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).string.isRequired,
    suggestionListRef: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).any
    }).isRequired,
    setSuggestion: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).func.isRequired,
    setSearchState: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).func.isRequired,
    closeSuggestions: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).func.isRequired
};
var $223437e755faf776$export$2e2bcd8739ae039 = $223437e755faf776$var$SearchSuggestions;





class $6e6a2720a886a595$var$Search extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "exampleCuries", Object.freeze([
            'uniprot:P12345',
            'pdb:2gc4',
            'taxonomy:9606'
        ]));
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "setSearchState", (currentState)=>{
            const isNewStateValid = currentState === (0, $f376d40762308610$export$2e2bcd8739ae039).VALID_CURIE;
            if (this.state.isSearchValid !== isNewStateValid) this.setState({
                isSearchValid: isNewStateValid
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleFocusShowSuggestions", ()=>{
            this.setState({
                showSuggestions: true
            });
            // Also scroll down to take the suggestion bar to the top of screen in small screens.
            if ((0, $a3cbc33b37bba001$export$cbc7c17b7602658a)()) {
                const searchBarYOffset = this.search.current.getBoundingClientRect().top + window.pageYOffset - 130;
                window.scroll({
                    top: searchBarYOffset,
                    behavior: 'smooth'
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "closeSuggestions", ()=>{
            this.setState({
                showSuggestions: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleChange", ()=>{
            this.setState({
                query: this.search.current.value
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleKeyDown", (e)=>{
            switch(e.key){
                case 'Enter':
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.suggestionListRef.current?.hasSelection()) this.suggestionListRef.current?.clickSelection();
                    else if (this.state.isSearchValid) this.props.onButtonClick(this.state.query);
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    this.suggestionListRef.current?.upSelection();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    this.suggestionListRef.current?.downSelection();
                    break;
                case 'PageDown':
                    e.preventDefault();
                    e.stopPropagation();
                    this.suggestionListRef.current?.downSelection(5);
                    break;
                case 'PageUp':
                    e.preventDefault();
                    e.stopPropagation();
                    this.suggestionListRef.current?.upSelection(5);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleSuggestion", (suggestion)=>{
            this.setState({
                query: suggestion,
                showSuggestions: true
            }, ()=>this.search.current.focus());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleSubmit", (e)=>{
            e.preventDefault();
            this.handleButtonClick();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleButtonClick", ()=>{
            if (this.state.isSearchValid) this.props.onButtonClick(this.state.query);
            else this.search.current && this.search.current.focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleExampleClick", (e)=>{
            e.preventDefault();
            if (e.key && e.key !== 'Enter') return; // Check for Enter key keyboard event (For accessibility)
            this.search.current.value = e.target.innerText;
            this.handleChange();
            this.search.current.focus();
        });
        this.state = {
            isSearchValid: false,
            showSuggestions: false,
            query: ''
        };
        this.search = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).createRef();
        this.suggestionListRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).createRef();
    }
    render() {
        const { props: { buttonCaption: buttonCaption, placeholderCaption: placeholderCaption }, state: { query: query, showSuggestions: showSuggestions, isSearchValid: isSearchValid } } = this;
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("form", {
            onSubmit: this.handleSubmit,
            role: "search",
            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                        className: "form-text text-muted ms-1",
                        children: [
                            "Examples:",
                            ' ',
                            this.exampleCuries.map((example)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                    role: "suggestion",
                                    tabIndex: "0",
                                    onClick: this.handleExampleClick,
                                    onKeyDown: this.handleExampleClick,
                                    className: "text-primary text-decoration-none me-2",
                                    children: example
                                }, example))
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        className: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("input", {
                                role: "searchbox",
                                spellCheck: false,
                                className: "form-control search-input",
                                onChange: this.handleChange,
                                onKeyDown: this.handleKeyDown,
                                onFocus: this.handleFocusShowSuggestions,
                                placeholder: placeholderCaption,
                                ref: this.search,
                                value: query
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                                className: "btn btn-primary text-white search-button",
                                onFocus: this.handleFocusShowSuggestions,
                                onClick: this.handleButtonClick,
                                disabled: !isSearchValid,
                                title: isSearchValid ? undefined : "The compact identifier is not valid",
                                type: "submit",
                                children: buttonCaption
                            }),
                            (0, $daaee31eed9617db$export$e506a1d27d1eaa20).showSearchSuggestions && showSuggestions && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $223437e755faf776$export$2e2bcd8739ae039), {
                                setSearchState: this.setSearchState,
                                closeSuggestions: this.closeSuggestions,
                                setSuggestion: this.handleSuggestion,
                                suggestionListRef: this.suggestionListRef,
                                query: query
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        className: "text-muted text-sm ms-1 text-decoration-none",
                        href: "https://www.ebi.ac.uk/ebisearch",
                        target: "_blank",
                        children: "powered by EBI Search"
                    })
                ]
            })
        });
    }
}
$6e6a2720a886a595$var$Search.propTypes = {
    onButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).func.isRequired,
    buttonCaption: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).string
    ]).isRequired,
    placeholderCaption: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).string.isRequired
};
var $6e6a2720a886a595$export$2e2bcd8739ae039 = (props)=>{
    const navigate = (0, $f500c00b0505d3a1$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($6e6a2720a886a595$var$Search, {
        ...props,
        navigate: navigate
    });
};




var $6kl77 = parcelRequire("6kl77");

//// Change these variables to have static content on the notice component   ////////////////////////////
const $092d716a99f094b5$var$showStaticNotice = false;
const $092d716a99f094b5$var$StaticNoticeTitle = "We need your help!";
const $092d716a99f094b5$var$StaticNoticeBody = ()=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("p", {
        className: "mb-0 text-justify text-muted",
        children: [
            "Has identifiers.org saved you time or effort? Please take 15 minutes to fill in a survey and help EMBL-EBI make the case for why open data resources are critical to life science research.",
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                href: "https://http.cat/status/200",
                children: " Click here to fill in the survey "
            })
        ]
    });
///////////////////////////////////////////////////////////////////////
const $092d716a99f094b5$var$getLatestUpdateInfo = async ()=>await fetch("https://docs.identifiers.org/updates/latest.json").then((res)=>res.ok ? res.json() : {}, (reason)=>{
        console.error(reason);
        return {};
    });
const $092d716a99f094b5$var$ignoreIfOldUpdate = (latestUpdateJson)=>{
    if (!latestUpdateJson.title) return {};
    const { daysPeriodToShowLatestUpdatePost: daysPeriodToShowLatestUpdatePost } = (0, $daaee31eed9617db$export$e506a1d27d1eaa20);
    const updateDate = new Date(latestUpdateJson.date);
    const today = new Date();
    const diffTime = Math.abs(today - updateDate);
    const diffDays = Math.floor(diffTime / 86400000);
    return diffDays < daysPeriodToShowLatestUpdatePost ? latestUpdateJson : {};
};
const $092d716a99f094b5$var$LatestUpdateBody = ({ latestUpdate: latestUpdate })=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                children: latestUpdate.description
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                className: "d-block",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        href: latestUpdate.url,
                        target: "_blank",
                        children: "More info"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                        className: "px-2",
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        href: "https://docs.identifiers.org/pages/updates.html",
                        target: "_blank",
                        children: "Other news"
                    })
                ]
            })
        ]
    });
const $092d716a99f094b5$var$Notice = /*#__PURE__*/ (0, $6kl77.memo)(()=>{
    const [latestUpdate, setLatestUpdate] = (0, $6kl77.useState)({});
    (0, $6kl77.useEffect)(()=>{
        if (!$092d716a99f094b5$var$showStaticNotice) $092d716a99f094b5$var$getLatestUpdateInfo().then($092d716a99f094b5$var$ignoreIfOldUpdate).then(setLatestUpdate);
    }, [
        $092d716a99f094b5$var$showStaticNotice
    ]);
    if (!$092d716a99f094b5$var$showStaticNotice && !latestUpdate.title) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $8939768198127506$exports.Fragment), {});
    else return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        className: "alert alert-info border-0 mt-4 w-100 px-3 py-2",
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h5", {
                className: "text-info-emphasis",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-bullhorn me-2 fs-2 text-align-center"
                    }),
                    $092d716a99f094b5$var$showStaticNotice ? $092d716a99f094b5$var$StaticNoticeTitle : latestUpdate.title
                ]
            }),
            $092d716a99f094b5$var$showStaticNotice ? /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($092d716a99f094b5$var$StaticNoticeBody, {}) : /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($092d716a99f094b5$var$LatestUpdateBody, {
                latestUpdate: latestUpdate
            })
        ]
    });
});
var $092d716a99f094b5$export$2e2bcd8739ae039 = $092d716a99f094b5$var$Notice;




var $6kl77 = parcelRequire("6kl77");

var $6kl77 = parcelRequire("6kl77");
const $95a672726cdabda1$var$MatomoContext = (0, $6kl77.createContext)(null);
var $95a672726cdabda1$export$2e2bcd8739ae039 = $95a672726cdabda1$var$MatomoContext;



var $6kl77 = parcelRequire("6kl77");
const $2bddbc1d9c47a324$var$useOutboundClickListener = (matomoInstance)=>{
    const handleOutboundClick = (event)=>{
        // The target is not guaranteed to be a link, it could be a child element.
        // Look up the element's parent until the anchor element is found.
        const findLinkElement = (el)=>{
            if (el instanceof HTMLAnchorElement && el.href) return el;
            if (el instanceof HTMLElement && el.parentElement) return findLinkElement(el.parentElement);
            return null;
        };
        const target = findLinkElement(event.target);
        if (!(target instanceof HTMLAnchorElement)) return;
        const { href: href } = target;
        // Check if the click target differs from the current hostname, meaning it's external
        if (// eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
        !href.match(new RegExp(`^(http://www.|https://www.|http://|https://)+(${window.location.hostname})`))) matomoInstance.trackLink({
            href: href
        });
    };
    (0, $6kl77.useEffect)(()=>{
        window.document.addEventListener('click', handleOutboundClick, {
            capture: true
        });
        return ()=>window.document.removeEventListener('click', handleOutboundClick, {
                capture: true
            });
    }, []);
};
var $2bddbc1d9c47a324$export$2e2bcd8739ae039 = $2bddbc1d9c47a324$var$useOutboundClickListener;


function $28ddde2167a8054a$var$useMatomo() {
    const instance = (0, $6kl77.useContext)((0, $95a672726cdabda1$export$2e2bcd8739ae039));
    const trackPageView = (0, $6kl77.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackPageView(params), [
        instance
    ]);
    const trackEvent = (0, $6kl77.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackEvent(params), [
        instance
    ]);
    const trackEvents = (0, $6kl77.useCallback)(()=>instance === null || instance === void 0 ? void 0 : instance.trackEvents(), [
        instance
    ]);
    const trackSiteSearch = (0, $6kl77.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackSiteSearch(params), [
        instance
    ]);
    const trackLink = (0, $6kl77.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackLink(params), [
        instance
    ]);
    const enableLinkTracking = (0, $6kl77.useCallback)(()=>{
        if (instance) (0, $2bddbc1d9c47a324$export$2e2bcd8739ae039)(instance);
    }, [
        instance
    ]);
    const pushInstruction = (0, $6kl77.useCallback)((name, ...args)=>{
        instance === null || instance === void 0 || instance.pushInstruction(name, ...args);
    }, [
        instance
    ]);
    return {
        trackEvent: trackEvent,
        trackEvents: trackEvents,
        trackPageView: trackPageView,
        trackSiteSearch: trackSiteSearch,
        trackLink: trackLink,
        enableLinkTracking: enableLinkTracking,
        pushInstruction: pushInstruction
    };
}
var $28ddde2167a8054a$export$2e2bcd8739ae039 = $28ddde2167a8054a$var$useMatomo;





var $6kl77 = parcelRequire("6kl77");



parcelRequire("6kl77");


var $6kl77 = parcelRequire("6kl77");

const $604d91a83285d2d4$var$EVENT_NAME = "loadIdorgPreview";
var $604d91a83285d2d4$export$2e2bcd8739ae039 = ({ url: url })=>{
    const [expanded, setExpanded] = (0, $6kl77.useState)(false);
    const [shouldLoadPreview, setShouldLoadPreview] = (0, $6kl77.useState)(false);
    const elementId = (0, $6kl77.useId)();
    const loadPreviewEvent = new CustomEvent($604d91a83285d2d4$var$EVENT_NAME, {
        detail: {
            elementId: elementId
        }
    });
    const collapseRef = (0, $6kl77.useRef)(null);
    (0, $6kl77.useEffect)(()=>{
        if (!collapseRef.current) return;
        const bsCollapse = new (0, $36993a23339f9fb9$export$78768a9af065a7b)(collapseRef.current, {
            toggle: false
        });
        expanded ? bsCollapse.show() : bsCollapse.hide();
    }, [
        expanded
    ]);
    const handleLoadPreviewEvent = (0, $6kl77.useCallback)((e)=>{
        const eventElementId = e.detail.elementId;
        if (elementId !== eventElementId) setExpanded(false);
    }, []);
    const onTogglePreviewClicked = (0, $6kl77.useCallback)(()=>{
        setShouldLoadPreview(true);
        setExpanded(!expanded);
        if (!expanded) window.dispatchEvent(loadPreviewEvent);
    }, [
        expanded
    ]);
    (0, $6kl77.useEffect)(()=>{
        window.addEventListener($604d91a83285d2d4$var$EVENT_NAME, handleLoadPreviewEvent);
        return ()=>{
            window.removeEventListener($604d91a83285d2d4$var$EVENT_NAME, handleLoadPreviewEvent);
        };
    }, []);
    if (location.protocol === 'https:' && url.startsWith("http")) url = url.replace(/^http:\/\//, 'https://');
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                className: "text-muted ms-1 text-decoration-none",
                type: "button",
                title: "Toggle preview",
                onClick: onTogglePreviewClicked,
                children: expanded ? /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                    className: "icon icon-common icon-eye-slash"
                }) : /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                    className: "icon icon-common icon-eye"
                })
            }),
            shouldLoadPreview && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                ref: collapseRef,
                className: "preview-iframe-container bg-white px-2 py-1 mt-1",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        className: "alert alert-info px-2 py-1",
                        children: "If the preview fails to load, it's likely being blocked by the provider. When this happens, please check by clicking the identifiers.org URL."
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("iframe", {
                        scrolling: "no",
                        sandbox: "allow-scripts allow-same-origin",
                        src: url,
                        className: "preview-iframe overflow-hidden w-100"
                    })
                ]
            })
        ]
    });
};


var $c3563a4c3c3857ce$export$2e2bcd8739ae039 = ({ url: url, match: match, loading: loading })=>{
    let isWarning = false;
    let body;
    if (loading === null || loading === true || !match) return undefined;
    else if (Object.keys(match).length === 0) body = /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                children: "We could not find an exact match for this URL"
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f2b0a7bd8c2e9c22$export$a6c7ac8248d6e38a), {
                to: "/reverseResolve",
                state: {
                    url: url
                },
                className: "btn btn-link fs-6 text-decoration-none m-0 p-0",
                children: "Click here to search by similarity"
            })
        ]
    });
    else {
        isWarning = !match.lui_pattern_match;
        body = /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                    className: "mb-2",
                    children: [
                        "Match with prefix",
                        ' ',
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                            href: 'https://registry.identifiers.org/registry/' + match.prefix,
                            target: "_blank",
                            className: "text-decoration-none",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("b", {
                                    children: match.prefix
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-external-link-alt ms-1 me-2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("hr", {
                            className: "m-0 p-0"
                        })
                    ]
                }),
                !match.lui_pattern_match && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    children: "However, the LUI pattern does not match, and might need to be updated. Please contact us using the feedback button above."
                }),
                match.possible_idorg_url && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                    children: [
                        "Likely URL:",
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                            href: match.possible_idorg_url,
                            target: "_blank",
                            children: match.possible_idorg_url
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                            className: "text-muted ms-1 text-decoration-none",
                            title: "copy to clipboard",
                            type: "button",
                            onClick: (ev)=>(0, $cce97f359217af33$export$2cdf1b96a9f86d16)(match.possible_idorg_url, ev),
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                className: "icon icon-common icon-copy"
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $604d91a83285d2d4$export$2e2bcd8739ae039), {
                            url: match.possible_idorg_url
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-exclamation-triangle"
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                    className: "mx-1",
                                    children: "Make sure it links where you expect before publishing this anywhere"
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-exclamation-triangle"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
        id: "reverse-match-container",
        className: "inline-search-container",
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
            className: "hints-box py-2 px-3 " + (isWarning ? "alert alert-warning mb-0" : "bg-white"),
            children: body
        })
    });
};



const $b1f12a5e4c6cbd50$var$isUrl = (string)=>{
    if (!string || !string.startsWith("http")) return false;
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
const $b1f12a5e4c6cbd50$var$exampleUrls = {
    IntAct: "https://www.ebi.ac.uk/intact/interaction/EBI-2307691",
    ENA: "https://www.ebi.ac.uk/ena/browser/view/BN000065",
    UniProt: "http://purl.uniprot.org/uniprot/P0DP23"
};
var $b1f12a5e4c6cbd50$export$2e2bcd8739ae039 = ()=>{
    const [url, setUrl] = (0, $6kl77.useState)('');
    const [match, setMatch] = (0, $6kl77.useState)(null);
    const [loading, setLoading] = (0, $6kl77.useState)(null);
    const handleExampleClick = (e)=>{
        setUrl(e.target.dataset.idorgExample);
        setTimeout(()=>document.getElementById("reverseResolveButton")?.click(), 50);
    };
    const handleInputChange = (e)=>{
        const { value: value } = e.target;
        setMatch(null);
        setLoading(null);
        setUrl(value);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);
        fetch((0, $daaee31eed9617db$export$e506a1d27d1eaa20).resolverApi + "/reverse/byPrefix", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                apiVersion: "1.0",
                payload: {
                    url: url
                }
            })
        }).then((res)=>res.status === 200 ? res.json() : null, console.error).then((match)=>setMatch(match ? match.payload : {})).finally(()=>setLoading(false));
    };
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                className: "form-text text-muted ms-1",
                children: [
                    "Examples:",
                    ' ',
                    Object.entries($b1f12a5e4c6cbd50$var$exampleUrls).map(([provider, url])=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                            role: "suggestion",
                            tabIndex: "0",
                            type: "button",
                            className: "text-primary me-2",
                            onClick: handleExampleClick,
                            onKeyDown: handleExampleClick,
                            title: url,
                            "data-idorg-example": url,
                            children: provider
                        }, provider))
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        className: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("input", {
                                role: "searchbox",
                                spellCheck: false,
                                className: "form-control search-input",
                                placeholder: "Enter an URL which you wish to link to via identifiers.org",
                                onChange: handleInputChange,
                                value: url
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("button", {
                                id: "reverseResolveButton",
                                className: "btn btn-primary text-white search-button",
                                disabled: $b1f12a5e4c6cbd50$var$isUrl(url) && !loading ? undefined : true,
                                type: "submit",
                                children: [
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                        className: "icon icon-common icon-search pe-2"
                                    }),
                                    loading ? "Converting..." : "Convert"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $c3563a4c3c3857ce$export$2e2bcd8739ae039), {
                                url: url,
                                match: match,
                                loading: loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        className: "text-muted text-sm ms-1 text-decoration-none",
                        href: "https://docs.identifiers.org/pages/api#resolution-api-services",
                        target: "_blank",
                        children: "powered by our resolution API"
                    })
                ]
            })
        ]
    });
};


class $d6770ce9a6d412e8$var$HomePage extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
    }
    componentDidMount() {
        const { trackPageView: trackPageView } = this.props.matomo;
        trackPageView();
    }
    render() {
        const boxPadding = (0, $a3cbc33b37bba001$export$cbc7c17b7602658a)() || (0, $a3cbc33b37bba001$export$9265a4c0580e69f6)() ? 'p-3' : 'p-5';
        const searchBarPadding = (0, $a3cbc33b37bba001$export$cbc7c17b7602658a)() ? 'p-1' : 'px-5';
        const topSpacer = (0, $a3cbc33b37bba001$export$cbc7c17b7602658a)() ? '' : 'spacer-5';
        const { navigate: navigate } = this.props;
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
            className: `row border ${topSpacer}`,
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                    className: `col col-12 col-xl-6 ${boxPadding} d-flex align-items-center justify-content-center flex-column`,
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("h1", {
                            className: "text-primary mb-4 text-left w-100",
                            children: "Identifiers.org Resolution Service"
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("p", {
                            className: "mb-0 text-justify text-muted",
                            children: [
                                "The Identifiers.org Resolution Service provides consistent access to life science data using Compact Identifiers. Compact Identifiers consist of an assigned unique prefix and a local provider designated accession number (prefix:accession). The resolving location of Compact Identifiers is determined using information that is stored in the Identifiers.org  ",
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                    href: (0, $daaee31eed9617db$export$e506a1d27d1eaa20).registryUrl,
                                    className: "text-primary",
                                    children: "Registry"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $092d716a99f094b5$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    className: "col col-12 col-xl-6 bg-light py-5 d-flex align-items-center justify-content-center",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        className: `row justify-content-center mt-2 ${searchBarPadding} w-100`,
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                            className: "col col-lg-7 col-xl-12",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h4", {
                                    children: [
                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-search pe-2"
                                        }),
                                        "Resolve a Compact Identifier"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $6e6a2720a886a595$export$2e2bcd8739ae039), {
                                    buttonCaption: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                className: "icon icon-common icon-search me-1"
                                            }),
                                            " Resolve"
                                        ]
                                    }),
                                    placeholderCaption: "Enter an identifier to resolve",
                                    onButtonClick: (query)=>navigate(`resolve?query=${query}`)
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("hr", {
                                    className: "my-4"
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h4", {
                                    children: [
                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-search pe-2"
                                        }),
                                        "Convert provider URL to identifiers.org URL"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $b1f12a5e4c6cbd50$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            ]
        });
    }
}
var $d6770ce9a6d412e8$export$2e2bcd8739ae039 = (props)=>{
    const matomo = (0, $28ddde2167a8054a$export$2e2bcd8739ae039)();
    const navigate = (0, $f500c00b0505d3a1$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($d6770ce9a6d412e8$var$HomePage, {
        ...props,
        matomo: matomo,
        navigate: navigate
    });
};





var $6kl77 = parcelRequire("6kl77");

//
// ResolvedResources actions.
//
// Resolve a compact identifier. Will dispatch setResolvedResources.
const $53ab143120526565$export$f09489aa9551cf18 = (query)=>{
    return async (dispatch, getState)=>{
        const config = getState().config;
        let requestUrl = new URL(`${config.resolverApi}/${query}`);
        let response;
        let data;
        try {
            response = await fetch(requestUrl);
            if (response.ok) data = await response.json();
            else data = [];
        } catch (err) {
            console.error('Error fetching namespaces: ', err);
        }
        // Sort resources by their score.
        if (data && data.hasOwnProperty('payload')) {
            data = data.payload.resolvedResources.sort((a, b)=>b.recommendation.recommendationIndex - a.recommendation.recommendationIndex);
            // Add compact identifier to every resource.
            data.forEach((resolvedResource)=>{
                if (resolvedResource.hasOwnProperty("providerCode") && resolvedResource.providerCode !== data.payload?.parsedCompactIdentifier.prefix && resolvedResource.providerCode && resolvedResource.providerCode.trim() !== '' && resolvedResource.providerCode !== 'CURATOR_REVIEW') resolvedResource['compactIdentifier'] = `${config.resolverApi}/${resolvedResource.providerCode}/${query}`;
                else resolvedResource['compactIdentifier'] = `${config.resolverApi}/${query}`;
            });
            dispatch($53ab143120526565$export$3c2fa40d7fc0798b(data));
        } else dispatch($53ab143120526565$export$3c2fa40d7fc0798b([]));
        return response;
    };
};
const $53ab143120526565$export$3c2fa40d7fc0798b = (resolvedResources)=>{
    return {
        type: 'SET_RESOLVEDRESOURCES',
        resolvedResources: resolvedResources
    };
};




parcelRequire("6kl77");
const $579fd66faa6ce4e7$var$Spinner = ()=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("h2", {
                className: "text-muted fw-bold mb-0",
                children: "Loading"
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "lds-ellipsis",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {})
                ]
            })
        ]
    });
var $579fd66faa6ce4e7$export$2e2bcd8739ae039 = $579fd66faa6ce4e7$var$Spinner;




var $6kl77 = parcelRequire("6kl77");



parcelRequire("6kl77");
const $4cf4bb271f4fe1be$var$ResourceItem = ({ data: data })=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        className: "card mt-3",
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "card-header d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-cubes size-200 me-2"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                        href: data.compactIdentifierResolvedUrl,
                        className: "ms-2 clear-link w-90",
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("p", {
                                className: "mb-0",
                                children: [
                                    data.description,
                                    (data.deprecatedNamespace || data.deprecatedResource) && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                        className: "badge bg-danger bg-opacity-50 rounded-pill mx-1",
                                        children: "deactivated"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                                className: "mb-0",
                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
                                    className: "text-muted text-wordbreak",
                                    children: data.compactIdentifier
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("ul", {
                className: "list-group list-group-flush",
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("li", {
                    className: "list-group-item",
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                            className: "mb-0",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                className: "text-success text-decoration-none",
                                href: data.compactIdentifierResolvedUrl,
                                target: "_blank",
                                children: data.compactIdentifierResolvedUrl
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                            className: "mb-0",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                className: "fw-bold",
                                children: data.institution.name
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                            className: "mb-0",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                className: "mb-0",
                                children: data.location.countryName
                            })
                        })
                    ]
                })
            })
        ]
    });
var $4cf4bb271f4fe1be$export$2e2bcd8739ae039 = $4cf4bb271f4fe1be$var$ResourceItem;


class $0158b919519a9640$var$ResourceList extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
    }
    render() {
        const { resolvedResources: resolvedResources, location: location } = this.props;
        const query = new URLSearchParams(location.search).get('query');
        return resolvedResources.length === 0 ? /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
            className: "col-12 col-lg px-0 pe-md-2",
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    className: "row mb-5",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        className: "col align-middle",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                className: "icon icon-common icon-bomb size-200 me-2 mt-4"
                            }),
                            "Error resolving query: ",
                            query ? `nothing found for compact identifier \"${query}\"` : "Query is empty."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                            href: `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`,
                            className: "text-decoration-none",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-arrow-left me-2"
                                }),
                                "Go back"
                            ]
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
            className: "col-12 col-lg px-0 pe-md-2",
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                    className: "text-muted",
                    children: [
                        "Found ",
                        resolvedResources.length,
                        " ",
                        resolvedResources.length === 1 ? 'entry' : 'entries',
                        "."
                    ]
                }),
                resolvedResources.map((rr, index)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $4cf4bb271f4fe1be$export$2e2bcd8739ae039), {
                        data: rr
                    }, `rr-${index}`))
            ]
        });
    }
}
// Redux mappings
const $0158b919519a9640$var$mapStateToProps = (state)=>({
        resolvedResources: state.resolvedResources
    });
const $0158b919519a9640$var$ConnectedResourceList = (0, $128f50888c77ce5a$export$2e2bcd8739ae039)($0158b919519a9640$var$mapStateToProps)($0158b919519a9640$var$ResourceList);
var $0158b919519a9640$export$2e2bcd8739ae039 = (props)=>{
    const location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($0158b919519a9640$var$ConnectedResourceList, {
        ...props,
        location: location
    });
};




var $6kl77 = parcelRequire("6kl77");




var $6kl77 = parcelRequire("6kl77");


const $4e0911ff33697de4$var$MetadataCard = ({ metadata: metadata, parsedCid: parsedCid })=>{
    const provider = metadata?.retrieverId ? metadata?.retrieverId[0] : "unknown";
    const contentElemId = `metadata-content-${provider}`;
    let moreInfoHref = $4e0911ff33697de4$var$getMoreInfoHrefFor(provider, parsedCid);
    const [expanded, setExpanded] = (0, $6kl77.useState)(true);
    const collapseRef = (0, $6kl77.useRef)(null);
    (0, $6kl77.useEffect)(()=>{
        if (!collapseRef.current) return;
        const bsCollapse = new (0, $36993a23339f9fb9$export$78768a9af065a7b)(collapseRef.current, {
            toggle: false
        });
        expanded ? bsCollapse.show() : bsCollapse.hide();
    });
    const metadataValues = Object.entries(metadata).filter(([k])=>k !== "retrieverId").flatMap(([k, v])=>v.map((vi, idx)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("li", {
                className: "list-group-item",
                children: [
                    k,
                    ":",
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($4e0911ff33697de4$var$MetadataValue, {
                        value: vi
                    })
                ]
            }, `list-group-item-${provider}-${k}-${idx}`)));
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        className: "metadata-card card mt-3 mb-3",
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                className: "card-header d-flex align-items-center",
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("button", {
                    title: "click to expand or collapse",
                    type: "button",
                    onClick: ()=>setExpanded(!expanded),
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                            children: [
                                " ",
                                expanded ? "\u25B2" : "\u25BC",
                                " "
                            ]
                        }),
                        $4e0911ff33697de4$var$GetTitleForRetrieverId(provider)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                ref: collapseRef,
                className: "card-body collapse p-0",
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("ul", {
                    className: "list-group list-group-flush",
                    children: [
                        metadataValues,
                        moreInfoHref && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
                            className: "list-group-item",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                href: moreInfoHref,
                                target: "_blank",
                                className: "clear-link",
                                children: "Click here for more"
                            })
                        }, `list-group-item-${provider}-more`)
                    ]
                })
            })
        ]
    });
};
const $4e0911ff33697de4$var$MetadataValue = (props)=>{
    if (typeof props.value === "string" && $4e0911ff33697de4$var$isValidUrl(props.value)) return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
        href: props.value,
        className: "text-decoration-none",
        children: [
            " ",
            props.value,
            " "
        ]
    });
    else return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            "\xa0",
            props.value
        ]
    });
};
const $4e0911ff33697de4$var$getMoreInfoHrefFor = (provider, parsedCid)=>{
    switch(provider){
        case "togoid":
            return `https://togoid.dbcls.jp/?route=&ids=${parsedCid.localId}`;
        default:
            return undefined;
    }
};
const $4e0911ff33697de4$var$isValidUrl = (urlString)=>{
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $4e0911ff33697de4$var$GetTitleForRetrieverId = (id)=>{
    switch(id){
        case "ebisearch":
            return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
                children: [
                    "Subset of indexed fields from\xa0",
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        onClick: (e)=>e.stopPropagation(),
                        target: "_blank",
                        className: "text-decoration-none",
                        href: "https://www.ebi.ac.uk/ebisearch",
                        children: "EBI Search"
                    })
                ]
            });
        case "togoid":
            return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
                children: [
                    "Subset of related URIs in\xa0",
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        onClick: (e)=>e.stopPropagation(),
                        target: "_blank",
                        className: "text-decoration-none",
                        href: "https://togoid.dbcls.jp/",
                        children: "TogoID"
                    }),
                    " database"
                ]
            });
        default:
            return id;
    }
};
$4e0911ff33697de4$var$MetadataCard.propTypes = {
    metadata: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).object
};
var $4e0911ff33697de4$export$2e2bcd8739ae039 = $4e0911ff33697de4$var$MetadataCard;


const $6d4f6c471e14acdc$var$MetadataView = ({ curie: curie })=>{
    const [loading, setLoading] = (0, $6kl77.useState)(false);
    const [successful, setSuccessful] = (0, $6kl77.useState)(false);
    const [metadataValues, setMetadataValues] = (0, $6kl77.useState)(null);
    const [parsedCid, setParsedCid] = (0, $6kl77.useState)(null);
    const handleMetadataPayload = (0, $6kl77.useCallback)((payload)=>{
        if (payload === null || payload === undefined) {
            setSuccessful(false);
            setLoading(false);
        } else {
            const fetchHeaders = {
                headers: {
                    accept: "application/json"
                }
            };
            setParsedCid(payload.parsedCompactIdentifier);
            const retrieverFetches = payload.ableRetrievers.map((url)=>fetch(url, fetchHeaders));
            Promise.allSettled(retrieverFetches).then((results)=>results.filter((r)=>r && r.status === "fulfilled")).then((fulfilledResults)=>Promise.all(fulfilledResults.filter((r)=>r.value.status === 200).map((r)=>r.value.json()))).then((metadataValues)=>{
                setMetadataValues(metadataValues);
                setSuccessful(true);
            }).catch((reason)=>{
                console.error("failed to fetch metadata", reason);
                setSuccessful(false);
            }).finally(()=>{
                setLoading(false);
            });
        }
    }, [
        setSuccessful,
        setLoading,
        setMetadataValues,
        setParsedCid
    ]);
    (0, $6kl77.useEffect)(()=>{
        if (!loading && metadataValues === null) {
            setLoading(true);
            fetch((0, $daaee31eed9617db$export$e506a1d27d1eaa20).metadataRetrieverApiBaseUrl + curie).then((r)=>r.status === 200 ? r.json() : null).then((r)=>r?.payload).then(handleMetadataPayload);
        }
    }, [
        setLoading,
        handleMetadataPayload,
        (0, $daaee31eed9617db$export$e506a1d27d1eaa20),
        curie
    ]);
    const wrapperClassName = "col-12 pt-3 pt-lg-0 px-0 ps-md-2 ";
    if (loading) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
        className: wrapperClassName + "col-lg-2",
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
            className: "text-muted",
            children: [
                "Checking for metadata providers ",
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("path", {
                        d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
                        className: "spinner_P7sC"
                    })
                })
            ]
        })
    });
    else if (!successful) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
        className: wrapperClassName + "col-lg-2",
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
            className: "text-muted",
            children: "Failed to retriever metadata! Please contact our team."
        })
    });
    else if (metadataValues?.length === 0) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
        className: wrapperClassName + "col-lg-2",
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("small", {
            className: "text-muted",
            children: "Zero metadata providers found"
        })
    });
    else return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        className: wrapperClassName + " col-lg-5",
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                className: "text-muted",
                children: [
                    "Found metadata in ",
                    metadataValues?.length,
                    " ",
                    metadataValues?.length === 1 ? 'provider' : 'providers',
                    ". These are acquired via our ",
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        target: "_blank",
                        href: "https://docs.identifiers.org/pages/metadata_service.html",
                        children: "metadata service API"
                    }),
                    "."
                ]
            }),
            metadataValues?.map((m, i)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $4e0911ff33697de4$export$2e2bcd8739ae039), {
                    metadata: m,
                    parsedCid: parsedCid
                }, "view_" + i))
        ]
    });
};
$6d4f6c471e14acdc$var$MetadataView.propTypes = {
    curie: (0, (/*@__PURE__*/$parcel$interopDefault($d7f0115ca29a2eb5$exports))).string.isRequired
};
var $6d4f6c471e14acdc$export$2e2bcd8739ae039 = $6d4f6c471e14acdc$var$MetadataView;






class $40131eda7fdc2fca$var$ResolvePage extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "componentDidMount", async ()=>{
            const { props: { getResolvedResources: getResolvedResources, getSchemaOrgMetadataByPrefixFromRegistry: getSchemaOrgMetadataByPrefixFromRegistry, schemaOrgMetadata: schemaOrgMetadata }, state: { query: query } } = this;
            const { trackPageView: trackPageView } = this.props.matomo;
            trackPageView();
            // Load and update schema.org metadata.
            const { prefix: prefix } = (0, $918429d3bafe7f46$export$c067719c5fdda563)(query);
            if (!schemaOrgMetadata.dataset) getSchemaOrgMetadataByPrefixFromRegistry(prefix);
            await getResolvedResources(query);
            this.setState({
                isLoading: false
            });
        });
        const params = new URLSearchParams(props.location.search);
        this.state = {
            query: params.get('query') || '',
            isLoading: true
        };
    }
    async componentWillUnmount() {
        const { getSchemaOrgMetadataFromRegistry: getSchemaOrgMetadataFromRegistry } = this.props;
        getSchemaOrgMetadataFromRegistry();
    }
    render() {
        const { props: { config: config }, state: { isLoading: isLoading, query: query } } = this;
        const compactIdentifier = `${config.resolverHardcodedUrl}/${query}`;
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
            className: "row mb-5",
            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                className: "col",
                children: isLoading ? /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $579fd66faa6ce4e7$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                            className: "row mb-5 justify-content-md-center",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                                className: "col d-flex align-items-center text-middle justify-content-center border p-2 bg-cardgrey",
                                children: [
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("h4", {
                                        className: "mb-0 text-success text-ellipsis",
                                        children: compactIdentifier
                                    }),
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                                        className: "btn btn-sm btn-primary-outline",
                                        onClick: (e)=>{
                                            (0, $cce97f359217af33$export$2cdf1b96a9f86d16)(compactIdentifier, e);
                                        },
                                        type: "button",
                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                            className: "icon icon-common icon-copy size-150"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                className: "col px-0",
                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h4", {
                                    className: "mb-0",
                                    children: [
                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                            className: "inline-block border border-end-0 p-1 pe-2",
                                            style: {
                                                backgroundColor: "#00000008"
                                            },
                                            children: "Compact Identifier"
                                        }),
                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                            className: "inline-block border-bottom  py-1 px-2",
                                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("strong", {
                                                className: "text-primary fst-italic",
                                                children: query
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                            className: "row g-0",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $0158b919519a9640$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $6d4f6c471e14acdc$export$2e2bcd8739ae039), {
                                    curie: query
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
}
// Redux mappings.
const $40131eda7fdc2fca$var$mapStateToProps = (state)=>({
        config: state.config,
        schemaOrgMetadata: state.schemaOrgMetadata
    });
const $40131eda7fdc2fca$var$mapDispatchToProps = (dispatch)=>({
        getResolvedResources: (query)=>dispatch((0, $53ab143120526565$export$f09489aa9551cf18)(query)),
        getSchemaOrgMetadataFromRegistry: (namespaceId)=>dispatch((0, $1a23819793c0c1da$export$78572dfc0a558ba6)(namespaceId)),
        getSchemaOrgMetadataByPrefixFromRegistry: (namespaceId)=>dispatch((0, $1a23819793c0c1da$export$358ac8bb95c77f0c)(namespaceId))
    });
const $40131eda7fdc2fca$var$ConnectedResolvePage = (0, $128f50888c77ce5a$export$2e2bcd8739ae039)($40131eda7fdc2fca$var$mapStateToProps, $40131eda7fdc2fca$var$mapDispatchToProps)($40131eda7fdc2fca$var$ResolvePage);
var $40131eda7fdc2fca$export$2e2bcd8739ae039 = (props)=>{
    const matomo = (0, $28ddde2167a8054a$export$2e2bcd8739ae039)();
    const location = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($40131eda7fdc2fca$var$ConnectedResolvePage, {
        ...props,
        location: location,
        matomo: matomo
    });
};



parcelRequire("6kl77");

var $f6beb96204694537$exports = {};
(function(global, factory) {
    $f6beb96204694537$exports = factory();
})($f6beb96204694537$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


// import { useMatomo } from '@datapunt/matomo-tracker-react';
const $f3027cde706e99b4$var$ErrorPage = ({ defaultMessage: defaultMessage })=>{
    // const { trackPageView } = useMatomo()
    // trackPageView(); // Will result in duplicated measurements if Spring renders this in failed resolution.
    const error = (0, $f500c00b0505d3a1$export$ed527bf60f6e05f2)();
    if (error) console.error(error);
    let title = (0, (/*@__PURE__*/$parcel$interopDefault($f6beb96204694537$exports))).get('title');
    if (title === undefined) title = "An error has happened";
    else {
        title = title.replaceAll("+", " ");
        (0, (/*@__PURE__*/$parcel$interopDefault($f6beb96204694537$exports))).remove('title');
    }
    let message = (0, (/*@__PURE__*/$parcel$interopDefault($f6beb96204694537$exports))).get('message');
    if (message === undefined) {
        const err = (0, $f500c00b0505d3a1$export$17f53340677d5831)();
        if (!err) message = defaultMessage || "Perhaps you are using an invalid URL";
        else if (typeof err == "string") message = err;
        else message = err.message;
    } else {
        message = message.replaceAll("+", " ");
        (0, (/*@__PURE__*/$parcel$interopDefault($f6beb96204694537$exports))).remove('message');
    }
    // window.history.replaceState({}, '', location.pathname)
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-bomb"
                    }),
                    " ",
                    title
                ]
            }),
            message.split("; ").map((s, i)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("p", {
                    children: [
                        " ",
                        s,
                        " "
                    ]
                }, i)),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f2b0a7bd8c2e9c22$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: "Go home"
                })
            })
        ]
    });
};
var $f3027cde706e99b4$export$2e2bcd8739ae039 = $f3027cde706e99b4$var$ErrorPage;




var $6kl77 = parcelRequire("6kl77");



var $101c473c18f0bc8f$export$2e2bcd8739ae039 = ()=>{
    const { resolverData: resolverData } = (0, $f500c00b0505d3a1$export$1448a5050d252c4d)();
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $6kl77.Suspense), {
        fallback: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $579fd66faa6ce4e7$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f500c00b0505d3a1$export$6ddabde395c8c576), {
            resolve: resolverData,
            children: $101c473c18f0bc8f$var$ProtectedLanding
        })
    });
};
const $101c473c18f0bc8f$var$ProtectedLanding = (resolverData)=>{
    const { payload: { resolvedResources: resolvedResources } } = resolverData;
    const bestResolvedResource = resolvedResources.reduce((best, curr)=>{
        if (best === null) return curr;
        const best_idx = best.recommendation.recommendation_index;
        const curr_idx = curr.recommendation.recommendation_index;
        return best_idx < curr_idx ? curr : best;
    }, null);
    if (bestResolvedResource === null) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f3027cde706e99b4$export$2e2bcd8739ae039), {
        defaultMessage: "Invalid compact identifier"
    });
    if (!bestResolvedResource.protectedUrls || !bestResolvedResource.renderProtectedLanding) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f3027cde706e99b4$export$2e2bcd8739ae039), {
        defaultMessage: "Invalid compact identifier for protected landing"
    });
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($101c473c18f0bc8f$var$ProtectedLandingPageContents, {
        ...bestResolvedResource
    });
};
const $101c473c18f0bc8f$var$ProtectedLandingPageContents = (resolvedResource)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("h1", {
                className: "text-primary mb-4 text-center",
                children: "The page that you are trying to access requires authentication"
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("p", {
                className: "text-center",
                children: [
                    "You are trying to access a protected resource of namespace ",
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("em", {
                        className: "fw-bold",
                        children: resolvedResource.namespacePrefix
                    }),
                    ". Before accessing its information you will need proper authorization."
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("p", {
                children: [
                    " ",
                    resolvedResource.authHelpDescription,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "d-flex flex-wrap",
                style: {
                    gap: ".25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                        className: "btn btn-primary text-white flex-fill",
                        href: resolvedResource.compactIdentifierResolvedUrl,
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("em", {
                                className: "fw-bold",
                                children: "I understand"
                            }),
                            ", take me to ",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {
                                className: "d-inline d-sm-none"
                            }),
                            resolvedResource.compactIdentifierResolvedUrl
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                        target: "_blank",
                        className: "btn btn-primary text-white flex-fill",
                        href: resolvedResource.authHelpUrl,
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("em", {
                                className: "fw-bold",
                                children: "I need more information"
                            }),
                            ", take me to ",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {
                                className: "d-inline d-sm-none"
                            }),
                            resolvedResource.authHelpUrl
                        ]
                    })
                ]
            })
        ]
    });




var $6kl77 = parcelRequire("6kl77");




var $033ff44ce612d10c$export$2e2bcd8739ae039 = ()=>{
    const { resolverData: resolverData } = (0, $f500c00b0505d3a1$export$1448a5050d252c4d)();
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $6kl77.Suspense), {
        fallback: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $579fd66faa6ce4e7$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f500c00b0505d3a1$export$6ddabde395c8c576), {
            resolve: resolverData,
            children: $033ff44ce612d10c$var$DeactivatedLanding
        })
    });
};
const $033ff44ce612d10c$var$allDeprecatedResource = (resolvedResources)=>resolvedResources.every((resource)=>resource.deprecatedResource);
const $033ff44ce612d10c$var$DeactivatedLanding = (resolverData)=>{
    const { payload: { parsedCompactIdentifier: parsedCompactIdentifier, resolvedResources: resolvedResources } } = resolverData;
    if (!parsedCompactIdentifier.deprecatedNamespace && !$033ff44ce612d10c$var$allDeprecatedResource(resolvedResources)) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f3027cde706e99b4$export$2e2bcd8739ae039), {
        defaultMessage: "Invalid compact identifier for deactivated landing"
    });
    const registryPageUrl = `${(0, $daaee31eed9617db$export$e506a1d27d1eaa20).registryUrl}/registry/${parsedCompactIdentifier.namespace}`;
    const bestResolvedUrl = resolvedResources.reduce((best, curr)=>{
        if (best === null) return curr;
        const best_idx = best.recommendation.recommendation_index;
        const curr_idx = curr.recommendation.recommendation_index;
        return best_idx < curr_idx ? curr : best;
    }, null).compactIdentifierResolvedUrl;
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)($033ff44ce612d10c$var$DeactivatedLandingContents, {
        registryPageUrl: registryPageUrl,
        bestResolvedUrl: bestResolvedUrl,
        namespace: parsedCompactIdentifier.namespace
    });
};
const $033ff44ce612d10c$var$DeactivatedLandingContents = ({ namespace: namespace, registryPageUrl: registryPageUrl, bestResolvedUrl: bestResolvedUrl })=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h1", {
                className: "text-danger mb-4 text-center",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-trash"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                        className: "mx-2",
                        children: [
                            "The namespace ",
                            namespace,
                            " has been deactivated"
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-trash"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                className: "text-center",
                children: " Due to it not being supported anymore or because it is not available online anymore. "
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "d-flex flex-wrap",
                style: {
                    gap: ".25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                        className: "btn btn-primary text-white flex-fill",
                        href: registryPageUrl,
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("em", {
                                className: "fw-bold",
                                children: "Go to the registry's page for more information"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {
                                className: "d-inline d-sm-none"
                            }),
                            registryPageUrl
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                        target: "_blank",
                        className: "btn btn-primary text-white flex-fill",
                        href: bestResolvedUrl,
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("em", {
                                className: "fw-bold",
                                children: "Go to latest available online location"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {
                                className: "d-inline d-sm-none"
                            }),
                            bestResolvedUrl
                        ]
                    })
                ]
            })
        ]
    });





var $6kl77 = parcelRequire("6kl77");

parcelRequire("6kl77");
var $b1fc18cebffef351$export$2e2bcd8739ae039 = ({ initialUrl: initialUrl, onSubmit: onSubmit, accInputRef: accInputRef, urlInputRef: urlInputRef })=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)("form", {
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
            className: "row g-2",
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("label", {
                                    htmlFor: "url-input",
                                    className: "input-group-text",
                                    children: "Provider URL"
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("input", {
                                    ref: urlInputRef,
                                    defaultValue: initialUrl,
                                    className: "form-control form-control-lg",
                                    name: "url",
                                    type: "url",
                                    value: undefined,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                            className: "form-text text-muted",
                            children: 'Input the URL that you want to generate a identifiers.org URL for. Make sure it starts with "http://" or "https://".'
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("label", {
                                    htmlFor: "accession-input",
                                    className: "input-group-text",
                                    children: "Accession or ID"
                                }),
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("input", {
                                    ref: accInputRef,
                                    id: "accession-input",
                                    name: "accession",
                                    type: "text",
                                    className: "form-control",
                                    value: undefined
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                            className: "form-text text-muted",
                            children: "Optional, but it might help resolution. Input the accession or ID of the object in the URL above. Normally this should be contained in the URL."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                    className: "col-12 col-lg-3 col-xl-3 col-xxl-2 d-flex flex-column align-items-stretch pb-4",
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("button", {
                            className: "btn btn-primary text-light py-3",
                            type: "submit",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-search pe-2"
                                }),
                                "Convert"
                            ]
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                            className: "btn btn-secondary text-light mt-2 flex-grow-2",
                            type: "reset",
                            children: "Clear"
                        })
                    ]
                })
            ]
        })
    });



parcelRequire("6kl77");

parcelRequire("6kl77");


var $4f1b4cb8f1fbc8cc$export$2e2bcd8739ae039 = ({ match: match })=>{
    if (!match) return undefined;
    const luiPatternBadge = {
        class: match.lui_pattern_match ? 'bg-success' : 'bg-warning text-dark',
        text: match.lui_pattern_match ? "Matches LUI pattern" : "Doesn't match LUI pattern"
    };
    const roundedScore = Math.floor(match.similarity_score);
    const similarityScoreBadgeClass = roundedScore >= 90 ? 'bg-success' : roundedScore < 50 ? 'bg-danger' : 'bg-warning text-dark';
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        className: "card h-100 similarity-match",
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "card-header",
                children: [
                    "Prefix ",
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("b", {
                        children: match.prefix
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                        className: "ms-1 text-primary",
                        target: "_blank",
                        href: "https://registry.identifiers.org/registry/" + match.prefix,
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                            className: "icon icon-common icon-external-link-alt ms-1 me-2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "card-body",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                            className: "badge " + luiPatternBadge.class,
                            children: luiPatternBadge.text
                        })
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                            className: "badge " + similarityScoreBadgeClass,
                            children: [
                                "Similarity score: ",
                                roundedScore,
                                "%"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                className: "card-footer w-100",
                children: match.possible_idorg_url ? /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                            target: "_blank",
                            className: "text-reset",
                            href: match.possible_idorg_url,
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                className: "me-1",
                                children: match.possible_idorg_url
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                            type: "button",
                            title: "copy",
                            onClick: (e)=>(0, $cce97f359217af33$export$2cdf1b96a9f86d16)(match.possible_idorg_url, e),
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                className: "icon icon-common icon-copy text-body-secondary"
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $604d91a83285d2d4$export$2e2bcd8739ae039), {
                            url: match.possible_idorg_url
                        })
                    ]
                }) : /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                            className: "me-1",
                            children: "Could not generate valid URL"
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                            type: "button",
                            title: "Doesn't match local unique identifier pattern",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                className: "icon icon-common icon-question-circle text-body-secondary"
                            })
                        })
                    ]
                })
            })
        ]
    });
};



var $573b87d1f921f120$export$2e2bcd8739ae039 = ({ loading: loading, error: error, simResults: simResults, prefixResult: prefixResult })=>{
    if (simResults.length === 0 && !prefixResult) return null;
    else if (loading) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $579fd66faa6ce4e7$export$2e2bcd8739ae039), {});
    else if (error) return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
        className: "alert alert-danger",
        role: "alert",
        children: "An error has occurred!"
    });
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "alert alert-warning d-flex flex-nowrap justify-content-between align-items-center",
                role: "alert",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-exclamation-triangle display-1"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                        className: "mx-2 text-center",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("b", {
                                children: "Beware that identifiers.org URLs below this notice are tentative"
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {}),
                            "They might direct to some other object or be completely invalid",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("br", {}),
                            "Make sure to test them before use"
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                        className: "icon icon-common icon-exclamation-triangle display-1"
                    })
                ]
            }),
            prefixResult && /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h2", {
                        className: "mb-1",
                        children: [
                            "URL prefix match",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                                type: "button",
                                className: "cursor-help ms-1",
                                title: "Matches URL against registry patterns exactly",
                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-question-circle fs-4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("hr", {
                        className: "mt-0 mb-3"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $4f1b4cb8f1fbc8cc$export$2e2bcd8739ae039), {
                            match: prefixResult
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("h3", {
                        className: "mb-1",
                        children: [
                            "Similarity matches",
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("button", {
                                type: "button",
                                className: "cursor-help ms-1",
                                title: "Topmost similar registry patterns currently on registry",
                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                    className: "icon icon-common icon-question-circle fs-4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("hr", {
                        className: "mt-0 mb-3"
                    }),
                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        className: "row align-items-stretch g-2",
                        children: [
                            simResults?.length === 0 && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                children: "No similar matches could be retrieved"
                            }),
                            simResults?.map((match, idx)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                    className: "col-4",
                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $4f1b4cb8f1fbc8cc$export$2e2bcd8739ae039), {
                                        match: match
                                    })
                                }, idx))
                        ]
                    })
                ]
            })
        ]
    });
};




var $48cb6205ba1e38f7$export$2e2bcd8739ae039 = ()=>{
    const { state: locationState } = (0, $f500c00b0505d3a1$export$45d76561a5302f2b)();
    const initialUrl = locationState ? locationState.url : '';
    const [loading, setLoading] = (0, $6kl77.useState)(false);
    const [error, setError] = (0, $6kl77.useState)(null);
    const [simResults, setSimResults] = (0, $6kl77.useState)([]);
    const [prefixResult, setPrefixResult] = (0, $6kl77.useState)(null);
    const urlInputRef = (0, $6kl77.useRef)();
    const accInputRef = (0, $6kl77.useRef)();
    (0, $6kl77.useEffect)(()=>{
        if (initialUrl) document.querySelector("button[type='submit']").click();
    }, []);
    const handleError = (0, $6kl77.useCallback)((reason)=>{
        (0, $b6441ce4f4950cd1$export$2d0aa172fa76a9bf).fire({
            icon: 'error',
            title: reason
        });
        console.error(reason);
        setError(true);
        setSimResults([]);
        setPrefixResult({});
    }, [
        setError,
        setSimResults,
        setPrefixResult
    ]);
    const handleSuccess = (0, $6kl77.useCallback)(([prefResults, simResults])=>{
        setError(false);
        setSimResults(simResults.payload);
        setPrefixResult(prefResults.payload);
    }, [
        setError,
        setSimResults,
        setPrefixResult
    ]);
    const onSubmit = (0, $6kl77.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (urlInputRef.current && !urlInputRef.current.checkValidity()) {
            await (0, $b6441ce4f4950cd1$export$2d0aa172fa76a9bf).fire({
                icon: 'error',
                title: urlInputRef.current.validationMessage
            });
            return;
        }
        const url = urlInputRef.current?.value;
        const accessionStr = accInputRef.current?.value;
        const accession = !accessionStr || accessionStr.trim().length === 0 ? undefined : accessionStr;
        setLoading(true);
        const fetchOpts = {
            method: 'POST',
            body: JSON.stringify({
                apiVersion: "1.0",
                payload: {
                    url: url,
                    accession: accession
                }
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        const prefixFetch = fetch((0, $daaee31eed9617db$export$e506a1d27d1eaa20).resolverApi + "/reverse/byPrefix", fetchOpts);
        const simFetch = fetch((0, $daaee31eed9617db$export$e506a1d27d1eaa20).resolverApi + "/reverse/bySimilarity", fetchOpts);
        Promise.all([
            prefixFetch,
            simFetch
        ]).then(([r1, r2])=>{
            const p1 = r1.status === 200 ? r1.json() : Promise.resolve({
                payload: null
            });
            const p2 = r2.status === 200 ? r2.json() : Promise.resolve({
                payload: []
            });
            return Promise.all([
                p1,
                p2
            ]);
        }).then(handleSuccess).catch(handleError).finally(()=>setLoading(false));
    }, [
        handleError,
        handleSuccess,
        setLoading,
        urlInputRef,
        accInputRef
    ]);
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $b1fc18cebffef351$export$2e2bcd8739ae039), {
                    onSubmit: onSubmit,
                    initialUrl: initialUrl,
                    urlInputRef: urlInputRef,
                    accInputRef: accInputRef
                })
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                className: "mt-5 mb-5",
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $573b87d1f921f120$export$2e2bcd8739ae039), {
                    loading: loading,
                    error: error,
                    simResults: simResults,
                    prefixResult: prefixResult
                })
            })
        ]
    });
};



parcelRequire("6kl77");



var $6kl77 = parcelRequire("6kl77");





var $6kl77 = parcelRequire("6kl77");
// Adapted from https://medium.com/trendkite-dev/building-a-sticky-header-component-in-react-f2117099a9a2
class $0084ca0e793ff315$var$Sticky extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "state", {
            height: 0,
            width: 0,
            stuckTop: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "frameId", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "stickyDiv", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleScroll", ()=>{
            const { sides: sides } = this.props;
            const stickyDiv = this.stickyDiv.current || null;
            const scrollTarget = this.props.scrollTarget || window;
            this.frameId = 0;
            if (!stickyDiv) return;
            const scrollRect = scrollTarget.getBoundingClientRect ? scrollTarget.getBoundingClientRect() : {
                height: scrollTarget.innerHeight,
                width: scrollTarget.innerWidth,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                x: scrollTarget.scrollX,
                y: scrollTarget.scrollY
            };
            let stickyRect = stickyDiv.getBoundingClientRect();
            if (!this.state.height || !this.state.width) this.setState({
                height: stickyRect.height,
                width: stickyRect.height
            });
            stickyRect = {
                height: this.state.height || stickyRect.height,
                width: this.state.width || stickyRect.width,
                x: stickyRect.x,
                y: stickyRect.y
            };
            if (typeof sides.bottom === 'number') {
                const stuckBottom = stickyRect.y + stickyRect.height > scrollRect.height + scrollRect.top - sides.bottom;
                this.setState({
                    stuckBottom: stuckBottom
                });
            }
            if (typeof sides.top === 'number') {
                const stuckTop = stickyRect.y < scrollRect.top + sides.top;
                this.setState({
                    stuckTop: stuckTop
                });
            }
            if (typeof sides.left === 'number') {
                const stuckLeft = stickyRect.x < scrollRect.left + sides.left;
                this.setState({
                    stuckLeft: stuckLeft
                });
            }
            if (typeof sides.right === 'number') {
                const stuckRight = stickyRect.x + stickyRect.width > scrollRect.width + scrollRect.left - sides.right;
                this.setState({
                    stuckRight: stuckRight
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "debouncedScroll", ()=>{
            if (!this.frameId) {
                const frameId = requestAnimationFrame(this.handleScroll);
                this.frameId = frameId;
            }
        });
    }
    componentDidMount() {
        this.addEvents();
        this.handleScroll();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.scrollTarget !== this.props.scrollTarget) {
            this.removeEvents();
            this.addEvents();
        }
    }
    componentWillUnmount() {
        this.removeEvents();
    }
    addEvents() {
        const scrollTarget = this.props.scrollTarget || window;
        if (scrollTarget && this.stickyDiv.current) scrollTarget.addEventListener('scroll', this.debouncedScroll);
    }
    removeEvents() {
        const scrollTarget = this.props.scrollTarget || window;
        if (scrollTarget) scrollTarget.removeEventListener('scroll', this.debouncedScroll);
        if (this.frameId) cancelAnimationFrame(this.frameId);
    }
    render() {
        const { children: children } = this.props;
        const { stuckBottom: stuckBottom, stuckLeft: stuckLeft, stuckRight: stuckRight, stuckTop: stuckTop } = this.state;
        const stickyModifiers = [];
        if (stuckBottom) stickyModifiers.push('stuck-bottom');
        if (stuckLeft) stickyModifiers.push('stuck-left');
        if (stuckRight) stickyModifiers.push('stuck-right');
        if (stuckTop) stickyModifiers.push('stuck-top');
        const childrenWithStuckProps = (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Children.map(children, (child)=>{
            const childModifiers = child.props && child.props.modifiers || [];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).cloneElement(child, {
                modifiers: [
                    ...childModifiers,
                    ...stickyModifiers
                ]
            });
        });
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
            className: $0084ca0e793ff315$var$Sticky.baseClass,
            ref: this.stickyDiv,
            children: childrenWithStuckProps
        });
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))($0084ca0e793ff315$var$Sticky, "baseClass", 'Sticky-base');
$0084ca0e793ff315$var$Sticky.defaultProps = {
    scrollTarget: null,
    sides: {
        top: 0
    }
};
var $0084ca0e793ff315$export$2e2bcd8739ae039 = $0084ca0e793ff315$var$Sticky;





var $6kl77 = parcelRequire("6kl77");
class $8cd9ce6bf89d90bb$var$EBINavBar extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleClickExtraItems", ()=>this.setState({
                extraItemsVisible: !this.state.extraItemsVisible
            }));
        this.state = {
            width: window.innerWidth,
            extraItemsVisible: false
        };
    }
    componentDidMount() {
        window.addEventListener('resize', ()=>this.setState({
                width: window.innerWidth
            }));
    }
    render() {
        const { handleClickExtraItems: handleClickExtraItems, props: { children: children, modifiers: modifiers }, state: { extraItemsVisible: extraItemsVisible } } = this;
        const modifierClasses = modifiers.length ? modifiers.reduce((result, modifier)=>{
            result = `${result} ${$8cd9ce6bf89d90bb$var$EBINavBar.baseClass}--${modifier}`;
            return result;
        }, '') : '';
        const visibleElements = Math.floor(window.innerWidth / 160) - 1;
        const childrenList = (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Children.map(children, (child)=>child);
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
            className: `${$8cd9ce6bf89d90bb$var$EBINavBar.baseClass} ${modifierClasses}`,
            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("nav", {
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("ul", {
                    id: "local-nav",
                    className: "dropdown menu float-start",
                    "data-description": "navigational",
                    children: [
                        childrenList.slice(0, visibleElements),
                        childrenList.length > visibleElements && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $8939768198127506$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                        href: "#!",
                                        onClick: handleClickExtraItems,
                                        children: [
                                            "Also in this section ",
                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                className: "icon icon-common icon-angle-down"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("ul", {
                                        children: extraItemsVisible && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                            className: "EBINavBar--extra-items-menu",
                                            children: childrenList.slice(visibleElements)
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        });
    }
}
$8cd9ce6bf89d90bb$var$EBINavBar.baseClass = 'EBINavBar';
var $8cd9ce6bf89d90bb$export$2e2bcd8739ae039 = $8cd9ce6bf89d90bb$var$EBINavBar;



parcelRequire("6kl77");
const $460c0bdd20a37873$var$EBINavItem = (props)=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)("li", {
        className: props.className,
        onClick: props.handleClickChildFunction,
        children: props.children
    });
var $460c0bdd20a37873$export$2e2bcd8739ae039 = $460c0bdd20a37873$var$EBINavItem;





var $6kl77 = parcelRequire("6kl77");

class $1d2886bd092f551c$var$EBINavDropDown extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleClickChild", ()=>{
            this.setState({
                expanded: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($585203cf2ca61400$exports)))(this, "handleClickExpandLink", ()=>{
            this.setState({
                expanded: !this.state.expanded
            });
        });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { handleClickChild: handleClickChild, handleClickExpandLink: handleClickExpandLink, props: { handleClickChildFunction: handleClickChildFunction, children: children, caption: caption }, state: { expanded: expanded } } = this;
        const childrenList = (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).cloneElement(child, {
                handleClickChildFunction: ()=>{
                    handleClickChild();
                    handleClickChildFunction && handleClickChildFunction();
                }
            }));
        return /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                    href: "#!",
                    onClick: handleClickExpandLink,
                    children: [
                        caption,
                        " ",
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                            className: "icon icon-common icon-angle-down"
                        })
                    ]
                }),
                expanded && /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("ul", {
                        className: "EBINav-dropdown px-0",
                        children: childrenList
                    })
                })
            ]
        });
    }
}
var $1d2886bd092f551c$export$2e2bcd8739ae039 = $1d2886bd092f551c$var$EBINavDropDown;


var $aa56d47348bd6336$exports = {};
$aa56d47348bd6336$exports = $parcel$resolve("esn4O");


const $dd1e5b7e463f3ab7$var$identifiersLogo = new URL($aa56d47348bd6336$exports);
// This code was written for v5 and code adjusts v6 to have the same behavious as v5
// https://reactrouter.com/en/main/components/nav-link
const $dd1e5b7e463f3ab7$var$NavLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).forwardRef(({ activeClassName: activeClassName, activeStyle: activeStyle, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f2b0a7bd8c2e9c22$export$b0d92dbee9b5b60d), {
        ref: ref,
        ...props,
        className: ({ isActive: isActive })=>[
                props.className,
                isActive ? activeClassName : null
            ].filter(Boolean).join(" "),
        style: ({ isActive: isActive })=>({
                ...props.style,
                ...isActive ? activeStyle : null
            })
    });
});
class $dd1e5b7e463f3ab7$var$Header extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
    }
    componentDidMount() {
        ebiFrameworkPopulateBlackBar();
        ebiFrameworkActivateBlackBar();
        ebiFrameworkExternalLinks();
        ebiFrameworkManageGlobalSearch();
        ebiFrameworkSearchNullError();
        ebiFrameworkHideGlobalNav();
        ebiFrameworkAssignImageByMetaTags();
        ebiFrameworkInsertEMBLdropdown();
    }
    render() {
        const { config: config } = this.props;
        return(// This is EMBL-EBI Enforced boilerplate header.
        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("header", {
                    id: "masthead-black-bar",
                    className: "clearfix masthead-black-bar expanded"
                }),
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    id: "content",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                        "data-sticky-container": true,
                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                            id: "masthead",
                            className: "masthead",
                            "data-sticky": true,
                            "data-sticky-on": "large",
                            "data-top-anchor": "main-content-area:top",
                            "data-btm-anchor": "main-content-area:bottom",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                                className: "masthead-inner row expanded mx-0 px-0",
                                children: [
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                        className: "columns medium-12",
                                        id: "local-title",
                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                                            className: "d-flex ms-3 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("img", {
                                                    src: $dd1e5b7e463f3ab7$var$identifiersLogo,
                                                    alt: "identifiers logo"
                                                }),
                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                                                    className: "logo-text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("h1", {
                                                            children: "Identifiers.org"
                                                        }),
                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                                                            className: "logo-subtitle",
                                                            children: "Resolution service"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                                        className: "sticky-placeholder px-0",
                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $0084ca0e793ff315$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8cd9ce6bf89d90bb$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)($dd1e5b7e463f3ab7$var$NavLink, {
                                                            to: "/",
                                                            className: "nav-link nav-link-dark",
                                                            activeClassName: "active",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-external-link-alt"
                                                                }),
                                                                " Resolution"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                                            href: config.registryUrl,
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-list"
                                                                }),
                                                                " Registry"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                                            href: `${config.registryUrl}/registry`,
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-search"
                                                                }),
                                                                " Browse the registry"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $1d2886bd092f551c$export$2e2bcd8739ae039), {
                                                        caption: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-hand-point-up me-1"
                                                                }),
                                                                "Make a request"
                                                            ]
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                                className: "nav-item",
                                                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                                                    href: `${config.registryUrl}/prefixregistrationrequest`,
                                                                    className: "nav-link nav-link-dark",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                            className: "icon icon-common icon-leaf me-1"
                                                                        }),
                                                                        "Request prefix"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                                className: "nav-item",
                                                                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                                                    href: `${config.registryUrl}/resourceregistrationrequest`,
                                                                    className: "nav-link nav-link-dark",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                            className: "icon icon-common icon-cube me-1"
                                                                        }),
                                                                        "Request resource"
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                                            href: config.documentationUrl,
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-documentation"
                                                                }),
                                                                " Documentation"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $460c0bdd20a37873$export$2e2bcd8739ae039), {
                                                        className: "nav-item float-end",
                                                        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("a", {
                                                            href: config.feedbackUrl,
                                                            target: "_blank",
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-comments"
                                                                }),
                                                                " Feedback"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        }));
    }
}
// Redux mappings.
const $dd1e5b7e463f3ab7$var$mapStateToProps = (state)=>({
        config: state.config
    });
var $dd1e5b7e463f3ab7$export$2e2bcd8739ae039 = (0, $128f50888c77ce5a$export$2e2bcd8739ae039)($dd1e5b7e463f3ab7$var$mapStateToProps)($dd1e5b7e463f3ab7$var$Header);




var $6kl77 = parcelRequire("6kl77");
var $dfcb512a111c59dc$exports = {};
$dfcb512a111c59dc$exports = $parcel$resolve("1Ui0B");


const $720e6aa7abbbc194$var$elixirKiteMark = new URL($dfcb512a111c59dc$exports);
class $720e6aa7abbbc194$var$Footer extends (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).Component {
    constructor(props){
        super(props);
    }
    componentDidMount() {
        ebiFrameworkUpdateFoot();
        ebiFrameworkUpdateFooterMeta();
        ebiFrameworkIncludeAnnouncements();
        ebiFrameworkRunDataProtectionBanner('1.4');
    }
    render() {
        return(// This is EMBL-EBI Enforced boilerplate footer.
        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                    className: "row footer-section align-items-center mb-2 mx-5 bg-light py-2",
                    children: [
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                            className: "col col-xl-1",
                            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("img", {
                                src: $720e6aa7abbbc194$var$elixirKiteMark,
                                alt: "Elixir mark"
                            })
                        }),
                        /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                            className: "col col-xl-11",
                            children: [
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                    children: "This service"
                                }),
                                " is part of the ELIXIR infrastructure",
                                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("p", {
                                    className: "mb-0",
                                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("small", {
                                        children: [
                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("span", {
                                                children: "Identifiers.org is an ELIXIR Interoperability Platform resource "
                                            }),
                                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("a", {
                                                href: "https://elixir-europe.org/platforms/interoperability",
                                                target: "_blank",
                                                className: "text-primary",
                                                children: "Learn more"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("footer", {
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsxs)("div", {
                        id: "global-footer",
                        className: "global-footer",
                        children: [
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("nav", {
                                id: "global-nav-expanded",
                                className: "global-nav-expanded row"
                            }),
                            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("section", {
                                id: "ebi-footer-meta",
                                className: "ebi-footer-meta row"
                            })
                        ]
                    })
                })
            ]
        }));
    }
}
var $720e6aa7abbbc194$export$2e2bcd8739ae039 = $720e6aa7abbbc194$var$Footer;


var $b8df185a2fa1264b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $8939768198127506$exports.jsxs)((0, $8939768198127506$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $dd1e5b7e463f3ab7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)("div", {
                    className: "w-100 pt-5",
                    children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f500c00b0505d3a1$export$910ae8079b2c2852), {})
                })
            }),
            /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $720e6aa7abbbc194$export$2e2bcd8739ae039), {})
        ]
    });


function $98f6749f81f7e6f4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $98f6749f81f7e6f4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $98f6749f81f7e6f4$export$2e2bcd8739ae039(o);
}



function $9851197793fd58dc$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $98f6749f81f7e6f4$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $98f6749f81f7e6f4$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $b426d272611b108d$export$2e2bcd8739ae039(t) {
    var i = (0, $9851197793fd58dc$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $98f6749f81f7e6f4$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $d1a27408b26385b3$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $b426d272611b108d$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $72b8690bc067643a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $72b8690bc067643a$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $72b8690bc067643a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d1a27408b26385b3$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $72b8690bc067643a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f9e5b52de85f8ab7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $f9e5b52de85f8ab7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f9e5b52de85f8ab7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $f9e5b52de85f8ab7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f9e5b52de85f8ab7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f9e5b52de85f8ab7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f9e5b52de85f8ab7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f9e5b52de85f8ab7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f9e5b52de85f8ab7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($f9e5b52de85f8ab7$var$isDate(val)) return 'date';
    if ($f9e5b52de85f8ab7$var$isError(val)) return 'error';
    var constructorName = $f9e5b52de85f8ab7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $f9e5b52de85f8ab7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $f9e5b52de85f8ab7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $f9e5b52de85f8ab7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $f9e5b52de85f8ab7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f9e5b52de85f8ab7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(1));
        return enhancer($f9e5b52de85f8ab7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f9e5b52de85f8ab7$var$isPlainObject(action)) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f9e5b52de85f8ab7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f9e5b52de85f8ab7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f9e5b52de85f8ab7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f9e5b52de85f8ab7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f9e5b52de85f8ab7$export$8928921ea2d3b126 = $f9e5b52de85f8ab7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f9e5b52de85f8ab7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f9e5b52de85f8ab7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f9e5b52de85f8ab7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f9e5b52de85f8ab7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $f9e5b52de85f8ab7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f9e5b52de85f8ab7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $f9e5b52de85f8ab7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f9e5b52de85f8ab7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f9e5b52de85f8ab7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f9e5b52de85f8ab7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f9e5b52de85f8ab7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f9e5b52de85f8ab7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f9e5b52de85f8ab7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $f9e5b52de85f8ab7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $f9e5b52de85f8ab7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f9e5b52de85f8ab7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f9e5b52de85f8ab7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f9e5b52de85f8ab7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f9e5b52de85f8ab7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $72b8690bc067643a$export$2e2bcd8739ae039)((0, $72b8690bc067643a$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $d24c4e8773237fff$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $d24c4e8773237fff$var$thunk = $d24c4e8773237fff$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$d24c4e8773237fff$var$thunk.withExtraArgument = $d24c4e8773237fff$var$createThunkMiddleware;
var $d24c4e8773237fff$export$2e2bcd8739ae039 = $d24c4e8773237fff$var$thunk;



// Config reducer
const $a0af66e494d0308b$var$defaultState = (0, $daaee31eed9617db$export$e506a1d27d1eaa20);
const $a0af66e494d0308b$var$configReducer = (state = $a0af66e494d0308b$var$defaultState, action)=>{
    switch(action.type){
        // Set store namespace list to the supplied one.
        case 'SET_CONFIG':
            return {
                ...state,
                ...action.config
            };
        default:
            return state;
    }
};
var $a0af66e494d0308b$export$2e2bcd8739ae039 = $a0af66e494d0308b$var$configReducer;


// Namespaces List reducer
const $70f3f63060f7e9e5$var$defaultState = [];
const $70f3f63060f7e9e5$var$namespaceListReducer = (state = $70f3f63060f7e9e5$var$defaultState, action)=>{
    switch(action.type){
        // Set store namespace list to the supplied one.
        case 'SET_NAMESPACELIST':
            return action.namespaceList;
        case 'SET_RESOURCES':
            {
                // Adds resources to namespace specified by action.prefix.
                let newNamespaceList = state.map((ns)=>{
                    if (ns.prefix === action.prefix) ns['resources'] = action.resources;
                    return ns;
                });
                return newNamespaceList;
            }
        default:
            return state;
    }
};
var $70f3f63060f7e9e5$export$2e2bcd8739ae039 = $70f3f63060f7e9e5$var$namespaceListReducer;


// ResolvedResources reducer
const $3ef4db8fb01f116b$var$defaultState = [];
const $3ef4db8fb01f116b$var$resolvedResourcesReducer = (state = $3ef4db8fb01f116b$var$defaultState, action)=>{
    switch(action.type){
        // Set store namespace list to the supplied one.
        case 'SET_RESOLVEDRESOURCES':
            return action.resolvedResources;
        default:
            return state;
    }
};
var $3ef4db8fb01f116b$export$2e2bcd8739ae039 = $3ef4db8fb01f116b$var$resolvedResourcesReducer;


const $c8ae838d33f4e66e$var$defaultState = {};
const $c8ae838d33f4e66e$var$schemaOrgMetadataReducer = (state = $c8ae838d33f4e66e$var$defaultState, action)=>{
    switch(action.type){
        // Set Schema.org metadata to the supplied one.
        case 'SET_SCHEMAORGMETADATA':
            return {
                ...action.schemaOrgMetadata
            };
        default:
            return state;
    }
};
var $c8ae838d33f4e66e$export$2e2bcd8739ae039 = $c8ae838d33f4e66e$var$schemaOrgMetadataReducer;


const $1cd9394d94558a21$var$composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $f9e5b52de85f8ab7$export$f672e0b6f7222cd7);
//
// Store management.
//
// Store creation.
const $1cd9394d94558a21$var$store = (0, $f9e5b52de85f8ab7$export$f51a9068ac82ea43)((0, $f9e5b52de85f8ab7$export$66e4520cdb265d18)({
    config: (0, $a0af66e494d0308b$export$2e2bcd8739ae039),
    namespaceList: (0, $70f3f63060f7e9e5$export$2e2bcd8739ae039),
    resolvedResources: (0, $3ef4db8fb01f116b$export$2e2bcd8739ae039),
    schemaOrgMetadata: (0, $c8ae838d33f4e66e$export$2e2bcd8739ae039)
}), $1cd9394d94558a21$var$composeEnhancers((0, $f9e5b52de85f8ab7$export$9ff26e0402cc7b7)((0, $d24c4e8773237fff$export$2e2bcd8739ae039))));
var $1cd9394d94558a21$export$2e2bcd8739ae039 = $1cd9394d94558a21$var$store;



const $fce2432f9efff74f$var$cidLoader = ({ params: params })=>{
    const cid = params["*"];
    if (!cid) return (0, $752b3505f31cd997$export$260e5c0943f31606)({
        resolverData: Promise.reject("Compact identifier is empty")
    });
    const resolverApi = (0, $1cd9394d94558a21$export$2e2bcd8739ae039).getState().config.resolverApi || (0, $daaee31eed9617db$export$e506a1d27d1eaa20).resolverApi;
    const resolverQueryUrl = new URL("/" + cid, resolverApi);
    const res = fetch(resolverQueryUrl).then((res)=>{
        if (!res.ok) return Promise.reject(`Resolution failed for ${cid}`);
        else return res.json();
    });
    return (0, $752b3505f31cd997$export$260e5c0943f31606)({
        resolverData: res
    });
};
const $fce2432f9efff74f$var$routes = [
    {
        //AppLayout is needed to make sure Header is inside router for the nav elements
        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $b8df185a2fa1264b$export$2e2bcd8739ae039), {}),
        children: [
            {
                //Outlet element is needed to make everyone share the same error element
                element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f500c00b0505d3a1$export$910ae8079b2c2852), {}),
                errorElement: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f3027cde706e99b4$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $d6770ce9a6d412e8$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/resolve",
                        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $40131eda7fdc2fca$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/reverseResolve",
                        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $48cb6205ba1e38f7$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/protectedLanding/*",
                        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $101c473c18f0bc8f$export$2e2bcd8739ae039), {}),
                        loader: $fce2432f9efff74f$var$cidLoader
                    },
                    {
                        path: "/deactivatedLanding/*",
                        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $033ff44ce612d10c$export$2e2bcd8739ae039), {}),
                        loader: $fce2432f9efff74f$var$cidLoader
                    },
                    {
                        path: "*",
                        element: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f3027cde706e99b4$export$2e2bcd8739ae039), {})
                    }
                ]
            }
        ]
    }
];
const $fce2432f9efff74f$var$router = (0, $f2b0a7bd8c2e9c22$export$1f3f55432a00e06d)($fce2432f9efff74f$var$routes);
var $fce2432f9efff74f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $f2b0a7bd8c2e9c22$export$323e4fc2fa4753fb), {
        router: $fce2432f9efff74f$var$router
    });




// eslint-disable-next-line import/prefer-default-export
const $cf8bccc0d0454f77$export$882fee97acc33843 = {
    TRACK_EVENT: 'trackEvent',
    TRACK_LINK: 'trackLink',
    TRACK_SEARCH: 'trackSiteSearch',
    TRACK_VIEW: 'trackPageView',
    TRACK_ECOMMERCE_ORDER: 'trackEcommerceOrder',
    TRACK_ECOMMERCE_CART_UPDATE: 'trackEcommerceCartUpdate'
};


var $c60d7e098a979724$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $c60d7e098a979724$var$MatomoTracker {
    constructor(userOptions){
        if (!userOptions.urlBase) throw new Error('Matomo urlBase is required.');
        if (!userOptions.siteId) throw new Error('Matomo siteId is required.');
        this.initialize(userOptions);
    }
    initialize({ urlBase: urlBase, siteId: siteId, userId: userId, trackerUrl: trackerUrl, srcUrl: srcUrl, disabled: disabled, heartBeat: heartBeat, linkTracking: linkTracking = true, configurations: configurations = {} }) {
        var _a;
        const normalizedUrlBase = urlBase[urlBase.length - 1] !== '/' ? `${urlBase}/` : urlBase;
        if (typeof window === 'undefined') return;
        window._paq = window._paq || [];
        if (window._paq.length !== 0) return;
        if (disabled) return;
        this.pushInstruction('setTrackerUrl', trackerUrl !== null && trackerUrl !== void 0 ? trackerUrl : `${normalizedUrlBase}matomo.php`);
        this.pushInstruction('setSiteId', siteId);
        if (userId) this.pushInstruction('setUserId', userId);
        Object.entries(configurations).forEach(([name, instructions])=>{
            if (instructions instanceof Array) this.pushInstruction(name, ...instructions);
            else this.pushInstruction(name, instructions);
        });
        // accurately measure the time spent on the last pageview of a visit
        if (!heartBeat || heartBeat && heartBeat.active) this.enableHeartBeatTimer((_a = heartBeat && heartBeat.seconds) !== null && _a !== void 0 ? _a : 15);
        // // measure outbound links and downloads
        // // might not work accurately on SPAs because new links (dom elements) are created dynamically without a server-side page reload.
        this.enableLinkTracking(linkTracking);
        const doc = document;
        const scriptElement = doc.createElement('script');
        const scripts = doc.getElementsByTagName('script')[0];
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = srcUrl || `${normalizedUrlBase}matomo.js`;
        if (scripts && scripts.parentNode) scripts.parentNode.insertBefore(scriptElement, scripts);
    }
    enableHeartBeatTimer(seconds) {
        this.pushInstruction('enableHeartBeatTimer', seconds);
    }
    enableLinkTracking(active) {
        this.pushInstruction('enableLinkTracking', active);
    }
    trackEventsForElements(elements) {
        if (elements.length) elements.forEach((element)=>{
            element.addEventListener('click', ()=>{
                const { matomoCategory: matomoCategory, matomoAction: matomoAction, matomoName: matomoName, matomoValue: matomoValue } = element.dataset;
                if (matomoCategory && matomoAction) this.trackEvent({
                    category: matomoCategory,
                    action: matomoAction,
                    name: matomoName,
                    value: Number(matomoValue)
                });
                else throw new Error(`Error: data-matomo-category and data-matomo-action are required.`);
            });
        });
    }
    // Tracks events based on data attributes
    trackEvents() {
        const matchString = '[data-matomo-event="click"]';
        let firstTime = false;
        if (!this.mutationObserver) {
            firstTime = true;
            this.mutationObserver = new MutationObserver((mutations)=>{
                mutations.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        // only track HTML elements
                        if (!(node instanceof HTMLElement)) return;
                        // check the inserted element for being a code snippet
                        if (node.matches(matchString)) this.trackEventsForElements([
                            node
                        ]);
                        const elements = Array.from(node.querySelectorAll(matchString));
                        this.trackEventsForElements(elements);
                    });
                });
            });
        }
        this.mutationObserver.observe(document, {
            childList: true,
            subtree: true
        });
        // Now track all already existing elements
        if (firstTime) {
            const elements = Array.from(document.querySelectorAll(matchString));
            this.trackEventsForElements(elements);
        }
    }
    stopObserving() {
        if (this.mutationObserver) this.mutationObserver.disconnect();
    }
    // Tracks events
    // https://matomo.org/docs/event-tracking/#tracking-events
    trackEvent(_a) {
        var { category: category, action: action, name: name, value: value } = _a, otherParams = $c60d7e098a979724$var$__rest(_a, [
            "category",
            "action",
            "name",
            "value"
        ]);
        if (category && action) this.track(Object.assign({
            data: [
                (0, $cf8bccc0d0454f77$export$882fee97acc33843).TRACK_EVENT,
                category,
                action,
                name,
                value
            ]
        }, otherParams));
        else throw new Error(`Error: category and action are required.`);
    }
    // Tracks site search
    // https://developer.matomo.org/guides/tracking-javascript-guide#internal-search-tracking
    trackSiteSearch(_a) {
        var { keyword: keyword, category: category, count: count } = _a, otherParams = $c60d7e098a979724$var$__rest(_a, [
            "keyword",
            "category",
            "count"
        ]);
        if (keyword) this.track(Object.assign({
            data: [
                (0, $cf8bccc0d0454f77$export$882fee97acc33843).TRACK_SEARCH,
                keyword,
                category,
                count
            ]
        }, otherParams));
        else throw new Error(`Error: keyword is required.`);
    }
    // Tracks outgoing links to other sites and downloads
    // https://developer.matomo.org/guides/tracking-javascript-guide#enabling-download-outlink-tracking
    trackLink({ href: href, linkType: linkType = 'link' }) {
        this.pushInstruction((0, $cf8bccc0d0454f77$export$882fee97acc33843).TRACK_LINK, href, linkType);
    }
    // Tracks page views
    // https://developer.matomo.org/guides/spa-tracking#tracking-a-new-page-view
    trackPageView(params) {
        this.track(Object.assign({
            data: [
                (0, $cf8bccc0d0454f77$export$882fee97acc33843).TRACK_VIEW
            ]
        }, params));
    }
    // Adds a product to an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    // https://matomo.org/docs/ecommerce-analytics/#1-addecommerceitemproductsku-productname-productcategory-price-quantity
    addEcommerceItem({ sku: sku, productName: productName, productCategory: productCategory, productPrice: productPrice = 0.0, productQuantity: productQuantity = 1 }) {
        this.pushInstruction('addEcommerceItem', sku, productName, productCategory, productPrice, productQuantity);
    }
    // Removes a product from an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    removeEcommerceItem({ sku: sku }) {
        this.pushInstruction('removeEcommerceItem', sku);
    }
    // Removes all products from an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    clearEcommerceCart() {
        this.pushInstruction('clearEcommerceCart');
    }
    // Tracks an Ecommerce order containing items added via addEcommerceItem.
    // https://matomo.org/docs/ecommerce-analytics/#2-trackecommerceorderorderid-revenue-subtotal-tax-shipping-discount
    trackEcommerceOrder({ orderId: orderId, orderRevenue: orderRevenue, orderSubTotal: orderSubTotal, taxAmount: taxAmount, shippingAmount: shippingAmount, discountOffered: discountOffered = false }) {
        this.track({
            data: [
                (0, $cf8bccc0d0454f77$export$882fee97acc33843).TRACK_ECOMMERCE_ORDER,
                orderId,
                orderRevenue,
                orderSubTotal,
                taxAmount,
                shippingAmount,
                discountOffered
            ]
        });
    }
    // Tracks updates to an Ecommerce Cart before an actual purchase.
    // This will replace currently tracked information of the cart. Always include all items of the updated cart!
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-an-ecommerce-cart-update-containing-two-products
    trackEcommerceCartUpdate(amount) {
        this.pushInstruction((0, $cf8bccc0d0454f77$export$882fee97acc33843).TRACK_ECOMMERCE_CART_UPDATE, amount);
    }
    // Marks the next page view as an Ecommerce product page.
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-a-product-page-view
    setEcommerceView({ sku: sku, productName: productName, productCategory: productCategory, productPrice: productPrice }) {
        this.pushInstruction('setEcommerceView', sku, productName, productCategory, productPrice);
    }
    // Marks the next tracked page view as an Ecommerce category page.
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-a-category-page-view
    setEcommerceCategoryView(productCategory) {
        this.setEcommerceView({
            productCategory: productCategory,
            productName: false,
            sku: false
        });
    }
    // Sends the tracked page/view/search to Matomo
    track({ data: data = [], documentTitle: documentTitle = window.document.title, href: href, customDimensions: customDimensions = false }) {
        if (data.length) {
            if (customDimensions && Array.isArray(customDimensions) && customDimensions.length) customDimensions.map((customDimension)=>this.pushInstruction('setCustomDimension', customDimension.id, customDimension.value));
            this.pushInstruction('setCustomUrl', href !== null && href !== void 0 ? href : window.location.href);
            this.pushInstruction('setDocumentTitle', documentTitle);
            this.pushInstruction(...data);
        }
    }
    /**
     * Pushes an instruction to Matomo for execution, this is equivalent to pushing entries into the `_paq` array.
     *
     * For example:
     *
     * ```ts
     * pushInstruction('setDocumentTitle', document.title)
     * ```
     * Is the equivalent of:
     *
     * ```ts
     * _paq.push(['setDocumentTitle', document.title]);
     * ```
     *
     * @param name The name of the instruction to be executed.
     * @param args The arguments to pass along with the instruction.
     */ pushInstruction(name, ...args) {
        if (typeof window !== 'undefined') // eslint-disable-next-line
        window._paq.push([
            name,
            ...args
        ]);
        return this;
    }
}
var $c60d7e098a979724$export$2e2bcd8739ae039 = $c60d7e098a979724$var$MatomoTracker;



var $df14efd2700651f8$export$2e2bcd8739ae039 = (0, $c60d7e098a979724$export$2e2bcd8739ae039);


function $291a4c41d22e2de4$var$createInstance(params) {
    return new (0, $df14efd2700651f8$export$2e2bcd8739ae039)(params);
}
var $291a4c41d22e2de4$export$2e2bcd8739ae039 = $291a4c41d22e2de4$var$createInstance;


var $6kl77 = parcelRequire("6kl77");

const $792411052b99f68e$var$MatomoProvider = ({ children: children, value: value })=>{
    const Context = (0, $95a672726cdabda1$export$2e2bcd8739ae039);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6kl77))).createElement(Context.Provider, {
        value: value
    }, children);
};
var $792411052b99f68e$export$2e2bcd8739ae039 = $792411052b99f68e$var$MatomoProvider;


var $cde07559df7e738a$exports = {};

/*!
  * Bootstrap v5.3.5 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $cde07559df7e738a$exports = factory((parcelRequire("cseje")));
})($cde07559df7e738a$exports, function(Popper) {
    'use strict';
    function _interopNamespaceDefault(e) {
        const n = Object.create(null, {
            [Symbol.toStringTag]: {
                value: 'Module'
            }
        });
        if (e) {
            for(const k in e)if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespaceDefault(Popper);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const Data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = 'transitionend';
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(',')[0];
        transitionDelay = transitionDelay.split(',')[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (object)=>{
        if (!object || typeof object !== 'object') return false;
        if (typeof object.jquery !== 'undefined') object = object[0];
        return typeof object.nodeType !== 'undefined';
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === 'string' && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest('details:not([open])');
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest('summary');
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains('disabled')) return true;
        if (typeof element.disabled !== 'undefined') return element.disabled;
        return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === 'function') {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === 'loading') {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === 'rtl';
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    };
    const nativeEvents = new Set([
        'click',
        'dblclick',
        'mouseup',
        'mousedown',
        'contextmenu',
        'mousewheel',
        'DOMMouseScroll',
        'mouseover',
        'mouseout',
        'mousemove',
        'selectstart',
        'selectend',
        'keydown',
        'keypress',
        'keyup',
        'orientationchange',
        'touchstart',
        'touchmove',
        'touchend',
        'touchcancel',
        'pointerdown',
        'pointermove',
        'pointerup',
        'pointerleave',
        'pointercancel',
        'gesturestart',
        'gesturechange',
        'gestureend',
        'focus',
        'blur',
        'change',
        'reset',
        'select',
        'submit',
        'focusin',
        'focusout',
        'load',
        'unload',
        'beforeunload',
        'resize',
        'move',
        'DOMContentLoaded',
        'readystatechange',
        'error',
        'abort',
        'scroll'
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === 'string';
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ''));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, '');
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== 'string' || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith('.');
            if (typeof callable !== 'undefined') {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== 'string' || !element) return null;
            const $ = getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === 'true') return true;
        if (value === 'false') return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === '' || value === 'null') return null;
        if (typeof value !== 'string') return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = isElement(element) ? Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === 'object' ? jsonConfig : {},
                ...isElement(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === 'object' ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = isElement(value) ? 'element' : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = '5.3.5';
    /**
   * Class definition
   */ class BaseComponent extends Config {
        constructor(element, config){
            super();
            element = getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        _queueCallback(callback, element, isAnimated = true) {
            executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute('data-bs-target');
        if (!selector || selector === '#') {
            let hrefAttribute = element.getAttribute('href');
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
            selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(',').map((sel)=>parseSelector(sel)).join(',') : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                'a',
                'button',
                'input',
                'textarea',
                'select',
                'details',
                '[tabindex]',
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
            return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = 'hide')=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                'A',
                'AREA'
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target);
            // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$f = 'alert';
    const DATA_KEY$a = 'bs.alert';
    const EVENT_KEY$b = `.${DATA_KEY$a}`;
    const EVENT_CLOSE = `close${EVENT_KEY$b}`;
    const EVENT_CLOSED = `closed${EVENT_KEY$b}`;
    const CLASS_NAME_FADE$5 = 'fade';
    const CLASS_NAME_SHOW$8 = 'show';
    /**
   * Class definition
   */ class Alert extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$f;
        }
        // Public
        close() {
            const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
            if (closeEvent.defaultPrevented) return;
            this._element.classList.remove(CLASS_NAME_SHOW$8);
            const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
            this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
        }
        // Private
        _destroyElement() {
            this._element.remove();
            EventHandler.trigger(this._element, EVENT_CLOSED);
            this.dispose();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Alert.getOrCreateInstance(this);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Alert, 'close');
    /**
   * jQuery
   */ defineJQueryPlugin(Alert);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$e = 'button';
    const DATA_KEY$9 = 'bs.button';
    const EVENT_KEY$a = `.${DATA_KEY$9}`;
    const DATA_API_KEY$6 = '.data-api';
    const CLASS_NAME_ACTIVE$3 = 'active';
    const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
    const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
    /**
   * Class definition
   */ class Button extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$e;
        }
        // Public
        toggle() {
            // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
            this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Button.getOrCreateInstance(this);
                if (config === 'toggle') data[config]();
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, (event)=>{
        event.preventDefault();
        const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
        const data = Button.getOrCreateInstance(button);
        data.toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Button);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/swipe.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$d = 'swipe';
    const EVENT_KEY$9 = '.bs.swipe';
    const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$9}`;
    const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$9}`;
    const EVENT_TOUCHEND = `touchend${EVENT_KEY$9}`;
    const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$9}`;
    const EVENT_POINTERUP = `pointerup${EVENT_KEY$9}`;
    const POINTER_TYPE_TOUCH = 'touch';
    const POINTER_TYPE_PEN = 'pen';
    const CLASS_NAME_POINTER_EVENT = 'pointer-event';
    const SWIPE_THRESHOLD = 40;
    const Default$c = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    };
    const DefaultType$c = {
        endCallback: '(function|null)',
        leftCallback: '(function|null)',
        rightCallback: '(function|null)'
    };
    /**
   * Class definition
   */ class Swipe extends Config {
        constructor(element, config){
            super();
            this._element = element;
            if (!element || !Swipe.isSupported()) return;
            this._config = this._getConfig(config);
            this._deltaX = 0;
            this._supportPointerEvents = Boolean(window.PointerEvent);
            this._initEvents();
        }
        // Getters
        static get Default() {
            return Default$c;
        }
        static get DefaultType() {
            return DefaultType$c;
        }
        static get NAME() {
            return NAME$d;
        }
        // Public
        dispose() {
            EventHandler.off(this._element, EVENT_KEY$9);
        }
        // Private
        _start(event) {
            if (!this._supportPointerEvents) {
                this._deltaX = event.touches[0].clientX;
                return;
            }
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
        }
        _end(event) {
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
            this._handleSwipe();
            execute(this._config.endCallback);
        }
        _move(event) {
            this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
            const absDeltaX = Math.abs(this._deltaX);
            if (absDeltaX <= SWIPE_THRESHOLD) return;
            const direction = absDeltaX / this._deltaX;
            this._deltaX = 0;
            if (!direction) return;
            execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
        }
        _initEvents() {
            if (this._supportPointerEvents) {
                EventHandler.on(this._element, EVENT_POINTERDOWN, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_POINTERUP, (event)=>this._end(event));
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                EventHandler.on(this._element, EVENT_TOUCHSTART, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_TOUCHMOVE, (event)=>this._move(event));
                EventHandler.on(this._element, EVENT_TOUCHEND, (event)=>this._end(event));
            }
        }
        _eventIsPointerPenTouch(event) {
            return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
        }
        // Static
        static isSupported() {
            return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$c = 'carousel';
    const DATA_KEY$8 = 'bs.carousel';
    const EVENT_KEY$8 = `.${DATA_KEY$8}`;
    const DATA_API_KEY$5 = '.data-api';
    const ARROW_LEFT_KEY$1 = 'ArrowLeft';
    const ARROW_RIGHT_KEY$1 = 'ArrowRight';
    const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    const ORDER_NEXT = 'next';
    const ORDER_PREV = 'prev';
    const DIRECTION_LEFT = 'left';
    const DIRECTION_RIGHT = 'right';
    const EVENT_SLIDE = `slide${EVENT_KEY$8}`;
    const EVENT_SLID = `slid${EVENT_KEY$8}`;
    const EVENT_KEYDOWN$1 = `keydown${EVENT_KEY$8}`;
    const EVENT_MOUSEENTER$1 = `mouseenter${EVENT_KEY$8}`;
    const EVENT_MOUSELEAVE$1 = `mouseleave${EVENT_KEY$8}`;
    const EVENT_DRAG_START = `dragstart${EVENT_KEY$8}`;
    const EVENT_LOAD_DATA_API$3 = `load${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const CLASS_NAME_CAROUSEL = 'carousel';
    const CLASS_NAME_ACTIVE$2 = 'active';
    const CLASS_NAME_SLIDE = 'slide';
    const CLASS_NAME_END = 'carousel-item-end';
    const CLASS_NAME_START = 'carousel-item-start';
    const CLASS_NAME_NEXT = 'carousel-item-next';
    const CLASS_NAME_PREV = 'carousel-item-prev';
    const SELECTOR_ACTIVE = '.active';
    const SELECTOR_ITEM = '.carousel-item';
    const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
    const SELECTOR_ITEM_IMG = '.carousel-item img';
    const SELECTOR_INDICATORS = '.carousel-indicators';
    const SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
    const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
    const KEY_TO_DIRECTION = {
        [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
        [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
    };
    const Default$b = {
        interval: 5000,
        keyboard: true,
        pause: 'hover',
        ride: false,
        touch: true,
        wrap: true
    };
    const DefaultType$b = {
        interval: '(number|boolean)',
        // TODO:v6 remove boolean support
        keyboard: 'boolean',
        pause: '(string|boolean)',
        ride: '(boolean|string)',
        touch: 'boolean',
        wrap: 'boolean'
    };
    /**
   * Class definition
   */ class Carousel extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._interval = null;
            this._activeElement = null;
            this._isSliding = false;
            this.touchTimeout = null;
            this._swipeHelper = null;
            this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
            this._addEventListeners();
            if (this._config.ride === CLASS_NAME_CAROUSEL) this.cycle();
        }
        // Getters
        static get Default() {
            return Default$b;
        }
        static get DefaultType() {
            return DefaultType$b;
        }
        static get NAME() {
            return NAME$c;
        }
        // Public
        next() {
            this._slide(ORDER_NEXT);
        }
        nextWhenVisible() {
            // FIXME TODO use `document.visibilityState`
            // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && isVisible(this._element)) this.next();
        }
        prev() {
            this._slide(ORDER_PREV);
        }
        pause() {
            if (this._isSliding) triggerTransitionEnd(this._element);
            this._clearInterval();
        }
        cycle() {
            this._clearInterval();
            this._updateInterval();
            this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
        }
        _maybeEnableCycle() {
            if (!this._config.ride) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.cycle());
                return;
            }
            this.cycle();
        }
        to(index) {
            const items = this._getItems();
            if (index > items.length - 1 || index < 0) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.to(index));
                return;
            }
            const activeIndex = this._getItemIndex(this._getActive());
            if (activeIndex === index) return;
            const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
            this._slide(order, items[index]);
        }
        dispose() {
            if (this._swipeHelper) this._swipeHelper.dispose();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            config.defaultInterval = config.interval;
            return config;
        }
        _addEventListeners() {
            if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, (event)=>this._keydown(event));
            if (this._config.pause === 'hover') {
                EventHandler.on(this._element, EVENT_MOUSEENTER$1, ()=>this.pause());
                EventHandler.on(this._element, EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
            }
            if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
            for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element))EventHandler.on(img, EVENT_DRAG_START, (event)=>event.preventDefault());
            const endCallBack = ()=>{
                if (this._config.pause !== 'hover') return;
                // If it's a touch-enabled device, mouseenter/leave are fired as
                // part of the mouse compatibility events on first tap - the carousel
                // would stop cycling until user tapped out of it;
                // here, we listen for touchend, explicitly pause the carousel
                // (as if it's the second time we tap on it, mouseenter compat event
                // is NOT fired) and after a timeout (to allow for mouse compatibility
                // events to fire) we explicitly restart cycling
                this.pause();
                if (this.touchTimeout) clearTimeout(this.touchTimeout);
                this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
            };
            const swipeConfig = {
                leftCallback: ()=>this._slide(this._directionToOrder(DIRECTION_LEFT)),
                rightCallback: ()=>this._slide(this._directionToOrder(DIRECTION_RIGHT)),
                endCallback: endCallBack
            };
            this._swipeHelper = new Swipe(this._element, swipeConfig);
        }
        _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            const direction = KEY_TO_DIRECTION[event.key];
            if (direction) {
                event.preventDefault();
                this._slide(this._directionToOrder(direction));
            }
        }
        _getItemIndex(element) {
            return this._getItems().indexOf(element);
        }
        _setActiveIndicatorElement(index) {
            if (!this._indicatorsElement) return;
            const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
            activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
            activeIndicator.removeAttribute('aria-current');
            const newActiveIndicator = SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
            if (newActiveIndicator) {
                newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
                newActiveIndicator.setAttribute('aria-current', 'true');
            }
        }
        _updateInterval() {
            const element = this._activeElement || this._getActive();
            if (!element) return;
            const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
            this._config.interval = elementInterval || this._config.defaultInterval;
        }
        _slide(order, element = null) {
            if (this._isSliding) return;
            const activeElement = this._getActive();
            const isNext = order === ORDER_NEXT;
            const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
            if (nextElement === activeElement) return;
            const nextElementIndex = this._getItemIndex(nextElement);
            const triggerEvent = (eventName)=>{
                return EventHandler.trigger(this._element, eventName, {
                    relatedTarget: nextElement,
                    direction: this._orderToDirection(order),
                    from: this._getItemIndex(activeElement),
                    to: nextElementIndex
                });
            };
            const slideEvent = triggerEvent(EVENT_SLIDE);
            if (slideEvent.defaultPrevented) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            // TODO: change tests that use empty divs to avoid this check
            return;
            const isCycling = Boolean(this._interval);
            this.pause();
            this._isSliding = true;
            this._setActiveIndicatorElement(nextElementIndex);
            this._activeElement = nextElement;
            const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
            const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
            nextElement.classList.add(orderClassName);
            reflow(nextElement);
            activeElement.classList.add(directionalClassName);
            nextElement.classList.add(directionalClassName);
            const completeCallBack = ()=>{
                nextElement.classList.remove(directionalClassName, orderClassName);
                nextElement.classList.add(CLASS_NAME_ACTIVE$2);
                activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                this._isSliding = false;
                triggerEvent(EVENT_SLID);
            };
            this._queueCallback(completeCallBack, activeElement, this._isAnimated());
            if (isCycling) this.cycle();
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_SLIDE);
        }
        _getActive() {
            return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
        }
        _getItems() {
            return SelectorEngine.find(SELECTOR_ITEM, this._element);
        }
        _clearInterval() {
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
        }
        _directionToOrder(direction) {
            if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
            return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
        }
        _orderToDirection(order) {
            if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
            return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Carousel.getOrCreateInstance(this, config);
                if (typeof config === 'number') {
                    data.to(config);
                    return;
                }
                if (typeof config === 'string') {
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
        event.preventDefault();
        const carousel = Carousel.getOrCreateInstance(target);
        const slideIndex = this.getAttribute('data-bs-slide-to');
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if (Manipulator.getDataAttribute(this, 'slide') === 'next') {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$3, ()=>{
        const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
        for (const carousel of carousels)Carousel.getOrCreateInstance(carousel);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Carousel);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$b = 'collapse';
    const DATA_KEY$7 = 'bs.collapse';
    const EVENT_KEY$7 = `.${DATA_KEY$7}`;
    const DATA_API_KEY$4 = '.data-api';
    const EVENT_SHOW$6 = `show${EVENT_KEY$7}`;
    const EVENT_SHOWN$6 = `shown${EVENT_KEY$7}`;
    const EVENT_HIDE$6 = `hide${EVENT_KEY$7}`;
    const EVENT_HIDDEN$6 = `hidden${EVENT_KEY$7}`;
    const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$7}${DATA_API_KEY$4}`;
    const CLASS_NAME_SHOW$7 = 'show';
    const CLASS_NAME_COLLAPSE = 'collapse';
    const CLASS_NAME_COLLAPSING = 'collapsing';
    const CLASS_NAME_COLLAPSED = 'collapsed';
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
    const WIDTH = 'width';
    const HEIGHT = 'height';
    const SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
    const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
    const Default$a = {
        parent: null,
        toggle: true
    };
    const DefaultType$a = {
        parent: '(null|element)',
        toggle: 'boolean'
    };
    /**
   * Class definition
   */ class Collapse extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._isTransitioning = false;
            this._triggerArray = [];
            const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
            for (const elem of toggleList){
                const selector = SelectorEngine.getSelectorFromElement(elem);
                const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
                if (selector !== null && filterElement.length) this._triggerArray.push(elem);
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
        // Getters
        static get Default() {
            return Default$a;
        }
        static get DefaultType() {
            return DefaultType$a;
        }
        static get NAME() {
            return NAME$b;
        }
        // Public
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let activeChildren = [];
            // find active children
            if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                    toggle: false
                }));
            if (activeChildren.length && activeChildren[0]._isTransitioning) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
            if (startEvent.defaultPrevented) return;
            for (const activeInstance of activeChildren)activeInstance.hide();
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
                this._element.style[dimension] = '';
                EventHandler.trigger(this._element, EVENT_SHOWN$6);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
            for (const trigger of this._triggerArray){
                const element = SelectorEngine.getElementFromSelector(trigger);
                if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler.trigger(this._element, EVENT_HIDDEN$6);
            };
            this._element.style[dimension] = '';
            this._queueCallback(complete, this._element, true);
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW$7);
        }
        // Private
        _configAfterMerge(config) {
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = getElement(config.parent);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
            for (const element of children){
                const selected = SelectorEngine.getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            }
        }
        _getFirstLevelChildren(selector) {
            const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            // remove children if greater depth
            return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            for (const element of triggerArray){
                element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                element.setAttribute('aria-expanded', isOpen);
            }
        }
        // Static
        static jQueryInterface(config) {
            const _config = {};
            if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
            return this.each(function() {
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
        for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
            toggle: false
        }).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Collapse);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$a = 'dropdown';
    const DATA_KEY$6 = 'bs.dropdown';
    const EVENT_KEY$6 = `.${DATA_KEY$6}`;
    const DATA_API_KEY$3 = '.data-api';
    const ESCAPE_KEY$2 = 'Escape';
    const TAB_KEY$1 = 'Tab';
    const ARROW_UP_KEY$1 = 'ArrowUp';
    const ARROW_DOWN_KEY$1 = 'ArrowDown';
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const EVENT_HIDE$5 = `hide${EVENT_KEY$6}`;
    const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$6}`;
    const EVENT_SHOW$5 = `show${EVENT_KEY$6}`;
    const EVENT_SHOWN$5 = `shown${EVENT_KEY$6}`;
    const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const CLASS_NAME_SHOW$6 = 'show';
    const CLASS_NAME_DROPUP = 'dropup';
    const CLASS_NAME_DROPEND = 'dropend';
    const CLASS_NAME_DROPSTART = 'dropstart';
    const CLASS_NAME_DROPUP_CENTER = 'dropup-center';
    const CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
    const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE$3}.${CLASS_NAME_SHOW$6}`;
    const SELECTOR_MENU = '.dropdown-menu';
    const SELECTOR_NAVBAR = '.navbar';
    const SELECTOR_NAVBAR_NAV = '.navbar-nav';
    const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
    const PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
    const PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
    const PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
    const PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
    const PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
    const PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
    const PLACEMENT_TOPCENTER = 'top';
    const PLACEMENT_BOTTOMCENTER = 'bottom';
    const Default$9 = {
        autoClose: true,
        boundary: 'clippingParents',
        display: 'dynamic',
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: 'toggle'
    };
    const DefaultType$9 = {
        autoClose: '(boolean|string)',
        boundary: '(string|element)',
        display: 'string',
        offset: '(array|string|function)',
        popperConfig: '(null|object|function)',
        reference: '(string|element|object)'
    };
    /**
   * Class definition
   */ class Dropdown extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._popper = null;
            this._parent = this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
            this._inNavbar = this._detectNavbar();
        }
        // Getters
        static get Default() {
            return Default$9;
        }
        static get DefaultType() {
            return DefaultType$9;
        }
        static get NAME() {
            return NAME$a;
        }
        // Public
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (isDisabled(this._element) || this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
            if (showEvent.defaultPrevented) return;
            this._createPopper();
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ('ontouchstart' in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', noop);
            this._element.focus();
            this._element.setAttribute('aria-expanded', true);
            this._menu.classList.add(CLASS_NAME_SHOW$6);
            this._element.classList.add(CLASS_NAME_SHOW$6);
            EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
        }
        hide() {
            if (isDisabled(this._element) || !this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        // Private
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
            if (hideEvent.defaultPrevented) return;
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', noop);
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW$6);
            this._element.classList.remove(CLASS_NAME_SHOW$6);
            this._element.setAttribute('aria-expanded', 'false');
            Manipulator.removeDataAttribute(this._menu, 'popper');
            EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
        }
        _getConfig(config) {
            config = super._getConfig(config);
            if (typeof config.reference === 'object' && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper() {
            if (typeof Popper__namespace === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
            let referenceElement = this._element;
            if (this._config.reference === 'parent') referenceElement = this._parent;
            else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
            else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
        }
        _isShown() {
            return this._menu.classList.contains(CLASS_NAME_SHOW$6);
        }
        _getPlacement() {
            const parentDropdown = this._parent;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
            // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(SELECTOR_NAVBAR) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
            if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            // Disable Popper if we have a static display or Dropdown is in Navbar
            if (this._inNavbar || this._config.display === 'static') {
                Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                defaultBsPopperConfig.modifiers = [
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ];
            }
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ])
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>isVisible(element));
            if (!items.length) return;
            // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1) return;
            const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
            for (const toggle of openToggles){
                const context = Dropdown.getInstance(toggle);
                if (!context || context._config.autoClose === false) continue;
                const composedPath = event.composedPath();
                const isMenuTarget = composedPath.includes(context._menu);
                if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event.type === 'click') relatedTarget.clickEvent = event;
                context._completeHide(relatedTarget);
            }
        }
        static dataApiKeydownHandler(event) {
            // If not an UP | DOWN | ESCAPE key => not a dropdown command
            // If input/textarea && if key is other than ESCAPE => not a dropdown command
            const isInput = /input|textarea/i.test(event.target.tagName);
            const isEscapeEvent = event.key === ESCAPE_KEY$2;
            const isUpOrDownEvent = [
                ARROW_UP_KEY$1,
                ARROW_DOWN_KEY$1
            ].includes(event.key);
            if (!isUpOrDownEvent && !isEscapeEvent) return;
            if (isInput && !isEscapeEvent) return;
            event.preventDefault();
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (isUpOrDownEvent) {
                event.stopPropagation();
                instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (instance._isShown()) {
                // else is escape and we check if it is shown
                event.stopPropagation();
                instance.hide();
                getToggleButton.focus();
            }
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Dropdown);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$9 = 'backdrop';
    const CLASS_NAME_FADE$4 = 'fade';
    const CLASS_NAME_SHOW$5 = 'show';
    const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$9}`;
    const Default$8 = {
        className: 'modal-backdrop',
        clickCallback: null,
        isAnimated: false,
        isVisible: true,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: 'body' // give the choice to place backdrop under different elements
    };
    const DefaultType$8 = {
        className: 'string',
        clickCallback: '(function|null)',
        isAnimated: 'boolean',
        isVisible: 'boolean',
        rootElement: '(element|string)'
    };
    /**
   * Class definition
   */ class Backdrop extends Config {
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isAppended = false;
            this._element = null;
        }
        // Getters
        static get Default() {
            return Default$8;
        }
        static get DefaultType() {
            return DefaultType$8;
        }
        static get NAME() {
            return NAME$9;
        }
        // Public
        show(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._append();
            const element = this._getElement();
            if (this._config.isAnimated) reflow(element);
            element.classList.add(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                execute(callback);
            });
        }
        hide(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._getElement().classList.remove(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                this.dispose();
                execute(callback);
            });
        }
        dispose() {
            if (!this._isAppended) return;
            EventHandler.off(this._element, EVENT_MOUSEDOWN);
            this._element.remove();
            this._isAppended = false;
        }
        // Private
        _getElement() {
            if (!this._element) {
                const backdrop = document.createElement('div');
                backdrop.className = this._config.className;
                if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
                this._element = backdrop;
            }
            return this._element;
        }
        _configAfterMerge(config) {
            // use getElement() with the default "body" to get a fresh Element on each instantiation
            config.rootElement = getElement(config.rootElement);
            return config;
        }
        _append() {
            if (this._isAppended) return;
            const element = this._getElement();
            this._config.rootElement.append(element);
            EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
                execute(this._config.clickCallback);
            });
            this._isAppended = true;
        }
        _emulateAnimation(callback) {
            executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$8 = 'focustrap';
    const DATA_KEY$5 = 'bs.focustrap';
    const EVENT_KEY$5 = `.${DATA_KEY$5}`;
    const EVENT_FOCUSIN$2 = `focusin${EVENT_KEY$5}`;
    const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
    const TAB_KEY = 'Tab';
    const TAB_NAV_FORWARD = 'forward';
    const TAB_NAV_BACKWARD = 'backward';
    const Default$7 = {
        autofocus: true,
        trapElement: null // The element to trap focus inside of
    };
    const DefaultType$7 = {
        autofocus: 'boolean',
        trapElement: 'element'
    };
    /**
   * Class definition
   */ class FocusTrap extends Config {
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isActive = false;
            this._lastTabNavDirection = null;
        }
        // Getters
        static get Default() {
            return Default$7;
        }
        static get DefaultType() {
            return DefaultType$7;
        }
        static get NAME() {
            return NAME$8;
        }
        // Public
        activate() {
            if (this._isActive) return;
            if (this._config.autofocus) this._config.trapElement.focus();
            EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
            EventHandler.on(document, EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
            EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
            this._isActive = true;
        }
        deactivate() {
            if (!this._isActive) return;
            this._isActive = false;
            EventHandler.off(document, EVENT_KEY$5);
        }
        // Private
        _handleFocusin(event) {
            const { trapElement: trapElement } = this._config;
            if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
            const elements = SelectorEngine.focusableChildren(trapElement);
            if (elements.length === 0) trapElement.focus();
            else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
            else elements[0].focus();
        }
        _handleKeydown(event) {
            if (event.key !== TAB_KEY) return;
            this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
    const SELECTOR_STICKY_CONTENT = '.sticky-top';
    const PROPERTY_PADDING = 'padding-right';
    const PROPERTY_MARGIN = 'margin-right';
    /**
   * Class definition
   */ class ScrollBarHelper {
        constructor(){
            this._element = document.body;
        }
        // Public
        getWidth() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
            const documentWidth = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - documentWidth);
        }
        hide() {
            const width = this.getWidth();
            this._disableOverFlow();
            // give padding to element to balance the hidden scrollbar width
            this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
            this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
        }
        reset() {
            this._resetElementAttributes(this._element, 'overflow');
            this._resetElementAttributes(this._element, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        // Private
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, 'overflow');
            this._element.style.overflow = 'hidden';
        }
        _setElementAttributes(selector, styleProperty, callback) {
            const scrollbarWidth = this.getWidth();
            const manipulationCallBack = (element)=>{
                if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                this._saveInitialAttribute(element, styleProperty);
                const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _saveInitialAttribute(element, styleProperty) {
            const actualValue = element.style.getPropertyValue(styleProperty);
            if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
        }
        _resetElementAttributes(selector, styleProperty) {
            const manipulationCallBack = (element)=>{
                const value = Manipulator.getDataAttribute(element, styleProperty);
                // We only want to remove the property if the value is `null`; the value can also be zero
                if (value === null) {
                    element.style.removeProperty(styleProperty);
                    return;
                }
                Manipulator.removeDataAttribute(element, styleProperty);
                element.style.setProperty(styleProperty, value);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _applyManipulationCallback(selector, callBack) {
            if (isElement(selector)) {
                callBack(selector);
                return;
            }
            for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$7 = 'modal';
    const DATA_KEY$4 = 'bs.modal';
    const EVENT_KEY$4 = `.${DATA_KEY$4}`;
    const DATA_API_KEY$2 = '.data-api';
    const ESCAPE_KEY$1 = 'Escape';
    const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
    const EVENT_HIDE_PREVENTED$1 = `hidePrevented${EVENT_KEY$4}`;
    const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
    const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
    const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
    const EVENT_RESIZE$1 = `resize${EVENT_KEY$4}`;
    const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$4}`;
    const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$4}`;
    const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
    const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$4}${DATA_API_KEY$2}`;
    const CLASS_NAME_OPEN = 'modal-open';
    const CLASS_NAME_FADE$3 = 'fade';
    const CLASS_NAME_SHOW$4 = 'show';
    const CLASS_NAME_STATIC = 'modal-static';
    const OPEN_SELECTOR$1 = '.modal.show';
    const SELECTOR_DIALOG = '.modal-dialog';
    const SELECTOR_MODAL_BODY = '.modal-body';
    const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
    const Default$6 = {
        backdrop: true,
        focus: true,
        keyboard: true
    };
    const DefaultType$6 = {
        backdrop: '(boolean|string)',
        focus: 'boolean',
        keyboard: 'boolean'
    };
    /**
   * Class definition
   */ class Modal extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._isShown = false;
            this._isTransitioning = false;
            this._scrollBar = new ScrollBarHelper();
            this._addEventListeners();
        }
        // Getters
        static get Default() {
            return Default$6;
        }
        static get DefaultType() {
            return DefaultType$6;
        }
        static get NAME() {
            return NAME$7;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown || this._isTransitioning) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._isTransitioning = true;
            this._scrollBar.hide();
            document.body.classList.add(CLASS_NAME_OPEN);
            this._adjustDialog();
            this._backdrop.show(()=>this._showElement(relatedTarget));
        }
        hide() {
            if (!this._isShown || this._isTransitioning) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
            if (hideEvent.defaultPrevented) return;
            this._isShown = false;
            this._isTransitioning = true;
            this._focustrap.deactivate();
            this._element.classList.remove(CLASS_NAME_SHOW$4);
            this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
        }
        dispose() {
            EventHandler.off(window, EVENT_KEY$4);
            EventHandler.off(this._dialog, EVENT_KEY$4);
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        // Private
        _initializeBackDrop() {
            return new Backdrop({
                isVisible: Boolean(this._config.backdrop),
                // 'static' option will be translated to true, and booleans will keep their value,
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _showElement(relatedTarget) {
            // try to append dynamic modal
            if (!document.body.contains(this._element)) document.body.append(this._element);
            this._element.style.display = 'block';
            this._element.removeAttribute('aria-hidden');
            this._element.setAttribute('aria-modal', true);
            this._element.setAttribute('role', 'dialog');
            this._element.scrollTop = 0;
            const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
            if (modalBody) modalBody.scrollTop = 0;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW$4);
            const transitionComplete = ()=>{
                if (this._config.focus) this._focustrap.activate();
                this._isTransitioning = false;
                EventHandler.trigger(this._element, EVENT_SHOWN$4, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, (event)=>{
                if (event.key !== ESCAPE_KEY$1) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                this._triggerBackdropTransition();
            });
            EventHandler.on(window, EVENT_RESIZE$1, ()=>{
                if (this._isShown && !this._isTransitioning) this._adjustDialog();
            });
            EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
                // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                    if (this._element !== event.target || this._element !== event2.target) return;
                    if (this._config.backdrop === 'static') {
                        this._triggerBackdropTransition();
                        return;
                    }
                    if (this._config.backdrop) this.hide();
                });
            });
        }
        _hideModal() {
            this._element.style.display = 'none';
            this._element.setAttribute('aria-hidden', true);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            this._isTransitioning = false;
            this._backdrop.hide(()=>{
                document.body.classList.remove(CLASS_NAME_OPEN);
                this._resetAdjustments();
                this._scrollBar.reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$4);
            });
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_FADE$3);
        }
        _triggerBackdropTransition() {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
            if (hideEvent.defaultPrevented) return;
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const initialOverflowY = this._element.style.overflowY;
            // return if the following background transition hasn't yet completed
            if (initialOverflowY === 'hidden' || this._element.classList.contains(CLASS_NAME_STATIC)) return;
            if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
            this._element.classList.add(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.classList.remove(CLASS_NAME_STATIC);
                this._queueCallback(()=>{
                    this._element.style.overflowY = initialOverflowY;
                }, this._dialog);
            }, this._dialog);
            this._element.focus();
        }
        /**
     * The following methods are used to handle overflowing modals
     */ _adjustDialog() {
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const scrollbarWidth = this._scrollBar.getWidth();
            const isBodyOverflowing = scrollbarWidth > 0;
            if (isBodyOverflowing && !isModalOverflowing) {
                const property = isRTL() ? 'paddingLeft' : 'paddingRight';
                this._element.style[property] = `${scrollbarWidth}px`;
            }
            if (!isBodyOverflowing && isModalOverflowing) {
                const property = isRTL() ? 'paddingRight' : 'paddingLeft';
                this._element.style[property] = `${scrollbarWidth}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = '';
            this._element.style.paddingRight = '';
        }
        // Static
        static jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                const data = Modal.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](relatedTarget);
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        EventHandler.one(target, EVENT_SHOW$4, (showEvent)=>{
            if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
            return;
            EventHandler.one(target, EVENT_HIDDEN$4, ()=>{
                if (isVisible(this)) this.focus();
            });
        });
        // avoid conflict when clicking modal toggler while another one is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
        if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
        const data = Modal.getOrCreateInstance(target);
        data.toggle(this);
    });
    enableDismissTrigger(Modal);
    /**
   * jQuery
   */ defineJQueryPlugin(Modal);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap offcanvas.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$6 = 'offcanvas';
    const DATA_KEY$3 = 'bs.offcanvas';
    const EVENT_KEY$3 = `.${DATA_KEY$3}`;
    const DATA_API_KEY$1 = '.data-api';
    const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const ESCAPE_KEY = 'Escape';
    const CLASS_NAME_SHOW$3 = 'show';
    const CLASS_NAME_SHOWING$1 = 'showing';
    const CLASS_NAME_HIDING = 'hiding';
    const CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
    const OPEN_SELECTOR = '.offcanvas.show';
    const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
    const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
    const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
    const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
    const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
    const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
    const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
    const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
    const Default$5 = {
        backdrop: true,
        keyboard: true,
        scroll: false
    };
    const DefaultType$5 = {
        backdrop: '(boolean|string)',
        keyboard: 'boolean',
        scroll: 'boolean'
    };
    /**
   * Class definition
   */ class Offcanvas extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._isShown = false;
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._addEventListeners();
        }
        // Getters
        static get Default() {
            return Default$5;
        }
        static get DefaultType() {
            return DefaultType$5;
        }
        static get NAME() {
            return NAME$6;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._backdrop.show();
            if (!this._config.scroll) new ScrollBarHelper().hide();
            this._element.setAttribute('aria-modal', true);
            this._element.setAttribute('role', 'dialog');
            this._element.classList.add(CLASS_NAME_SHOWING$1);
            const completeCallBack = ()=>{
                if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
                this._element.classList.add(CLASS_NAME_SHOW$3);
                this._element.classList.remove(CLASS_NAME_SHOWING$1);
                EventHandler.trigger(this._element, EVENT_SHOWN$3, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(completeCallBack, this._element, true);
        }
        hide() {
            if (!this._isShown) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
            if (hideEvent.defaultPrevented) return;
            this._focustrap.deactivate();
            this._element.blur();
            this._isShown = false;
            this._element.classList.add(CLASS_NAME_HIDING);
            this._backdrop.hide();
            const completeCallback = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                if (!this._config.scroll) new ScrollBarHelper().reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$3);
            };
            this._queueCallback(completeCallback, this._element, true);
        }
        dispose() {
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        // Private
        _initializeBackDrop() {
            const clickCallback = ()=>{
                if (this._config.backdrop === 'static') {
                    EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
                    return;
                }
                this.hide();
            };
            // 'static' option will be translated to true, and booleans will keep their value
            const isVisible = Boolean(this._config.backdrop);
            return new Backdrop({
                className: CLASS_NAME_BACKDROP,
                isVisible: isVisible,
                isAnimated: true,
                rootElement: this._element.parentNode,
                clickCallback: isVisible ? clickCallback : null
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
                if (event.key !== ESCAPE_KEY) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
            });
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Offcanvas.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        EventHandler.one(target, EVENT_HIDDEN$3, ()=>{
            // focus on trigger when it is closed
            if (isVisible(this)) this.focus();
        });
        // avoid conflict when clicking a toggler of an offcanvas, while another is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
        const data = Offcanvas.getOrCreateInstance(target);
        data.toggle(this);
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$2, ()=>{
        for (const selector of SelectorEngine.find(OPEN_SELECTOR))Offcanvas.getOrCreateInstance(selector).show();
    });
    EventHandler.on(window, EVENT_RESIZE, ()=>{
        for (const element of SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') Offcanvas.getOrCreateInstance(element).hide();
    });
    enableDismissTrigger(Offcanvas);
    /**
   * jQuery
   */ defineJQueryPlugin(Offcanvas);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ // js-docs-start allow-list
    const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    const DefaultAllowlist = {
        // Global attributes allowed on any supplied element below.
        '*': [
            'class',
            'dir',
            'id',
            'lang',
            'role',
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            'target',
            'href',
            'title',
            'rel'
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height'
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    // js-docs-end allow-list
    const uriAttributes = new Set([
        'background',
        'cite',
        'href',
        'itemtype',
        'longdesc',
        'poster',
        'src',
        'xlink:href'
    ]);
    /**
   * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
   * contexts.
   *
   * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
   */ // eslint-disable-next-line unicorn/better-regex
    const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    const allowedAttribute = (attribute, allowedAttributeList)=>{
        const attributeName = attribute.nodeName.toLowerCase();
        if (allowedAttributeList.includes(attributeName)) {
            if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
            return true;
        }
        // Check if a regular expression validates the attribute.
        return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
        if (!unsafeHtml.length) return unsafeHtml;
        if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
        const domParser = new window.DOMParser();
        const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
        const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
        for (const element of elements){
            const elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            const attributeList = [].concat(...element.attributes);
            const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/template-factory.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$5 = 'TemplateFactory';
    const Default$4 = {
        allowList: DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: '',
        html: false,
        sanitize: true,
        sanitizeFn: null,
        template: '<div></div>'
    };
    const DefaultType$4 = {
        allowList: 'object',
        content: 'object',
        extraClass: '(string|function)',
        html: 'boolean',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        template: 'string'
    };
    const DefaultContentType = {
        entry: '(string|element|function|null)',
        selector: '(string|element)'
    };
    /**
   * Class definition
   */ class TemplateFactory extends Config {
        constructor(config){
            super();
            this._config = this._getConfig(config);
        }
        // Getters
        static get Default() {
            return Default$4;
        }
        static get DefaultType() {
            return DefaultType$4;
        }
        static get NAME() {
            return NAME$5;
        }
        // Public
        getContent() {
            return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(content) {
            this._checkContent(content);
            this._config.content = {
                ...this._config.content,
                ...content
            };
            return this;
        }
        toHtml() {
            const templateWrapper = document.createElement('div');
            templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
            for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
            const template = templateWrapper.children[0];
            const extraClass = this._resolvePossibleFunction(this._config.extraClass);
            if (extraClass) template.classList.add(...extraClass.split(' '));
            return template;
        }
        // Private
        _typeCheckConfig(config) {
            super._typeCheckConfig(config);
            this._checkContent(config.content);
        }
        _checkContent(arg) {
            for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
                selector: selector,
                entry: content
            }, DefaultContentType);
        }
        _setContent(template, content, selector) {
            const templateElement = SelectorEngine.findOne(selector, template);
            if (!templateElement) return;
            content = this._resolvePossibleFunction(content);
            if (!content) {
                templateElement.remove();
                return;
            }
            if (isElement(content)) {
                this._putElementInTemplate(getElement(content), templateElement);
                return;
            }
            if (this._config.html) {
                templateElement.innerHTML = this._maybeSanitize(content);
                return;
            }
            templateElement.textContent = content;
        }
        _maybeSanitize(arg) {
            return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                undefined,
                this
            ]);
        }
        _putElementInTemplate(element, templateElement) {
            if (this._config.html) {
                templateElement.innerHTML = '';
                templateElement.append(element);
                return;
            }
            templateElement.textContent = element.textContent;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$4 = 'tooltip';
    const DISALLOWED_ATTRIBUTES = new Set([
        'sanitize',
        'allowList',
        'sanitizeFn'
    ]);
    const CLASS_NAME_FADE$2 = 'fade';
    const CLASS_NAME_MODAL = 'modal';
    const CLASS_NAME_SHOW$2 = 'show';
    const SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
    const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
    const EVENT_MODAL_HIDE = 'hide.bs.modal';
    const TRIGGER_HOVER = 'hover';
    const TRIGGER_FOCUS = 'focus';
    const TRIGGER_CLICK = 'click';
    const TRIGGER_MANUAL = 'manual';
    const EVENT_HIDE$2 = 'hide';
    const EVENT_HIDDEN$2 = 'hidden';
    const EVENT_SHOW$2 = 'show';
    const EVENT_SHOWN$2 = 'shown';
    const EVENT_INSERTED = 'inserted';
    const EVENT_CLICK$1 = 'click';
    const EVENT_FOCUSIN$1 = 'focusin';
    const EVENT_FOCUSOUT$1 = 'focusout';
    const EVENT_MOUSEENTER = 'mouseenter';
    const EVENT_MOUSELEAVE = 'mouseleave';
    const AttachmentMap = {
        AUTO: 'auto',
        TOP: 'top',
        RIGHT: isRTL() ? 'left' : 'right',
        BOTTOM: 'bottom',
        LEFT: isRTL() ? 'right' : 'left'
    };
    const Default$3 = {
        allowList: DefaultAllowlist,
        animation: true,
        boundary: 'clippingParents',
        container: false,
        customClass: '',
        delay: 0,
        fallbackPlacements: [
            'top',
            'right',
            'bottom',
            'left'
        ],
        html: false,
        offset: [
            0,
            6
        ],
        placement: 'top',
        popperConfig: null,
        sanitize: true,
        sanitizeFn: null,
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: '',
        trigger: 'hover focus'
    };
    const DefaultType$3 = {
        allowList: 'object',
        animation: 'boolean',
        boundary: '(string|element)',
        container: '(string|element|boolean)',
        customClass: '(string|function)',
        delay: '(number|object)',
        fallbackPlacements: 'array',
        html: 'boolean',
        offset: '(array|string|function)',
        placement: '(string|function)',
        popperConfig: '(null|object|function)',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        selector: '(string|boolean)',
        template: 'string',
        title: '(string|element|function)',
        trigger: 'string'
    };
    /**
   * Class definition
   */ class Tooltip extends BaseComponent {
        constructor(element, config){
            if (typeof Popper__namespace === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
            super(element, config);
            // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._isHovered = null;
            this._activeTrigger = {};
            this._popper = null;
            this._templateFactory = null;
            this._newContent = null;
            // Protected
            this.tip = null;
            this._setListeners();
            if (!this._config.selector) this._fixTitle();
        }
        // Getters
        static get Default() {
            return Default$3;
        }
        static get DefaultType() {
            return DefaultType$3;
        }
        static get NAME() {
            return NAME$4;
        }
        // Public
        enable() {
            this._isEnabled = true;
        }
        disable() {
            this._isEnabled = false;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            if (!this._isEnabled) return;
            if (this._isShown()) {
                this._leave();
                return;
            }
            this._enter();
        }
        dispose() {
            clearTimeout(this._timeout);
            EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
            if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
            this._disposePopper();
            super.dispose();
        }
        show() {
            if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
            if (!(this._isWithContent() && this._isEnabled)) return;
            const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
            const shadowRoot = findShadowRoot(this._element);
            const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
            if (showEvent.defaultPrevented || !isInTheDom) return;
            // TODO: v6 remove this or make it optional
            this._disposePopper();
            const tip = this._getTipElement();
            this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
            const { container: container } = this._config;
            if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                container.append(tip);
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
            }
            this._popper = this._createPopper(tip);
            tip.classList.add(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', noop);
            const complete = ()=>{
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
                if (this._isHovered === false) this._leave();
                this._isHovered = false;
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        hide() {
            if (!this._isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
            if (hideEvent.defaultPrevented) return;
            const tip = this._getTipElement();
            tip.classList.remove(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            this._isHovered = null; // it is a trick to support manual triggering
            const complete = ()=>{
                if (this._isWithActiveTrigger()) return;
                if (!this._isHovered) this._disposePopper();
                this._element.removeAttribute('aria-describedby');
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        update() {
            if (this._popper) this._popper.update();
        }
        // Protected
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
            return this.tip;
        }
        _createTipElement(content) {
            const tip = this._getTemplateFactory(content).toHtml();
            // TODO: remove this check in v6
            if (!tip) return null;
            tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
            // TODO: v6 the following can be achieved with CSS only
            tip.classList.add(`bs-${this.constructor.NAME}-auto`);
            const tipId = getUID(this.constructor.NAME).toString();
            tip.setAttribute('id', tipId);
            if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
            return tip;
        }
        setContent(content) {
            this._newContent = content;
            if (this._isShown()) {
                this._disposePopper();
                this.show();
            }
        }
        _getTemplateFactory(content) {
            if (this._templateFactory) this._templateFactory.changeContent(content);
            else this._templateFactory = new TemplateFactory({
                ...this._config,
                content: // the `content` var has to be after `this._config`
                // to override config.content in case of popover
                content,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            });
            return this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [SELECTOR_TOOLTIP_INNER]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
        }
        // Private
        _initializeOnDelegatedTarget(event) {
            return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
        }
        _createPopper(tip) {
            const placement = execute(this._config.placement, [
                this,
                tip,
                this._element
            ]);
            const attachment = AttachmentMap[placement.toUpperCase()];
            return Popper__namespace.createPopper(this._element, tip, this._getPopperConfig(attachment));
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
            if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                this._element,
                this._element
            ]);
        }
        _getPopperConfig(attachment) {
            const defaultBsPopperConfig = {
                placement: attachment,
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: 'arrow',
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: 'preSetPlacement',
                        enabled: true,
                        phase: 'beforeMain',
                        fn: (data)=>{
                            // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                            // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                            this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                        }
                    }
                ]
            };
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ])
            };
        }
        _setListeners() {
            const triggers = this._config.trigger.split(' ');
            for (const trigger of triggers){
                if (trigger === 'click') EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context.toggle();
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                    const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                    EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                        context._enter();
                    });
                    EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                        context._leave();
                    });
                }
            }
            this._hideModalHandler = ()=>{
                if (this._element) this.hide();
            };
            EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        }
        _fixTitle() {
            const title = this._element.getAttribute('title');
            if (!title) return;
            if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
            this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
            this._element.removeAttribute('title');
        }
        _enter() {
            if (this._isShown() || this._isHovered) {
                this._isHovered = true;
                return;
            }
            this._isHovered = true;
            this._setTimeout(()=>{
                if (this._isHovered) this.show();
            }, this._config.delay.show);
        }
        _leave() {
            if (this._isWithActiveTrigger()) return;
            this._isHovered = false;
            this._setTimeout(()=>{
                if (!this._isHovered) this.hide();
            }, this._config.delay.hide);
        }
        _setTimeout(handler, timeout) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(handler, timeout);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(true);
        }
        _getConfig(config) {
            const dataAttributes = Manipulator.getDataAttributes(this._element);
            for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
            config = {
                ...dataAttributes,
                ...typeof config === 'object' && config ? config : {}
            };
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            config.container = config.container === false ? document.body : getElement(config.container);
            if (typeof config.delay === 'number') config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === 'number') config.title = config.title.toString();
            if (typeof config.content === 'number') config.content = config.content.toString();
            return config;
        }
        _getDelegateConfig() {
            const config = {};
            for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
            config.selector = false;
            config.trigger = 'manual';
            // In the future can be replaced with:
            // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
            // `Object.fromEntries(keysWithDifferentValues)`
            return config;
        }
        _disposePopper() {
            if (this._popper) {
                this._popper.destroy();
                this._popper = null;
            }
            if (this.tip) {
                this.tip.remove();
                this.tip = null;
            }
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tooltip.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Tooltip);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$3 = 'popover';
    const SELECTOR_TITLE = '.popover-header';
    const SELECTOR_CONTENT = '.popover-body';
    const Default$2 = {
        ...Tooltip.Default,
        content: '',
        offset: [
            0,
            8
        ],
        placement: 'right',
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: 'click'
    };
    const DefaultType$2 = {
        ...Tooltip.DefaultType,
        content: '(null|string|element|function)'
    };
    /**
   * Class definition
   */ class Popover extends Tooltip {
        // Getters
        static get Default() {
            return Default$2;
        }
        static get DefaultType() {
            return DefaultType$2;
        }
        static get NAME() {
            return NAME$3;
        }
        // Overrides
        _isWithContent() {
            return this._getTitle() || this._getContent();
        }
        // Private
        _getContentForTemplate() {
            return {
                [SELECTOR_TITLE]: this._getTitle(),
                [SELECTOR_CONTENT]: this._getContent()
            };
        }
        _getContent() {
            return this._resolvePossibleFunction(this._config.content);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Popover.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Popover);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$2 = 'scrollspy';
    const DATA_KEY$2 = 'bs.scrollspy';
    const EVENT_KEY$2 = `.${DATA_KEY$2}`;
    const DATA_API_KEY = '.data-api';
    const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
    const EVENT_CLICK = `click${EVENT_KEY$2}`;
    const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$2}${DATA_API_KEY}`;
    const CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
    const CLASS_NAME_ACTIVE$1 = 'active';
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_TARGET_LINKS = '[href]';
    const SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
    const SELECTOR_NAV_LINKS = '.nav-link';
    const SELECTOR_NAV_ITEMS = '.nav-item';
    const SELECTOR_LIST_ITEMS = '.list-group-item';
    const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_NAV_ITEMS} > ${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`;
    const SELECTOR_DROPDOWN = '.dropdown';
    const SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
    const Default$1 = {
        offset: null,
        // TODO: v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: '0px 0px -25%',
        smoothScroll: false,
        target: null,
        threshold: [
            0.1,
            0.5,
            1
        ]
    };
    const DefaultType$1 = {
        offset: '(number|null)',
        // TODO v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: 'string',
        smoothScroll: 'boolean',
        target: 'element',
        threshold: 'array'
    };
    /**
   * Class definition
   */ class ScrollSpy extends BaseComponent {
        constructor(element, config){
            super(element, config);
            // this._element is the observablesContainer and config.target the menu links wrapper
            this._targetLinks = new Map();
            this._observableSections = new Map();
            this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
            this._activeTarget = null;
            this._observer = null;
            this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            };
            this.refresh(); // initialize
        }
        // Getters
        static get Default() {
            return Default$1;
        }
        static get DefaultType() {
            return DefaultType$1;
        }
        static get NAME() {
            return NAME$2;
        }
        // Public
        refresh() {
            this._initializeTargetsAndObservables();
            this._maybeEnableSmoothScroll();
            if (this._observer) this._observer.disconnect();
            else this._observer = this._getNewObserver();
            for (const section of this._observableSections.values())this._observer.observe(section);
        }
        dispose() {
            this._observer.disconnect();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
            config.target = getElement(config.target) || document.body;
            // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
            config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
            if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
            return config;
        }
        _maybeEnableSmoothScroll() {
            if (!this._config.smoothScroll) return;
            // unregister any previous listeners
            EventHandler.off(this._config.target, EVENT_CLICK);
            EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, (event)=>{
                const observableSection = this._observableSections.get(event.target.hash);
                if (observableSection) {
                    event.preventDefault();
                    const root = this._rootElement || window;
                    const height = observableSection.offsetTop - this._element.offsetTop;
                    if (root.scrollTo) {
                        root.scrollTo({
                            top: height,
                            behavior: 'smooth'
                        });
                        return;
                    }
                    // Chrome 60 doesn't support `scrollTo`
                    root.scrollTop = height;
                }
            });
        }
        _getNewObserver() {
            const options = {
                root: this._rootElement,
                threshold: this._config.threshold,
                rootMargin: this._config.rootMargin
            };
            return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
        }
        // The logic of selection
        _observerCallback(entries) {
            const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
            const activate = (entry)=>{
                this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                this._process(targetElement(entry));
            };
            const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
            const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
            this._previousScrollData.parentScrollTop = parentScrollTop;
            for (const entry of entries){
                if (!entry.isIntersecting) {
                    this._activeTarget = null;
                    this._clearActiveClass(targetElement(entry));
                    continue;
                }
                const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                // if we are scrolling down, pick the bigger offsetTop
                if (userScrollsDown && entryIsLowerThanPrevious) {
                    activate(entry);
                    // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                    if (!parentScrollTop) return;
                    continue;
                }
                // if we are scrolling up, pick the smallest offsetTop
                if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
            }
        }
        _initializeTargetsAndObservables() {
            this._targetLinks = new Map();
            this._observableSections = new Map();
            const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
            for (const anchor of targetLinks){
                // ensure that the anchor has an id and is not disabled
                if (!anchor.hash || isDisabled(anchor)) continue;
                const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                // ensure that the observableSection exists & is visible
                if (isVisible(observableSection)) {
                    this._targetLinks.set(decodeURI(anchor.hash), anchor);
                    this._observableSections.set(anchor.hash, observableSection);
                }
            }
        }
        _process(target) {
            if (this._activeTarget === target) return;
            this._clearActiveClass(this._config.target);
            this._activeTarget = target;
            target.classList.add(CLASS_NAME_ACTIVE$1);
            this._activateParents(target);
            EventHandler.trigger(this._element, EVENT_ACTIVATE, {
                relatedTarget: target
            });
        }
        _activateParents(target) {
            // Activate dropdown parents
            if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
                SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
                return;
            }
            for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
            for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS))item.classList.add(CLASS_NAME_ACTIVE$1);
        }
        _clearActiveClass(parent) {
            parent.classList.remove(CLASS_NAME_ACTIVE$1);
            const activeNodes = SelectorEngine.find(`${SELECTOR_TARGET_LINKS}.${CLASS_NAME_ACTIVE$1}`, parent);
            for (const node of activeNodes)node.classList.remove(CLASS_NAME_ACTIVE$1);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = ScrollSpy.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, ()=>{
        for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY))ScrollSpy.getOrCreateInstance(spy);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(ScrollSpy);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$1 = 'tab';
    const DATA_KEY$1 = 'bs.tab';
    const EVENT_KEY$1 = `.${DATA_KEY$1}`;
    const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
    const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
    const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
    const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}`;
    const EVENT_KEYDOWN = `keydown${EVENT_KEY$1}`;
    const EVENT_LOAD_DATA_API = `load${EVENT_KEY$1}`;
    const ARROW_LEFT_KEY = 'ArrowLeft';
    const ARROW_RIGHT_KEY = 'ArrowRight';
    const ARROW_UP_KEY = 'ArrowUp';
    const ARROW_DOWN_KEY = 'ArrowDown';
    const HOME_KEY = 'Home';
    const END_KEY = 'End';
    const CLASS_NAME_ACTIVE = 'active';
    const CLASS_NAME_FADE$1 = 'fade';
    const CLASS_NAME_SHOW$1 = 'show';
    const CLASS_DROPDOWN = 'dropdown';
    const SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
    const SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
    const NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${SELECTOR_DROPDOWN_TOGGLE})`;
    const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    const SELECTOR_OUTER = '.nav-item, .list-group-item';
    const SELECTOR_INNER = `.nav-link${NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${NOT_SELECTOR_DROPDOWN_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    const SELECTOR_INNER_ELEM = `${SELECTOR_INNER}, ${SELECTOR_DATA_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
    /**
   * Class definition
   */ class Tab extends BaseComponent {
        constructor(element){
            super(element);
            this._parent = this._element.closest(SELECTOR_TAB_PANEL);
            if (!this._parent) return;
            // Set up initial aria attributes
            this._setInitialAttributes(this._parent, this._getChildren());
            EventHandler.on(this._element, EVENT_KEYDOWN, (event)=>this._keydown(event));
        }
        // Getters
        static get NAME() {
            return NAME$1;
        }
        // Public
        show() {
            // Shows this elem and deactivate the active sibling if exists
            const innerElem = this._element;
            if (this._elemIsActive(innerElem)) return;
            // Search for active tab on same parent to deactivate it
            const active = this._getActiveElem();
            const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
                relatedTarget: innerElem
            }) : null;
            const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
                relatedTarget: active
            });
            if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
            this._deactivate(active, innerElem);
            this._activate(innerElem, active);
        }
        // Private
        _activate(element, relatedElem) {
            if (!element) return;
            element.classList.add(CLASS_NAME_ACTIVE);
            this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
            const complete = ()=>{
                if (element.getAttribute('role') !== 'tab') {
                    element.classList.add(CLASS_NAME_SHOW$1);
                    return;
                }
                element.removeAttribute('tabindex');
                element.setAttribute('aria-selected', true);
                this._toggleDropDown(element, true);
                EventHandler.trigger(element, EVENT_SHOWN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _deactivate(element, relatedElem) {
            if (!element) return;
            element.classList.remove(CLASS_NAME_ACTIVE);
            element.blur();
            this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
            const complete = ()=>{
                if (element.getAttribute('role') !== 'tab') {
                    element.classList.remove(CLASS_NAME_SHOW$1);
                    return;
                }
                element.setAttribute('aria-selected', false);
                element.setAttribute('tabindex', '-1');
                this._toggleDropDown(element, false);
                EventHandler.trigger(element, EVENT_HIDDEN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _keydown(event) {
            if (![
                ARROW_LEFT_KEY,
                ARROW_RIGHT_KEY,
                ARROW_UP_KEY,
                ARROW_DOWN_KEY,
                HOME_KEY,
                END_KEY
            ].includes(event.key)) return;
            event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
            event.preventDefault();
            const children = this._getChildren().filter((element)=>!isDisabled(element));
            let nextActiveElement;
            if ([
                HOME_KEY,
                END_KEY
            ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
            else {
                const isNext = [
                    ARROW_RIGHT_KEY,
                    ARROW_DOWN_KEY
                ].includes(event.key);
                nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
            }
            if (nextActiveElement) {
                nextActiveElement.focus({
                    preventScroll: true
                });
                Tab.getOrCreateInstance(nextActiveElement).show();
            }
        }
        _getChildren() {
            // collection of inner elements
            return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
        }
        _getActiveElem() {
            return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
        }
        _setInitialAttributes(parent, children) {
            this._setAttributeIfNotExists(parent, 'role', 'tablist');
            for (const child of children)this._setInitialAttributesOnChild(child);
        }
        _setInitialAttributesOnChild(child) {
            child = this._getInnerElement(child);
            const isActive = this._elemIsActive(child);
            const outerElem = this._getOuterElement(child);
            child.setAttribute('aria-selected', isActive);
            if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
            if (!isActive) child.setAttribute('tabindex', '-1');
            this._setAttributeIfNotExists(child, 'role', 'tab');
            // set attributes to the related panel too
            this._setInitialAttributesOnTargetPanel(child);
        }
        _setInitialAttributesOnTargetPanel(child) {
            const target = SelectorEngine.getElementFromSelector(child);
            if (!target) return;
            this._setAttributeIfNotExists(target, 'role', 'tabpanel');
            if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
        }
        _toggleDropDown(element, open) {
            const outerElem = this._getOuterElement(element);
            if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
            const toggle = (selector, className)=>{
                const element = SelectorEngine.findOne(selector, outerElem);
                if (element) element.classList.toggle(className, open);
            };
            toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
            toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
            outerElem.setAttribute('aria-expanded', open);
        }
        _setAttributeIfNotExists(element, attribute, value) {
            if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
        }
        _elemIsActive(elem) {
            return elem.classList.contains(CLASS_NAME_ACTIVE);
        }
        // Try to get the inner element (usually the .nav-link)
        _getInnerElement(elem) {
            return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
        }
        // Try to get the outer element (usually the .nav-item)
        _getOuterElement(elem) {
            return elem.closest(SELECTOR_OUTER) || elem;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tab.getOrCreateInstance(this);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        Tab.getOrCreateInstance(this).show();
    });
    /**
   * Initialize on focus
   */ EventHandler.on(window, EVENT_LOAD_DATA_API, ()=>{
        for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE))Tab.getOrCreateInstance(element);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Tab);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'toast';
    const DATA_KEY = 'bs.toast';
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
    const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const CLASS_NAME_FADE = 'fade';
    const CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = 'show';
    const CLASS_NAME_SHOWING = 'showing';
    const DefaultType = {
        animation: 'boolean',
        autohide: 'boolean',
        delay: 'number'
    };
    const Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * Class definition
   */ class Toast extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._timeout = null;
            this._hasMouseInteraction = false;
            this._hasKeyboardInteraction = false;
            this._setListeners();
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        show() {
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
            if (showEvent.defaultPrevented) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            const complete = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOWING);
                EventHandler.trigger(this._element, EVENT_SHOWN);
                this._maybeScheduleHide();
            };
            this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        hide() {
            if (!this.isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            const complete = ()=>{
                this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        dispose() {
            this._clearTimeout();
            if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
            super.dispose();
        }
        isShown() {
            return this._element.classList.contains(CLASS_NAME_SHOW);
        }
        // Private
        _maybeScheduleHide() {
            if (!this._config.autohide) return;
            if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
            this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay);
        }
        _onInteraction(event, isInteracting) {
            switch(event.type){
                case 'mouseover':
                case 'mouseout':
                    this._hasMouseInteraction = isInteracting;
                    break;
                case 'focusin':
                case 'focusout':
                    this._hasKeyboardInteraction = isInteracting;
                    break;
            }
            if (isInteracting) {
                this._clearTimeout();
                return;
            }
            const nextElement = event.relatedTarget;
            if (this._element === nextElement || this._element.contains(nextElement)) return;
            this._maybeScheduleHide();
        }
        _setListeners() {
            EventHandler.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
            EventHandler.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
        }
        _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Toast.getOrCreateInstance(this, config);
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                    data[config](this);
                }
            });
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Toast);
    /**
   * jQuery
   */ defineJQueryPlugin(Toast);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap index.umd.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const index_umd = {
        Alert: Alert,
        Button: Button,
        Carousel: Carousel,
        Collapse: Collapse,
        Dropdown: Dropdown,
        Modal: Modal,
        Offcanvas: Offcanvas,
        Popover: Popover,
        ScrollSpy: ScrollSpy,
        Tab: Tab,
        Toast: Toast,
        Tooltip: Tooltip
    };
    return index_umd;
});


// ==================== APP Initialization ====================
(async ()=>{
    const instance = (0, $291a4c41d22e2de4$export$2e2bcd8739ae039)({
        urlBase: 'https://matomo.identifiers.org/',
        siteId: 1,
        disabled: false,
        // optional, false by default. Makes all tracking calls no-ops if set to true.
        heartBeat: {
            // optional, enabled by default
            active: true,
            // optional, default value: true
            seconds: 30 // optional, default value: `15
        },
        linkTracking: true,
        // optional, default value: true
        configurations: {
            // optional, default value: {}
            // any valid matomo configuration, all below are optional
            disableCookies: true,
            setSecureCookie: location.protocol.includes('https'),
            // Only available in https
            setRequestMethod: 'GET'
        }
    });
    // Get initial data.
    // Configuration from devops endpoint, which will be residing in the same url as the app.
    const configUrlPort = (0, window.location.port);
    // const configUrl = `${window.location.protocol}//${window.location.hostname}:${configUrlPort}`;
    const configUrl = location.protocol + `//identifiers.org`;
    await (0, $1cd9394d94558a21$export$2e2bcd8739ae039).dispatch((0, $f345da7c359121ca$export$f02ab100cc0f1b0c)(configUrl));
    // Get Schema.org Metadata depending on current path and append it to the document's head.
    /* Do not use URLSearchParams so google structured search tool can use this. ( <= chrome 42)
  const searchParams = new URLSearchParams(window.location.search);
  const query = searchParams.get('query');
  */ const query = window.location.search.split('query=').pop();
    if (query) {
        const splitQuery = (0, $918429d3bafe7f46$export$c067719c5fdda563)(query);
        await (0, $1cd9394d94558a21$export$2e2bcd8739ae039).dispatch((0, $1a23819793c0c1da$export$358ac8bb95c77f0c)(splitQuery.prefix));
    } else await (0, $1cd9394d94558a21$export$2e2bcd8739ae039).dispatch((0, $1a23819793c0c1da$export$78572dfc0a558ba6)());
    // Render app.
    const rootElement = document.getElementById("app");
    const reactRoot = (0, $f995a7d9315d4218$export$882461b6382ed46c)(rootElement);
    reactRoot.render(/*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $947b4ef5dc45af9b$export$2e2bcd8739ae039), {
        store: (0, $1cd9394d94558a21$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $792411052b99f68e$export$2e2bcd8739ae039), {
            value: instance,
            children: /*#__PURE__*/ (0, $8939768198127506$exports.jsx)((0, $fce2432f9efff74f$export$2e2bcd8739ae039), {})
        })
    }));
    //  // Run ebi framework stuff.
    //  ebiFrameworkPopulateBlackBar();
    //  ebiFrameworkActivateBlackBar();
    //  ebiFrameworkExternalLinks();
    //  ebiFrameworkManageGlobalSearch();
    //  ebiFrameworkSearchNullError();
    //  ebiFrameworkHideGlobalNav();
    //  ebiFrameworkAssignImageByMetaTags();
    //  ebiFrameworkInsertEMBLdropdown();
    //  ebiFrameworkUpdateFoot();
    //  ebiFrameworkUpdateFooterMeta();
    //  ebiFrameworkIncludeAnnouncements();
    //  ebiFrameworkRunDataProtectionBanner('1.3');
    ebiFrameworkInvokeScripts();
})();


//# sourceMappingURL=app.ff854493.js.map
